
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $5445e1f52820f998$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $5445e1f52820f998$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = "[data-choice]";
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn("Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.");
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
                        var passedElement = typeof element === "string" ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            "auto",
                            "always"
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = "auto";
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = "";
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, "choices-");
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: "item-choice"
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === "" || option.hasAttribute("placeholder"),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn("Trying to initialise Choices on element already initialised", {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute("disabled");
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === "function") callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = "value";
                        if (label === void 0) label = "label";
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== "string" || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === "function") {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === "function" && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate("notice", canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === "function" ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate("notice", notice, "no-results");
                            } else {
                                notice = typeof this.config.noChoicesText === "function" ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate("notice", notice, "no-choices");
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === "always" || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate("choiceGroup", group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === "auto" ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate("choice", choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === "auto" && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate("item", item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate("placeholder", this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || "";
                            } else this.input.placeholder = this._placeholderValue || "";
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== "undefined" && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === "function" ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === "function" ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === "function" ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === "function" && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === "function" ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === "string" ? value.trim() : value;
                        var currentValue = typeof this._currentValue === "string" ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener("click", this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener("touchmove", this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener("focus", this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener("blur", this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener("keyup", this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener("reset", this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, true);
                        documentElement.removeEventListener("click", this._onClick);
                        documentElement.removeEventListener("touchmove", this._onTouchMove);
                        this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener("focus", this._onFocus);
                            this.containerOuter.element.removeEventListener("blur", this._onBlur);
                        }
                        this.input.element.removeEventListener("keyup", this._onKeyUp);
                        this.input.element.removeEventListener("focus", this._onFocus);
                        this.input.element.removeEventListener("blur", this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener("reset", this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate("notice", canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute("data-button");
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = "[data-choice-selectable]";
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest("[data-button],[data-item],[data-choice]");
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ("button" in dataset) this._handleButtonAction(activeItems, item);
                            else if ("item" in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ("choice" in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && "choice" in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute("aria-selected", "false");
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute("aria-selected", "true");
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === "string" ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === "undefined" || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.labelKey, labelKey = _c === void 0 ? "label" : _c;
                        var groupChoices = (0, utils_1.isType)("Object", group) ? group.choices : Array.from(group.getElementsByTagName("OPTION"));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)("Object", choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === "function") userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate("containerInner"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate("input", this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate("choiceList", this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate("itemList", this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate("dropdown"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || "";
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === "SELECT") this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? "" : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === "object" && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === "string") _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener("focus", this._onFocus);
                        this.element.addEventListener("blur", this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== "number") return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === "auto") shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === "top") shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute("aria-disabled");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "0");
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute("aria-disabled", "true");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "-1");
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute("aria-busy", "true");
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute("aria-busy");
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener("paste", this._onPaste);
                        this.element.addEventListener("input", this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("input", this._onInput);
                        this.element.removeEventListener("paste", this._onPaste);
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = "";
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = "";
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === "active";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute("style");
                        if (origStyle) this.element.setAttribute("data-choice-orig-style", origStyle);
                        this.element.setAttribute("data-choice", "active");
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute("tabindex");
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute("data-choice-orig-style");
                        if (origStyle) {
                            this.element.removeAttribute("data-choice-orig-style");
                            this.element.setAttribute("style", origStyle);
                        } else this.element.removeAttribute("style");
                        this.element.removeAttribute("data-choice");
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute("value", value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector("option[placeholder]");
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName("OPTGROUP"));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = "";
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: "showDropdown",
                    hideDropdown: "hideDropdown",
                    change: "change",
                    choice: "choice",
                    search: "search",
                    addItem: "addItem",
                    removeItem: "removeItem",
                    highlightItem: "highlightItem",
                    highlightChoice: "highlightChoice",
                    unhighlightItem: "unhighlightItem"
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: "ADD_CHOICE",
                    FILTER_CHOICES: "FILTER_CHOICES",
                    ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                    CLEAR_CHOICES: "CLEAR_CHOICES",
                    ADD_GROUP: "ADD_GROUP",
                    ADD_ITEM: "ADD_ITEM",
                    REMOVE_ITEM: "REMOVE_ITEM",
                    HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                    CLEAR_ALL: "CLEAR_ALL",
                    RESET_TO: "RESET_TO",
                    SET_IS_LOADING: "SET_IS_LOADING"
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = "text";
                exports.SELECT_ONE_TYPE = "select-one";
                exports.SELECT_MULTIPLE_TYPE = "select-multiple";
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: "choices",
                    containerInner: "choices__inner",
                    input: "choices__input",
                    inputCloned: "choices__input--cloned",
                    list: "choices__list",
                    listItems: "choices__list--multiple",
                    listSingle: "choices__list--single",
                    listDropdown: "choices__list--dropdown",
                    item: "choices__item",
                    itemSelectable: "choices__item--selectable",
                    itemDisabled: "choices__item--disabled",
                    itemChoice: "choices__item--choice",
                    placeholder: "choices__placeholder",
                    group: "choices__group",
                    groupHeading: "choices__heading",
                    button: "choices__button",
                    activeState: "is-active",
                    focusState: "is-focused",
                    openState: "is-open",
                    disabledState: "is-disabled",
                    highlightedState: "is-highlighted",
                    selectedState: "is-selected",
                    flippedState: "is-flipped",
                    loadingState: "is-loading",
                    noResults: "has-no-results",
                    noChoices: "has-no-choices"
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ",",
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        "label",
                        "value"
                    ],
                    position: "auto",
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: "auto",
                    loadingText: "Loading...",
                    noResultsText: "No results found",
                    noChoicesText: "No choices to choose from",
                    itemSelectText: "Press to select",
                    uniqueItemText: "Only unique values can be added",
                    customAddItemText: "Only values matching specific conditions can be added",
                    addItemText: function(value) {
                        return 'Press Enter to add <b>"'.concat((0, utils_1.sanitise)(value), '"</b>');
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: "",
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join("");
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, "");
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement("div");
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== "string") return value;
                    return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement("div");
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: "base",
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = "value";
                    return array.some(function(item) {
                        if (typeof value === "string") return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== "undefined") try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_CHOICE":
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case "ADD_ITEM":
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case "REMOVE_ITEM":
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case "FILTER_CHOICES":
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case "ACTIVATE_CHOICES":
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case "CLEAR_CHOICES":
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_GROUP":
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case "CLEAR_CHOICES":
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === "CLEAR_ALL") state = exports.defaultState;
                    else if (action.type === "RESET_TO") return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_ITEM":
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case "REMOVE_ITEM":
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case "HIGHLIGHT_ITEM":
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "SET_IS_LOADING":
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement("div"), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
                            if (searchEnabled) div.setAttribute("aria-autocomplete", "list");
                        }
                        div.setAttribute("aria-haspopup", "true");
                        div.setAttribute("aria-expanded", "false");
                        if (labelId) div.setAttribute("aria-labelledby", labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement("div"), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement("div"), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement("div"), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? "innerHTML" : "innerText"] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            className: item
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c));
                        Object.assign(div.dataset, {
                            item: "",
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute("aria-selected", "true");
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = "";
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = "Remove item";
                            var removeButton = Object.assign(document.createElement("button"), (_d = {
                                type: "button",
                                className: button
                            }, _d[allowHTML ? "innerHTML" : "innerText"] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute("aria-label", "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = "";
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement("div"), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute("aria-multiselectable", "true");
                        div.setAttribute("role", "listbox");
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement("div"), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : "")
                        });
                        div.setAttribute("role", "group");
                        Object.assign(div.dataset, {
                            group: "",
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        div.appendChild(Object.assign(document.createElement("div"), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            id: elementId
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute("role", groupId && groupId > 0 ? "treeitem" : "option");
                        Object.assign(div.dataset, {
                            choice: "",
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = "";
                            div.setAttribute("aria-disabled", "true");
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = "";
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement("input"), {
                            type: "search",
                            name: "search_terms",
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: false
                        });
                        inp.setAttribute("role", "textbox");
                        inp.setAttribute("aria-autocomplete", "list");
                        inp.setAttribute("aria-label", placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement("div");
                        div.classList.add(list, listDropdown);
                        div.setAttribute("aria-expanded", "false");
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = "";
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === "no-choices") classes.push(noChoices);
                        else if (type === "no-results") classes.push(noResults);
                        return Object.assign(document.createElement("div"), (_b = {}, _b[allowHTML ? "innerHTML" : "innerText"] = innerText, _b.className = classes.join(" "), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === "object";
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === "function" ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error("first argument should be an array");
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == "string") return value;
                    let result = value + "";
                    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
                }
                function toString(value) {
                    return value == null ? "" : baseToString(value);
                }
                function isString(value) {
                    return typeof value === "string";
                }
                function isNumber(value) {
                    return typeof value === "number";
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
                }
                function isObject(value) {
                    return typeof value === "object";
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, "name")) throw new Error(MISSING_KEY_PROPERTY("name"));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, "weight")) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split(".");
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join(".") : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split(".") : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "exact";
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "prefix-exact";
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-prefix-exact";
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "suffix-exact";
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-suffix-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return "fuzzy";
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "include";
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = "|";
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: "$and",
                    OR: "$or"
                };
                const KeyType = {
                    PATH: "$path",
                    PATTERN: "$val"
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = "6.6.2";
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === "function" && Symbol.observable || "@@observable";
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split("").join(".");
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== "object" || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return "undefined";
                    if (val === null) return "null";
                    var type = typeof val;
                    switch(type){
                        case "boolean":
                        case "string":
                        case "number":
                        case "symbol":
                        case "function":
                            return type;
                    }
                    if (Array.isArray(val)) return "array";
                    if (isDate(val)) return "date";
                    if (isError(val)) return "error";
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case "Symbol":
                        case "Promise":
                        case "WeakMap":
                        case "WeakSet":
                        case "Map":
                        case "Set":
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
                }
                function ctorName(val) {
                    return typeof val.constructor === "function" ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== "undefined") {
                        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === "undefined") throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === "undefined") {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $28c15c8b5c5906e8$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${$28c15c8b5c5906e8$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener("resize", ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
});


var $d0178846fa869d5e$exports = {};
/** @type {import('tailwindcss').Config} */ $d0178846fa869d5e$exports = {
    /**
     * FD content
     * **/ // content: ["./src/**/*.{html,js}"],
    /**
     * SD content
     * **/ content: [
        "./app/modules/**/*.php",
        "./app/layout/**/*.php",
        "./app/modules/!panel/**",
        "./app/public/js/*.js"
    ],
    theme: {
        screens: {
            "xs": "360px",
            // => @media (min-width: 360px) { ... }
            "sm": "640px",
            // => @media (min-width: 640px) { ... }
            "md": "768px",
            // => @media (min-width: 768px) { ... }
            "lg": "1024px",
            // => @media (min-width: 1024px) { ... }
            "xl": "1280px",
            // => @media (min-width: 1280px) { ... }
            "2xl": "1536px",
            // => @media (min-width: 1536px) { ... }
            "3xl": "1800px"
        },
        extend: {
            colors: {
                transparent: "transparent",
                current: "currentColor"
            }
        }
    },
    plugins: []
};


function $5c2065aa5c493538$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 600,
        threshold: 0.5,
        delay: 0,
        easing: "ease",
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens;
    /* --- Merge all options --- */ const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += "ms";
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty("speed", speed, true);
    setGlobalProperty("easing", easing);
    // Setup of Intersection Observer
    const intesectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            // Show element
            if (entry.isIntersecting) entry.target.classList.add("animated");
            else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove("animated");
        });
    }, {
        threshold: 0,
        rootMargin: window.innerWidth >= 640 ? "0% 0% -10% 0%" : "0% 0% -5% 0%"
    });
    // Change animation of element on breakpoints
    function changeEffectOnResize(element, breakpoint, effect) {
        const initialEffect = element.dataset.view;
        let fixedBreakpoint = typeof breakpoint === "string" ? breakpoint.replace(/\D/g, "") : breakpoint;
        if (window.innerWidth >= fixedBreakpoint) element.dataset.view = effect;
        else element.dataset.view = initialEffect;
    }
    // Main function to observe element
    function intersectElement(element, isMutation = false) {
        element.classList.add("in-view");
        const dataset = element.dataset;
        // Set speed to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        // Set easing to current element
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        for(const key in dataset){
            const property = key.toLowerCase();
            let dataViewValue = property.match(/view(.*)/)[1].replace(/^-/, "");
            // Check if dataset value equal to breakpoint
            if (dataViewValue && dataViewValue in breakpoints) changeEffectOnResize(element, breakpoints[dataViewValue], dataset[key]);
        }
        if (!isMutation) window.addEventListener("load", ()=>{
            // Observe element with delay
            if (dataset.viewDelay) setTimeout(()=>intesectionObserver.observe(element), dataset.viewDelay);
            else intesectionObserver.observe(element);
        });
        else intesectionObserver.observe(element);
    }
    /* --- Intersect elements on init --- */ const targetElements = document.querySelectorAll("[data-view]");
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        // Callback function to handle the mutations
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                // Check if any added node has the desired class
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && "view" in target.dataset) intersectElement(target, true);
                });
            }
        };
        // Create a MutationObserver instance
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$5c2065aa5c493538$export$74b8f1741b4483c3();
const $5c2065aa5c493538$var$startViewAnimationArr = document.querySelectorAll(".start-view-animation");
if ($5c2065aa5c493538$var$startViewAnimationArr.length) for(let i = 0; i < $5c2065aa5c493538$var$startViewAnimationArr.length; i++)setTimeout(function() {
    $5c2065aa5c493538$var$startViewAnimationArr[i].classList.add("animated");
}, 50);


/**
 * Swiper 9.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 13, 2023
 */ /* eslint no-param-reassign: "off" */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $3081ebf44248f949$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $3081ebf44248f949$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($3081ebf44248f949$var$isObject(src[key]) && $3081ebf44248f949$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $3081ebf44248f949$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $3081ebf44248f949$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $3081ebf44248f949$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $3081ebf44248f949$export$8b58be045bf06082(doc, $3081ebf44248f949$export$3fdcb9b4d81368d8);
    return doc;
}
const $3081ebf44248f949$export$8582633f185c62bb = {
    document: $3081ebf44248f949$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $3081ebf44248f949$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $3081ebf44248f949$export$8b58be045bf06082(win, $3081ebf44248f949$export$8582633f185c62bb);
    return win;
}



function $82a8063a260ef37b$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $82a8063a260ef37b$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $82a8063a260ef37b$export$461939dd4422153() {
    return Date.now();
}
function $82a8063a260ef37b$export$3735103072e4a80(el) {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $82a8063a260ef37b$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $82a8063a260ef37b$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $82a8063a260ef37b$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $82a8063a260ef37b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $82a8063a260ef37b$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$82a8063a260ef37b$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($82a8063a260ef37b$export$a6cdc56e425d0d0a(to[nextKey]) && $82a8063a260ef37b$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $82a8063a260ef37b$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$82a8063a260ef37b$export$a6cdc56e425d0d0a(to[nextKey]) && $82a8063a260ef37b$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $82a8063a260ef37b$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $82a8063a260ef37b$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $82a8063a260ef37b$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $82a8063a260ef37b$export$616841b86f802685(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowEl && slideEl.shadowEl.querySelector(".swiper-slide-transform") || slideEl;
}
function $82a8063a260ef37b$export$dc9b7e8989189d9f(elements = [], selector = "") {
    const found = [];
    elements.forEach((el)=>{
        found.push(...el.querySelectorAll(selector));
    });
    return found;
}
function $82a8063a260ef37b$export$eb846d859f2895e6(element, selector = "") {
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $82a8063a260ef37b$export$c8a8987d4410bf2d(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : [
        classes
    ]);
    return el;
}
function $82a8063a260ef37b$export$d7820ec56f35bbaa(el) {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const document1 = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $82a8063a260ef37b$export$392b9fa9626e91e0(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $82a8063a260ef37b$export$b245807c30cf5df8(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $82a8063a260ef37b$export$4184470d4bd0f986(el, prop) {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $82a8063a260ef37b$export$371885c503a01623(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $82a8063a260ef37b$export$aedc7b608ca8e855(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $82a8063a260ef37b$export$6b974c5889da0bb5(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $82a8063a260ef37b$export$863f37913038cf77(el, size, includeMargins) {
    const window1 = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}



let $75d070a80991e766$var$support;
function $75d070a80991e766$var$calcSupport() {
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    return {
        smoothScroll: document.documentElement && document.documentElement.style && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch)
    };
}
function $75d070a80991e766$export$d61c7b85ff180578() {
    if (!$75d070a80991e766$var$support) $75d070a80991e766$var$support = $75d070a80991e766$var$calcSupport();
    return $75d070a80991e766$var$support;
}




let $bca2e0b0c1c9c1d6$var$deviceCached;
function $bca2e0b0c1c9c1d6$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $75d070a80991e766$export$d61c7b85ff180578)();
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $bca2e0b0c1c9c1d6$export$30c823bc834d6ab4(overrides = {}) {
    if (!$bca2e0b0c1c9c1d6$var$deviceCached) $bca2e0b0c1c9c1d6$var$deviceCached = $bca2e0b0c1c9c1d6$var$calcDevice(overrides);
    return $bca2e0b0c1c9c1d6$var$deviceCached;
}



let $eabf08b929c88d76$var$browser;
function $eabf08b929c88d76$var$calcBrowser() {
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $eabf08b929c88d76$export$89e15fc796a4a429() {
    if (!$eabf08b929c88d76$var$browser) $eabf08b929c88d76$var$browser = $eabf08b929c88d76$var$calcBrowser();
    return $eabf08b929c88d76$var$browser;
}



function $d68f0f612dfcbdee$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}




function $022d34378fb115cb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $82a8063a260ef37b$export$aedc7b608ca8e855)(swiper.el);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.el, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ var $016667baf1af41d7$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};



function $21b741789545d4af$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "padding-left") || 0, 10) - parseInt((0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "padding-top") || 0, 10) - parseInt((0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $7a345636eadbe9ce$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $82a8063a260ef37b$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $82a8063a260ef37b$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $82a8063a260ef37b$export$4184470d4bd0f986)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $82a8063a260ef37b$export$863f37913038cf77)(slide, "width", true) : (0, $82a8063a260ef37b$export$863f37913038cf77)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $82a8063a260ef37b$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $82a8063a260ef37b$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}


function $f38f21aece4a87ad$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}


function $485e40799ad6d616$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}


function $08e092212165bd93$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}


function $0abf7561e622bc3f$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}



function $b61a5bbe17fafc8c$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const getFilteredSlide = (selector)=>{
        return (0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        let nextSlide = (0, $82a8063a260ef37b$export$b245807c30cf5df8)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        let prevSlide = (0, $82a8063a260ef37b$export$392b9fa9626e91e0)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}


const $ab8e284d475a2d56$export$54749c0631f34ffc = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        const lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (lazyEl) lazyEl.remove();
    }
};
const $ab8e284d475a2d56$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $ab8e284d475a2d56$export$513ccb98c53b8039 = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $ab8e284d475a2d56$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $ab8e284d475a2d56$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $ab8e284d475a2d56$var$unlazy(swiper, i);
    }
};


function $b4e27fa7f6fdaf82$export$81ecffcda7ad6ebb(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $b4e27fa7f6fdaf82$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $b4e27fa7f6fdaf82$export$81ecffcda7ad6ebb(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) (0, $ab8e284d475a2d56$export$513ccb98c53b8039)(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}


function $145d8c18d866b24e$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = e.closest(`.${params.slideClass}, swiper-slide`);
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $ec6c5ba9d606b951$export$2e2bcd8739ae039 = {
    updateSize: $21b741789545d4af$export$2e2bcd8739ae039,
    updateSlides: $7a345636eadbe9ce$export$2e2bcd8739ae039,
    updateAutoHeight: $f38f21aece4a87ad$export$2e2bcd8739ae039,
    updateSlidesOffset: $485e40799ad6d616$export$2e2bcd8739ae039,
    updateSlidesProgress: $08e092212165bd93$export$2e2bcd8739ae039,
    updateProgress: $0abf7561e622bc3f$export$2e2bcd8739ae039,
    updateSlidesClasses: $b61a5bbe17fafc8c$export$2e2bcd8739ae039,
    updateActiveIndex: $b4e27fa7f6fdaf82$export$2e2bcd8739ae039,
    updateClickedSlide: $145d8c18d866b24e$export$2e2bcd8739ae039
};



function $dd6cb7ee25bf4f66$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $82a8063a260ef37b$export$5ec402b7fcf74398)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $2fc3224058677a1d$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $a0579ec2c5fa6977$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $993178d5f64aa627$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $dda8441c927e720d$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $82a8063a260ef37b$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $ac3776eb519e7a1b$export$2e2bcd8739ae039 = {
    getTranslate: $dd6cb7ee25bf4f66$export$2e2bcd8739ae039,
    setTranslate: $2fc3224058677a1d$export$2e2bcd8739ae039,
    minTranslate: $a0579ec2c5fa6977$export$2e2bcd8739ae039,
    maxTranslate: $993178d5f64aa627$export$2e2bcd8739ae039,
    translateTo: $dda8441c927e720d$export$2e2bcd8739ae039
};


function $685449b142fbb5f1$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.emit("setTransition", duration, byController);
}


function $b5a450b4388f4916$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $6697db0e334ee1d1$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $b5a450b4388f4916$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $7c193b77ade958cc$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $b5a450b4388f4916$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $b9ed435bb540c3f9$export$2e2bcd8739ae039 = {
    setTransition: $685449b142fbb5f1$export$2e2bcd8739ae039,
    transitionStart: $6697db0e334ee1d1$export$2e2bcd8739ae039,
    transitionEnd: $7c193b77ade958cc$export$2e2bcd8739ae039
};



function $28c3cf403a7556f3$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $82a8063a260ef37b$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $cb49429d81636bf4$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $06fc9ed5203ece58$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $915c479fd8512184$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $b74deee6b8dd73db$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $f9ce7c4e256fa6f9$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}



function $9ece5048cb38c310$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $b00edaa95e084380$export$2e2bcd8739ae039 = {
    slideTo: $28c3cf403a7556f3$export$2e2bcd8739ae039,
    slideToLoop: $cb49429d81636bf4$export$2e2bcd8739ae039,
    slideNext: $06fc9ed5203ece58$export$2e2bcd8739ae039,
    slidePrev: $915c479fd8512184$export$2e2bcd8739ae039,
    slideReset: $b74deee6b8dd73db$export$2e2bcd8739ae039,
    slideToClosest: $f9ce7c4e256fa6f9$export$2e2bcd8739ae039,
    slideToClickedSlide: $9ece5048cb38c310$export$2e2bcd8739ae039
};



function $d7dd7a0eeb24fb72$export$2e2bcd8739ae039(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const slides = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index)=>{
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}


function $f44582be0e74fd5e$export$2e2bcd8739ae039({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    let loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            appendSlidesIndexes.push(index);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                }
            } else if (setTranslate) swiper.slideToLoop(slideRealIndex, 0, false, true);
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            slideTo: false,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix(loopParams);
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix(loopParams);
    }
    swiper.emit("loopFix");
}


function $d1da8c4588472fe7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}


var $6c4c0a24e5cc713b$export$2e2bcd8739ae039 = {
    loopCreate: $d7dd7a0eeb24fb72$export$2e2bcd8739ae039,
    loopFix: $f44582be0e74fd5e$export$2e2bcd8739ae039,
    loopDestroy: $d1da8c4588472fe7$export$2e2bcd8739ae039
};


function $ebfd70447c993f20$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}


function $2c038cc5b5471e38$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}


var $dae0dd7d8df36b0c$export$2e2bcd8739ae039 = {
    setGrabCursor: $ebfd70447c993f20$export$2e2bcd8739ae039,
    unsetGrabCursor: $2c038cc5b5471e38$export$2e2bcd8739ae039
};





// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $798d11f374edb96b$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $3081ebf44248f949$export$f65ca476c09acec0)() || el === (0, $3081ebf44248f949$export$38b2d434cce3ea22)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $798d11f374edb96b$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const data = swiper.touchEventsData;
    data.evCache.push(event);
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $798d11f374edb96b$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) document.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}




function $06d2a53e92d3179b$export$2e2bcd8739ae039(event) {
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $4f17e1edb844e799$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === event.pointerId);
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave"
    ].includes(event.type)) {
        const proceed = event.type === "pointercancel" && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
    (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $6c9ebc1c512da9b8$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $7e84007fbc330b14$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $c339c1f668758d3a$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}



function $122d6e5be5e78c45$export$2e2bcd8739ae039(e) {
    const swiper = this;
    (0, $ab8e284d475a2d56$export$54749c0631f34ffc)(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}


let $d1a8b50cd0980d8d$var$dummyEventAttached = false;
function $d1a8b50cd0980d8d$var$dummyEventListener() {}
const $d1a8b50cd0980d8d$var$events = (swiper, method)=>{
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $6c9ebc1c512da9b8$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $6c9ebc1c512da9b8$export$2e2bcd8739ae039), true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $d1a8b50cd0980d8d$var$attachEvents() {
    const swiper = this;
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const { params: params } = swiper;
    swiper.onTouchStart = (0, $798d11f374edb96b$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $06d2a53e92d3179b$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $4f17e1edb844e799$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $c339c1f668758d3a$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $7e84007fbc330b14$export$2e2bcd8739ae039).bind(swiper);
    swiper.onLoad = (0, $122d6e5be5e78c45$export$2e2bcd8739ae039).bind(swiper);
    if (!$d1a8b50cd0980d8d$var$dummyEventAttached) {
        document.addEventListener("touchstart", $d1a8b50cd0980d8d$var$dummyEventListener);
        $d1a8b50cd0980d8d$var$dummyEventAttached = true;
    }
    $d1a8b50cd0980d8d$var$events(swiper, "on");
}
function $d1a8b50cd0980d8d$var$detachEvents() {
    const swiper = this;
    $d1a8b50cd0980d8d$var$events(swiper, "off");
}
var $d1a8b50cd0980d8d$export$2e2bcd8739ae039 = {
    attachEvents: $d1a8b50cd0980d8d$var$attachEvents,
    detachEvents: $d1a8b50cd0980d8d$var$detachEvents
};



const $4e1ab29ae1f97559$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $4e1ab29ae1f97559$export$2e2bcd8739ae039() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $4e1ab29ae1f97559$var$isGridEnabled(swiper, params);
    const isMultiRow = $4e1ab29ae1f97559$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $82a8063a260ef37b$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}



function $587c4e6bee3b65e3$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $1a9f2fa40098a537$export$2e2bcd8739ae039 = {
    setBreakpoint: $4e1ab29ae1f97559$export$2e2bcd8739ae039,
    getBreakpoint: $587c4e6bee3b65e3$export$2e2bcd8739ae039
};


function $8d44a566ba0eb3b7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $8d44a566ba0eb3b7$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $8d44a566ba0eb3b7$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}


function $096568edae71ff0e$export$2e2bcd8739ae039() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}


var $ed8f1eacfdff276f$export$2e2bcd8739ae039 = {
    addClasses: $8d44a566ba0eb3b7$export$2e2bcd8739ae039,
    removeClasses: $096568edae71ff0e$export$2e2bcd8739ae039
};


function $6d54261028552aef$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $6d54261028552aef$export$2e2bcd8739ae039 = {
    checkOverflow: $6d54261028552aef$var$checkOverflow
};


var $b19f28d03d1d33d8$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $d9400f1cf0d40b1b$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $82a8063a260ef37b$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $82a8063a260ef37b$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $82a8063a260ef37b$export$8b58be045bf06082)(allModulesParams, obj);
    };
}



const $6b419225685b7836$var$prototypes = {
    eventsEmitter: $016667baf1af41d7$export$2e2bcd8739ae039,
    update: $ec6c5ba9d606b951$export$2e2bcd8739ae039,
    translate: $ac3776eb519e7a1b$export$2e2bcd8739ae039,
    transition: $b9ed435bb540c3f9$export$2e2bcd8739ae039,
    slide: $b00edaa95e084380$export$2e2bcd8739ae039,
    loop: $6c4c0a24e5cc713b$export$2e2bcd8739ae039,
    grabCursor: $dae0dd7d8df36b0c$export$2e2bcd8739ae039,
    events: $d1a8b50cd0980d8d$export$2e2bcd8739ae039,
    breakpoints: $1a9f2fa40098a537$export$2e2bcd8739ae039,
    checkOverflow: $6d54261028552aef$export$2e2bcd8739ae039,
    classes: $ed8f1eacfdff276f$export$2e2bcd8739ae039
};
const $6b419225685b7836$var$extendedDefaults = {};
class $6b419225685b7836$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $6b419225685b7836$var$Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $75d070a80991e766$export$d61c7b85ff180578)();
        swiper.device = (0, $bca2e0b0c1c9c1d6$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $eabf08b929c88d76$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: (0, $d9400f1cf0d40b1b$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, (0, $b19f28d03d1d33d8$export$2e2bcd8739ae039), allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, swiperParams, $6b419225685b7836$var$extendedDefaults, params);
        swiper.originalParams = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $82a8063a260ef37b$export$8b58be045bf06082)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $82a8063a260ef37b$export$371885c503a01623)(slides[0]);
        return (0, $82a8063a260ef37b$export$371885c503a01623)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) (0, $ab8e284d475a2d56$export$54749c0631f34ffc)(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.shadowEl) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $82a8063a260ef37b$export$eb846d859f2895e6)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $82a8063a260ef37b$export$eb846d859f2895e6)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement ? el : wrapperEl,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $82a8063a260ef37b$export$4184470d4bd0f986)(el, "direction") === "rtl"),
            wrongRTL: (0, $82a8063a260ef37b$export$4184470d4bd0f986)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) (0, $ab8e284d475a2d56$export$54749c0631f34ffc)(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                (0, $ab8e284d475a2d56$export$54749c0631f34ffc)(swiper, e.target);
            });
        });
        (0, $ab8e284d475a2d56$export$513ccb98c53b8039)(swiper);
        // Init Flag
        swiper.initialized = true;
        (0, $ab8e284d475a2d56$export$513ccb98c53b8039)(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $82a8063a260ef37b$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $82a8063a260ef37b$export$8b58be045bf06082)($6b419225685b7836$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $6b419225685b7836$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $b19f28d03d1d33d8$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$6b419225685b7836$var$Swiper.prototype.__modules__) $6b419225685b7836$var$Swiper.prototype.__modules__ = [];
        const modules = $6b419225685b7836$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$6b419225685b7836$var$Swiper.installModule(m));
            return $6b419225685b7836$var$Swiper;
        }
        $6b419225685b7836$var$Swiper.installModule(module);
        return $6b419225685b7836$var$Swiper;
    }
}
Object.keys($6b419225685b7836$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($6b419225685b7836$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $6b419225685b7836$var$Swiper.prototype[protoMethod] = $6b419225685b7836$var$prototypes[prototypeGroup][protoMethod];
    });
});
$6b419225685b7836$var$Swiper.use([
    (0, $d68f0f612dfcbdee$export$2e2bcd8739ae039),
    (0, $022d34378fb115cb$export$2e2bcd8739ae039)
]);
var $6b419225685b7836$export$2e2bcd8739ae039 = $6b419225685b7836$var$Swiper;




function $cf6783ccb31231a9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("swiper-slide");
        else slideEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slidesEl.querySelectorAll(`.${swiper.params.slideClass}, swiper-slide`).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slidesEl.querySelectorAll(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $82a8063a260ef37b$export$eb846d859f2895e6)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $82a8063a260ef37b$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 

function $6f206c250cee72b6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $82a8063a260ef37b$export$aedc7b608ca8e855)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $82a8063a260ef37b$export$aedc7b608ca8e855)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $82a8063a260ef37b$export$d7820ec56f35bbaa)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 

function $9474755bef426fce$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $82a8063a260ef37b$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $82a8063a260ef37b$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $82a8063a260ef37b$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $82a8063a260ef37b$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $0d558c5155422ac7$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}


function $0c7a5e05c02656c6$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    const makeElementsArray = (el)=>{
        if (!Array.isArray(el)) el = [
            el
        ].filter((e)=>!!e);
        return el;
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.shadowRoot.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $0d558c5155422ac7$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList[swiper.enabled ? "remove" : "add"](swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $adcc3970e8cd7281$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $300742dc018452cb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    const makeElementsArray = (el)=>{
        if (!Array.isArray(el)) el = [
            el
        ].filter((e)=>!!e);
        return el;
    };
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $82a8063a260ef37b$export$371885c503a01623)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const newSlideIndex = swiper.getSlideIndexByData(index);
            const currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
            if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) swiper.loopFix({
                direction: newSlideIndex > currentSlideIndex ? "next" : "prev",
                activeSlideIndex: newSlideIndex,
                slideTo: false
            });
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $82a8063a260ef37b$export$863f37913038cf77)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $82a8063a260ef37b$export$371885c503a01623)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $0d558c5155422ac7$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $82a8063a260ef37b$export$aedc7b608ca8e855)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(params.clickableClass);
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) subEl.removeEventListener("click", onBulletClick);
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        let { el: el } = swiper.pagination;
        if (!Array.isArray(el)) el = [
            el
        ].filter((element)=>!!element);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}





function $11b79c66c61ad46f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $82a8063a260ef37b$export$d7820ec56f35bbaa)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $0d558c5155422ac7$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = document.querySelectorAll(params.el);
        else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector(`.${swiper.params.scrollbar.dragClass}`);
            if (!dragEl) {
                dragEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $442f32660508e567$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        (0, $82a8063a260ef37b$export$eb846d859f2895e6)(el, "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el } = swiper;
        el.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $ead6da17b3df0051$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.el.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $82a8063a260ef37b$export$aedc7b608ca8e855)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, $82a8063a260ef37b$export$5ec402b7fcf74398)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $82a8063a260ef37b$export$5ec402b7fcf74398)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $82a8063a260ef37b$export$aedc7b608ca8e855)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $82a8063a260ef37b$export$d7820ec56f35bbaa)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $82a8063a260ef37b$export$d7820ec56f35bbaa)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $82a8063a260ef37b$export$eb846d859f2895e6)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $82a8063a260ef37b$export$aedc7b608ca8e855)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $a7208bd30ac6f6d9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $82a8063a260ef37b$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                (0, $82a8063a260ef37b$export$6b974c5889da0bb5)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $630f1dc87ffb06a9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    const makeElementsArray = (el)=>{
        if (!Array.isArray(el)) el = [
            el
        ].filter((e)=>!!e);
        return el;
    };
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $82a8063a260ef37b$export$371885c503a01623)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $adcc3970e8cd7281$export$2e2bcd8739ae039)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        if (swiper.isElement) swiper.el.shadowEl.append(liveRegion);
        else swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $d9ee4e99234fbe89$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $20fe67370fe84a2f$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
    const window = (0, $3081ebf44248f949$export$38b2d434cce3ea22)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $82a8063a260ef37b$export$eb846d859f2895e6)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
function $a22c4587aa5a240b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime;
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            autoplayStartTime = new Date().getTime();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $fdc9900393aaa8d8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $82a8063a260ef37b$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $82a8063a260ef37b$export$eb846d859f2895e6)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $3081ebf44248f949$export$f65ca476c09acec0)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $3e27cefe89536367$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $82a8063a260ef37b$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $82a8063a260ef37b$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $82a8063a260ef37b$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $82a8063a260ef37b$export$6b974c5889da0bb5)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $82a8063a260ef37b$export$6b974c5889da0bb5)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $82a8063a260ef37b$export$6b974c5889da0bb5)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $682fde4457878069$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style[getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $4419cd1ec8e80c86$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}


function $acdd0fee041891b3$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $4fcf39853410758e$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $b9368afa717263d3$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $bee5d4103b96e6b6$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $660e2fa3c9c4b380$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $4419cd1ec8e80c86$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $acdd0fee041891b3$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $4fcf39853410758e$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $b9368afa717263d3$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $bee5d4103b96e6b6$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $8c3dbf418c0f4c13$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $cc160fa388ffa377$export$2e2bcd8739ae039(effectParams, slideEl) {
    const transformEl = (0, $82a8063a260ef37b$export$616841b86f802685)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $2dcd51b64795ddca$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowEl && slideEl.shadowEl === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $82a8063a260ef37b$export$6b974c5889da0bb5)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $3f55e670ecf070db$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $cc160fa388ffa377$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $82a8063a260ef37b$export$616841b86f802685)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $2dcd51b64795ddca$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $5bd3da05d9d2eceb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", `swiper-slide-shadow-${isHorizontal ? "left" : "top"}`);
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", `swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`);
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.slidesEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    swiper.slidesEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $7e5a2fb1eba6541b$export$2e2bcd8739ae039(params, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const shadowContainer = (0, $82a8063a260ef37b$export$616841b86f802685)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass}`);
    if (!shadowEl) {
        shadowEl = (0, $82a8063a260ef37b$export$c8a8987d4410bf2d)("div", `swiper-slide-shadow${side ? `-${side}` : ""}`);
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $0cb9fddc8eae23ec$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, $cc160fa388ffa377$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $82a8063a260ef37b$export$616841b86f802685)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $2dcd51b64795ddca$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $b34d0273727a7beb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, $cc160fa388ffa377$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $82a8063a260ef37b$export$616841b86f802685)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $9874f3145d5b393b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $cc160fa388ffa377$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $82a8063a260ef37b$export$616841b86f802685)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $2dcd51b64795ddca$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $594dcc85c83c1536$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $7e5a2fb1eba6541b$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $cc160fa388ffa377$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $82a8063a260ef37b$export$616841b86f802685)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $2dcd51b64795ddca$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $8c3dbf418c0f4c13$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.85
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


const $0b515b836d29f568$export$f16e6af5a274aa5b = (breakpoint, swiperClass, swiperSettings, startOnView)=>{
    let swiper;
    breakpoint = window.matchMedia(breakpoint);
    const initSwiper = function(className, settings) {
        swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(className, settings);
        if (startOnView) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    };
    const checker = function() {
        if (breakpoint.matches) return initSwiper(swiperClass, swiperSettings);
        else {
            if (swiper !== undefined) swiper.destroy(true, true);
            return;
        }
    };
    breakpoint.addEventListener("change", checker);
    checker();
}; /* Usage *?
import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperOnResize } from '../utils/swiperOnResize.js';

let newsSwiperWr = document.querySelectorAll('.news-swiper-wr');
newsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');


    swiperOnResize('(max-width: 992px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 'auto',
          spaceBetween: 8,
          speed: 800,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );
  }
});
*/ 


const $6ad400af65f406ec$var$headerComponent = document.getElementsByClassName("header")[0];
const $6ad400af65f406ec$var$scrollContainer = ()=>document.documentElement || document.body;
const $6ad400af65f406ec$var$burgerInitiallyBlack = document.querySelector(".burger.burger-black") !== null;
document.addEventListener("scroll", ()=>{
    if ($6ad400af65f406ec$var$scrollContainer().scrollTop > 200) $6ad400af65f406ec$var$headerComponent.classList.add("scrolled");
    else if ($6ad400af65f406ec$var$scrollContainer().scrollTop == 0) $6ad400af65f406ec$var$headerComponent.classList.remove("scrolled");
});
const $6ad400af65f406ec$var$mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--mobile-menu-start-point"));
let $6ad400af65f406ec$var$isMobileMenuEnable = window.outerWidth <= $6ad400af65f406ec$var$mobileMenuStartPoint || document.querySelector(".header-mobile");
const $6ad400af65f406ec$var$dropdownToggle = document.querySelectorAll(".dropdown-toggle");
$6ad400af65f406ec$var$dropdownToggle.forEach((toggle)=>{
    toggle.addEventListener("click", function(e) {
        if ($6ad400af65f406ec$var$isMobileMenuEnable) {
            const menuItem = this.closest(".menu-item.dropdown");
            const dropdownMenu = this.nextElementSibling;
            const activeDropdowns = document.querySelectorAll(".menu-item.dropdown.active .dropdown-menu");
            activeDropdowns.forEach((menu)=>{
                menu.style.display = "none";
                menu.closest(".dropdown").classList.remove("active");
            });
            menuItem.classList.toggle("active");
            if (menuItem.classList.contains("active")) {
                e.preventDefault();
                dropdownMenu.style.display = "block";
            }
        }
    });
});
function $6ad400af65f406ec$var$menuToggleFunc() {
    const menuToggle = document.querySelector(".menu-toggle");
    const navbarNav = document.querySelector(".navbar-nav");
    const headerCloseWrapper = document.querySelector(".header-close-wrapper");
    const burger = document.querySelector(".burger");
    const navbarBtn = document.querySelector(".navbar-btn");
    const headerBlack = document.querySelector(".header-black");
    menuToggle.classList.toggle("active");
    navbarNav.classList.toggle("active");
    headerCloseWrapper.classList.toggle("active");
    $6ad400af65f406ec$var$headerComponent.classList.toggle("open-menu");
    // if (navbarBtn) {
    //   if (menuToggle.classList.contains('active')) {
    //     navbarBtn.style.display = 'none';
    //   } else {
    //     navbarBtn.style.display = '';
    //   }
    // }
    if (burger && $6ad400af65f406ec$var$burgerInitiallyBlack) burger.classList.toggle("burger-black");
    if (headerBlack) {
        const paths = headerBlack.querySelectorAll("path");
        paths.forEach((path)=>{
            if (menuToggle.classList.contains("active")) path.style.fill = "var(--cl-white)";
            else path.style.removeProperty("fill");
        });
    }
    if (scrollLock.getScrollState()) {
        scrollLock.disablePageScroll(document.querySelector(".navbar-nav .menu"));
        scrollLock.addScrollableSelector(".simplebar-content-wrapper");
    } else scrollLock.enablePageScroll();
}
function $6ad400af65f406ec$var$updateMenu() {
    $6ad400af65f406ec$var$isMobileMenuEnable = window.outerWidth <= $6ad400af65f406ec$var$mobileMenuStartPoint || document.querySelector(".mobile-header");
    if (!$6ad400af65f406ec$var$isMobileMenuEnable) {
        const dropdownMenus = document.querySelectorAll(".dropdown-menu");
        dropdownMenus.forEach((menu)=>{
            menu.style.display = "";
        });
        const headerCloseWrapper = document.querySelector(".header-close-wrapper");
        headerCloseWrapper.classList.remove("active");
        const activeMenuItems = document.querySelectorAll(".menu-item.active");
        activeMenuItems.forEach((item)=>{
            item.classList.remove("active");
        });
        const navbarNav = document.querySelector(".navbar-nav");
        navbarNav.classList.remove("active");
        const menuToggle = document.querySelector(".menu-toggle");
        menuToggle.classList.remove("active");
        const burger = document.querySelector(".burger");
        if (burger && $6ad400af65f406ec$var$burgerInitiallyBlack) burger.classList.add("burger-black");
        scrollLock.enablePageScroll();
    }
}
window.addEventListener("resize", $6ad400af65f406ec$var$updateMenu);
window.addEventListener("orientationchange", $6ad400af65f406ec$var$updateMenu);
const $6ad400af65f406ec$var$menuToggle = document.querySelector(".menu-toggle");
const $6ad400af65f406ec$var$headerCloseWrapper = document.querySelector(".header-close-wrapper");
$6ad400af65f406ec$var$menuToggle.addEventListener("click", $6ad400af65f406ec$var$menuToggleFunc);
$6ad400af65f406ec$var$headerCloseWrapper.addEventListener("click", $6ad400af65f406ec$var$menuToggleFunc);
function $6ad400af65f406ec$var$headerSticky() {
    let prevScrollPos = window.pageYOffset;
    window.addEventListener("scroll", ()=>{
        const currentScrollPos = window.pageYOffset;
        const headerHeight = $6ad400af65f406ec$var$headerComponent.scrollHeight;
        if (window.scrollY > 0) {
            if (prevScrollPos > currentScrollPos) {
                $6ad400af65f406ec$var$headerComponent.style.top = 0;
                $6ad400af65f406ec$var$headerComponent.classList.add("scrolled");
            } else $6ad400af65f406ec$var$headerComponent.style.top = `-${headerHeight + 3}px`;
        }
        if (window.scrollY === 0) {
            $6ad400af65f406ec$var$headerComponent.classList.remove("scrolled");
            $6ad400af65f406ec$var$headerComponent.style.top = 0;
        }
        prevScrollPos = currentScrollPos;
    });
    if (window.scrollY !== 0) $6ad400af65f406ec$var$headerComponent.classList.add("scrolled");
}
$6ad400af65f406ec$var$headerSticky();


var $c63fa967237543b8$exports = {};
(function(f) {
    var g;
    $c63fa967237543b8$exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
                /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
                var hasOwnProperty = Object.prototype.hasOwnProperty;
                var propIsEnumerable = Object.prototype.propertyIsEnumerable;
                function toObject(val) {
                    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(val);
                }
                function shouldUseNative() {
                    try {
                        if (!Object.assign) return false;
                        // Detect buggy property enumeration order in older V8 versions.
                        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                        test1[5] = "de";
                        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test2 = {};
                        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
                        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                            return test2[n];
                        });
                        if (order2.join("") !== "0123456789") return false;
                        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                        var test3 = {};
                        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                            test3[letter] = letter;
                        });
                        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
                        return true;
                    } catch (err) {
                        // We don't expect any of the above to throw, but better to be safe.
                        return false;
                    }
                }
                module1.exports = shouldUseNative() ? Object.assign : function(target, source) {
                    var from;
                    var to = toObject(target);
                    var symbols;
                    for(var s = 1; s < arguments.length; s++){
                        from = Object(arguments[s]);
                        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
                        if (getOwnPropertySymbols) {
                            symbols = getOwnPropertySymbols(from);
                            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
                        }
                    }
                    return to;
                };
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                (function(process) {
                    // Generated by CoffeeScript 1.12.2
                    (function() {
                        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
                        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
                            return performance.now();
                        };
                        else if (typeof process !== "undefined" && process !== null && process.hrtime) {
                            module1.exports = function() {
                                return (getNanoSeconds() - nodeLoadTime) / 1e6;
                            };
                            hrtime = process.hrtime;
                            getNanoSeconds = function() {
                                var hr;
                                hr = hrtime();
                                return hr[0] * 1e9 + hr[1];
                            };
                            moduleLoadTime = getNanoSeconds();
                            upTime = process.uptime() * 1e9;
                            nodeLoadTime = moduleLoadTime - upTime;
                        } else if (Date.now) {
                            module1.exports = function() {
                                return Date.now() - loadTime;
                            };
                            loadTime = Date.now();
                        } else {
                            module1.exports = function() {
                                return new Date().getTime() - loadTime;
                            };
                            loadTime = new Date().getTime();
                        }
                    }).call(this);
                }).call(this, require1("_process"));
            },
            {
                "_process": 3
            }
        ],
        3: [
            function(require1, module1, exports) {
                // shim for using process in browser
                var process = module1.exports = {};
                // cached from whatever global is present so that test runners that stub it
                // don't break things.  But we need to wrap it in a try catch in case it is
                // wrapped in strict mode code which doesn't define any globals.  It's inside a
                // function because try/catches deoptimize in certain engines.
                var cachedSetTimeout;
                var cachedClearTimeout;
                function defaultSetTimout() {
                    throw new Error("setTimeout has not been defined");
                }
                function defaultClearTimeout() {
                    throw new Error("clearTimeout has not been defined");
                }
                (function() {
                    try {
                        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
                        else cachedSetTimeout = defaultSetTimout;
                    } catch (e) {
                        cachedSetTimeout = defaultSetTimout;
                    }
                    try {
                        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
                        else cachedClearTimeout = defaultClearTimeout;
                    } catch (e) {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                })();
                function runTimeout(fun) {
                    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                    // if setTimeout wasn't available but was latter defined
                    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                        cachedSetTimeout = setTimeout;
                        return setTimeout(fun, 0);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedSetTimeout(fun, 0);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                            return cachedSetTimeout.call(null, fun, 0);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                            return cachedSetTimeout.call(this, fun, 0);
                        }
                    }
                }
                function runClearTimeout(marker) {
                    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
                    return clearTimeout(marker);
                    // if clearTimeout wasn't available but was latter defined
                    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                        cachedClearTimeout = clearTimeout;
                        return clearTimeout(marker);
                    }
                    try {
                        // when when somebody has screwed with setTimeout but no I.E. maddness
                        return cachedClearTimeout(marker);
                    } catch (e) {
                        try {
                            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                            return cachedClearTimeout.call(null, marker);
                        } catch (e) {
                            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                            return cachedClearTimeout.call(this, marker);
                        }
                    }
                }
                var queue = [];
                var draining = false;
                var currentQueue;
                var queueIndex = -1;
                function cleanUpNextTick() {
                    if (!draining || !currentQueue) return;
                    draining = false;
                    if (currentQueue.length) queue = currentQueue.concat(queue);
                    else queueIndex = -1;
                    if (queue.length) drainQueue();
                }
                function drainQueue() {
                    if (draining) return;
                    var timeout = runTimeout(cleanUpNextTick);
                    draining = true;
                    var len = queue.length;
                    while(len){
                        currentQueue = queue;
                        queue = [];
                        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
                        queueIndex = -1;
                        len = queue.length;
                    }
                    currentQueue = null;
                    draining = false;
                    runClearTimeout(timeout);
                }
                process.nextTick = function(fun) {
                    var args = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
                    queue.push(new Item(fun, args));
                    if (queue.length === 1 && !draining) runTimeout(drainQueue);
                };
                // v8 likes predictible objects
                function Item(fun, array) {
                    this.fun = fun;
                    this.array = array;
                }
                Item.prototype.run = function() {
                    this.fun.apply(null, this.array);
                };
                process.title = "browser";
                process.browser = true;
                process.env = {};
                process.argv = [];
                process.version = ""; // empty string to avoid regexp issues
                process.versions = {};
                function noop() {}
                process.on = noop;
                process.addListener = noop;
                process.once = noop;
                process.off = noop;
                process.removeListener = noop;
                process.removeAllListeners = noop;
                process.emit = noop;
                process.prependListener = noop;
                process.prependOnceListener = noop;
                process.listeners = function(name) {
                    return [];
                };
                process.binding = function(name) {
                    throw new Error("process.binding is not supported");
                };
                process.cwd = function() {
                    return "/";
                };
                process.chdir = function(dir) {
                    throw new Error("process.chdir is not supported");
                };
                process.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                (function(global1) {
                    var now = require1("performance-now"), root = typeof window === "undefined" ? global1 : window, vendors = [
                        "moz",
                        "webkit"
                    ], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
                    for(var i = 0; !raf && i < vendors.length; i++){
                        raf = root[vendors[i] + "Request" + suffix];
                        caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
                    }
                    // Some versions of FF have rAF but not cAF
                    if (!raf || !caf) {
                        var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
                        raf = function(callback) {
                            if (queue.length === 0) {
                                var _now = now(), next = Math.max(0, frameDuration - (_now - last));
                                last = next + _now;
                                setTimeout(function() {
                                    var cp = queue.slice(0);
                                    // Clear queue here to prevent
                                    // callbacks from appending listeners
                                    // to the current frame's queue
                                    queue.length = 0;
                                    for(var i = 0; i < cp.length; i++){
                                        if (!cp[i].cancelled) try {
                                            cp[i].callback(last);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw e;
                                            }, 0);
                                        }
                                    }
                                }, Math.round(next));
                            }
                            queue.push({
                                handle: ++id,
                                callback: callback,
                                cancelled: false
                            });
                            return id;
                        };
                        caf = function(handle) {
                            for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
                        };
                    }
                    module1.exports = function(fn) {
                        // Wrap in a new function to prevent
                        // `cancel` potentially being assigned
                        // to the native rAF function
                        return raf.call(root, fn);
                    };
                    module1.exports.cancel = function() {
                        caf.apply(root, arguments);
                    };
                    module1.exports.polyfill = function() {
                        root.requestAnimationFrame = raf;
                        root.cancelAnimationFrame = caf;
                    };
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "performance-now": 2
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /**
* Parallax.js
* @author Matthew Wagerfield - @wagerfield, René Roth - mail@reneroth.org
* @description Creates a parallax effect between an array of layers,
*              driving the motion from the gyroscope output of a smartdevice.
*              If no gyroscope is available, the cursor position is used.
*/ var rqAnFr = require1("raf");
                var objectAssign = require1("object-assign");
                var helpers = {
                    propertyCache: {},
                    vendors: [
                        null,
                        [
                            "-webkit-",
                            "webkit"
                        ],
                        [
                            "-moz-",
                            "Moz"
                        ],
                        [
                            "-o-",
                            "O"
                        ],
                        [
                            "-ms-",
                            "ms"
                        ]
                    ],
                    clamp: function clamp(value, min, max) {
                        return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
                    },
                    data: function data(element, name) {
                        return helpers.deserialize(element.getAttribute("data-" + name));
                    },
                    deserialize: function deserialize(value) {
                        if (value === "true") return true;
                        else if (value === "false") return false;
                        else if (value === "null") return null;
                        else if (!isNaN(parseFloat(value)) && isFinite(value)) return parseFloat(value);
                        else return value;
                    },
                    camelCase: function camelCase(value) {
                        return value.replace(/-+(.)?/g, function(match, character) {
                            return character ? character.toUpperCase() : "";
                        });
                    },
                    accelerate: function accelerate(element) {
                        helpers.css(element, "transform", "translate3d(0,0,0) rotate(0.0001deg)");
                        helpers.css(element, "transform-style", "preserve-3d");
                        helpers.css(element, "backface-visibility", "hidden");
                    },
                    transformSupport: function transformSupport(value) {
                        var element = document.createElement("div"), propertySupport = false, propertyValue = null, featureSupport = false, cssProperty = null, jsProperty = null;
                        for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) {
                                cssProperty = helpers.vendors[i][0] + "transform";
                                jsProperty = helpers.vendors[i][1] + "Transform";
                            } else {
                                cssProperty = "transform";
                                jsProperty = "transform";
                            }
                            if (element.style[jsProperty] !== undefined) {
                                propertySupport = true;
                                break;
                            }
                        }
                        switch(value){
                            case "2D":
                                featureSupport = propertySupport;
                                break;
                            case "3D":
                                if (propertySupport) {
                                    var body = document.body || document.createElement("body"), documentElement = document.documentElement, documentOverflow = documentElement.style.overflow, isCreatedBody = false;
                                    if (!document.body) {
                                        isCreatedBody = true;
                                        documentElement.style.overflow = "hidden";
                                        documentElement.appendChild(body);
                                        body.style.overflow = "hidden";
                                        body.style.background = "";
                                    }
                                    body.appendChild(element);
                                    element.style[jsProperty] = "translate3d(1px,1px,1px)";
                                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
                                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== "none";
                                    documentElement.style.overflow = documentOverflow;
                                    body.removeChild(element);
                                    if (isCreatedBody) {
                                        body.removeAttribute("style");
                                        body.parentNode.removeChild(body);
                                    }
                                }
                                break;
                        }
                        return featureSupport;
                    },
                    css: function css(element, property, value) {
                        var jsProperty = helpers.propertyCache[property];
                        if (!jsProperty) for(var i = 0, l = helpers.vendors.length; i < l; i++){
                            if (helpers.vendors[i] !== null) jsProperty = helpers.camelCase(helpers.vendors[i][1] + "-" + property);
                            else jsProperty = property;
                            if (element.style[jsProperty] !== undefined) {
                                helpers.propertyCache[property] = jsProperty;
                                break;
                            }
                        }
                        element.style[jsProperty] = value;
                    }
                };
                var MAGIC_NUMBER = 30, DEFAULTS = {
                    relativeInput: false,
                    clipRelativeInput: false,
                    inputElement: null,
                    hoverOnly: false,
                    calibrationThreshold: 100,
                    calibrationDelay: 500,
                    supportDelay: 500,
                    calibrateX: false,
                    calibrateY: true,
                    invertX: true,
                    invertY: true,
                    limitX: false,
                    limitY: false,
                    scalarX: 10.0,
                    scalarY: 10.0,
                    frictionX: 0.1,
                    frictionY: 0.1,
                    originX: 0.5,
                    originY: 0.5,
                    pointerEvents: false,
                    precision: 1,
                    onReady: null,
                    selector: null
                };
                var Parallax = function() {
                    function Parallax(element, options) {
                        _classCallCheck(this, Parallax);
                        this.element = element;
                        var data = {
                            calibrateX: helpers.data(this.element, "calibrate-x"),
                            calibrateY: helpers.data(this.element, "calibrate-y"),
                            invertX: helpers.data(this.element, "invert-x"),
                            invertY: helpers.data(this.element, "invert-y"),
                            limitX: helpers.data(this.element, "limit-x"),
                            limitY: helpers.data(this.element, "limit-y"),
                            scalarX: helpers.data(this.element, "scalar-x"),
                            scalarY: helpers.data(this.element, "scalar-y"),
                            frictionX: helpers.data(this.element, "friction-x"),
                            frictionY: helpers.data(this.element, "friction-y"),
                            originX: helpers.data(this.element, "origin-x"),
                            originY: helpers.data(this.element, "origin-y"),
                            pointerEvents: helpers.data(this.element, "pointer-events"),
                            precision: helpers.data(this.element, "precision"),
                            relativeInput: helpers.data(this.element, "relative-input"),
                            clipRelativeInput: helpers.data(this.element, "clip-relative-input"),
                            hoverOnly: helpers.data(this.element, "hover-only"),
                            inputElement: document.querySelector(helpers.data(this.element, "input-element")),
                            selector: helpers.data(this.element, "selector")
                        };
                        for(var key in data)if (data[key] === null) delete data[key];
                        objectAssign(this, DEFAULTS, data, options);
                        if (!this.inputElement) this.inputElement = this.element;
                        this.calibrationTimer = null;
                        this.calibrationFlag = true;
                        this.enabled = false;
                        this.depthsX = [];
                        this.depthsY = [];
                        this.raf = null;
                        this.bounds = null;
                        this.elementPositionX = 0;
                        this.elementPositionY = 0;
                        this.elementWidth = 0;
                        this.elementHeight = 0;
                        this.elementCenterX = 0;
                        this.elementCenterY = 0;
                        this.elementRangeX = 0;
                        this.elementRangeY = 0;
                        this.calibrationX = 0;
                        this.calibrationY = 0;
                        this.inputX = 0;
                        this.inputY = 0;
                        this.motionX = 0;
                        this.motionY = 0;
                        this.velocityX = 0;
                        this.velocityY = 0;
                        this.onMouseMove = this.onMouseMove.bind(this);
                        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
                        this.onDeviceMotion = this.onDeviceMotion.bind(this);
                        this.onOrientationTimer = this.onOrientationTimer.bind(this);
                        this.onMotionTimer = this.onMotionTimer.bind(this);
                        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
                        this.onAnimationFrame = this.onAnimationFrame.bind(this);
                        this.onWindowResize = this.onWindowResize.bind(this);
                        this.windowWidth = null;
                        this.windowHeight = null;
                        this.windowCenterX = null;
                        this.windowCenterY = null;
                        this.windowRadiusX = null;
                        this.windowRadiusY = null;
                        this.portrait = false;
                        this.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
                        this.motionSupport = !!window.DeviceMotionEvent && !this.desktop;
                        this.orientationSupport = !!window.DeviceOrientationEvent && !this.desktop;
                        this.orientationStatus = 0;
                        this.motionStatus = 0;
                        this.initialise();
                    }
                    _createClass(Parallax, [
                        {
                            key: "initialise",
                            value: function initialise() {
                                if (this.transform2DSupport === undefined) {
                                    this.transform2DSupport = helpers.transformSupport("2D");
                                    this.transform3DSupport = helpers.transformSupport("3D");
                                }
                                // Configure Context Styles
                                if (this.transform3DSupport) helpers.accelerate(this.element);
                                var style = window.getComputedStyle(this.element);
                                if (style.getPropertyValue("position") === "static") this.element.style.position = "relative";
                                // Pointer events
                                if (!this.pointerEvents) this.element.style.pointerEvents = "none";
                                // Setup
                                this.updateLayers();
                                this.updateDimensions();
                                this.enable();
                                this.queueCalibration(this.calibrationDelay);
                            }
                        },
                        {
                            key: "doReadyCallback",
                            value: function doReadyCallback() {
                                if (this.onReady) this.onReady();
                            }
                        },
                        {
                            key: "updateLayers",
                            value: function updateLayers() {
                                if (this.selector) this.layers = this.element.querySelectorAll(this.selector);
                                else this.layers = this.element.children;
                                if (!this.layers.length) console.warn("ParallaxJS: Your scene does not have any layers.");
                                this.depthsX = [];
                                this.depthsY = [];
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index];
                                    if (this.transform3DSupport) helpers.accelerate(layer);
                                    layer.style.position = index ? "absolute" : "relative";
                                    layer.style.display = "block";
                                    layer.style.left = 0;
                                    layer.style.top = 0;
                                    var depth = helpers.data(layer, "depth") || 0;
                                    this.depthsX.push(helpers.data(layer, "depth-x") || depth);
                                    this.depthsY.push(helpers.data(layer, "depth-y") || depth);
                                }
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions() {
                                this.windowWidth = window.innerWidth;
                                this.windowHeight = window.innerHeight;
                                this.windowCenterX = this.windowWidth * this.originX;
                                this.windowCenterY = this.windowHeight * this.originY;
                                this.windowRadiusX = Math.max(this.windowCenterX, this.windowWidth - this.windowCenterX);
                                this.windowRadiusY = Math.max(this.windowCenterY, this.windowHeight - this.windowCenterY);
                            }
                        },
                        {
                            key: "updateBounds",
                            value: function updateBounds() {
                                this.bounds = this.inputElement.getBoundingClientRect();
                                this.elementPositionX = this.bounds.left;
                                this.elementPositionY = this.bounds.top;
                                this.elementWidth = this.bounds.width;
                                this.elementHeight = this.bounds.height;
                                this.elementCenterX = this.elementWidth * this.originX;
                                this.elementCenterY = this.elementHeight * this.originY;
                                this.elementRangeX = Math.max(this.elementCenterX, this.elementWidth - this.elementCenterX);
                                this.elementRangeY = Math.max(this.elementCenterY, this.elementHeight - this.elementCenterY);
                            }
                        },
                        {
                            key: "queueCalibration",
                            value: function queueCalibration(delay) {
                                clearTimeout(this.calibrationTimer);
                                this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
                            }
                        },
                        {
                            key: "enable",
                            value: function enable() {
                                if (this.enabled) return;
                                this.enabled = true;
                                if (this.orientationSupport) {
                                    this.portrait = false;
                                    window.addEventListener("deviceorientation", this.onDeviceOrientation);
                                    this.detectionTimer = setTimeout(this.onOrientationTimer, this.supportDelay);
                                } else if (this.motionSupport) {
                                    this.portrait = false;
                                    window.addEventListener("devicemotion", this.onDeviceMotion);
                                    this.detectionTimer = setTimeout(this.onMotionTimer, this.supportDelay);
                                } else {
                                    this.calibrationX = 0;
                                    this.calibrationY = 0;
                                    this.portrait = false;
                                    window.addEventListener("mousemove", this.onMouseMove);
                                    this.doReadyCallback();
                                }
                                window.addEventListener("resize", this.onWindowResize);
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "disable",
                            value: function disable() {
                                if (!this.enabled) return;
                                this.enabled = false;
                                if (this.orientationSupport) window.removeEventListener("deviceorientation", this.onDeviceOrientation);
                                else if (this.motionSupport) window.removeEventListener("devicemotion", this.onDeviceMotion);
                                else window.removeEventListener("mousemove", this.onMouseMove);
                                window.removeEventListener("resize", this.onWindowResize);
                                rqAnFr.cancel(this.raf);
                            }
                        },
                        {
                            key: "calibrate",
                            value: function calibrate(x, y) {
                                this.calibrateX = x === undefined ? this.calibrateX : x;
                                this.calibrateY = y === undefined ? this.calibrateY : y;
                            }
                        },
                        {
                            key: "invert",
                            value: function invert(x, y) {
                                this.invertX = x === undefined ? this.invertX : x;
                                this.invertY = y === undefined ? this.invertY : y;
                            }
                        },
                        {
                            key: "friction",
                            value: function friction(x, y) {
                                this.frictionX = x === undefined ? this.frictionX : x;
                                this.frictionY = y === undefined ? this.frictionY : y;
                            }
                        },
                        {
                            key: "scalar",
                            value: function scalar(x, y) {
                                this.scalarX = x === undefined ? this.scalarX : x;
                                this.scalarY = y === undefined ? this.scalarY : y;
                            }
                        },
                        {
                            key: "limit",
                            value: function limit(x, y) {
                                this.limitX = x === undefined ? this.limitX : x;
                                this.limitY = y === undefined ? this.limitY : y;
                            }
                        },
                        {
                            key: "origin",
                            value: function origin(x, y) {
                                this.originX = x === undefined ? this.originX : x;
                                this.originY = y === undefined ? this.originY : y;
                            }
                        },
                        {
                            key: "setInputElement",
                            value: function setInputElement(element) {
                                this.inputElement = element;
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "setPosition",
                            value: function setPosition(element, x, y) {
                                x = x.toFixed(this.precision) + "px";
                                y = y.toFixed(this.precision) + "px";
                                if (this.transform3DSupport) helpers.css(element, "transform", "translate3d(" + x + "," + y + ",0)");
                                else if (this.transform2DSupport) helpers.css(element, "transform", "translate(" + x + "," + y + ")");
                                else {
                                    element.style.left = x;
                                    element.style.top = y;
                                }
                            }
                        },
                        {
                            key: "onOrientationTimer",
                            value: function onOrientationTimer() {
                                if (this.orientationSupport && this.orientationStatus === 0) {
                                    this.disable();
                                    this.orientationSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onMotionTimer",
                            value: function onMotionTimer() {
                                if (this.motionSupport && this.motionStatus === 0) {
                                    this.disable();
                                    this.motionSupport = false;
                                    this.enable();
                                } else this.doReadyCallback();
                            }
                        },
                        {
                            key: "onCalibrationTimer",
                            value: function onCalibrationTimer() {
                                this.calibrationFlag = true;
                            }
                        },
                        {
                            key: "onWindowResize",
                            value: function onWindowResize() {
                                this.updateDimensions();
                            }
                        },
                        {
                            key: "onAnimationFrame",
                            value: function onAnimationFrame() {
                                this.updateBounds();
                                var calibratedInputX = this.inputX - this.calibrationX, calibratedInputY = this.inputY - this.calibrationY;
                                if (Math.abs(calibratedInputX) > this.calibrationThreshold || Math.abs(calibratedInputY) > this.calibrationThreshold) this.queueCalibration(0);
                                if (this.portrait) {
                                    this.motionX = this.calibrateX ? calibratedInputY : this.inputY;
                                    this.motionY = this.calibrateY ? calibratedInputX : this.inputX;
                                } else {
                                    this.motionX = this.calibrateX ? calibratedInputX : this.inputX;
                                    this.motionY = this.calibrateY ? calibratedInputY : this.inputY;
                                }
                                this.motionX *= this.elementWidth * (this.scalarX / 100);
                                this.motionY *= this.elementHeight * (this.scalarY / 100);
                                if (!isNaN(parseFloat(this.limitX))) this.motionX = helpers.clamp(this.motionX, -this.limitX, this.limitX);
                                if (!isNaN(parseFloat(this.limitY))) this.motionY = helpers.clamp(this.motionY, -this.limitY, this.limitY);
                                this.velocityX += (this.motionX - this.velocityX) * this.frictionX;
                                this.velocityY += (this.motionY - this.velocityY) * this.frictionY;
                                for(var index = 0; index < this.layers.length; index++){
                                    var layer = this.layers[index], depthX = this.depthsX[index], depthY = this.depthsY[index], xOffset = this.velocityX * (depthX * (this.invertX ? -1 : 1)), yOffset = this.velocityY * (depthY * (this.invertY ? -1 : 1));
                                    this.setPosition(layer, xOffset, yOffset);
                                }
                                this.raf = rqAnFr(this.onAnimationFrame);
                            }
                        },
                        {
                            key: "rotate",
                            value: function rotate(beta, gamma) {
                                // Extract Rotation
                                var x = (beta || 0) / MAGIC_NUMBER, //  -90 :: 90
                                y = (gamma || 0) / MAGIC_NUMBER; // -180 :: 180
                                // Detect Orientation Change
                                var portrait = this.windowHeight > this.windowWidth;
                                if (this.portrait !== portrait) {
                                    this.portrait = portrait;
                                    this.calibrationFlag = true;
                                }
                                if (this.calibrationFlag) {
                                    this.calibrationFlag = false;
                                    this.calibrationX = x;
                                    this.calibrationY = y;
                                }
                                this.inputX = x;
                                this.inputY = y;
                            }
                        },
                        {
                            key: "onDeviceOrientation",
                            value: function onDeviceOrientation(event) {
                                var beta = event.beta;
                                var gamma = event.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.orientationStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onDeviceMotion",
                            value: function onDeviceMotion(event) {
                                var beta = event.rotationRate.beta;
                                var gamma = event.rotationRate.gamma;
                                if (beta !== null && gamma !== null) {
                                    this.motionStatus = 1;
                                    this.rotate(beta, gamma);
                                }
                            }
                        },
                        {
                            key: "onMouseMove",
                            value: function onMouseMove(event) {
                                var clientX = event.clientX, clientY = event.clientY;
                                // reset input to center if hoverOnly is set and we're not hovering the element
                                if (this.hoverOnly && (clientX < this.elementPositionX || clientX > this.elementPositionX + this.elementWidth || clientY < this.elementPositionY || clientY > this.elementPositionY + this.elementHeight)) {
                                    this.inputX = 0;
                                    this.inputY = 0;
                                    return;
                                }
                                if (this.relativeInput) {
                                    // Clip mouse coordinates inside element bounds.
                                    if (this.clipRelativeInput) {
                                        clientX = Math.max(clientX, this.elementPositionX);
                                        clientX = Math.min(clientX, this.elementPositionX + this.elementWidth);
                                        clientY = Math.max(clientY, this.elementPositionY);
                                        clientY = Math.min(clientY, this.elementPositionY + this.elementHeight);
                                    }
                                    // Calculate input relative to the element.
                                    if (this.elementRangeX && this.elementRangeY) {
                                        this.inputX = (clientX - this.elementPositionX - this.elementCenterX) / this.elementRangeX;
                                        this.inputY = (clientY - this.elementPositionY - this.elementCenterY) / this.elementRangeY;
                                    }
                                } else // Calculate input relative to the window.
                                if (this.windowRadiusX && this.windowRadiusY) {
                                    this.inputX = (clientX - this.windowCenterX) / this.windowRadiusX;
                                    this.inputY = (clientY - this.windowCenterY) / this.windowRadiusY;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.disable();
                                clearTimeout(this.calibrationTimer);
                                clearTimeout(this.detectionTimer);
                                this.element.removeAttribute("style");
                                for(var index = 0; index < this.layers.length; index++)this.layers[index].removeAttribute("style");
                                delete this.element;
                                delete this.layers;
                            }
                        },
                        {
                            key: "version",
                            value: function version() {
                                return "3.1.0";
                            }
                        }
                    ]);
                    return Parallax;
                }();
                module1.exports = Parallax;
            },
            {
                "object-assign": 1,
                "raf": 4
            }
        ]
    }, {}, [
        5
    ])(5);
});


if (document.querySelector("[data-parallax-el]") && window.innerWidth >= 1025) {
    const parallaxContainer = document.querySelectorAll("[data-parallax-el]");
    parallaxContainer.forEach((elem)=>{
        let parallaxInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($c63fa967237543b8$exports)))(elem);
        parallaxInstance.enable();
    });
}
if (document.getElementsByClassName("aura-card") && window.innerWidth > 551) {
    const page = document.querySelector("#site");
    const header = document.querySelector("header");
    const headerBurger = document.querySelector(".header .burger");
    const auraContainers = document.querySelectorAll(".aura-container");
    if (window.innerWidth > 1025) auraContainers.forEach((container)=>{
        const auraCursor = container.querySelector(".cursor-aura");
        const auraCursorWidth = auraCursor.offsetWidth;
        const auraCursorHeight = auraCursor.offsetHeight;
        const initLeft = parseFloat(getComputedStyle(auraCursor).left);
        const initTop = parseFloat(getComputedStyle(auraCursor).top);
        function cursorAuraLogic(e) {
            auraCursor.classList.add("active");
            const rect = container.getBoundingClientRect();
            let x = e.clientX - rect.left - auraCursorWidth / 1.85;
            let y = e.clientY - rect.top - auraCursorHeight / 1.95;
            const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
            const currentTop = parseFloat(getComputedStyle(auraCursor).top);
            x -= currentLeft;
            y -= currentTop;
            requestAnimationFrame(()=>{
                auraCursor.style.left = `${initLeft}px`;
                auraCursor.style.top = `${initTop}px`;
                auraCursor.style.transform = `translate(${x}px, ${y}px)`;
            });
        }
        function cursorAuraLeaveLogic() {
            auraCursor.classList.remove("active");
            auraCursor.style.left = `${initLeft}px`;
            auraCursor.style.top = `${initTop}px`;
            auraCursor.style.transform = `translate(-50%, -50%)`;
        }
        container.addEventListener("mousemove", (e)=>{
            auraCursor.classList.add("is-init");
            cursorAuraLogic(e);
        });
        container.addEventListener("mouseleave", (event)=>{
            const nextElement = document.elementFromPoint(event.clientX, event.clientY);
            if (header) {
                if (header.contains(nextElement)) return;
            }
            cursorAuraLeaveLogic();
        });
        if (header) {
            header.addEventListener("mousemove", (e)=>{
                if (!header.classList.contains("open-menu")) {
                    auraCursor.classList.add("is-init");
                    cursorAuraLogic(e);
                }
            });
            header.addEventListener("mouseleave", (event)=>{
                const nextElement = document.elementFromPoint(event.clientX, event.clientY);
                console.log(nextElement);
                if (container.contains(nextElement)) {
                    console.log(123);
                    return;
                }
                cursorAuraLeaveLogic();
            });
            headerBurger.addEventListener("click", ()=>{
                cursorAuraLeaveLogic();
            });
        }
    /*window.addEventListener('DOMContentLoaded', (event) => {
        const isCursorOverElement = isCursorOverElementOnLoad(container);
        console.log(
          'Курсор на элементе при загрузке страницы:',
          isCursorOverElement
        );
        cursorAuraLogic(event);
      });*/ });
}




let $d0a78bf654d142ab$var$newsSwiperWr = document.querySelectorAll(".home-hero-swiper-first-wr");
$d0a78bf654d142ab$var$newsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        (0, $0b515b836d29f568$export$f16e6af5a274aa5b)("(max-width: 449px)", swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            slidesPerView: "auto",
            spaceBetween: 10,
            speed: 800,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
    }
});




let $13e719998aa72176$var$newsSwiperWr = document.querySelectorAll(".home-hero-swiper-second-wr");
$13e719998aa72176$var$newsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        (0, $0b515b836d29f568$export$f16e6af5a274aa5b)("(max-width: 449px)", swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            slidesPerView: "auto",
            spaceBetween: 10,
            speed: 800,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
    }
});




let $07189716ad87d3c2$var$jobTypesSwiperWr = document.querySelectorAll(".home-areas-swiper-wr");
$07189716ad87d3c2$var$jobTypesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1.06,
            spaceBetween: 26,
            speed: 800,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.8
                },
                1024: {
                    slidesPerView: 2.2
                },
                1200: {
                    slidesPerView: 2.4
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $0b680d3b22adf520$var$jobTypesSwiperWr = document.querySelectorAll(".home-team-swiper-wr");
$0b680d3b22adf520$var$jobTypesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                425: {
                    slidesPerView: 1.1,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 1.8,
                    spaceBetween: 26
                },
                1024: {
                    slidesPerView: 2.2,
                    spaceBetween: 26
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 26
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $85a888003aaab7f4$var$jobTypesSwiperWr = document.querySelectorAll(".home-difference-swiper-wr");
$85a888003aaab7f4$var$jobTypesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1.045,
            spaceBetween: 16,
            watchSlidesProgress: true,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                425: {
                    slidesPerView: 1.2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 26
                },
                1024: {
                    slidesPerView: 3.2,
                    spaceBetween: 26
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 26
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            },
            allowTouchMove: true
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $cd0ad77c70b7861e$var$successSwiperWr = document.querySelectorAll(".home-success-swiper-wr");
$cd0ad77c70b7861e$var$successSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1.045,
            spaceBetween: 26,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                551: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 2.3
                },
                1024: {
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});
const $cd0ad77c70b7861e$var$successCards = document.querySelectorAll(".home-success-card");
const $cd0ad77c70b7861e$var$setMinTitleHeight = (cards)=>{
    let maxHeights = {
        authorName: 0,
        authorPosition: 0,
        authorCompany: 0,
        authorTime: 0
    };
    cards.forEach((card)=>{
        const authorName = card.querySelector(".home-success-card__author.with-name");
        const authorPosition = card.querySelector(".home-success-card__role.with-position");
        const authorCompany = card.querySelector(".home-success-card__role.with-company");
        const authorTime = card.querySelector(".home-success-card__author.with-time");
        if (authorName) maxHeights.authorName = Math.max(maxHeights.authorName, authorName.offsetHeight);
        if (authorPosition) maxHeights.authorPosition = Math.max(maxHeights.authorPosition, authorPosition.offsetHeight);
        if (authorCompany) maxHeights.authorCompany = Math.max(maxHeights.authorCompany, authorCompany.offsetHeight);
        if (authorTime) maxHeights.authorTime = Math.max(maxHeights.authorTime, authorTime.offsetHeight);
    });
    cards.forEach((card)=>{
        const authorName = card.querySelector(".home-success-card__author.with-name");
        const authorPosition = card.querySelector(".home-success-card__role.with-position");
        const authorCompany = card.querySelector(".home-success-card__role.with-company");
        const authorTime = card.querySelector(".home-success-card__author.with-time");
        if (authorName) authorName.style.minHeight = `${maxHeights.authorName}px`;
        if (authorPosition) authorPosition.style.minHeight = `${maxHeights.authorPosition}px`;
        if (authorCompany) authorCompany.style.minHeight = `${maxHeights.authorCompany}px`;
        if (authorTime) authorTime.style.minHeight = `${maxHeights.authorTime}px`;
    });
};
setTimeout(()=>$cd0ad77c70b7861e$var$setMinTitleHeight($cd0ad77c70b7861e$var$successCards), 1000);
window.addEventListener("resize", ()=>{
    $cd0ad77c70b7861e$var$setMinTitleHeight($cd0ad77c70b7861e$var$successCards);
});




let $1760509c457efee9$var$newsSwiperWr = document.querySelectorAll(".home-news-swiper-wr");
$1760509c457efee9$var$newsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 16,
            breakpoints: {
                551: {
                    slidesPerView: 1.5
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 26
                }
            },
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $7298c29f1a9704ce$var$relatedJobsSwiperWr = document.querySelectorAll(".related-jobs-swiper-wr");
$7298c29f1a9704ce$var$relatedJobsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 26,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 26,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});





let $d408680d5c63900f$var$clientsSwiperWr = document.querySelectorAll(".clients-swiper-wr");
$d408680d5c63900f$var$clientsSwiperWr.forEach((el)=>{
    if (el) {
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        if (slidesCount <= 6) (0, $0b515b836d29f568$export$f16e6af5a274aa5b)("(max-width: 951px)", swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            slidesPerView: "auto",
            spaceBetween: 20,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },
            loop: true,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                641: {
                    spaceBetween: 0
                }
            }
        });
        else {
            let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
                modules: [
                    (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                    (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
                ],
                observer: true,
                observeParents: true,
                slidesPerView: "auto",
                spaceBetween: 20,
                speed: 800,
                threshold: 10,
                loop: true,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                breakpoints: {
                    641: {
                        spaceBetween: 0
                    },
                    1024: {
                        centeredSlides: true
                    }
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                on: {
                    afterInit: function() {
                        wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                    },
                    resize: function() {
                        wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                    }
                }
            });
            (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
        }
    }
});




let $d1a9f157eb3c43f9$var$placementssSwiperWr = document.querySelectorAll(".recent-placements-swiper-wr");
$d1a9f157eb3c43f9$var$placementssSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039),
                (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            breakpoints: {
                500: {
                    slidesPerView: 2.2,
                    spaceBetween: 16
                },
                850: {
                    slidesPerView: 3.2,
                    spaceBetween: 26
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 26
                }
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $0fe0d19eb0f9dafb$var$jobTypesSwiperWr = document.querySelectorAll(".section-our-vision__slider");
const $0fe0d19eb0f9dafb$var$tabsOurVisionArr = document.querySelectorAll(".section-our-vision__left-text");
$0fe0d19eb0f9dafb$var$jobTypesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                (0, $300742dc018452cb$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 800,
            navigation: {
                prevEl: prevEl,
                nextEl: nextEl
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth <= 1024 ? false : true
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    allowTouchMove: false,
                    autoplay: false
                }
            }
        });
        if (window.innerWidth < 768) (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
        console.log($0fe0d19eb0f9dafb$var$tabsOurVisionArr);
        $0fe0d19eb0f9dafb$var$tabsOurVisionArr.forEach((tab, i)=>{
            tab.addEventListener("click", ()=>{
                for(let j = 0; j < $0fe0d19eb0f9dafb$var$tabsOurVisionArr.length; j++)$0fe0d19eb0f9dafb$var$tabsOurVisionArr[j].classList.remove("active");
                tab.classList.add("active");
                swiper.slideTo(i);
            });
        });
    }
});




let $f3f088ce1f831f1d$var$purposeSwiperWr = document.querySelectorAll(".purpose-swiper-wr");
$f3f088ce1f831f1d$var$purposeSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector(".swiper");
        let nextEl = el.querySelector(".swiper-button-next");
        let prevEl = el.querySelector(".swiper-button-prev");
        let slidesCount = el.querySelectorAll(".swiper-slide").length;
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 26,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove("justify-center") : wrapper.classList.add("justify-center");
                }
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




/* Reveal/Hide card hidden content */ const $8977c586c913b67c$var$practiceAreasCards = document.querySelectorAll(".section-practice-areas-card");
$8977c586c913b67c$var$practiceAreasCards.forEach((card, i)=>{
    const arrow = card.querySelector(".section-practice-areas-card__arrow");
    card.addEventListener("click", (e)=>{
        if (!card.classList.contains("open")) {
            $8977c586c913b67c$var$practiceAreasCards.forEach((c)=>{
                c.classList.remove("open");
                c.querySelector(".section-practice-areas-card__arrow").classList.remove("active");
            });
            card.classList.add("open");
            arrow.classList.add("active");
        } else {
            card.classList.remove("open");
            arrow.classList.remove("active");
        }
    });
    i;
});
let $8977c586c913b67c$var$columnCount = 4;
let $8977c586c913b67c$var$teamsList;
function $8977c586c913b67c$var$initTeamsHub() {
    $8977c586c913b67c$var$teamsList = document.querySelector(".section-practice-areas__cards");
    if ($8977c586c913b67c$var$teamsList) {
        console.log($8977c586c913b67c$var$columnCount);
        $8977c586c913b67c$var$addOpenContentBlocks($8977c586c913b67c$var$teamsList, $8977c586c913b67c$var$columnCount);
        const itemsArr = $8977c586c913b67c$var$teamsList.querySelectorAll(".section-practice-areas-card");
        itemsArr.forEach((item, idx)=>{
            item.addEventListener("click", $8977c586c913b67c$var$handleClick);
            if (idx === 0) item.click();
        });
    }
}
function $8977c586c913b67c$var$addOpenContentBlocks(teamsList, columnsCount) {
    if (teamsList) {
        const itemsArr = teamsList.querySelectorAll(".section-practice-areas-card");
        const rowsCount = Math.ceil(itemsArr.length / columnsCount);
        for(let i = 1; i <= rowsCount; i++){
            const openContentBlock = document.createElement("div");
            openContentBlock.classList.add("section-practice-areas-open-content");
            const insertPosition = i * columnsCount < itemsArr.length ? itemsArr[i * columnsCount - 1].nextSibling : null;
            if (insertPosition) teamsList.insertBefore(openContentBlock, insertPosition);
            else teamsList.appendChild(openContentBlock);
        }
    }
}
function $8977c586c913b67c$var$handleClick(event) {
    if (document.querySelector(".section-practice-areas-open-content")) {
        const openElArr = document.querySelectorAll(".section-practice-areas-open-content");
        openElArr.forEach((openEl)=>{
            openEl.classList.remove("active");
        });
    }
    const clickedItem = event.currentTarget;
    let openFlag = true;
    if (clickedItem.classList.contains("active")) {
        clickedItem.classList.remove("active");
        openFlag = false;
        setTimeout(function() {
            openFlag = true;
        }, 100);
    } else {
        const itemsArr = $8977c586c913b67c$var$teamsList.querySelectorAll(".section-practice-areas-card");
        itemsArr.forEach((item)=>{
            item.classList.remove("active");
        });
        clickedItem.classList.add("active");
    }
    console.log(clickedItem);
    const contentToCopy = clickedItem.querySelector(".section-practice-areas-card-container").cloneNode(true);
    let nextOpenContentBlock = clickedItem.nextElementSibling;
    while(nextOpenContentBlock && !nextOpenContentBlock.classList.contains("section-practice-areas-open-content"))nextOpenContentBlock = nextOpenContentBlock.nextElementSibling;
    if (nextOpenContentBlock) {
        nextOpenContentBlock.innerHTML = "";
        nextOpenContentBlock.appendChild(contentToCopy);
        if (openFlag) {
            nextOpenContentBlock.classList.add("active");
            $8977c586c913b67c$var$initSwiper(nextOpenContentBlock);
        } else nextOpenContentBlock.classList.remove("active");
    }
}
function $8977c586c913b67c$var$initSwiper(contentBlock) {
    console.log(12314);
    let jobsAreasSwiperWr = contentBlock.querySelector(".jobs-areas-swiper-wr");
    if (jobsAreasSwiperWr) {
        let swiperEl = jobsAreasSwiperWr.querySelector(".swiper");
        let nextEl = jobsAreasSwiperWr.querySelector(".swiper-button-next");
        let prevEl = jobsAreasSwiperWr.querySelector(".swiper-button-prev");
        let wrapper = swiperEl.querySelector(".swiper-wrapper");
        let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                640: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 26,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 26,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
}
function $8977c586c913b67c$var$destroyTeamsHub() {
    if ($8977c586c913b67c$var$teamsList) {
        const itemsArr = $8977c586c913b67c$var$teamsList.querySelectorAll(".section-practice-areas-card");
        itemsArr.forEach((item)=>{
            item.removeEventListener("click", $8977c586c913b67c$var$handleClick);
        });
        if (document.querySelector(".section-practice-areas-open-content")) {
            const openElArr = document.querySelectorAll(".section-practice-areas-open-content");
            openElArr.forEach((openEl)=>{
                openEl.remove();
            });
        }
        $8977c586c913b67c$var$teamsList = null;
    }
}
/*initTeamsHub();*/ function $8977c586c913b67c$var$handleResize() {
    if (window.innerWidth <= 551) {
        $8977c586c913b67c$var$columnCount = 1;
        $8977c586c913b67c$var$destroyTeamsHub();
        $8977c586c913b67c$var$initTeamsHub();
    } else if (window.innerWidth <= 951) {
        $8977c586c913b67c$var$columnCount = 2;
        $8977c586c913b67c$var$destroyTeamsHub();
        $8977c586c913b67c$var$initTeamsHub();
    } else {
        $8977c586c913b67c$var$columnCount = 4;
        $8977c586c913b67c$var$destroyTeamsHub();
        $8977c586c913b67c$var$initTeamsHub();
    }
}
window.addEventListener("resize", $8977c586c913b67c$var$handleResize);
$8977c586c913b67c$var$handleResize();


let $6b0579eb62a406cc$var$columnCount = 3;
let $6b0579eb62a406cc$var$teamsList;
let $6b0579eb62a406cc$var$activeCard = null;
function $6b0579eb62a406cc$var$initTeamsHub() {
    $6b0579eb62a406cc$var$teamsList = document.querySelector(".section-our-team__cards");
    if (!$6b0579eb62a406cc$var$teamsList) return;
    console.log($6b0579eb62a406cc$var$columnCount);
    $6b0579eb62a406cc$var$addOpenContentBlocks($6b0579eb62a406cc$var$teamsList, $6b0579eb62a406cc$var$columnCount);
    const itemsArr = $6b0579eb62a406cc$var$teamsList.querySelectorAll(".home-team-card");
    itemsArr.forEach((item)=>{
        const itemId = item.getAttribute("id");
        item.addEventListener("click", $6b0579eb62a406cc$var$handleClick);
        if (window.location.hash === `#${itemId}`) item.click();
    });
}
function $6b0579eb62a406cc$var$addOpenContentBlocks(teamsList, columnsCount) {
    if (teamsList) {
        const itemsArr = teamsList.querySelectorAll(".home-team-card");
        const rowsCount = Math.ceil(itemsArr.length / columnsCount);
        for(let i = 1; i <= rowsCount; i++){
            const openContentBlock = document.createElement("div");
            openContentBlock.classList.add("section-our-team-open-content");
            const insertPosition = i * columnsCount < itemsArr.length ? itemsArr[i * columnsCount - 1].nextSibling : null;
            if (insertPosition) teamsList.insertBefore(openContentBlock, insertPosition);
            else teamsList.appendChild(openContentBlock);
        }
    }
}
function $6b0579eb62a406cc$var$handleClick(event) {
    const clickedItem = event.currentTarget;
    if (window.innerWidth <= 1024) {
        if (clickedItem.classList.contains("active")) return;
    }
    let nextOpenContentBlock = clickedItem.nextElementSibling;
    while(nextOpenContentBlock && !nextOpenContentBlock.classList.contains("section-our-team-open-content"))nextOpenContentBlock = nextOpenContentBlock.nextElementSibling;
    const currentActiveItem = $6b0579eb62a406cc$var$teamsList.querySelector(".home-team-card.active");
    const currentActiveContent = $6b0579eb62a406cc$var$teamsList.querySelector(".section-our-team-open-content.active");
    if (clickedItem.classList.contains("active")) {
        clickedItem.classList.remove("active");
        $6b0579eb62a406cc$var$activeCard = null;
        if (nextOpenContentBlock) {
            nextOpenContentBlock.classList.remove("active");
            setTimeout(()=>{
                nextOpenContentBlock.innerHTML = "";
            }, 400);
        }
    } else {
        const itemsArr = $6b0579eb62a406cc$var$teamsList.querySelectorAll(".home-team-card");
        itemsArr.forEach((item)=>{
            item.classList.remove("active");
        });
        clickedItem.classList.add("active");
        $6b0579eb62a406cc$var$activeCard = clickedItem;
        if (currentActiveContent) {
            currentActiveContent.classList.remove("active");
            currentActiveContent.innerHTML = "";
        }
        if (nextOpenContentBlock) {
            const contentToCopy = clickedItem.querySelector(".home-team-card-container").cloneNode(true);
            nextOpenContentBlock.innerHTML = "";
            nextOpenContentBlock.appendChild(contentToCopy);
            // Force a reflow
            nextOpenContentBlock.offsetWidth;
            setTimeout(()=>{
                nextOpenContentBlock.classList.add("active");
            }, 400);
        }
    }
}
function $6b0579eb62a406cc$var$destroyTeamsHub() {
    if ($6b0579eb62a406cc$var$teamsList) {
        const itemsArr = $6b0579eb62a406cc$var$teamsList.querySelectorAll(".home-team-card");
        itemsArr.forEach((item)=>{
            item.removeEventListener("click", $6b0579eb62a406cc$var$handleClick);
        });
        if (document.querySelector(".section-our-team-open-content")) {
            const openElArr = document.querySelectorAll(".section-our-team-open-content");
            openElArr.forEach((openEl)=>{
                openEl.remove();
            });
        }
        $6b0579eb62a406cc$var$teamsList = null;
    }
}
function $6b0579eb62a406cc$var$handleResize() {
    if (window.innerWidth <= 551) $6b0579eb62a406cc$var$columnCount = 1;
    else if (window.innerWidth <= 1024) $6b0579eb62a406cc$var$columnCount = 2;
    else $6b0579eb62a406cc$var$columnCount = 3;
    $6b0579eb62a406cc$var$destroyTeamsHub();
    $6b0579eb62a406cc$var$initTeamsHub();
}
document.addEventListener("DOMContentLoaded", ()=>{
    $6b0579eb62a406cc$var$handleResize();
});
window.addEventListener("resize", $6b0579eb62a406cc$var$handleResize);


const $fc3c1206aa360f0c$var$solutionsAccordion = document.querySelector(".solutions-section__accordion");
if ($fc3c1206aa360f0c$var$solutionsAccordion) {
    const solutionsAccordionItemsArr = document.querySelectorAll(".solutions-section__accordion-item");
    solutionsAccordionItemsArr.forEach((item)=>{
        const itemToggle = item.querySelector(".solutions-section__accordion-item-top");
        const itemHidden = item.querySelector(".solutions-section__accordion-item-hidden");
        const itemText = item.querySelector(".solutions-section__accordion-item-text");
        itemToggle.addEventListener("click", (e)=>{
            if (!item.classList.contains("active")) {
                for(let i = 0; i < solutionsAccordionItemsArr.length; i++)solutionsAccordionItemsArr[i].classList.remove("active");
                item.classList.add("active");
                const itemHiddenHeight = itemText.classList + 50;
                itemHidden.style.maxHeight = `${itemHiddenHeight}px`;
            } else item.classList.remove("active");
        });
    });
}


window.collapseTopFunc = function collapseTopFunc1() {
    const collapseTop = document.querySelector(".current-jobs-search-add-collapse__top");
    const collapseBottom = document.querySelector(".current-jobs-search-add-collapse__bottom");
    if (collapseTop) collapseTop.addEventListener("click", function() {
        this.classList.toggle("active");
        collapseBottom.classList.toggle("collapsed");
        const svg = this.querySelector("svg");
        svg.style.transform = collapseBottom.classList.contains("collapsed") ? "rotate(0deg)" : "rotate(180deg)";
        const path = svg.querySelector("path");
        path.setAttribute("fill", this.classList.contains("active") ? "var(--cl-blue)" : "#0A0B26");
    });
};
collapseTopFunc(); /*/!* CLEAR INPUTS AFTER REMOVING FILTERS *!/
window.clearFilters = function clearFilters() {
  const filtersContainer = document.querySelector(
    '.current-jobs-search__filters'
  );
  const filtersArr = filtersContainer.querySelectorAll(
    '.current-jobs-search__filter'
  );

  filtersArr.forEach((filterTag) => {
    const filterName = filterTag.querySelector('span').innerText;
    console.log(filterName);

    filterTag.addEventListener('click', () => {});
  });
};*/ 


window.uploadFile = function uploadFile1() {
    if (document.querySelector("[data-upload-file-animation]")) {
        const uploadFileBlocksArr = document.querySelectorAll("[data-upload-file-animation]");
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener("dragover", function() {
                this.classList.add("drag");
                this.classList.remove("drop", "done");
            });
            fileUpload.addEventListener("dragleave", function() {
                this.classList.remove("drag");
            });
            fileUpload.addEventListener("drop", start, false);
            fileUpload.addEventListener("change", start, false);
            function start() {
                this.classList.remove("drag");
                this.classList.add("drop");
                setTimeout(()=>this.classList.add("done"), 500);
            }
        });
    }
};
uploadFile();


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector("textarea[data-autosize]")) {
        const autosizeTextareaElements = document.querySelectorAll("textarea[data-autosize]");
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener("input", autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();
function $b4527f46cc7e9b87$var$customSelectsLogic() {
    const defaultCustomSelect = document.getElementsByClassName("default-custom-select")[0];
    if (defaultCustomSelect) {
        const defaultCustomSelectArr = document.querySelectorAll(".default-custom-select");
        defaultCustomSelectArr.forEach((customSelect, i)=>{
            const zIndexValue = defaultCustomSelectArr.length - i;
            customSelect.style.zIndex = zIndexValue + 10;
            const customSelectPlaceholder = customSelect.querySelector(".default-custom-select__placeholder");
            const customSelectList = customSelect.querySelector(".default-custom-select__list");
            const customSelectPlaceholderTextContent = customSelect.querySelector(".default-custom-select__placeholder").textContent;
            customSelectPlaceholder.setAttribute("data-original-placeholder", customSelectPlaceholderTextContent);
            customSelect.addEventListener("click", (e)=>{
                if (!customSelect.classList.contains("active")) {
                    customSelect.classList.add("active");
                    console.log(customSelect);
                } else if (!e.target.classList.contains("default-custom-select__list")) customSelect.classList.remove("active");
            });
            document.addEventListener("click", (event)=>{
                if (!customSelectList.contains(event.target) && !customSelect.contains(event.target)) customSelect.classList.remove("active");
            });
            const checkboxesSelect = customSelect.querySelectorAll('input[type="checkbox"]');
            function placeholderCheck() {
                const checkedCount = customSelect.querySelectorAll('input[type="checkbox"]:checked').length;
                console.log(customSelect.querySelectorAll('input[type="checkbox"]:checked'));
                if (checkedCount === 1) {
                    const checkedItem = customSelect.querySelector('input[type="checkbox"]:checked');
                    customSelectPlaceholder.textContent = checkedItem.nextElementSibling.nextElementSibling.textContent;
                } else customSelectPlaceholder.textContent = checkedCount > 0 ? `${checkedCount} items selected` : customSelectPlaceholderTextContent;
            }
            checkboxesSelect.forEach((checkbox)=>{
                checkbox.addEventListener("change", ()=>{
                    placeholderCheck();
                });
            });
            const checkboxes = document.querySelectorAll('input[type="checkbox"]');
            for(let j = 0; j < checkboxes.length; j++)checkboxes[j].addEventListener("change", ()=>{
                placeholderCheck();
            });
            placeholderCheck();
        });
    }
}
$b4527f46cc7e9b87$var$customSelectsLogic();
const $b4527f46cc7e9b87$var$currentJobsSearchMain = document.querySelector(".current-jobs-search__main");
if ($b4527f46cc7e9b87$var$currentJobsSearchMain) {
    const inputsArr = $b4527f46cc7e9b87$var$currentJobsSearchMain.querySelectorAll(".input");
    inputsArr.forEach((input, i)=>{
        const zIndexValue = inputsArr.length - i;
        input.style.zIndex = zIndexValue + 10;
    });
}
window.checkAllCheckboxes = function checkAllCheckboxes1() {
    const customSelects = document.querySelectorAll(".default-custom-select");
    customSelects.forEach((customSelect)=>{
        const customSelectPlaceholder = customSelect.querySelector(".default-custom-select__placeholder");
        function placeholderCheck() {
            const checkedCount = customSelect.querySelectorAll('input[type="checkbox"]:checked').length;
            if (checkedCount === 1) {
                const checkedItem = customSelect.querySelector('input[type="checkbox"]:checked');
                customSelectPlaceholder.textContent = checkedItem.nextElementSibling.nextElementSibling.textContent;
            } else customSelectPlaceholder.textContent = checkedCount > 0 ? `${checkedCount} items selected` : customSelectPlaceholder.getAttribute("data-original-placeholder");
        }
        placeholderCheck();
    });
};
checkAllCheckboxes();


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $ba30919e9e6c5fb2$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $ba30919e9e6c5fb2$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $ba30919e9e6c5fb2$export$803cd8101b6c182b = /*#__PURE__*/ $ba30919e9e6c5fb2$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $ba30919e9e6c5fb2$export$27b07d8a310ed8b5[0], side + "-" + $ba30919e9e6c5fb2$export$27b07d8a310ed8b5[1]), []);
const $ba30919e9e6c5fb2$export$96ec731ed4dcb222 = Math.min;
const $ba30919e9e6c5fb2$export$8960430cfd85939f = Math.max;
const $ba30919e9e6c5fb2$export$2077e0241d6afd3c = Math.round;
const $ba30919e9e6c5fb2$export$a3fe094919f356fd = Math.floor;
const $ba30919e9e6c5fb2$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $ba30919e9e6c5fb2$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $ba30919e9e6c5fb2$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $ba30919e9e6c5fb2$export$7d15b64cf5a3a4c4(start, value, end) {
    return $ba30919e9e6c5fb2$export$8960430cfd85939f(start, $ba30919e9e6c5fb2$export$96ec731ed4dcb222(value, end));
}
function $ba30919e9e6c5fb2$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $ba30919e9e6c5fb2$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $ba30919e9e6c5fb2$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $ba30919e9e6c5fb2$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $ba30919e9e6c5fb2$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $ba30919e9e6c5fb2$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($ba30919e9e6c5fb2$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $ba30919e9e6c5fb2$export$2b57e0052a6d6d4c(placement) {
    return $ba30919e9e6c5fb2$export$8a000a963141ac32($ba30919e9e6c5fb2$export$f28e8f882010718a(placement));
}
function $ba30919e9e6c5fb2$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $ba30919e9e6c5fb2$export$f0989780f32bfcda(placement);
    const alignmentAxis = $ba30919e9e6c5fb2$export$2b57e0052a6d6d4c(placement);
    const length = $ba30919e9e6c5fb2$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $ba30919e9e6c5fb2$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $ba30919e9e6c5fb2$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $ba30919e9e6c5fb2$export$496432a3699e50b1(placement) {
    const oppositePlacement = $ba30919e9e6c5fb2$export$9c5e28bad23365fa(placement);
    return [
        $ba30919e9e6c5fb2$export$2b182c584985588b(placement),
        oppositePlacement,
        $ba30919e9e6c5fb2$export$2b182c584985588b(oppositePlacement)
    ];
}
function $ba30919e9e6c5fb2$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$ba30919e9e6c5fb2$var$oppositeAlignmentMap[alignment]);
}
function $ba30919e9e6c5fb2$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $ba30919e9e6c5fb2$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $ba30919e9e6c5fb2$export$f0989780f32bfcda(placement);
    let list = $ba30919e9e6c5fb2$var$getSideList($ba30919e9e6c5fb2$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($ba30919e9e6c5fb2$export$2b182c584985588b));
    }
    return list;
}
function $ba30919e9e6c5fb2$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$ba30919e9e6c5fb2$var$oppositeSideMap[side]);
}
function $ba30919e9e6c5fb2$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $ba30919e9e6c5fb2$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $ba30919e9e6c5fb2$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $ba30919e9e6c5fb2$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $e273a525241d0e9e$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $ba30919e9e6c5fb2$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $ba30919e9e6c5fb2$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $e273a525241d0e9e$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $e273a525241d0e9e$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $e273a525241d0e9e$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $e273a525241d0e9e$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $ba30919e9e6c5fb2$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e273a525241d0e9e$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ba30919e9e6c5fb2$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ba30919e9e6c5fb2$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $ba30919e9e6c5fb2$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ba30919e9e6c5fb2$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $e273a525241d0e9e$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $ba30919e9e6c5fb2$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e273a525241d0e9e$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ba30919e9e6c5fb2$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ba30919e9e6c5fb2$export$803cd8101b6c182b) ? $e273a525241d0e9e$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ba30919e9e6c5fb2$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e273a525241d0e9e$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ba30919e9e6c5fb2$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $ba30919e9e6c5fb2$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $ba30919e9e6c5fb2$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ba30919e9e6c5fb2$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $e273a525241d0e9e$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $e273a525241d0e9e$var$isAnySideFullyClipped(overflow) {
    return (0, $ba30919e9e6c5fb2$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e273a525241d0e9e$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $e273a525241d0e9e$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $e273a525241d0e9e$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $e273a525241d0e9e$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $e273a525241d0e9e$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $e273a525241d0e9e$var$getBoundingRect(rects) {
    const minX = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $e273a525241d0e9e$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)($e273a525241d0e9e$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e273a525241d0e9e$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $e273a525241d0e9e$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)($e273a525241d0e9e$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ba30919e9e6c5fb2$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $e273a525241d0e9e$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e273a525241d0e9e$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $e273a525241d0e9e$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e273a525241d0e9e$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)((0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $ba30919e9e6c5fb2$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ba30919e9e6c5fb2$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ba30919e9e6c5fb2$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e273a525241d0e9e$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $ba30919e9e6c5fb2$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e273a525241d0e9e$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $ba30919e9e6c5fb2$export$fef61f332f2c0afc)(options, state);
            const overflow = await $e273a525241d0e9e$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $ba30919e9e6c5fb2$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $ba30919e9e6c5fb2$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $ba30919e9e6c5fb2$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $ff3fc704714c7ab9$export$651544f548703224(node) {
    if ($ff3fc704714c7ab9$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $ff3fc704714c7ab9$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $ff3fc704714c7ab9$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($ff3fc704714c7ab9$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $ff3fc704714c7ab9$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $ff3fc704714c7ab9$export$38b2d434cce3ea22(value).Node;
}
function $ff3fc704714c7ab9$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $ff3fc704714c7ab9$export$38b2d434cce3ea22(value).Element;
}
function $ff3fc704714c7ab9$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $ff3fc704714c7ab9$export$38b2d434cce3ea22(value).HTMLElement;
}
function $ff3fc704714c7ab9$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $ff3fc704714c7ab9$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $ff3fc704714c7ab9$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $ff3fc704714c7ab9$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $ff3fc704714c7ab9$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($ff3fc704714c7ab9$export$651544f548703224(element));
}
function $ff3fc704714c7ab9$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $ff3fc704714c7ab9$export$d6c4e8150c35fed1(element) {
    const webkit = $ff3fc704714c7ab9$export$78551043582a6a98();
    const css = $ff3fc704714c7ab9$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $ff3fc704714c7ab9$export$940d8225183e1404(element) {
    let currentNode = $ff3fc704714c7ab9$export$4e12058fc4d51d56(element);
    while($ff3fc704714c7ab9$export$1b3bfaa9684536aa(currentNode) && !$ff3fc704714c7ab9$export$d1162fb0b6d4cd51(currentNode)){
        if ($ff3fc704714c7ab9$export$89e651af02346cd4(currentNode)) return null;
        if ($ff3fc704714c7ab9$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $ff3fc704714c7ab9$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $ff3fc704714c7ab9$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $ff3fc704714c7ab9$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($ff3fc704714c7ab9$export$651544f548703224(node));
}
function $ff3fc704714c7ab9$export$3735103072e4a80(element) {
    return $ff3fc704714c7ab9$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $ff3fc704714c7ab9$export$dc8fc79fa2800137(element) {
    if ($ff3fc704714c7ab9$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $ff3fc704714c7ab9$export$4e12058fc4d51d56(node) {
    if ($ff3fc704714c7ab9$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $ff3fc704714c7ab9$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $ff3fc704714c7ab9$export$e495491855dc5418(node);
    return $ff3fc704714c7ab9$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $ff3fc704714c7ab9$export$7cd01a57c8ca906c(node) {
    const parentNode = $ff3fc704714c7ab9$export$4e12058fc4d51d56(node);
    if ($ff3fc704714c7ab9$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($ff3fc704714c7ab9$export$1b3bfaa9684536aa(parentNode) && $ff3fc704714c7ab9$export$989e911fa9af580a(parentNode)) return parentNode;
    return $ff3fc704714c7ab9$export$7cd01a57c8ca906c(parentNode);
}
function $ff3fc704714c7ab9$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $ff3fc704714c7ab9$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $ff3fc704714c7ab9$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $ff3fc704714c7ab9$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $ff3fc704714c7ab9$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $ff3fc704714c7ab9$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $4aebc664d8c92966$var$getCssDimensions(element) {
    const css = (0, $ff3fc704714c7ab9$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ba30919e9e6c5fb2$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $ba30919e9e6c5fb2$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4aebc664d8c92966$var$unwrapElement(element) {
    return !(0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $4aebc664d8c92966$var$getScale(element) {
    const domElement = $4aebc664d8c92966$var$unwrapElement(element);
    if (!(0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(domElement)) return (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $4aebc664d8c92966$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ba30919e9e6c5fb2$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ba30919e9e6c5fb2$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $4aebc664d8c92966$var$noOffsets = /*#__PURE__*/ (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(0);
function $4aebc664d8c92966$var$getVisualOffsets(element) {
    const win = (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(element);
    if (!(0, $ff3fc704714c7ab9$export$78551043582a6a98)() || !win.visualViewport) return $4aebc664d8c92966$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4aebc664d8c92966$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $4aebc664d8c92966$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $4aebc664d8c92966$var$unwrapElement(element);
    let scale = (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(offsetParent)) scale = $4aebc664d8c92966$var$getScale(offsetParent);
        } else scale = $4aebc664d8c92966$var$getScale(element);
    }
    const visualOffsets = $4aebc664d8c92966$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4aebc664d8c92966$var$getVisualOffsets(domElement) : (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $4aebc664d8c92966$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $ff3fc704714c7ab9$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $4aebc664d8c92966$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $ff3fc704714c7ab9$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(1);
    const offsets = (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $ff3fc704714c7ab9$export$651544f548703224)(offsetParent) !== "body" || (0, $ff3fc704714c7ab9$export$989e911fa9af580a)(documentElement)) scroll = (0, $ff3fc704714c7ab9$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $4aebc664d8c92966$var$getBoundingClientRect(offsetParent);
            scale = $4aebc664d8c92966$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $4aebc664d8c92966$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $4aebc664d8c92966$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $4aebc664d8c92966$var$getBoundingClientRect((0, $ff3fc704714c7ab9$export$e495491855dc5418)(element)).left + (0, $ff3fc704714c7ab9$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4aebc664d8c92966$var$getDocumentRect(element) {
    const html = (0, $ff3fc704714c7ab9$export$e495491855dc5418)(element);
    const scroll = (0, $ff3fc704714c7ab9$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $4aebc664d8c92966$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $ff3fc704714c7ab9$export$3735103072e4a80)(body).direction === "rtl") x += (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4aebc664d8c92966$var$getViewportRect(element, strategy) {
    const win = (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(element);
    const html = (0, $ff3fc704714c7ab9$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $ff3fc704714c7ab9$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $4aebc664d8c92966$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $4aebc664d8c92966$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(element) ? $4aebc664d8c92966$var$getScale(element) : (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4aebc664d8c92966$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $4aebc664d8c92966$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $4aebc664d8c92966$var$getDocumentRect((0, $ff3fc704714c7ab9$export$e495491855dc5418)(element));
    else if ((0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $4aebc664d8c92966$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $4aebc664d8c92966$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $ba30919e9e6c5fb2$export$ee05aea0aeecbad4)(rect);
}
function $4aebc664d8c92966$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $ff3fc704714c7ab9$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(parentNode) || (0, $ff3fc704714c7ab9$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $ff3fc704714c7ab9$export$3735103072e4a80)(parentNode).position === "fixed" || $4aebc664d8c92966$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4aebc664d8c92966$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $ff3fc704714c7ab9$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(el) && (0, $ff3fc704714c7ab9$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $ff3fc704714c7ab9$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $ff3fc704714c7ab9$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $ff3fc704714c7ab9$export$45a5e7f76e0caa8d)(currentNode) && !(0, $ff3fc704714c7ab9$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $ff3fc704714c7ab9$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $ff3fc704714c7ab9$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $ff3fc704714c7ab9$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $4aebc664d8c92966$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $ff3fc704714c7ab9$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4aebc664d8c92966$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $4aebc664d8c92966$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $4aebc664d8c92966$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $4aebc664d8c92966$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $4aebc664d8c92966$var$getDimensions(element) {
    const { width: width, height: height } = $4aebc664d8c92966$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $4aebc664d8c92966$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $ff3fc704714c7ab9$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $4aebc664d8c92966$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ba30919e9e6c5fb2$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $ff3fc704714c7ab9$export$651544f548703224)(offsetParent) !== "body" || (0, $ff3fc704714c7ab9$export$989e911fa9af580a)(documentElement)) scroll = (0, $ff3fc704714c7ab9$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4aebc664d8c92966$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $4aebc664d8c92966$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $4aebc664d8c92966$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(element) || (0, $ff3fc704714c7ab9$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4aebc664d8c92966$var$getOffsetParent(element, polyfill) {
    const window = (0, $ff3fc704714c7ab9$export$38b2d434cce3ea22)(element);
    if (!(0, $ff3fc704714c7ab9$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $4aebc664d8c92966$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $ff3fc704714c7ab9$export$71535ffaa902797f)(offsetParent) && (0, $ff3fc704714c7ab9$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $4aebc664d8c92966$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $ff3fc704714c7ab9$export$651544f548703224)(offsetParent) === "html" || (0, $ff3fc704714c7ab9$export$651544f548703224)(offsetParent) === "body" && (0, $ff3fc704714c7ab9$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $ff3fc704714c7ab9$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $ff3fc704714c7ab9$export$940d8225183e1404)(element) || window;
}
const $4aebc664d8c92966$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $4aebc664d8c92966$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $4aebc664d8c92966$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $4aebc664d8c92966$var$isRTL(element) {
    return (0, $ff3fc704714c7ab9$export$3735103072e4a80)(element).direction === "rtl";
}
const $4aebc664d8c92966$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4aebc664d8c92966$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $ff3fc704714c7ab9$export$e495491855dc5418,
    getClippingRect: $4aebc664d8c92966$var$getClippingRect,
    getOffsetParent: $4aebc664d8c92966$var$getOffsetParent,
    getElementRects: $4aebc664d8c92966$var$getElementRects,
    getClientRects: $4aebc664d8c92966$var$getClientRects,
    getDimensions: $4aebc664d8c92966$var$getDimensions,
    getScale: $4aebc664d8c92966$var$getScale,
    isElement: $ff3fc704714c7ab9$export$45a5e7f76e0caa8d,
    isRTL: $4aebc664d8c92966$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $4aebc664d8c92966$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $ff3fc704714c7ab9$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ba30919e9e6c5fb2$export$a3fe094919f356fd)(top);
        const insetRight = (0, $ba30919e9e6c5fb2$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $ba30919e9e6c5fb2$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $ba30919e9e6c5fb2$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ba30919e9e6c5fb2$export$8960430cfd85939f)(0, (0, $ba30919e9e6c5fb2$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4aebc664d8c92966$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $4aebc664d8c92966$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $ff3fc704714c7ab9$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $ff3fc704714c7ab9$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $4aebc664d8c92966$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $4aebc664d8c92966$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $4aebc664d8c92966$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4aebc664d8c92966$export$91fb6ecbd551914 = (0, $e273a525241d0e9e$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4aebc664d8c92966$export$fba63a578e423eb = (0, $e273a525241d0e9e$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4aebc664d8c92966$export$8a83211c878a3f1f = (0, $e273a525241d0e9e$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4aebc664d8c92966$export$346677f925de839c = (0, $e273a525241d0e9e$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4aebc664d8c92966$export$fe8985bb6374093c = (0, $e273a525241d0e9e$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4aebc664d8c92966$export$f2120bbfa5450bd2 = (0, $e273a525241d0e9e$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4aebc664d8c92966$export$18c8ad048e32c7d5 = (0, $e273a525241d0e9e$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4aebc664d8c92966$export$7bf07e38f3dc4b69 = (0, $e273a525241d0e9e$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $4aebc664d8c92966$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $4aebc664d8c92966$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $e273a525241d0e9e$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


var $3cfd30e35d79a5df$var$av = Object.defineProperty;
var $3cfd30e35d79a5df$var$lv = (e, r, u)=>r in e ? $3cfd30e35d79a5df$var$av(e, r, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: u
    }) : e[r] = u;
var $3cfd30e35d79a5df$var$Ln = (e, r, u)=>($3cfd30e35d79a5df$var$lv(e, typeof r != "symbol" ? r + "" : r, u), u), $3cfd30e35d79a5df$var$cv = (e, r, u)=>{
    if (!r.has(e)) throw TypeError("Cannot " + u);
};
var $3cfd30e35d79a5df$var$Ci = (e, r, u)=>{
    if (r.has(e)) throw TypeError("Cannot add the same private member more than once");
    r instanceof WeakSet ? r.add(e) : r.set(e, u);
};
var $3cfd30e35d79a5df$var$Ri = (e, r, u)=>($3cfd30e35d79a5df$var$cv(e, r, "access private method"), u);
var $3cfd30e35d79a5df$var$dr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {}, $3cfd30e35d79a5df$var$Wi = {
    exports: {}
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ $3cfd30e35d79a5df$var$Wi.exports;
(function(e, r) {
    (function() {
        var u, f = "4.17.21", s = 200, h = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", g = "Invalid `variable` option passed into `_.template`", v = "__lodash_hash_undefined__", w = 500, d = "__lodash_placeholder__", y = 1, x = 2, C = 4, P = 1, z = 2, $ = 1, O = 2, U = 4, k = 8, B = 16, q = 32, X = 64, V = 128, rn = 256, on = 512, pn = 30, j = "...", zn = 800, xn = 16, A = 1, R = 2, I = 3, F = 1 / 0, G = 9007199254740991, Y = 17976931348623157e292, nn = NaN, Q = 4294967295, gn = Q - 1, In = Q >>> 1, An = [
            [
                "ary",
                V
            ],
            [
                "bind",
                $
            ],
            [
                "bindKey",
                O
            ],
            [
                "curry",
                k
            ],
            [
                "curryRight",
                B
            ],
            [
                "flip",
                on
            ],
            [
                "partial",
                q
            ],
            [
                "partialRight",
                X
            ],
            [
                "rearg",
                rn
            ]
        ], Sn = "[object Arguments]", Jn = "[object Array]", rt = "[object AsyncFunction]", Hn = "[object Boolean]", Dt = "[object Date]", Cc = "[object DOMException]", Or = "[object Error]", $r = "[object Function]", mf = "[object GeneratorFunction]", St = "[object Map]", Ze = "[object Number]", Rc = "[object Null]", zt = "[object Object]", yf = "[object Promise]", Tc = "[object Proxy]", Je = "[object RegExp]", Et = "[object Set]", Qe = "[object String]", Fr = "[object Symbol]", Ic = "[object Undefined]", Ve = "[object WeakMap]", Mc = "[object WeakSet]", je = "[object ArrayBuffer]", Ce = "[object DataView]", fu = "[object Float32Array]", su = "[object Float64Array]", au = "[object Int8Array]", lu = "[object Int16Array]", cu = "[object Int32Array]", hu = "[object Uint8Array]", pu = "[object Uint8ClampedArray]", gu = "[object Uint16Array]", du = "[object Uint32Array]", Lc = /\b__p \+= '';/g, bc = /\b(__p \+=) '' \+/g, Pc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, xf = /&(?:amp|lt|gt|quot|#39);/g, Sf = /[&<>"']/g, Nc = RegExp(xf.source), Oc = RegExp(Sf.source), $c = /<%-([\s\S]+?)%>/g, Fc = /<%([\s\S]+?)%>/g, Ef = /<%=([\s\S]+?)%>/g, Dc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, zc = /^\w*$/, Bc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, _u = /[\\^$.*+?()[\]{}|]/g, Wc = RegExp(_u.source), vu = /^\s+/, kc = /\s/, Uc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Gc = /\{\n\/\* \[wrapped with (.+)\] \*/, qc = /,? & /, Hc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Xc = /[()=,{}\[\]\/\s]/, Yc = /\\(\\)?/g, Kc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Af = /\w*$/, Zc = /^[-+]0x[0-9a-f]+$/i, Jc = /^0b[01]+$/i, Qc = /^\[object .+?Constructor\]$/, Vc = /^0o[0-7]+$/i, jc = /^(?:0|[1-9]\d*)$/, nh = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Dr = /($^)/, th = /['\n\r\u2028\u2029\\]/g, zr = "\ud800-\udfff", eh = "\\u0300-\\u036f", rh = "\\ufe20-\\ufe2f", ih = "\\u20d0-\\u20ff", Cf = eh + rh + ih, Rf = "\\u2700-\\u27bf", Tf = "a-z\\xdf-\\xf6\\xf8-\\xff", uh = "\\xac\\xb1\\xd7\\xf7", oh = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", fh = "\\u2000-\\u206f", sh = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", If = "A-Z\\xc0-\\xd6\\xd8-\\xde", Mf = "\\ufe0e\\ufe0f", Lf = uh + oh + fh + sh, wu = "['\u2019]", ah = "[" + zr + "]", bf = "[" + Lf + "]", Br = "[" + Cf + "]", Pf = "\\d+", lh = "[" + Rf + "]", Nf = "[" + Tf + "]", Of = "[^" + zr + Lf + Pf + Rf + Tf + If + "]", mu = "\ud83c[\udffb-\udfff]", ch = "(?:" + Br + "|" + mu + ")", $f = "[^" + zr + "]", yu = "(?:\ud83c[\udde6-\uddff]){2}", xu = "[\ud800-\udbff][\udc00-\udfff]", Re = "[" + If + "]", Ff = "\\u200d", Df = "(?:" + Nf + "|" + Of + ")", hh = "(?:" + Re + "|" + Of + ")", zf = "(?:" + wu + "(?:d|ll|m|re|s|t|ve))?", Bf = "(?:" + wu + "(?:D|LL|M|RE|S|T|VE))?", Wf = ch + "?", kf = "[" + Mf + "]?", ph = "(?:" + Ff + "(?:" + [
            $f,
            yu,
            xu
        ].join("|") + ")" + kf + Wf + ")*", gh = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", dh = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Uf = kf + Wf + ph, _h = "(?:" + [
            lh,
            yu,
            xu
        ].join("|") + ")" + Uf, vh = "(?:" + [
            $f + Br + "?",
            Br,
            yu,
            xu,
            ah
        ].join("|") + ")", wh = RegExp(wu, "g"), mh = RegExp(Br, "g"), Su = RegExp(mu + "(?=" + mu + ")|" + vh + Uf, "g"), yh = RegExp([
            Re + "?" + Nf + "+" + zf + "(?=" + [
                bf,
                Re,
                "$"
            ].join("|") + ")",
            hh + "+" + Bf + "(?=" + [
                bf,
                Re + Df,
                "$"
            ].join("|") + ")",
            Re + "?" + Df + "+" + zf,
            Re + "+" + Bf,
            dh,
            gh,
            Pf,
            _h
        ].join("|"), "g"), xh = RegExp("[" + Ff + zr + Cf + Mf + "]"), Sh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Eh = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], Ah = -1, En = {};
        En[fu] = En[su] = En[au] = En[lu] = En[cu] = En[hu] = En[pu] = En[gu] = En[du] = !0, En[Sn] = En[Jn] = En[je] = En[Hn] = En[Ce] = En[Dt] = En[Or] = En[$r] = En[St] = En[Ze] = En[zt] = En[Je] = En[Et] = En[Qe] = En[Ve] = !1;
        var mn = {};
        mn[Sn] = mn[Jn] = mn[je] = mn[Ce] = mn[Hn] = mn[Dt] = mn[fu] = mn[su] = mn[au] = mn[lu] = mn[cu] = mn[St] = mn[Ze] = mn[zt] = mn[Je] = mn[Et] = mn[Qe] = mn[Fr] = mn[hu] = mn[pu] = mn[gu] = mn[du] = !0, mn[Or] = mn[$r] = mn[Ve] = !1;
        var Ch = {
            // Latin-1 Supplement block.
            \u00C0: "A",
            \u00C1: "A",
            \u00C2: "A",
            \u00C3: "A",
            \u00C4: "A",
            \u00C5: "A",
            \u00E0: "a",
            \u00E1: "a",
            \u00E2: "a",
            \u00E3: "a",
            \u00E4: "a",
            \u00E5: "a",
            \u00C7: "C",
            \u00E7: "c",
            \u00D0: "D",
            \u00F0: "d",
            \u00C8: "E",
            \u00C9: "E",
            \u00CA: "E",
            \u00CB: "E",
            \u00E8: "e",
            \u00E9: "e",
            \u00EA: "e",
            \u00EB: "e",
            \u00CC: "I",
            \u00CD: "I",
            \u00CE: "I",
            \u00CF: "I",
            \u00EC: "i",
            \u00ED: "i",
            \u00EE: "i",
            \u00EF: "i",
            \u00D1: "N",
            \u00F1: "n",
            \u00D2: "O",
            \u00D3: "O",
            \u00D4: "O",
            \u00D5: "O",
            \u00D6: "O",
            \u00D8: "O",
            \u00F2: "o",
            \u00F3: "o",
            \u00F4: "o",
            \u00F5: "o",
            \u00F6: "o",
            \u00F8: "o",
            \u00D9: "U",
            \u00DA: "U",
            \u00DB: "U",
            \u00DC: "U",
            \u00F9: "u",
            \u00FA: "u",
            \u00FB: "u",
            \u00FC: "u",
            \u00DD: "Y",
            \u00FD: "y",
            \u00FF: "y",
            \u00C6: "Ae",
            \u00E6: "ae",
            \u00DE: "Th",
            \u00FE: "th",
            \u00DF: "ss",
            // Latin Extended-A block.
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        }, Rh = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        }, Th = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        }, Ih = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Mh = parseFloat, Lh = parseInt, Gf = typeof $3cfd30e35d79a5df$var$dr == "object" && $3cfd30e35d79a5df$var$dr && $3cfd30e35d79a5df$var$dr.Object === Object && $3cfd30e35d79a5df$var$dr, bh = typeof self == "object" && self && self.Object === Object && self, Wn = Gf || bh || Function("return this")(), Eu = r && !r.nodeType && r, se = Eu && !0 && e && !e.nodeType && e, qf = se && se.exports === Eu, Au = qf && Gf.process, ht = function() {
            try {
                var S = se && se.require && se.require("util").types;
                return S || Au && Au.binding && Au.binding("util");
            } catch  {}
        }(), Hf = ht && ht.isArrayBuffer, Xf = ht && ht.isDate, Yf = ht && ht.isMap, Kf = ht && ht.isRegExp, Zf = ht && ht.isSet, Jf = ht && ht.isTypedArray;
        function it(S, M, T) {
            switch(T.length){
                case 0:
                    return S.call(M);
                case 1:
                    return S.call(M, T[0]);
                case 2:
                    return S.call(M, T[0], T[1]);
                case 3:
                    return S.call(M, T[0], T[1], T[2]);
            }
            return S.apply(M, T);
        }
        function Ph(S, M, T, W) {
            for(var tn = -1, dn = S == null ? 0 : S.length; ++tn < dn;){
                var Fn = S[tn];
                M(W, Fn, T(Fn), S);
            }
            return W;
        }
        function pt(S, M) {
            for(var T = -1, W = S == null ? 0 : S.length; ++T < W && M(S[T], T, S) !== !1;);
            return S;
        }
        function Nh(S, M) {
            for(var T = S == null ? 0 : S.length; T-- && M(S[T], T, S) !== !1;);
            return S;
        }
        function Qf(S, M) {
            for(var T = -1, W = S == null ? 0 : S.length; ++T < W;)if (!M(S[T], T, S)) return !1;
            return !0;
        }
        function Vt(S, M) {
            for(var T = -1, W = S == null ? 0 : S.length, tn = 0, dn = []; ++T < W;){
                var Fn = S[T];
                M(Fn, T, S) && (dn[tn++] = Fn);
            }
            return dn;
        }
        function Wr(S, M) {
            var T = S == null ? 0 : S.length;
            return !!T && Te(S, M, 0) > -1;
        }
        function Cu(S, M, T) {
            for(var W = -1, tn = S == null ? 0 : S.length; ++W < tn;)if (T(M, S[W])) return !0;
            return !1;
        }
        function Cn(S, M) {
            for(var T = -1, W = S == null ? 0 : S.length, tn = Array(W); ++T < W;)tn[T] = M(S[T], T, S);
            return tn;
        }
        function jt(S, M) {
            for(var T = -1, W = M.length, tn = S.length; ++T < W;)S[tn + T] = M[T];
            return S;
        }
        function Ru(S, M, T, W) {
            var tn = -1, dn = S == null ? 0 : S.length;
            for(W && dn && (T = S[++tn]); ++tn < dn;)T = M(T, S[tn], tn, S);
            return T;
        }
        function Oh(S, M, T, W) {
            var tn = S == null ? 0 : S.length;
            for(W && tn && (T = S[--tn]); tn--;)T = M(T, S[tn], tn, S);
            return T;
        }
        function Tu(S, M) {
            for(var T = -1, W = S == null ? 0 : S.length; ++T < W;)if (M(S[T], T, S)) return !0;
            return !1;
        }
        var $h = Iu("length");
        function Fh(S) {
            return S.split("");
        }
        function Dh(S) {
            return S.match(Hc) || [];
        }
        function Vf(S, M, T) {
            var W;
            return T(S, function(tn, dn, Fn) {
                if (M(tn, dn, Fn)) return W = dn, !1;
            }), W;
        }
        function kr(S, M, T, W) {
            for(var tn = S.length, dn = T + (W ? 1 : -1); W ? dn-- : ++dn < tn;)if (M(S[dn], dn, S)) return dn;
            return -1;
        }
        function Te(S, M, T) {
            return M === M ? Zh(S, M, T) : kr(S, jf, T);
        }
        function zh(S, M, T, W) {
            for(var tn = T - 1, dn = S.length; ++tn < dn;)if (W(S[tn], M)) return tn;
            return -1;
        }
        function jf(S) {
            return S !== S;
        }
        function ns(S, M) {
            var T = S == null ? 0 : S.length;
            return T ? Lu(S, M) / T : nn;
        }
        function Iu(S) {
            return function(M) {
                return M == null ? u : M[S];
            };
        }
        function Mu(S) {
            return function(M) {
                return S == null ? u : S[M];
            };
        }
        function ts(S, M, T, W, tn) {
            return tn(S, function(dn, Fn, wn) {
                T = W ? (W = !1, dn) : M(T, dn, Fn, wn);
            }), T;
        }
        function Bh(S, M) {
            var T = S.length;
            for(S.sort(M); T--;)S[T] = S[T].value;
            return S;
        }
        function Lu(S, M) {
            for(var T, W = -1, tn = S.length; ++W < tn;){
                var dn = M(S[W]);
                dn !== u && (T = T === u ? dn : T + dn);
            }
            return T;
        }
        function bu(S, M) {
            for(var T = -1, W = Array(S); ++T < S;)W[T] = M(T);
            return W;
        }
        function Wh(S, M) {
            return Cn(M, function(T) {
                return [
                    T,
                    S[T]
                ];
            });
        }
        function es(S) {
            return S && S.slice(0, os(S) + 1).replace(vu, "");
        }
        function ut(S) {
            return function(M) {
                return S(M);
            };
        }
        function Pu(S, M) {
            return Cn(M, function(T) {
                return S[T];
            });
        }
        function nr(S, M) {
            return S.has(M);
        }
        function rs(S, M) {
            for(var T = -1, W = S.length; ++T < W && Te(M, S[T], 0) > -1;);
            return T;
        }
        function is(S, M) {
            for(var T = S.length; T-- && Te(M, S[T], 0) > -1;);
            return T;
        }
        function kh(S, M) {
            for(var T = S.length, W = 0; T--;)S[T] === M && ++W;
            return W;
        }
        var Uh = Mu(Ch), Gh = Mu(Rh);
        function qh(S) {
            return "\\" + Ih[S];
        }
        function Hh(S, M) {
            return S == null ? u : S[M];
        }
        function Ie(S) {
            return xh.test(S);
        }
        function Xh(S) {
            return Sh.test(S);
        }
        function Yh(S) {
            for(var M, T = []; !(M = S.next()).done;)T.push(M.value);
            return T;
        }
        function Nu(S) {
            var M = -1, T = Array(S.size);
            return S.forEach(function(W, tn) {
                T[++M] = [
                    tn,
                    W
                ];
            }), T;
        }
        function us(S, M) {
            return function(T) {
                return S(M(T));
            };
        }
        function ne(S, M) {
            for(var T = -1, W = S.length, tn = 0, dn = []; ++T < W;){
                var Fn = S[T];
                (Fn === M || Fn === d) && (S[T] = d, dn[tn++] = T);
            }
            return dn;
        }
        function Ur(S) {
            var M = -1, T = Array(S.size);
            return S.forEach(function(W) {
                T[++M] = W;
            }), T;
        }
        function Kh(S) {
            var M = -1, T = Array(S.size);
            return S.forEach(function(W) {
                T[++M] = [
                    W,
                    W
                ];
            }), T;
        }
        function Zh(S, M, T) {
            for(var W = T - 1, tn = S.length; ++W < tn;)if (S[W] === M) return W;
            return -1;
        }
        function Jh(S, M, T) {
            for(var W = T + 1; W--;)if (S[W] === M) return W;
            return W;
        }
        function Me(S) {
            return Ie(S) ? Vh(S) : $h(S);
        }
        function At(S) {
            return Ie(S) ? jh(S) : Fh(S);
        }
        function os(S) {
            for(var M = S.length; M-- && kc.test(S.charAt(M)););
            return M;
        }
        var Qh = Mu(Th);
        function Vh(S) {
            for(var M = Su.lastIndex = 0; Su.test(S);)++M;
            return M;
        }
        function jh(S) {
            return S.match(Su) || [];
        }
        function n0(S) {
            return S.match(yh) || [];
        }
        var t0 = function S(M) {
            M = M == null ? Wn : Le.defaults(Wn.Object(), M, Le.pick(Wn, Eh));
            var T = M.Array, W = M.Date, tn = M.Error, dn = M.Function, Fn = M.Math, wn = M.Object, Ou = M.RegExp, e0 = M.String, gt = M.TypeError, Gr = T.prototype, r0 = dn.prototype, be = wn.prototype, qr = M["__core-js_shared__"], Hr = r0.toString, vn = be.hasOwnProperty, i0 = 0, fs = function() {
                var n = /[^.]+$/.exec(qr && qr.keys && qr.keys.IE_PROTO || "");
                return n ? "Symbol(src)_1." + n : "";
            }(), Xr = be.toString, u0 = Hr.call(wn), o0 = Wn._, f0 = Ou("^" + Hr.call(vn).replace(_u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Yr = qf ? M.Buffer : u, te = M.Symbol, Kr = M.Uint8Array, ss = Yr ? Yr.allocUnsafe : u, Zr = us(wn.getPrototypeOf, wn), as = wn.create, ls = be.propertyIsEnumerable, Jr = Gr.splice, cs = te ? te.isConcatSpreadable : u, tr = te ? te.iterator : u, ae = te ? te.toStringTag : u, Qr = function() {
                try {
                    var n = ge(wn, "defineProperty");
                    return n({}, "", {}), n;
                } catch  {}
            }(), s0 = M.clearTimeout !== Wn.clearTimeout && M.clearTimeout, a0 = W && W.now !== Wn.Date.now && W.now, l0 = M.setTimeout !== Wn.setTimeout && M.setTimeout, Vr = Fn.ceil, jr = Fn.floor, $u = wn.getOwnPropertySymbols, c0 = Yr ? Yr.isBuffer : u, hs = M.isFinite, h0 = Gr.join, p0 = us(wn.keys, wn), Dn = Fn.max, Gn = Fn.min, g0 = W.now, d0 = M.parseInt, ps = Fn.random, _0 = Gr.reverse, Fu = ge(M, "DataView"), er = ge(M, "Map"), Du = ge(M, "Promise"), Pe = ge(M, "Set"), rr = ge(M, "WeakMap"), ir = ge(wn, "create"), ni = rr && new rr(), Ne = {}, v0 = de(Fu), w0 = de(er), m0 = de(Du), y0 = de(Pe), x0 = de(rr), ti = te ? te.prototype : u, ur = ti ? ti.valueOf : u, gs = ti ? ti.toString : u;
            function l(n) {
                if (Mn(n) && !en(n) && !(n instanceof ln)) {
                    if (n instanceof dt) return n;
                    if (vn.call(n, "__wrapped__")) return da(n);
                }
                return new dt(n);
            }
            var Oe = /* @__PURE__ */ function() {
                function n() {}
                return function(t) {
                    if (!Rn(t)) return {};
                    if (as) return as(t);
                    n.prototype = t;
                    var i = new n();
                    return n.prototype = u, i;
                };
            }();
            function ei() {}
            function dt(n, t) {
                this.__wrapped__ = n, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = u;
            }
            l.templateSettings = {
                /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */ escape: $c,
                /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */ evaluate: Fc,
                /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */ interpolate: Ef,
                /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */ variable: "",
                /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */ imports: {
                    /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */ _: l
                }
            }, l.prototype = ei.prototype, l.prototype.constructor = l, dt.prototype = Oe(ei.prototype), dt.prototype.constructor = dt;
            function ln(n) {
                this.__wrapped__ = n, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
            }
            function S0() {
                var n = new ln(this.__wrapped__);
                return n.__actions__ = Qn(this.__actions__), n.__dir__ = this.__dir__, n.__filtered__ = this.__filtered__, n.__iteratees__ = Qn(this.__iteratees__), n.__takeCount__ = this.__takeCount__, n.__views__ = Qn(this.__views__), n;
            }
            function E0() {
                if (this.__filtered__) {
                    var n = new ln(this);
                    n.__dir__ = -1, n.__filtered__ = !0;
                } else n = this.clone(), n.__dir__ *= -1;
                return n;
            }
            function A0() {
                var n = this.__wrapped__.value(), t = this.__dir__, i = en(n), o = t < 0, a = i ? n.length : 0, p = Fp(0, a, this.__views__), _ = p.start, m = p.end, E = m - _, L = o ? m : _ - 1, b = this.__iteratees__, N = b.length, D = 0, H = Gn(E, this.__takeCount__);
                if (!i || !o && a == E && H == E) return zs(n, this.__actions__);
                var Z = [];
                n: for(; E-- && D < H;){
                    L += t;
                    for(var fn = -1, J = n[L]; ++fn < N;){
                        var an = b[fn], cn = an.iteratee, st = an.type, Kn = cn(J);
                        if (st == R) J = Kn;
                        else if (!Kn) {
                            if (st == A) continue n;
                            break n;
                        }
                    }
                    Z[D++] = J;
                }
                return Z;
            }
            ln.prototype = Oe(ei.prototype), ln.prototype.constructor = ln;
            function le(n) {
                var t = -1, i = n == null ? 0 : n.length;
                for(this.clear(); ++t < i;){
                    var o = n[t];
                    this.set(o[0], o[1]);
                }
            }
            function C0() {
                this.__data__ = ir ? ir(null) : {}, this.size = 0;
            }
            function R0(n) {
                var t = this.has(n) && delete this.__data__[n];
                return this.size -= t ? 1 : 0, t;
            }
            function T0(n) {
                var t = this.__data__;
                if (ir) {
                    var i = t[n];
                    return i === v ? u : i;
                }
                return vn.call(t, n) ? t[n] : u;
            }
            function I0(n) {
                var t = this.__data__;
                return ir ? t[n] !== u : vn.call(t, n);
            }
            function M0(n, t) {
                var i = this.__data__;
                return this.size += this.has(n) ? 0 : 1, i[n] = ir && t === u ? v : t, this;
            }
            le.prototype.clear = C0, le.prototype.delete = R0, le.prototype.get = T0, le.prototype.has = I0, le.prototype.set = M0;
            function Bt(n) {
                var t = -1, i = n == null ? 0 : n.length;
                for(this.clear(); ++t < i;){
                    var o = n[t];
                    this.set(o[0], o[1]);
                }
            }
            function L0() {
                this.__data__ = [], this.size = 0;
            }
            function b0(n) {
                var t = this.__data__, i = ri(t, n);
                if (i < 0) return !1;
                var o = t.length - 1;
                return i == o ? t.pop() : Jr.call(t, i, 1), --this.size, !0;
            }
            function P0(n) {
                var t = this.__data__, i = ri(t, n);
                return i < 0 ? u : t[i][1];
            }
            function N0(n) {
                return ri(this.__data__, n) > -1;
            }
            function O0(n, t) {
                var i = this.__data__, o = ri(i, n);
                return o < 0 ? (++this.size, i.push([
                    n,
                    t
                ])) : i[o][1] = t, this;
            }
            Bt.prototype.clear = L0, Bt.prototype.delete = b0, Bt.prototype.get = P0, Bt.prototype.has = N0, Bt.prototype.set = O0;
            function Wt(n) {
                var t = -1, i = n == null ? 0 : n.length;
                for(this.clear(); ++t < i;){
                    var o = n[t];
                    this.set(o[0], o[1]);
                }
            }
            function $0() {
                this.size = 0, this.__data__ = {
                    hash: new le(),
                    map: new (er || Bt)(),
                    string: new le()
                };
            }
            function F0(n) {
                var t = di(this, n).delete(n);
                return this.size -= t ? 1 : 0, t;
            }
            function D0(n) {
                return di(this, n).get(n);
            }
            function z0(n) {
                return di(this, n).has(n);
            }
            function B0(n, t) {
                var i = di(this, n), o = i.size;
                return i.set(n, t), this.size += i.size == o ? 0 : 1, this;
            }
            Wt.prototype.clear = $0, Wt.prototype.delete = F0, Wt.prototype.get = D0, Wt.prototype.has = z0, Wt.prototype.set = B0;
            function ce(n) {
                var t = -1, i = n == null ? 0 : n.length;
                for(this.__data__ = new Wt(); ++t < i;)this.add(n[t]);
            }
            function W0(n) {
                return this.__data__.set(n, v), this;
            }
            function k0(n) {
                return this.__data__.has(n);
            }
            ce.prototype.add = ce.prototype.push = W0, ce.prototype.has = k0;
            function Ct(n) {
                var t = this.__data__ = new Bt(n);
                this.size = t.size;
            }
            function U0() {
                this.__data__ = new Bt(), this.size = 0;
            }
            function G0(n) {
                var t = this.__data__, i = t.delete(n);
                return this.size = t.size, i;
            }
            function q0(n) {
                return this.__data__.get(n);
            }
            function H0(n) {
                return this.__data__.has(n);
            }
            function X0(n, t) {
                var i = this.__data__;
                if (i instanceof Bt) {
                    var o = i.__data__;
                    if (!er || o.length < s - 1) return o.push([
                        n,
                        t
                    ]), this.size = ++i.size, this;
                    i = this.__data__ = new Wt(o);
                }
                return i.set(n, t), this.size = i.size, this;
            }
            Ct.prototype.clear = U0, Ct.prototype.delete = G0, Ct.prototype.get = q0, Ct.prototype.has = H0, Ct.prototype.set = X0;
            function ds(n, t) {
                var i = en(n), o = !i && _e(n), a = !i && !o && oe(n), p = !i && !o && !a && ze(n), _ = i || o || a || p, m = _ ? bu(n.length, e0) : [], E = m.length;
                for(var L in n)(t || vn.call(n, L)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
                (L == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
                a && (L == "offset" || L == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
                p && (L == "buffer" || L == "byteLength" || L == "byteOffset") || // Skip index properties.
                qt(L, E))) && m.push(L);
                return m;
            }
            function _s(n) {
                var t = n.length;
                return t ? n[Ku(0, t - 1)] : u;
            }
            function Y0(n, t) {
                return _i(Qn(n), he(t, 0, n.length));
            }
            function K0(n) {
                return _i(Qn(n));
            }
            function zu(n, t, i) {
                (i !== u && !Rt(n[t], i) || i === u && !(t in n)) && kt(n, t, i);
            }
            function or(n, t, i) {
                var o = n[t];
                (!(vn.call(n, t) && Rt(o, i)) || i === u && !(t in n)) && kt(n, t, i);
            }
            function ri(n, t) {
                for(var i = n.length; i--;)if (Rt(n[i][0], t)) return i;
                return -1;
            }
            function Z0(n, t, i, o) {
                return ee(n, function(a, p, _) {
                    t(o, a, i(a), _);
                }), o;
            }
            function vs(n, t) {
                return n && bt(t, Bn(t), n);
            }
            function J0(n, t) {
                return n && bt(t, jn(t), n);
            }
            function kt(n, t, i) {
                t == "__proto__" && Qr ? Qr(n, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: i,
                    writable: !0
                }) : n[t] = i;
            }
            function Bu(n, t) {
                for(var i = -1, o = t.length, a = T(o), p = n == null; ++i < o;)a[i] = p ? u : yo(n, t[i]);
                return a;
            }
            function he(n, t, i) {
                return n === n && (i !== u && (n = n <= i ? n : i), t !== u && (n = n >= t ? n : t)), n;
            }
            function _t(n, t, i, o, a, p) {
                var _, m = t & y, E = t & x, L = t & C;
                if (i && (_ = a ? i(n, o, a, p) : i(n)), _ !== u) return _;
                if (!Rn(n)) return n;
                var b = en(n);
                if (b) {
                    if (_ = zp(n), !m) return Qn(n, _);
                } else {
                    var N = qn(n), D = N == $r || N == mf;
                    if (oe(n)) return ks(n, m);
                    if (N == zt || N == Sn || D && !a) {
                        if (_ = E || D ? {} : oa(n), !m) return E ? Tp(n, J0(_, n)) : Rp(n, vs(_, n));
                    } else {
                        if (!mn[N]) return a ? n : {};
                        _ = Bp(n, N, m);
                    }
                }
                p || (p = new Ct());
                var H = p.get(n);
                if (H) return H;
                p.set(n, _), $a(n) ? n.forEach(function(J) {
                    _.add(_t(J, t, i, J, n, p));
                }) : Na(n) && n.forEach(function(J, an) {
                    _.set(an, _t(J, t, i, an, n, p));
                });
                var Z = L ? E ? uo : io : E ? jn : Bn, fn = b ? u : Z(n);
                return pt(fn || n, function(J, an) {
                    fn && (an = J, J = n[an]), or(_, an, _t(J, t, i, an, n, p));
                }), _;
            }
            function Q0(n) {
                var t = Bn(n);
                return function(i) {
                    return ws(i, n, t);
                };
            }
            function ws(n, t, i) {
                var o = i.length;
                if (n == null) return !o;
                for(n = wn(n); o--;){
                    var a = i[o], p = t[a], _ = n[a];
                    if (_ === u && !(a in n) || !p(_)) return !1;
                }
                return !0;
            }
            function ms(n, t, i) {
                if (typeof n != "function") throw new gt(c);
                return pr(function() {
                    n.apply(u, i);
                }, t);
            }
            function fr(n, t, i, o) {
                var a = -1, p = Wr, _ = !0, m = n.length, E = [], L = t.length;
                if (!m) return E;
                i && (t = Cn(t, ut(i))), o ? (p = Cu, _ = !1) : t.length >= s && (p = nr, _ = !1, t = new ce(t));
                n: for(; ++a < m;){
                    var b = n[a], N = i == null ? b : i(b);
                    if (b = o || b !== 0 ? b : 0, _ && N === N) {
                        for(var D = L; D--;)if (t[D] === N) continue n;
                        E.push(b);
                    } else p(t, N, o) || E.push(b);
                }
                return E;
            }
            var ee = Xs(Lt), ys = Xs(ku, !0);
            function V0(n, t) {
                var i = !0;
                return ee(n, function(o, a, p) {
                    return i = !!t(o, a, p), i;
                }), i;
            }
            function ii(n, t, i) {
                for(var o = -1, a = n.length; ++o < a;){
                    var p = n[o], _ = t(p);
                    if (_ != null && (m === u ? _ === _ && !ft(_) : i(_, m))) var m = _, E = p;
                }
                return E;
            }
            function j0(n, t, i, o) {
                var a = n.length;
                for(i = un(i), i < 0 && (i = -i > a ? 0 : a + i), o = o === u || o > a ? a : un(o), o < 0 && (o += a), o = i > o ? 0 : Da(o); i < o;)n[i++] = t;
                return n;
            }
            function xs(n, t) {
                var i = [];
                return ee(n, function(o, a, p) {
                    t(o, a, p) && i.push(o);
                }), i;
            }
            function kn(n, t, i, o, a) {
                var p = -1, _ = n.length;
                for(i || (i = kp), a || (a = []); ++p < _;){
                    var m = n[p];
                    t > 0 && i(m) ? t > 1 ? kn(m, t - 1, i, o, a) : jt(a, m) : o || (a[a.length] = m);
                }
                return a;
            }
            var Wu = Ys(), Ss = Ys(!0);
            function Lt(n, t) {
                return n && Wu(n, t, Bn);
            }
            function ku(n, t) {
                return n && Ss(n, t, Bn);
            }
            function ui(n, t) {
                return Vt(t, function(i) {
                    return Ht(n[i]);
                });
            }
            function pe(n, t) {
                t = ie(t, n);
                for(var i = 0, o = t.length; n != null && i < o;)n = n[Pt(t[i++])];
                return i && i == o ? n : u;
            }
            function Es(n, t, i) {
                var o = t(n);
                return en(n) ? o : jt(o, i(n));
            }
            function Xn(n) {
                return n == null ? n === u ? Ic : Rc : ae && ae in wn(n) ? $p(n) : Kp(n);
            }
            function Uu(n, t) {
                return n > t;
            }
            function np(n, t) {
                return n != null && vn.call(n, t);
            }
            function tp(n, t) {
                return n != null && t in wn(n);
            }
            function ep(n, t, i) {
                return n >= Gn(t, i) && n < Dn(t, i);
            }
            function Gu(n, t, i) {
                for(var o = i ? Cu : Wr, a = n[0].length, p = n.length, _ = p, m = T(p), E = 1 / 0, L = []; _--;){
                    var b = n[_];
                    _ && t && (b = Cn(b, ut(t))), E = Gn(b.length, E), m[_] = !i && (t || a >= 120 && b.length >= 120) ? new ce(_ && b) : u;
                }
                b = n[0];
                var N = -1, D = m[0];
                n: for(; ++N < a && L.length < E;){
                    var H = b[N], Z = t ? t(H) : H;
                    if (H = i || H !== 0 ? H : 0, !(D ? nr(D, Z) : o(L, Z, i))) {
                        for(_ = p; --_;){
                            var fn = m[_];
                            if (!(fn ? nr(fn, Z) : o(n[_], Z, i))) continue n;
                        }
                        D && D.push(Z), L.push(H);
                    }
                }
                return L;
            }
            function rp(n, t, i, o) {
                return Lt(n, function(a, p, _) {
                    t(o, i(a), p, _);
                }), o;
            }
            function sr(n, t, i) {
                t = ie(t, n), n = la(n, t);
                var o = n == null ? n : n[Pt(wt(t))];
                return o == null ? u : it(o, n, i);
            }
            function As(n) {
                return Mn(n) && Xn(n) == Sn;
            }
            function ip(n) {
                return Mn(n) && Xn(n) == je;
            }
            function up(n) {
                return Mn(n) && Xn(n) == Dt;
            }
            function ar(n, t, i, o, a) {
                return n === t ? !0 : n == null || t == null || !Mn(n) && !Mn(t) ? n !== n && t !== t : op(n, t, i, o, ar, a);
            }
            function op(n, t, i, o, a, p) {
                var _ = en(n), m = en(t), E = _ ? Jn : qn(n), L = m ? Jn : qn(t);
                E = E == Sn ? zt : E, L = L == Sn ? zt : L;
                var b = E == zt, N = L == zt, D = E == L;
                if (D && oe(n)) {
                    if (!oe(t)) return !1;
                    _ = !0, b = !1;
                }
                if (D && !b) return p || (p = new Ct()), _ || ze(n) ? ra(n, t, i, o, a, p) : Np(n, t, E, i, o, a, p);
                if (!(i & P)) {
                    var H = b && vn.call(n, "__wrapped__"), Z = N && vn.call(t, "__wrapped__");
                    if (H || Z) {
                        var fn = H ? n.value() : n, J = Z ? t.value() : t;
                        return p || (p = new Ct()), a(fn, J, i, o, p);
                    }
                }
                return D ? (p || (p = new Ct()), Op(n, t, i, o, a, p)) : !1;
            }
            function fp(n) {
                return Mn(n) && qn(n) == St;
            }
            function qu(n, t, i, o) {
                var a = i.length, p = a, _ = !o;
                if (n == null) return !p;
                for(n = wn(n); a--;){
                    var m = i[a];
                    if (_ && m[2] ? m[1] !== n[m[0]] : !(m[0] in n)) return !1;
                }
                for(; ++a < p;){
                    m = i[a];
                    var E = m[0], L = n[E], b = m[1];
                    if (_ && m[2]) {
                        if (L === u && !(E in n)) return !1;
                    } else {
                        var N = new Ct();
                        if (o) var D = o(L, b, E, n, t, N);
                        if (!(D === u ? ar(b, L, P | z, o, N) : D)) return !1;
                    }
                }
                return !0;
            }
            function Cs(n) {
                if (!Rn(n) || Gp(n)) return !1;
                var t = Ht(n) ? f0 : Qc;
                return t.test(de(n));
            }
            function sp(n) {
                return Mn(n) && Xn(n) == Je;
            }
            function ap(n) {
                return Mn(n) && qn(n) == Et;
            }
            function lp(n) {
                return Mn(n) && Si(n.length) && !!En[Xn(n)];
            }
            function Rs(n) {
                return typeof n == "function" ? n : n == null ? nt : typeof n == "object" ? en(n) ? Ms(n[0], n[1]) : Is(n) : Ka(n);
            }
            function Hu(n) {
                if (!hr(n)) return p0(n);
                var t = [];
                for(var i in wn(n))vn.call(n, i) && i != "constructor" && t.push(i);
                return t;
            }
            function cp(n) {
                if (!Rn(n)) return Yp(n);
                var t = hr(n), i = [];
                for(var o in n)o == "constructor" && (t || !vn.call(n, o)) || i.push(o);
                return i;
            }
            function Xu(n, t) {
                return n < t;
            }
            function Ts(n, t) {
                var i = -1, o = Vn(n) ? T(n.length) : [];
                return ee(n, function(a, p, _) {
                    o[++i] = t(a, p, _);
                }), o;
            }
            function Is(n) {
                var t = fo(n);
                return t.length == 1 && t[0][2] ? sa(t[0][0], t[0][1]) : function(i) {
                    return i === n || qu(i, n, t);
                };
            }
            function Ms(n, t) {
                return ao(n) && fa(t) ? sa(Pt(n), t) : function(i) {
                    var o = yo(i, n);
                    return o === u && o === t ? xo(i, n) : ar(t, o, P | z);
                };
            }
            function oi(n, t, i, o, a) {
                n !== t && Wu(t, function(p, _) {
                    if (a || (a = new Ct()), Rn(p)) hp(n, t, _, i, oi, o, a);
                    else {
                        var m = o ? o(co(n, _), p, _ + "", n, t, a) : u;
                        m === u && (m = p), zu(n, _, m);
                    }
                }, jn);
            }
            function hp(n, t, i, o, a, p, _) {
                var m = co(n, i), E = co(t, i), L = _.get(E);
                if (L) {
                    zu(n, i, L);
                    return;
                }
                var b = p ? p(m, E, i + "", n, t, _) : u, N = b === u;
                if (N) {
                    var D = en(E), H = !D && oe(E), Z = !D && !H && ze(E);
                    b = E, D || H || Z ? en(m) ? b = m : bn(m) ? b = Qn(m) : H ? (N = !1, b = ks(E, !0)) : Z ? (N = !1, b = Us(E, !0)) : b = [] : gr(E) || _e(E) ? (b = m, _e(m) ? b = za(m) : (!Rn(m) || Ht(m)) && (b = oa(E))) : N = !1;
                }
                N && (_.set(E, b), a(b, E, o, p, _), _.delete(E)), zu(n, i, b);
            }
            function Ls(n, t) {
                var i = n.length;
                if (i) return t += t < 0 ? i : 0, qt(t, i) ? n[t] : u;
            }
            function bs(n, t, i) {
                t.length ? t = Cn(t, function(p) {
                    return en(p) ? function(_) {
                        return pe(_, p.length === 1 ? p[0] : p);
                    } : p;
                }) : t = [
                    nt
                ];
                var o = -1;
                t = Cn(t, ut(K()));
                var a = Ts(n, function(p, _, m) {
                    var E = Cn(t, function(L) {
                        return L(p);
                    });
                    return {
                        criteria: E,
                        index: ++o,
                        value: p
                    };
                });
                return Bh(a, function(p, _) {
                    return Cp(p, _, i);
                });
            }
            function pp(n, t) {
                return Ps(n, t, function(i, o) {
                    return xo(n, o);
                });
            }
            function Ps(n, t, i) {
                for(var o = -1, a = t.length, p = {}; ++o < a;){
                    var _ = t[o], m = pe(n, _);
                    i(m, _) && lr(p, ie(_, n), m);
                }
                return p;
            }
            function gp(n) {
                return function(t) {
                    return pe(t, n);
                };
            }
            function Yu(n, t, i, o) {
                var a = o ? zh : Te, p = -1, _ = t.length, m = n;
                for(n === t && (t = Qn(t)), i && (m = Cn(n, ut(i))); ++p < _;)for(var E = 0, L = t[p], b = i ? i(L) : L; (E = a(m, b, E, o)) > -1;)m !== n && Jr.call(m, E, 1), Jr.call(n, E, 1);
                return n;
            }
            function Ns(n, t) {
                for(var i = n ? t.length : 0, o = i - 1; i--;){
                    var a = t[i];
                    if (i == o || a !== p) {
                        var p = a;
                        qt(a) ? Jr.call(n, a, 1) : Qu(n, a);
                    }
                }
                return n;
            }
            function Ku(n, t) {
                return n + jr(ps() * (t - n + 1));
            }
            function dp(n, t, i, o) {
                for(var a = -1, p = Dn(Vr((t - n) / (i || 1)), 0), _ = T(p); p--;)_[o ? p : ++a] = n, n += i;
                return _;
            }
            function Zu(n, t) {
                var i = "";
                if (!n || t < 1 || t > G) return i;
                do t % 2 && (i += n), t = jr(t / 2), t && (n += n);
                while (t);
                return i;
            }
            function sn(n, t) {
                return ho(aa(n, t, nt), n + "");
            }
            function _p(n) {
                return _s(Be(n));
            }
            function vp(n, t) {
                var i = Be(n);
                return _i(i, he(t, 0, i.length));
            }
            function lr(n, t, i, o) {
                if (!Rn(n)) return n;
                t = ie(t, n);
                for(var a = -1, p = t.length, _ = p - 1, m = n; m != null && ++a < p;){
                    var E = Pt(t[a]), L = i;
                    if (E === "__proto__" || E === "constructor" || E === "prototype") return n;
                    if (a != _) {
                        var b = m[E];
                        L = o ? o(b, E, m) : u, L === u && (L = Rn(b) ? b : qt(t[a + 1]) ? [] : {});
                    }
                    or(m, E, L), m = m[E];
                }
                return n;
            }
            var Os = ni ? function(n, t) {
                return ni.set(n, t), n;
            } : nt, wp = Qr ? function(n, t) {
                return Qr(n, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: Eo(t),
                    writable: !0
                });
            } : nt;
            function mp(n) {
                return _i(Be(n));
            }
            function vt(n, t, i) {
                var o = -1, a = n.length;
                t < 0 && (t = -t > a ? 0 : a + t), i = i > a ? a : i, i < 0 && (i += a), a = t > i ? 0 : i - t >>> 0, t >>>= 0;
                for(var p = T(a); ++o < a;)p[o] = n[o + t];
                return p;
            }
            function yp(n, t) {
                var i;
                return ee(n, function(o, a, p) {
                    return i = t(o, a, p), !i;
                }), !!i;
            }
            function fi(n, t, i) {
                var o = 0, a = n == null ? o : n.length;
                if (typeof t == "number" && t === t && a <= In) {
                    for(; o < a;){
                        var p = o + a >>> 1, _ = n[p];
                        _ !== null && !ft(_) && (i ? _ <= t : _ < t) ? o = p + 1 : a = p;
                    }
                    return a;
                }
                return Ju(n, t, nt, i);
            }
            function Ju(n, t, i, o) {
                var a = 0, p = n == null ? 0 : n.length;
                if (p === 0) return 0;
                t = i(t);
                for(var _ = t !== t, m = t === null, E = ft(t), L = t === u; a < p;){
                    var b = jr((a + p) / 2), N = i(n[b]), D = N !== u, H = N === null, Z = N === N, fn = ft(N);
                    if (_) var J = o || Z;
                    else L ? J = Z && (o || D) : m ? J = Z && D && (o || !H) : E ? J = Z && D && !H && (o || !fn) : H || fn ? J = !1 : J = o ? N <= t : N < t;
                    J ? a = b + 1 : p = b;
                }
                return Gn(p, gn);
            }
            function $s(n, t) {
                for(var i = -1, o = n.length, a = 0, p = []; ++i < o;){
                    var _ = n[i], m = t ? t(_) : _;
                    if (!i || !Rt(m, E)) {
                        var E = m;
                        p[a++] = _ === 0 ? 0 : _;
                    }
                }
                return p;
            }
            function Fs(n) {
                return typeof n == "number" ? n : ft(n) ? nn : +n;
            }
            function ot(n) {
                if (typeof n == "string") return n;
                if (en(n)) return Cn(n, ot) + "";
                if (ft(n)) return gs ? gs.call(n) : "";
                var t = n + "";
                return t == "0" && 1 / n == -F ? "-0" : t;
            }
            function re(n, t, i) {
                var o = -1, a = Wr, p = n.length, _ = !0, m = [], E = m;
                if (i) _ = !1, a = Cu;
                else if (p >= s) {
                    var L = t ? null : bp(n);
                    if (L) return Ur(L);
                    _ = !1, a = nr, E = new ce();
                } else E = t ? [] : m;
                n: for(; ++o < p;){
                    var b = n[o], N = t ? t(b) : b;
                    if (b = i || b !== 0 ? b : 0, _ && N === N) {
                        for(var D = E.length; D--;)if (E[D] === N) continue n;
                        t && E.push(N), m.push(b);
                    } else a(E, N, i) || (E !== m && E.push(N), m.push(b));
                }
                return m;
            }
            function Qu(n, t) {
                return t = ie(t, n), n = la(n, t), n == null || delete n[Pt(wt(t))];
            }
            function Ds(n, t, i, o) {
                return lr(n, t, i(pe(n, t)), o);
            }
            function si(n, t, i, o) {
                for(var a = n.length, p = o ? a : -1; (o ? p-- : ++p < a) && t(n[p], p, n););
                return i ? vt(n, o ? 0 : p, o ? p + 1 : a) : vt(n, o ? p + 1 : 0, o ? a : p);
            }
            function zs(n, t) {
                var i = n;
                return i instanceof ln && (i = i.value()), Ru(t, function(o, a) {
                    return a.func.apply(a.thisArg, jt([
                        o
                    ], a.args));
                }, i);
            }
            function Vu(n, t, i) {
                var o = n.length;
                if (o < 2) return o ? re(n[0]) : [];
                for(var a = -1, p = T(o); ++a < o;)for(var _ = n[a], m = -1; ++m < o;)m != a && (p[a] = fr(p[a] || _, n[m], t, i));
                return re(kn(p, 1), t, i);
            }
            function Bs(n, t, i) {
                for(var o = -1, a = n.length, p = t.length, _ = {}; ++o < a;){
                    var m = o < p ? t[o] : u;
                    i(_, n[o], m);
                }
                return _;
            }
            function ju(n) {
                return bn(n) ? n : [];
            }
            function no(n) {
                return typeof n == "function" ? n : nt;
            }
            function ie(n, t) {
                return en(n) ? n : ao(n, t) ? [
                    n
                ] : ga(_n(n));
            }
            var xp = sn;
            function ue(n, t, i) {
                var o = n.length;
                return i = i === u ? o : i, !t && i >= o ? n : vt(n, t, i);
            }
            var Ws = s0 || function(n) {
                return Wn.clearTimeout(n);
            };
            function ks(n, t) {
                if (t) return n.slice();
                var i = n.length, o = ss ? ss(i) : new n.constructor(i);
                return n.copy(o), o;
            }
            function to(n) {
                var t = new n.constructor(n.byteLength);
                return new Kr(t).set(new Kr(n)), t;
            }
            function Sp(n, t) {
                var i = t ? to(n.buffer) : n.buffer;
                return new n.constructor(i, n.byteOffset, n.byteLength);
            }
            function Ep(n) {
                var t = new n.constructor(n.source, Af.exec(n));
                return t.lastIndex = n.lastIndex, t;
            }
            function Ap(n) {
                return ur ? wn(ur.call(n)) : {};
            }
            function Us(n, t) {
                var i = t ? to(n.buffer) : n.buffer;
                return new n.constructor(i, n.byteOffset, n.length);
            }
            function Gs(n, t) {
                if (n !== t) {
                    var i = n !== u, o = n === null, a = n === n, p = ft(n), _ = t !== u, m = t === null, E = t === t, L = ft(t);
                    if (!m && !L && !p && n > t || p && _ && E && !m && !L || o && _ && E || !i && E || !a) return 1;
                    if (!o && !p && !L && n < t || L && i && a && !o && !p || m && i && a || !_ && a || !E) return -1;
                }
                return 0;
            }
            function Cp(n, t, i) {
                for(var o = -1, a = n.criteria, p = t.criteria, _ = a.length, m = i.length; ++o < _;){
                    var E = Gs(a[o], p[o]);
                    if (E) {
                        if (o >= m) return E;
                        var L = i[o];
                        return E * (L == "desc" ? -1 : 1);
                    }
                }
                return n.index - t.index;
            }
            function qs(n, t, i, o) {
                for(var a = -1, p = n.length, _ = i.length, m = -1, E = t.length, L = Dn(p - _, 0), b = T(E + L), N = !o; ++m < E;)b[m] = t[m];
                for(; ++a < _;)(N || a < p) && (b[i[a]] = n[a]);
                for(; L--;)b[m++] = n[a++];
                return b;
            }
            function Hs(n, t, i, o) {
                for(var a = -1, p = n.length, _ = -1, m = i.length, E = -1, L = t.length, b = Dn(p - m, 0), N = T(b + L), D = !o; ++a < b;)N[a] = n[a];
                for(var H = a; ++E < L;)N[H + E] = t[E];
                for(; ++_ < m;)(D || a < p) && (N[H + i[_]] = n[a++]);
                return N;
            }
            function Qn(n, t) {
                var i = -1, o = n.length;
                for(t || (t = T(o)); ++i < o;)t[i] = n[i];
                return t;
            }
            function bt(n, t, i, o) {
                var a = !i;
                i || (i = {});
                for(var p = -1, _ = t.length; ++p < _;){
                    var m = t[p], E = o ? o(i[m], n[m], m, i, n) : u;
                    E === u && (E = n[m]), a ? kt(i, m, E) : or(i, m, E);
                }
                return i;
            }
            function Rp(n, t) {
                return bt(n, so(n), t);
            }
            function Tp(n, t) {
                return bt(n, ia(n), t);
            }
            function ai(n, t) {
                return function(i, o) {
                    var a = en(i) ? Ph : Z0, p = t ? t() : {};
                    return a(i, n, K(o, 2), p);
                };
            }
            function $e(n) {
                return sn(function(t, i) {
                    var o = -1, a = i.length, p = a > 1 ? i[a - 1] : u, _ = a > 2 ? i[2] : u;
                    for(p = n.length > 3 && typeof p == "function" ? (a--, p) : u, _ && Yn(i[0], i[1], _) && (p = a < 3 ? u : p, a = 1), t = wn(t); ++o < a;){
                        var m = i[o];
                        m && n(t, m, o, p);
                    }
                    return t;
                });
            }
            function Xs(n, t) {
                return function(i, o) {
                    if (i == null) return i;
                    if (!Vn(i)) return n(i, o);
                    for(var a = i.length, p = t ? a : -1, _ = wn(i); (t ? p-- : ++p < a) && o(_[p], p, _) !== !1;);
                    return i;
                };
            }
            function Ys(n) {
                return function(t, i, o) {
                    for(var a = -1, p = wn(t), _ = o(t), m = _.length; m--;){
                        var E = _[n ? m : ++a];
                        if (i(p[E], E, p) === !1) break;
                    }
                    return t;
                };
            }
            function Ip(n, t, i) {
                var o = t & $, a = cr(n);
                function p() {
                    var _ = this && this !== Wn && this instanceof p ? a : n;
                    return _.apply(o ? i : this, arguments);
                }
                return p;
            }
            function Ks(n) {
                return function(t) {
                    t = _n(t);
                    var i = Ie(t) ? At(t) : u, o = i ? i[0] : t.charAt(0), a = i ? ue(i, 1).join("") : t.slice(1);
                    return o[n]() + a;
                };
            }
            function Fe(n) {
                return function(t) {
                    return Ru(Xa(Ha(t).replace(wh, "")), n, "");
                };
            }
            function cr(n) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new n();
                        case 1:
                            return new n(t[0]);
                        case 2:
                            return new n(t[0], t[1]);
                        case 3:
                            return new n(t[0], t[1], t[2]);
                        case 4:
                            return new n(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new n(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new n(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var i = Oe(n.prototype), o = n.apply(i, t);
                    return Rn(o) ? o : i;
                };
            }
            function Mp(n, t, i) {
                var o = cr(n);
                function a() {
                    for(var p = arguments.length, _ = T(p), m = p, E = De(a); m--;)_[m] = arguments[m];
                    var L = p < 3 && _[0] !== E && _[p - 1] !== E ? [] : ne(_, E);
                    if (p -= L.length, p < i) return js(n, t, li, a.placeholder, u, _, L, u, u, i - p);
                    var b = this && this !== Wn && this instanceof a ? o : n;
                    return it(b, this, _);
                }
                return a;
            }
            function Zs(n) {
                return function(t, i, o) {
                    var a = wn(t);
                    if (!Vn(t)) {
                        var p = K(i, 3);
                        t = Bn(t), i = function(m) {
                            return p(a[m], m, a);
                        };
                    }
                    var _ = n(t, i, o);
                    return _ > -1 ? a[p ? t[_] : _] : u;
                };
            }
            function Js(n) {
                return Gt(function(t) {
                    var i = t.length, o = i, a = dt.prototype.thru;
                    for(n && t.reverse(); o--;){
                        var p = t[o];
                        if (typeof p != "function") throw new gt(c);
                        if (a && !_ && gi(p) == "wrapper") var _ = new dt([], !0);
                    }
                    for(o = _ ? o : i; ++o < i;){
                        p = t[o];
                        var m = gi(p), E = m == "wrapper" ? oo(p) : u;
                        E && lo(E[0]) && E[1] == (V | k | q | rn) && !E[4].length && E[9] == 1 ? _ = _[gi(E[0])].apply(_, E[3]) : _ = p.length == 1 && lo(p) ? _[m]() : _.thru(p);
                    }
                    return function() {
                        var L = arguments, b = L[0];
                        if (_ && L.length == 1 && en(b)) return _.plant(b).value();
                        for(var N = 0, D = i ? t[N].apply(this, L) : b; ++N < i;)D = t[N].call(this, D);
                        return D;
                    };
                });
            }
            function li(n, t, i, o, a, p, _, m, E, L) {
                var b = t & V, N = t & $, D = t & O, H = t & (k | B), Z = t & on, fn = D ? u : cr(n);
                function J() {
                    for(var an = arguments.length, cn = T(an), st = an; st--;)cn[st] = arguments[st];
                    if (H) var Kn = De(J), at = kh(cn, Kn);
                    if (o && (cn = qs(cn, o, a, H)), p && (cn = Hs(cn, p, _, H)), an -= at, H && an < L) {
                        var Pn = ne(cn, Kn);
                        return js(n, t, li, J.placeholder, i, cn, Pn, m, E, L - an);
                    }
                    var Tt = N ? i : this, Yt = D ? Tt[n] : n;
                    return an = cn.length, m ? cn = Zp(cn, m) : Z && an > 1 && cn.reverse(), b && E < an && (cn.length = E), this && this !== Wn && this instanceof J && (Yt = fn || cr(Yt)), Yt.apply(Tt, cn);
                }
                return J;
            }
            function Qs(n, t) {
                return function(i, o) {
                    return rp(i, n, t(o), {});
                };
            }
            function ci(n, t) {
                return function(i, o) {
                    var a;
                    if (i === u && o === u) return t;
                    if (i !== u && (a = i), o !== u) {
                        if (a === u) return o;
                        typeof i == "string" || typeof o == "string" ? (i = ot(i), o = ot(o)) : (i = Fs(i), o = Fs(o)), a = n(i, o);
                    }
                    return a;
                };
            }
            function eo(n) {
                return Gt(function(t) {
                    return t = Cn(t, ut(K())), sn(function(i) {
                        var o = this;
                        return n(t, function(a) {
                            return it(a, o, i);
                        });
                    });
                });
            }
            function hi(n, t) {
                t = t === u ? " " : ot(t);
                var i = t.length;
                if (i < 2) return i ? Zu(t, n) : t;
                var o = Zu(t, Vr(n / Me(t)));
                return Ie(t) ? ue(At(o), 0, n).join("") : o.slice(0, n);
            }
            function Lp(n, t, i, o) {
                var a = t & $, p = cr(n);
                function _() {
                    for(var m = -1, E = arguments.length, L = -1, b = o.length, N = T(b + E), D = this && this !== Wn && this instanceof _ ? p : n; ++L < b;)N[L] = o[L];
                    for(; E--;)N[L++] = arguments[++m];
                    return it(D, a ? i : this, N);
                }
                return _;
            }
            function Vs(n) {
                return function(t, i, o) {
                    return o && typeof o != "number" && Yn(t, i, o) && (i = o = u), t = Xt(t), i === u ? (i = t, t = 0) : i = Xt(i), o = o === u ? t < i ? 1 : -1 : Xt(o), dp(t, i, o, n);
                };
            }
            function pi(n) {
                return function(t, i) {
                    return typeof t == "string" && typeof i == "string" || (t = mt(t), i = mt(i)), n(t, i);
                };
            }
            function js(n, t, i, o, a, p, _, m, E, L) {
                var b = t & k, N = b ? _ : u, D = b ? u : _, H = b ? p : u, Z = b ? u : p;
                t |= b ? q : X, t &= ~(b ? X : q), t & U || (t &= ~($ | O));
                var fn = [
                    n,
                    t,
                    a,
                    H,
                    N,
                    Z,
                    D,
                    m,
                    E,
                    L
                ], J = i.apply(u, fn);
                return lo(n) && ca(J, fn), J.placeholder = o, ha(J, n, t);
            }
            function ro(n) {
                var t = Fn[n];
                return function(i, o) {
                    if (i = mt(i), o = o == null ? 0 : Gn(un(o), 292), o && hs(i)) {
                        var a = (_n(i) + "e").split("e"), p = t(a[0] + "e" + (+a[1] + o));
                        return a = (_n(p) + "e").split("e"), +(a[0] + "e" + (+a[1] - o));
                    }
                    return t(i);
                };
            }
            var bp = Pe && 1 / Ur(new Pe([
                ,
                -0
            ]))[1] == F ? function(n) {
                return new Pe(n);
            } : Ro;
            function na(n) {
                return function(t) {
                    var i = qn(t);
                    return i == St ? Nu(t) : i == Et ? Kh(t) : Wh(t, n(t));
                };
            }
            function Ut(n, t, i, o, a, p, _, m) {
                var E = t & O;
                if (!E && typeof n != "function") throw new gt(c);
                var L = o ? o.length : 0;
                if (L || (t &= ~(q | X), o = a = u), _ = _ === u ? _ : Dn(un(_), 0), m = m === u ? m : un(m), L -= a ? a.length : 0, t & X) {
                    var b = o, N = a;
                    o = a = u;
                }
                var D = E ? u : oo(n), H = [
                    n,
                    t,
                    i,
                    o,
                    a,
                    b,
                    N,
                    p,
                    _,
                    m
                ];
                if (D && Xp(H, D), n = H[0], t = H[1], i = H[2], o = H[3], a = H[4], m = H[9] = H[9] === u ? E ? 0 : n.length : Dn(H[9] - L, 0), !m && t & (k | B) && (t &= ~(k | B)), !t || t == $) var Z = Ip(n, t, i);
                else t == k || t == B ? Z = Mp(n, t, m) : (t == q || t == ($ | q)) && !a.length ? Z = Lp(n, t, i, o) : Z = li.apply(u, H);
                var fn = D ? Os : ca;
                return ha(fn(Z, H), n, t);
            }
            function ta(n, t, i, o) {
                return n === u || Rt(n, be[i]) && !vn.call(o, i) ? t : n;
            }
            function ea(n, t, i, o, a, p) {
                return Rn(n) && Rn(t) && (p.set(t, n), oi(n, t, u, ea, p), p.delete(t)), n;
            }
            function Pp(n) {
                return gr(n) ? u : n;
            }
            function ra(n, t, i, o, a, p) {
                var _ = i & P, m = n.length, E = t.length;
                if (m != E && !(_ && E > m)) return !1;
                var L = p.get(n), b = p.get(t);
                if (L && b) return L == t && b == n;
                var N = -1, D = !0, H = i & z ? new ce() : u;
                for(p.set(n, t), p.set(t, n); ++N < m;){
                    var Z = n[N], fn = t[N];
                    if (o) var J = _ ? o(fn, Z, N, t, n, p) : o(Z, fn, N, n, t, p);
                    if (J !== u) {
                        if (J) continue;
                        D = !1;
                        break;
                    }
                    if (H) {
                        if (!Tu(t, function(an, cn) {
                            if (!nr(H, cn) && (Z === an || a(Z, an, i, o, p))) return H.push(cn);
                        })) {
                            D = !1;
                            break;
                        }
                    } else if (!(Z === fn || a(Z, fn, i, o, p))) {
                        D = !1;
                        break;
                    }
                }
                return p.delete(n), p.delete(t), D;
            }
            function Np(n, t, i, o, a, p, _) {
                switch(i){
                    case Ce:
                        if (n.byteLength != t.byteLength || n.byteOffset != t.byteOffset) return !1;
                        n = n.buffer, t = t.buffer;
                    case je:
                        return !(n.byteLength != t.byteLength || !p(new Kr(n), new Kr(t)));
                    case Hn:
                    case Dt:
                    case Ze:
                        return Rt(+n, +t);
                    case Or:
                        return n.name == t.name && n.message == t.message;
                    case Je:
                    case Qe:
                        return n == t + "";
                    case St:
                        var m = Nu;
                    case Et:
                        var E = o & P;
                        if (m || (m = Ur), n.size != t.size && !E) return !1;
                        var L = _.get(n);
                        if (L) return L == t;
                        o |= z, _.set(n, t);
                        var b = ra(m(n), m(t), o, a, p, _);
                        return _.delete(n), b;
                    case Fr:
                        if (ur) return ur.call(n) == ur.call(t);
                }
                return !1;
            }
            function Op(n, t, i, o, a, p) {
                var _ = i & P, m = io(n), E = m.length, L = io(t), b = L.length;
                if (E != b && !_) return !1;
                for(var N = E; N--;){
                    var D = m[N];
                    if (!(_ ? D in t : vn.call(t, D))) return !1;
                }
                var H = p.get(n), Z = p.get(t);
                if (H && Z) return H == t && Z == n;
                var fn = !0;
                p.set(n, t), p.set(t, n);
                for(var J = _; ++N < E;){
                    D = m[N];
                    var an = n[D], cn = t[D];
                    if (o) var st = _ ? o(cn, an, D, t, n, p) : o(an, cn, D, n, t, p);
                    if (!(st === u ? an === cn || a(an, cn, i, o, p) : st)) {
                        fn = !1;
                        break;
                    }
                    J || (J = D == "constructor");
                }
                if (fn && !J) {
                    var Kn = n.constructor, at = t.constructor;
                    Kn != at && "constructor" in n && "constructor" in t && !(typeof Kn == "function" && Kn instanceof Kn && typeof at == "function" && at instanceof at) && (fn = !1);
                }
                return p.delete(n), p.delete(t), fn;
            }
            function Gt(n) {
                return ho(aa(n, u, wa), n + "");
            }
            function io(n) {
                return Es(n, Bn, so);
            }
            function uo(n) {
                return Es(n, jn, ia);
            }
            var oo = ni ? function(n) {
                return ni.get(n);
            } : Ro;
            function gi(n) {
                for(var t = n.name + "", i = Ne[t], o = vn.call(Ne, t) ? i.length : 0; o--;){
                    var a = i[o], p = a.func;
                    if (p == null || p == n) return a.name;
                }
                return t;
            }
            function De(n) {
                var t = vn.call(l, "placeholder") ? l : n;
                return t.placeholder;
            }
            function K() {
                var n = l.iteratee || Ao;
                return n = n === Ao ? Rs : n, arguments.length ? n(arguments[0], arguments[1]) : n;
            }
            function di(n, t) {
                var i = n.__data__;
                return Up(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
            }
            function fo(n) {
                for(var t = Bn(n), i = t.length; i--;){
                    var o = t[i], a = n[o];
                    t[i] = [
                        o,
                        a,
                        fa(a)
                    ];
                }
                return t;
            }
            function ge(n, t) {
                var i = Hh(n, t);
                return Cs(i) ? i : u;
            }
            function $p(n) {
                var t = vn.call(n, ae), i = n[ae];
                try {
                    n[ae] = u;
                    var o = !0;
                } catch  {}
                var a = Xr.call(n);
                return o && (t ? n[ae] = i : delete n[ae]), a;
            }
            var so = $u ? function(n) {
                return n == null ? [] : (n = wn(n), Vt($u(n), function(t) {
                    return ls.call(n, t);
                }));
            } : To, ia = $u ? function(n) {
                for(var t = []; n;)jt(t, so(n)), n = Zr(n);
                return t;
            } : To, qn = Xn;
            (Fu && qn(new Fu(new ArrayBuffer(1))) != Ce || er && qn(new er()) != St || Du && qn(Du.resolve()) != yf || Pe && qn(new Pe()) != Et || rr && qn(new rr()) != Ve) && (qn = function(n) {
                var t = Xn(n), i = t == zt ? n.constructor : u, o = i ? de(i) : "";
                if (o) switch(o){
                    case v0:
                        return Ce;
                    case w0:
                        return St;
                    case m0:
                        return yf;
                    case y0:
                        return Et;
                    case x0:
                        return Ve;
                }
                return t;
            });
            function Fp(n, t, i) {
                for(var o = -1, a = i.length; ++o < a;){
                    var p = i[o], _ = p.size;
                    switch(p.type){
                        case "drop":
                            n += _;
                            break;
                        case "dropRight":
                            t -= _;
                            break;
                        case "take":
                            t = Gn(t, n + _);
                            break;
                        case "takeRight":
                            n = Dn(n, t - _);
                            break;
                    }
                }
                return {
                    start: n,
                    end: t
                };
            }
            function Dp(n) {
                var t = n.match(Gc);
                return t ? t[1].split(qc) : [];
            }
            function ua(n, t, i) {
                t = ie(t, n);
                for(var o = -1, a = t.length, p = !1; ++o < a;){
                    var _ = Pt(t[o]);
                    if (!(p = n != null && i(n, _))) break;
                    n = n[_];
                }
                return p || ++o != a ? p : (a = n == null ? 0 : n.length, !!a && Si(a) && qt(_, a) && (en(n) || _e(n)));
            }
            function zp(n) {
                var t = n.length, i = new n.constructor(t);
                return t && typeof n[0] == "string" && vn.call(n, "index") && (i.index = n.index, i.input = n.input), i;
            }
            function oa(n) {
                return typeof n.constructor == "function" && !hr(n) ? Oe(Zr(n)) : {};
            }
            function Bp(n, t, i) {
                var o = n.constructor;
                switch(t){
                    case je:
                        return to(n);
                    case Hn:
                    case Dt:
                        return new o(+n);
                    case Ce:
                        return Sp(n, i);
                    case fu:
                    case su:
                    case au:
                    case lu:
                    case cu:
                    case hu:
                    case pu:
                    case gu:
                    case du:
                        return Us(n, i);
                    case St:
                        return new o();
                    case Ze:
                    case Qe:
                        return new o(n);
                    case Je:
                        return Ep(n);
                    case Et:
                        return new o();
                    case Fr:
                        return Ap(n);
                }
            }
            function Wp(n, t) {
                var i = t.length;
                if (!i) return n;
                var o = i - 1;
                return t[o] = (i > 1 ? "& " : "") + t[o], t = t.join(i > 2 ? ", " : " "), n.replace(Uc, `{
/* [wrapped with ` + t + `] */
`);
            }
            function kp(n) {
                return en(n) || _e(n) || !!(cs && n && n[cs]);
            }
            function qt(n, t) {
                var i = typeof n;
                return t = t ?? G, !!t && (i == "number" || i != "symbol" && jc.test(n)) && n > -1 && n % 1 == 0 && n < t;
            }
            function Yn(n, t, i) {
                if (!Rn(i)) return !1;
                var o = typeof t;
                return (o == "number" ? Vn(i) && qt(t, i.length) : o == "string" && t in i) ? Rt(i[t], n) : !1;
            }
            function ao(n, t) {
                if (en(n)) return !1;
                var i = typeof n;
                return i == "number" || i == "symbol" || i == "boolean" || n == null || ft(n) ? !0 : zc.test(n) || !Dc.test(n) || t != null && n in wn(t);
            }
            function Up(n) {
                var t = typeof n;
                return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
            }
            function lo(n) {
                var t = gi(n), i = l[t];
                if (typeof i != "function" || !(t in ln.prototype)) return !1;
                if (n === i) return !0;
                var o = oo(i);
                return !!o && n === o[0];
            }
            function Gp(n) {
                return !!fs && fs in n;
            }
            var qp = qr ? Ht : Io;
            function hr(n) {
                var t = n && n.constructor, i = typeof t == "function" && t.prototype || be;
                return n === i;
            }
            function fa(n) {
                return n === n && !Rn(n);
            }
            function sa(n, t) {
                return function(i) {
                    return i == null ? !1 : i[n] === t && (t !== u || n in wn(i));
                };
            }
            function Hp(n) {
                var t = yi(n, function(o) {
                    return i.size === w && i.clear(), o;
                }), i = t.cache;
                return t;
            }
            function Xp(n, t) {
                var i = n[1], o = t[1], a = i | o, p = a < ($ | O | V), _ = o == V && i == k || o == V && i == rn && n[7].length <= t[8] || o == (V | rn) && t[7].length <= t[8] && i == k;
                if (!(p || _)) return n;
                o & $ && (n[2] = t[2], a |= i & $ ? 0 : U);
                var m = t[3];
                if (m) {
                    var E = n[3];
                    n[3] = E ? qs(E, m, t[4]) : m, n[4] = E ? ne(n[3], d) : t[4];
                }
                return m = t[5], m && (E = n[5], n[5] = E ? Hs(E, m, t[6]) : m, n[6] = E ? ne(n[5], d) : t[6]), m = t[7], m && (n[7] = m), o & V && (n[8] = n[8] == null ? t[8] : Gn(n[8], t[8])), n[9] == null && (n[9] = t[9]), n[0] = t[0], n[1] = a, n;
            }
            function Yp(n) {
                var t = [];
                if (n != null) for(var i in wn(n))t.push(i);
                return t;
            }
            function Kp(n) {
                return Xr.call(n);
            }
            function aa(n, t, i) {
                return t = Dn(t === u ? n.length - 1 : t, 0), function() {
                    for(var o = arguments, a = -1, p = Dn(o.length - t, 0), _ = T(p); ++a < p;)_[a] = o[t + a];
                    a = -1;
                    for(var m = T(t + 1); ++a < t;)m[a] = o[a];
                    return m[t] = i(_), it(n, this, m);
                };
            }
            function la(n, t) {
                return t.length < 2 ? n : pe(n, vt(t, 0, -1));
            }
            function Zp(n, t) {
                for(var i = n.length, o = Gn(t.length, i), a = Qn(n); o--;){
                    var p = t[o];
                    n[o] = qt(p, i) ? a[p] : u;
                }
                return n;
            }
            function co(n, t) {
                if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__") return n[t];
            }
            var ca = pa(Os), pr = l0 || function(n, t) {
                return Wn.setTimeout(n, t);
            }, ho = pa(wp);
            function ha(n, t, i) {
                var o = t + "";
                return ho(n, Wp(o, Jp(Dp(o), i)));
            }
            function pa(n) {
                var t = 0, i = 0;
                return function() {
                    var o = g0(), a = xn - (o - i);
                    if (i = o, a > 0) {
                        if (++t >= zn) return arguments[0];
                    } else t = 0;
                    return n.apply(u, arguments);
                };
            }
            function _i(n, t) {
                var i = -1, o = n.length, a = o - 1;
                for(t = t === u ? o : t; ++i < t;){
                    var p = Ku(i, a), _ = n[p];
                    n[p] = n[i], n[i] = _;
                }
                return n.length = t, n;
            }
            var ga = Hp(function(n) {
                var t = [];
                return n.charCodeAt(0) === 46 && t.push(""), n.replace(Bc, function(i, o, a, p) {
                    t.push(a ? p.replace(Yc, "$1") : o || i);
                }), t;
            });
            function Pt(n) {
                if (typeof n == "string" || ft(n)) return n;
                var t = n + "";
                return t == "0" && 1 / n == -F ? "-0" : t;
            }
            function de(n) {
                if (n != null) {
                    try {
                        return Hr.call(n);
                    } catch  {}
                    try {
                        return n + "";
                    } catch  {}
                }
                return "";
            }
            function Jp(n, t) {
                return pt(An, function(i) {
                    var o = "_." + i[0];
                    t & i[1] && !Wr(n, o) && n.push(o);
                }), n.sort();
            }
            function da(n) {
                if (n instanceof ln) return n.clone();
                var t = new dt(n.__wrapped__, n.__chain__);
                return t.__actions__ = Qn(n.__actions__), t.__index__ = n.__index__, t.__values__ = n.__values__, t;
            }
            function Qp(n, t, i) {
                (i ? Yn(n, t, i) : t === u) ? t = 1 : t = Dn(un(t), 0);
                var o = n == null ? 0 : n.length;
                if (!o || t < 1) return [];
                for(var a = 0, p = 0, _ = T(Vr(o / t)); a < o;)_[p++] = vt(n, a, a += t);
                return _;
            }
            function Vp(n) {
                for(var t = -1, i = n == null ? 0 : n.length, o = 0, a = []; ++t < i;){
                    var p = n[t];
                    p && (a[o++] = p);
                }
                return a;
            }
            function jp() {
                var n = arguments.length;
                if (!n) return [];
                for(var t = T(n - 1), i = arguments[0], o = n; o--;)t[o - 1] = arguments[o];
                return jt(en(i) ? Qn(i) : [
                    i
                ], kn(t, 1));
            }
            var ng = sn(function(n, t) {
                return bn(n) ? fr(n, kn(t, 1, bn, !0)) : [];
            }), tg = sn(function(n, t) {
                var i = wt(t);
                return bn(i) && (i = u), bn(n) ? fr(n, kn(t, 1, bn, !0), K(i, 2)) : [];
            }), eg = sn(function(n, t) {
                var i = wt(t);
                return bn(i) && (i = u), bn(n) ? fr(n, kn(t, 1, bn, !0), u, i) : [];
            });
            function rg(n, t, i) {
                var o = n == null ? 0 : n.length;
                return o ? (t = i || t === u ? 1 : un(t), vt(n, t < 0 ? 0 : t, o)) : [];
            }
            function ig(n, t, i) {
                var o = n == null ? 0 : n.length;
                return o ? (t = i || t === u ? 1 : un(t), t = o - t, vt(n, 0, t < 0 ? 0 : t)) : [];
            }
            function ug(n, t) {
                return n && n.length ? si(n, K(t, 3), !0, !0) : [];
            }
            function og(n, t) {
                return n && n.length ? si(n, K(t, 3), !0) : [];
            }
            function fg(n, t, i, o) {
                var a = n == null ? 0 : n.length;
                return a ? (i && typeof i != "number" && Yn(n, t, i) && (i = 0, o = a), j0(n, t, i, o)) : [];
            }
            function _a(n, t, i) {
                var o = n == null ? 0 : n.length;
                if (!o) return -1;
                var a = i == null ? 0 : un(i);
                return a < 0 && (a = Dn(o + a, 0)), kr(n, K(t, 3), a);
            }
            function va(n, t, i) {
                var o = n == null ? 0 : n.length;
                if (!o) return -1;
                var a = o - 1;
                return i !== u && (a = un(i), a = i < 0 ? Dn(o + a, 0) : Gn(a, o - 1)), kr(n, K(t, 3), a, !0);
            }
            function wa(n) {
                var t = n == null ? 0 : n.length;
                return t ? kn(n, 1) : [];
            }
            function sg(n) {
                var t = n == null ? 0 : n.length;
                return t ? kn(n, F) : [];
            }
            function ag(n, t) {
                var i = n == null ? 0 : n.length;
                return i ? (t = t === u ? 1 : un(t), kn(n, t)) : [];
            }
            function lg(n) {
                for(var t = -1, i = n == null ? 0 : n.length, o = {}; ++t < i;){
                    var a = n[t];
                    o[a[0]] = a[1];
                }
                return o;
            }
            function ma(n) {
                return n && n.length ? n[0] : u;
            }
            function cg(n, t, i) {
                var o = n == null ? 0 : n.length;
                if (!o) return -1;
                var a = i == null ? 0 : un(i);
                return a < 0 && (a = Dn(o + a, 0)), Te(n, t, a);
            }
            function hg(n) {
                var t = n == null ? 0 : n.length;
                return t ? vt(n, 0, -1) : [];
            }
            var pg = sn(function(n) {
                var t = Cn(n, ju);
                return t.length && t[0] === n[0] ? Gu(t) : [];
            }), gg = sn(function(n) {
                var t = wt(n), i = Cn(n, ju);
                return t === wt(i) ? t = u : i.pop(), i.length && i[0] === n[0] ? Gu(i, K(t, 2)) : [];
            }), dg = sn(function(n) {
                var t = wt(n), i = Cn(n, ju);
                return t = typeof t == "function" ? t : u, t && i.pop(), i.length && i[0] === n[0] ? Gu(i, u, t) : [];
            });
            function _g(n, t) {
                return n == null ? "" : h0.call(n, t);
            }
            function wt(n) {
                var t = n == null ? 0 : n.length;
                return t ? n[t - 1] : u;
            }
            function vg(n, t, i) {
                var o = n == null ? 0 : n.length;
                if (!o) return -1;
                var a = o;
                return i !== u && (a = un(i), a = a < 0 ? Dn(o + a, 0) : Gn(a, o - 1)), t === t ? Jh(n, t, a) : kr(n, jf, a, !0);
            }
            function wg(n, t) {
                return n && n.length ? Ls(n, un(t)) : u;
            }
            var mg = sn(ya);
            function ya(n, t) {
                return n && n.length && t && t.length ? Yu(n, t) : n;
            }
            function yg(n, t, i) {
                return n && n.length && t && t.length ? Yu(n, t, K(i, 2)) : n;
            }
            function xg(n, t, i) {
                return n && n.length && t && t.length ? Yu(n, t, u, i) : n;
            }
            var Sg = Gt(function(n, t) {
                var i = n == null ? 0 : n.length, o = Bu(n, t);
                return Ns(n, Cn(t, function(a) {
                    return qt(a, i) ? +a : a;
                }).sort(Gs)), o;
            });
            function Eg(n, t) {
                var i = [];
                if (!(n && n.length)) return i;
                var o = -1, a = [], p = n.length;
                for(t = K(t, 3); ++o < p;){
                    var _ = n[o];
                    t(_, o, n) && (i.push(_), a.push(o));
                }
                return Ns(n, a), i;
            }
            function po(n) {
                return n == null ? n : _0.call(n);
            }
            function Ag(n, t, i) {
                var o = n == null ? 0 : n.length;
                return o ? (i && typeof i != "number" && Yn(n, t, i) ? (t = 0, i = o) : (t = t == null ? 0 : un(t), i = i === u ? o : un(i)), vt(n, t, i)) : [];
            }
            function Cg(n, t) {
                return fi(n, t);
            }
            function Rg(n, t, i) {
                return Ju(n, t, K(i, 2));
            }
            function Tg(n, t) {
                var i = n == null ? 0 : n.length;
                if (i) {
                    var o = fi(n, t);
                    if (o < i && Rt(n[o], t)) return o;
                }
                return -1;
            }
            function Ig(n, t) {
                return fi(n, t, !0);
            }
            function Mg(n, t, i) {
                return Ju(n, t, K(i, 2), !0);
            }
            function Lg(n, t) {
                var i = n == null ? 0 : n.length;
                if (i) {
                    var o = fi(n, t, !0) - 1;
                    if (Rt(n[o], t)) return o;
                }
                return -1;
            }
            function bg(n) {
                return n && n.length ? $s(n) : [];
            }
            function Pg(n, t) {
                return n && n.length ? $s(n, K(t, 2)) : [];
            }
            function Ng(n) {
                var t = n == null ? 0 : n.length;
                return t ? vt(n, 1, t) : [];
            }
            function Og(n, t, i) {
                return n && n.length ? (t = i || t === u ? 1 : un(t), vt(n, 0, t < 0 ? 0 : t)) : [];
            }
            function $g(n, t, i) {
                var o = n == null ? 0 : n.length;
                return o ? (t = i || t === u ? 1 : un(t), t = o - t, vt(n, t < 0 ? 0 : t, o)) : [];
            }
            function Fg(n, t) {
                return n && n.length ? si(n, K(t, 3), !1, !0) : [];
            }
            function Dg(n, t) {
                return n && n.length ? si(n, K(t, 3)) : [];
            }
            var zg = sn(function(n) {
                return re(kn(n, 1, bn, !0));
            }), Bg = sn(function(n) {
                var t = wt(n);
                return bn(t) && (t = u), re(kn(n, 1, bn, !0), K(t, 2));
            }), Wg = sn(function(n) {
                var t = wt(n);
                return t = typeof t == "function" ? t : u, re(kn(n, 1, bn, !0), u, t);
            });
            function kg(n) {
                return n && n.length ? re(n) : [];
            }
            function Ug(n, t) {
                return n && n.length ? re(n, K(t, 2)) : [];
            }
            function Gg(n, t) {
                return t = typeof t == "function" ? t : u, n && n.length ? re(n, u, t) : [];
            }
            function go(n) {
                if (!(n && n.length)) return [];
                var t = 0;
                return n = Vt(n, function(i) {
                    if (bn(i)) return t = Dn(i.length, t), !0;
                }), bu(t, function(i) {
                    return Cn(n, Iu(i));
                });
            }
            function xa(n, t) {
                if (!(n && n.length)) return [];
                var i = go(n);
                return t == null ? i : Cn(i, function(o) {
                    return it(t, u, o);
                });
            }
            var qg = sn(function(n, t) {
                return bn(n) ? fr(n, t) : [];
            }), Hg = sn(function(n) {
                return Vu(Vt(n, bn));
            }), Xg = sn(function(n) {
                var t = wt(n);
                return bn(t) && (t = u), Vu(Vt(n, bn), K(t, 2));
            }), Yg = sn(function(n) {
                var t = wt(n);
                return t = typeof t == "function" ? t : u, Vu(Vt(n, bn), u, t);
            }), Kg = sn(go);
            function Zg(n, t) {
                return Bs(n || [], t || [], or);
            }
            function Jg(n, t) {
                return Bs(n || [], t || [], lr);
            }
            var Qg = sn(function(n) {
                var t = n.length, i = t > 1 ? n[t - 1] : u;
                return i = typeof i == "function" ? (n.pop(), i) : u, xa(n, i);
            });
            function Sa(n) {
                var t = l(n);
                return t.__chain__ = !0, t;
            }
            function Vg(n, t) {
                return t(n), n;
            }
            function vi(n, t) {
                return t(n);
            }
            var jg = Gt(function(n) {
                var t = n.length, i = t ? n[0] : 0, o = this.__wrapped__, a = function(p) {
                    return Bu(p, n);
                };
                return t > 1 || this.__actions__.length || !(o instanceof ln) || !qt(i) ? this.thru(a) : (o = o.slice(i, +i + (t ? 1 : 0)), o.__actions__.push({
                    func: vi,
                    args: [
                        a
                    ],
                    thisArg: u
                }), new dt(o, this.__chain__).thru(function(p) {
                    return t && !p.length && p.push(u), p;
                }));
            });
            function nd() {
                return Sa(this);
            }
            function td() {
                return new dt(this.value(), this.__chain__);
            }
            function ed() {
                this.__values__ === u && (this.__values__ = Fa(this.value()));
                var n = this.__index__ >= this.__values__.length, t = n ? u : this.__values__[this.__index__++];
                return {
                    done: n,
                    value: t
                };
            }
            function rd() {
                return this;
            }
            function id(n) {
                for(var t, i = this; i instanceof ei;){
                    var o = da(i);
                    o.__index__ = 0, o.__values__ = u, t ? a.__wrapped__ = o : t = o;
                    var a = o;
                    i = i.__wrapped__;
                }
                return a.__wrapped__ = n, t;
            }
            function ud() {
                var n = this.__wrapped__;
                if (n instanceof ln) {
                    var t = n;
                    return this.__actions__.length && (t = new ln(this)), t = t.reverse(), t.__actions__.push({
                        func: vi,
                        args: [
                            po
                        ],
                        thisArg: u
                    }), new dt(t, this.__chain__);
                }
                return this.thru(po);
            }
            function od() {
                return zs(this.__wrapped__, this.__actions__);
            }
            var fd = ai(function(n, t, i) {
                vn.call(n, i) ? ++n[i] : kt(n, i, 1);
            });
            function sd(n, t, i) {
                var o = en(n) ? Qf : V0;
                return i && Yn(n, t, i) && (t = u), o(n, K(t, 3));
            }
            function ad(n, t) {
                var i = en(n) ? Vt : xs;
                return i(n, K(t, 3));
            }
            var ld = Zs(_a), cd = Zs(va);
            function hd(n, t) {
                return kn(wi(n, t), 1);
            }
            function pd(n, t) {
                return kn(wi(n, t), F);
            }
            function gd(n, t, i) {
                return i = i === u ? 1 : un(i), kn(wi(n, t), i);
            }
            function Ea(n, t) {
                var i = en(n) ? pt : ee;
                return i(n, K(t, 3));
            }
            function Aa(n, t) {
                var i = en(n) ? Nh : ys;
                return i(n, K(t, 3));
            }
            var dd = ai(function(n, t, i) {
                vn.call(n, i) ? n[i].push(t) : kt(n, i, [
                    t
                ]);
            });
            function _d(n, t, i, o) {
                n = Vn(n) ? n : Be(n), i = i && !o ? un(i) : 0;
                var a = n.length;
                return i < 0 && (i = Dn(a + i, 0)), Ei(n) ? i <= a && n.indexOf(t, i) > -1 : !!a && Te(n, t, i) > -1;
            }
            var vd = sn(function(n, t, i) {
                var o = -1, a = typeof t == "function", p = Vn(n) ? T(n.length) : [];
                return ee(n, function(_) {
                    p[++o] = a ? it(t, _, i) : sr(_, t, i);
                }), p;
            }), wd = ai(function(n, t, i) {
                kt(n, i, t);
            });
            function wi(n, t) {
                var i = en(n) ? Cn : Ts;
                return i(n, K(t, 3));
            }
            function md(n, t, i, o) {
                return n == null ? [] : (en(t) || (t = t == null ? [] : [
                    t
                ]), i = o ? u : i, en(i) || (i = i == null ? [] : [
                    i
                ]), bs(n, t, i));
            }
            var yd = ai(function(n, t, i) {
                n[i ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function xd(n, t, i) {
                var o = en(n) ? Ru : ts, a = arguments.length < 3;
                return o(n, K(t, 4), i, a, ee);
            }
            function Sd(n, t, i) {
                var o = en(n) ? Oh : ts, a = arguments.length < 3;
                return o(n, K(t, 4), i, a, ys);
            }
            function Ed(n, t) {
                var i = en(n) ? Vt : xs;
                return i(n, xi(K(t, 3)));
            }
            function Ad(n) {
                var t = en(n) ? _s : _p;
                return t(n);
            }
            function Cd(n, t, i) {
                (i ? Yn(n, t, i) : t === u) ? t = 1 : t = un(t);
                var o = en(n) ? Y0 : vp;
                return o(n, t);
            }
            function Rd(n) {
                var t = en(n) ? K0 : mp;
                return t(n);
            }
            function Td(n) {
                if (n == null) return 0;
                if (Vn(n)) return Ei(n) ? Me(n) : n.length;
                var t = qn(n);
                return t == St || t == Et ? n.size : Hu(n).length;
            }
            function Id(n, t, i) {
                var o = en(n) ? Tu : yp;
                return i && Yn(n, t, i) && (t = u), o(n, K(t, 3));
            }
            var Md = sn(function(n, t) {
                if (n == null) return [];
                var i = t.length;
                return i > 1 && Yn(n, t[0], t[1]) ? t = [] : i > 2 && Yn(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), bs(n, kn(t, 1), []);
            }), mi = a0 || function() {
                return Wn.Date.now();
            };
            function Ld(n, t) {
                if (typeof t != "function") throw new gt(c);
                return n = un(n), function() {
                    if (--n < 1) return t.apply(this, arguments);
                };
            }
            function Ca(n, t, i) {
                return t = i ? u : t, t = n && t == null ? n.length : t, Ut(n, V, u, u, u, u, t);
            }
            function Ra(n, t) {
                var i;
                if (typeof t != "function") throw new gt(c);
                return n = un(n), function() {
                    return --n > 0 && (i = t.apply(this, arguments)), n <= 1 && (t = u), i;
                };
            }
            var _o = sn(function(n, t, i) {
                var o = $;
                if (i.length) {
                    var a = ne(i, De(_o));
                    o |= q;
                }
                return Ut(n, o, t, i, a);
            }), Ta = sn(function(n, t, i) {
                var o = $ | O;
                if (i.length) {
                    var a = ne(i, De(Ta));
                    o |= q;
                }
                return Ut(t, o, n, i, a);
            });
            function Ia(n, t, i) {
                t = i ? u : t;
                var o = Ut(n, k, u, u, u, u, u, t);
                return o.placeholder = Ia.placeholder, o;
            }
            function Ma(n, t, i) {
                t = i ? u : t;
                var o = Ut(n, B, u, u, u, u, u, t);
                return o.placeholder = Ma.placeholder, o;
            }
            function La(n, t, i) {
                var o, a, p, _, m, E, L = 0, b = !1, N = !1, D = !0;
                if (typeof n != "function") throw new gt(c);
                t = mt(t) || 0, Rn(i) && (b = !!i.leading, N = "maxWait" in i, p = N ? Dn(mt(i.maxWait) || 0, t) : p, D = "trailing" in i ? !!i.trailing : D);
                function H(Pn) {
                    var Tt = o, Yt = a;
                    return o = a = u, L = Pn, _ = n.apply(Yt, Tt), _;
                }
                function Z(Pn) {
                    return L = Pn, m = pr(an, t), b ? H(Pn) : _;
                }
                function fn(Pn) {
                    var Tt = Pn - E, Yt = Pn - L, Za = t - Tt;
                    return N ? Gn(Za, p - Yt) : Za;
                }
                function J(Pn) {
                    var Tt = Pn - E, Yt = Pn - L;
                    return E === u || Tt >= t || Tt < 0 || N && Yt >= p;
                }
                function an() {
                    var Pn = mi();
                    if (J(Pn)) return cn(Pn);
                    m = pr(an, fn(Pn));
                }
                function cn(Pn) {
                    return m = u, D && o ? H(Pn) : (o = a = u, _);
                }
                function st() {
                    m !== u && Ws(m), L = 0, o = E = a = m = u;
                }
                function Kn() {
                    return m === u ? _ : cn(mi());
                }
                function at() {
                    var Pn = mi(), Tt = J(Pn);
                    if (o = arguments, a = this, E = Pn, Tt) {
                        if (m === u) return Z(E);
                        if (N) return Ws(m), m = pr(an, t), H(E);
                    }
                    return m === u && (m = pr(an, t)), _;
                }
                return at.cancel = st, at.flush = Kn, at;
            }
            var bd = sn(function(n, t) {
                return ms(n, 1, t);
            }), Pd = sn(function(n, t, i) {
                return ms(n, mt(t) || 0, i);
            });
            function Nd(n) {
                return Ut(n, on);
            }
            function yi(n, t) {
                if (typeof n != "function" || t != null && typeof t != "function") throw new gt(c);
                var i = function() {
                    var o = arguments, a = t ? t.apply(this, o) : o[0], p = i.cache;
                    if (p.has(a)) return p.get(a);
                    var _ = n.apply(this, o);
                    return i.cache = p.set(a, _) || p, _;
                };
                return i.cache = new (yi.Cache || Wt)(), i;
            }
            yi.Cache = Wt;
            function xi(n) {
                if (typeof n != "function") throw new gt(c);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !n.call(this);
                        case 1:
                            return !n.call(this, t[0]);
                        case 2:
                            return !n.call(this, t[0], t[1]);
                        case 3:
                            return !n.call(this, t[0], t[1], t[2]);
                    }
                    return !n.apply(this, t);
                };
            }
            function Od(n) {
                return Ra(2, n);
            }
            var $d = xp(function(n, t) {
                t = t.length == 1 && en(t[0]) ? Cn(t[0], ut(K())) : Cn(kn(t, 1), ut(K()));
                var i = t.length;
                return sn(function(o) {
                    for(var a = -1, p = Gn(o.length, i); ++a < p;)o[a] = t[a].call(this, o[a]);
                    return it(n, this, o);
                });
            }), vo = sn(function(n, t) {
                var i = ne(t, De(vo));
                return Ut(n, q, u, t, i);
            }), ba = sn(function(n, t) {
                var i = ne(t, De(ba));
                return Ut(n, X, u, t, i);
            }), Fd = Gt(function(n, t) {
                return Ut(n, rn, u, u, u, t);
            });
            function Dd(n, t) {
                if (typeof n != "function") throw new gt(c);
                return t = t === u ? t : un(t), sn(n, t);
            }
            function zd(n, t) {
                if (typeof n != "function") throw new gt(c);
                return t = t == null ? 0 : Dn(un(t), 0), sn(function(i) {
                    var o = i[t], a = ue(i, 0, t);
                    return o && jt(a, o), it(n, this, a);
                });
            }
            function Bd(n, t, i) {
                var o = !0, a = !0;
                if (typeof n != "function") throw new gt(c);
                return Rn(i) && (o = "leading" in i ? !!i.leading : o, a = "trailing" in i ? !!i.trailing : a), La(n, t, {
                    leading: o,
                    maxWait: t,
                    trailing: a
                });
            }
            function Wd(n) {
                return Ca(n, 1);
            }
            function kd(n, t) {
                return vo(no(t), n);
            }
            function Ud() {
                if (!arguments.length) return [];
                var n = arguments[0];
                return en(n) ? n : [
                    n
                ];
            }
            function Gd(n) {
                return _t(n, C);
            }
            function qd(n, t) {
                return t = typeof t == "function" ? t : u, _t(n, C, t);
            }
            function Hd(n) {
                return _t(n, y | C);
            }
            function Xd(n, t) {
                return t = typeof t == "function" ? t : u, _t(n, y | C, t);
            }
            function Yd(n, t) {
                return t == null || ws(n, t, Bn(t));
            }
            function Rt(n, t) {
                return n === t || n !== n && t !== t;
            }
            var Kd = pi(Uu), Zd = pi(function(n, t) {
                return n >= t;
            }), _e = As(/* @__PURE__ */ function() {
                return arguments;
            }()) ? As : function(n) {
                return Mn(n) && vn.call(n, "callee") && !ls.call(n, "callee");
            }, en = T.isArray, Jd = Hf ? ut(Hf) : ip;
            function Vn(n) {
                return n != null && Si(n.length) && !Ht(n);
            }
            function bn(n) {
                return Mn(n) && Vn(n);
            }
            function Qd(n) {
                return n === !0 || n === !1 || Mn(n) && Xn(n) == Hn;
            }
            var oe = c0 || Io, Vd = Xf ? ut(Xf) : up;
            function jd(n) {
                return Mn(n) && n.nodeType === 1 && !gr(n);
            }
            function n_(n) {
                if (n == null) return !0;
                if (Vn(n) && (en(n) || typeof n == "string" || typeof n.splice == "function" || oe(n) || ze(n) || _e(n))) return !n.length;
                var t = qn(n);
                if (t == St || t == Et) return !n.size;
                if (hr(n)) return !Hu(n).length;
                for(var i in n)if (vn.call(n, i)) return !1;
                return !0;
            }
            function t_(n, t) {
                return ar(n, t);
            }
            function e_(n, t, i) {
                i = typeof i == "function" ? i : u;
                var o = i ? i(n, t) : u;
                return o === u ? ar(n, t, u, i) : !!o;
            }
            function wo(n) {
                if (!Mn(n)) return !1;
                var t = Xn(n);
                return t == Or || t == Cc || typeof n.message == "string" && typeof n.name == "string" && !gr(n);
            }
            function r_(n) {
                return typeof n == "number" && hs(n);
            }
            function Ht(n) {
                if (!Rn(n)) return !1;
                var t = Xn(n);
                return t == $r || t == mf || t == rt || t == Tc;
            }
            function Pa(n) {
                return typeof n == "number" && n == un(n);
            }
            function Si(n) {
                return typeof n == "number" && n > -1 && n % 1 == 0 && n <= G;
            }
            function Rn(n) {
                var t = typeof n;
                return n != null && (t == "object" || t == "function");
            }
            function Mn(n) {
                return n != null && typeof n == "object";
            }
            var Na = Yf ? ut(Yf) : fp;
            function i_(n, t) {
                return n === t || qu(n, t, fo(t));
            }
            function u_(n, t, i) {
                return i = typeof i == "function" ? i : u, qu(n, t, fo(t), i);
            }
            function o_(n) {
                return Oa(n) && n != +n;
            }
            function f_(n) {
                if (qp(n)) throw new tn(h);
                return Cs(n);
            }
            function s_(n) {
                return n === null;
            }
            function a_(n) {
                return n == null;
            }
            function Oa(n) {
                return typeof n == "number" || Mn(n) && Xn(n) == Ze;
            }
            function gr(n) {
                if (!Mn(n) || Xn(n) != zt) return !1;
                var t = Zr(n);
                if (t === null) return !0;
                var i = vn.call(t, "constructor") && t.constructor;
                return typeof i == "function" && i instanceof i && Hr.call(i) == u0;
            }
            var mo = Kf ? ut(Kf) : sp;
            function l_(n) {
                return Pa(n) && n >= -G && n <= G;
            }
            var $a = Zf ? ut(Zf) : ap;
            function Ei(n) {
                return typeof n == "string" || !en(n) && Mn(n) && Xn(n) == Qe;
            }
            function ft(n) {
                return typeof n == "symbol" || Mn(n) && Xn(n) == Fr;
            }
            var ze = Jf ? ut(Jf) : lp;
            function c_(n) {
                return n === u;
            }
            function h_(n) {
                return Mn(n) && qn(n) == Ve;
            }
            function p_(n) {
                return Mn(n) && Xn(n) == Mc;
            }
            var g_ = pi(Xu), d_ = pi(function(n, t) {
                return n <= t;
            });
            function Fa(n) {
                if (!n) return [];
                if (Vn(n)) return Ei(n) ? At(n) : Qn(n);
                if (tr && n[tr]) return Yh(n[tr]());
                var t = qn(n), i = t == St ? Nu : t == Et ? Ur : Be;
                return i(n);
            }
            function Xt(n) {
                if (!n) return n === 0 ? n : 0;
                if (n = mt(n), n === F || n === -F) {
                    var t = n < 0 ? -1 : 1;
                    return t * Y;
                }
                return n === n ? n : 0;
            }
            function un(n) {
                var t = Xt(n), i = t % 1;
                return t === t ? i ? t - i : t : 0;
            }
            function Da(n) {
                return n ? he(un(n), 0, Q) : 0;
            }
            function mt(n) {
                if (typeof n == "number") return n;
                if (ft(n)) return nn;
                if (Rn(n)) {
                    var t = typeof n.valueOf == "function" ? n.valueOf() : n;
                    n = Rn(t) ? t + "" : t;
                }
                if (typeof n != "string") return n === 0 ? n : +n;
                n = es(n);
                var i = Jc.test(n);
                return i || Vc.test(n) ? Lh(n.slice(2), i ? 2 : 8) : Zc.test(n) ? nn : +n;
            }
            function za(n) {
                return bt(n, jn(n));
            }
            function __(n) {
                return n ? he(un(n), -G, G) : n === 0 ? n : 0;
            }
            function _n(n) {
                return n == null ? "" : ot(n);
            }
            var v_ = $e(function(n, t) {
                if (hr(t) || Vn(t)) {
                    bt(t, Bn(t), n);
                    return;
                }
                for(var i in t)vn.call(t, i) && or(n, i, t[i]);
            }), Ba = $e(function(n, t) {
                bt(t, jn(t), n);
            }), Ai = $e(function(n, t, i, o) {
                bt(t, jn(t), n, o);
            }), w_ = $e(function(n, t, i, o) {
                bt(t, Bn(t), n, o);
            }), m_ = Gt(Bu);
            function y_(n, t) {
                var i = Oe(n);
                return t == null ? i : vs(i, t);
            }
            var x_ = sn(function(n, t) {
                n = wn(n);
                var i = -1, o = t.length, a = o > 2 ? t[2] : u;
                for(a && Yn(t[0], t[1], a) && (o = 1); ++i < o;)for(var p = t[i], _ = jn(p), m = -1, E = _.length; ++m < E;){
                    var L = _[m], b = n[L];
                    (b === u || Rt(b, be[L]) && !vn.call(n, L)) && (n[L] = p[L]);
                }
                return n;
            }), S_ = sn(function(n) {
                return n.push(u, ea), it(Wa, u, n);
            });
            function E_(n, t) {
                return Vf(n, K(t, 3), Lt);
            }
            function A_(n, t) {
                return Vf(n, K(t, 3), ku);
            }
            function C_(n, t) {
                return n == null ? n : Wu(n, K(t, 3), jn);
            }
            function R_(n, t) {
                return n == null ? n : Ss(n, K(t, 3), jn);
            }
            function T_(n, t) {
                return n && Lt(n, K(t, 3));
            }
            function I_(n, t) {
                return n && ku(n, K(t, 3));
            }
            function M_(n) {
                return n == null ? [] : ui(n, Bn(n));
            }
            function L_(n) {
                return n == null ? [] : ui(n, jn(n));
            }
            function yo(n, t, i) {
                var o = n == null ? u : pe(n, t);
                return o === u ? i : o;
            }
            function b_(n, t) {
                return n != null && ua(n, t, np);
            }
            function xo(n, t) {
                return n != null && ua(n, t, tp);
            }
            var P_ = Qs(function(n, t, i) {
                t != null && typeof t.toString != "function" && (t = Xr.call(t)), n[t] = i;
            }, Eo(nt)), N_ = Qs(function(n, t, i) {
                t != null && typeof t.toString != "function" && (t = Xr.call(t)), vn.call(n, t) ? n[t].push(i) : n[t] = [
                    i
                ];
            }, K), O_ = sn(sr);
            function Bn(n) {
                return Vn(n) ? ds(n) : Hu(n);
            }
            function jn(n) {
                return Vn(n) ? ds(n, !0) : cp(n);
            }
            function $_(n, t) {
                var i = {};
                return t = K(t, 3), Lt(n, function(o, a, p) {
                    kt(i, t(o, a, p), o);
                }), i;
            }
            function F_(n, t) {
                var i = {};
                return t = K(t, 3), Lt(n, function(o, a, p) {
                    kt(i, a, t(o, a, p));
                }), i;
            }
            var D_ = $e(function(n, t, i) {
                oi(n, t, i);
            }), Wa = $e(function(n, t, i, o) {
                oi(n, t, i, o);
            }), z_ = Gt(function(n, t) {
                var i = {};
                if (n == null) return i;
                var o = !1;
                t = Cn(t, function(p) {
                    return p = ie(p, n), o || (o = p.length > 1), p;
                }), bt(n, uo(n), i), o && (i = _t(i, y | x | C, Pp));
                for(var a = t.length; a--;)Qu(i, t[a]);
                return i;
            });
            function B_(n, t) {
                return ka(n, xi(K(t)));
            }
            var W_ = Gt(function(n, t) {
                return n == null ? {} : pp(n, t);
            });
            function ka(n, t) {
                if (n == null) return {};
                var i = Cn(uo(n), function(o) {
                    return [
                        o
                    ];
                });
                return t = K(t), Ps(n, i, function(o, a) {
                    return t(o, a[0]);
                });
            }
            function k_(n, t, i) {
                t = ie(t, n);
                var o = -1, a = t.length;
                for(a || (a = 1, n = u); ++o < a;){
                    var p = n == null ? u : n[Pt(t[o])];
                    p === u && (o = a, p = i), n = Ht(p) ? p.call(n) : p;
                }
                return n;
            }
            function U_(n, t, i) {
                return n == null ? n : lr(n, t, i);
            }
            function G_(n, t, i, o) {
                return o = typeof o == "function" ? o : u, n == null ? n : lr(n, t, i, o);
            }
            var Ua = na(Bn), Ga = na(jn);
            function q_(n, t, i) {
                var o = en(n), a = o || oe(n) || ze(n);
                if (t = K(t, 4), i == null) {
                    var p = n && n.constructor;
                    a ? i = o ? new p() : [] : Rn(n) ? i = Ht(p) ? Oe(Zr(n)) : {} : i = {};
                }
                return (a ? pt : Lt)(n, function(_, m, E) {
                    return t(i, _, m, E);
                }), i;
            }
            function H_(n, t) {
                return n == null ? !0 : Qu(n, t);
            }
            function X_(n, t, i) {
                return n == null ? n : Ds(n, t, no(i));
            }
            function Y_(n, t, i, o) {
                return o = typeof o == "function" ? o : u, n == null ? n : Ds(n, t, no(i), o);
            }
            function Be(n) {
                return n == null ? [] : Pu(n, Bn(n));
            }
            function K_(n) {
                return n == null ? [] : Pu(n, jn(n));
            }
            function Z_(n, t, i) {
                return i === u && (i = t, t = u), i !== u && (i = mt(i), i = i === i ? i : 0), t !== u && (t = mt(t), t = t === t ? t : 0), he(mt(n), t, i);
            }
            function J_(n, t, i) {
                return t = Xt(t), i === u ? (i = t, t = 0) : i = Xt(i), n = mt(n), ep(n, t, i);
            }
            function Q_(n, t, i) {
                if (i && typeof i != "boolean" && Yn(n, t, i) && (t = i = u), i === u && (typeof t == "boolean" ? (i = t, t = u) : typeof n == "boolean" && (i = n, n = u)), n === u && t === u ? (n = 0, t = 1) : (n = Xt(n), t === u ? (t = n, n = 0) : t = Xt(t)), n > t) {
                    var o = n;
                    n = t, t = o;
                }
                if (i || n % 1 || t % 1) {
                    var a = ps();
                    return Gn(n + a * (t - n + Mh("1e-" + ((a + "").length - 1))), t);
                }
                return Ku(n, t);
            }
            var V_ = Fe(function(n, t, i) {
                return t = t.toLowerCase(), n + (i ? qa(t) : t);
            });
            function qa(n) {
                return So(_n(n).toLowerCase());
            }
            function Ha(n) {
                return n = _n(n), n && n.replace(nh, Uh).replace(mh, "");
            }
            function j_(n, t, i) {
                n = _n(n), t = ot(t);
                var o = n.length;
                i = i === u ? o : he(un(i), 0, o);
                var a = i;
                return i -= t.length, i >= 0 && n.slice(i, a) == t;
            }
            function n1(n) {
                return n = _n(n), n && Oc.test(n) ? n.replace(Sf, Gh) : n;
            }
            function t1(n) {
                return n = _n(n), n && Wc.test(n) ? n.replace(_u, "\\$&") : n;
            }
            var e1 = Fe(function(n, t, i) {
                return n + (i ? "-" : "") + t.toLowerCase();
            }), r1 = Fe(function(n, t, i) {
                return n + (i ? " " : "") + t.toLowerCase();
            }), i1 = Ks("toLowerCase");
            function u1(n, t, i) {
                n = _n(n), t = un(t);
                var o = t ? Me(n) : 0;
                if (!t || o >= t) return n;
                var a = (t - o) / 2;
                return hi(jr(a), i) + n + hi(Vr(a), i);
            }
            function o1(n, t, i) {
                n = _n(n), t = un(t);
                var o = t ? Me(n) : 0;
                return t && o < t ? n + hi(t - o, i) : n;
            }
            function f1(n, t, i) {
                n = _n(n), t = un(t);
                var o = t ? Me(n) : 0;
                return t && o < t ? hi(t - o, i) + n : n;
            }
            function s1(n, t, i) {
                return i || t == null ? t = 0 : t && (t = +t), d0(_n(n).replace(vu, ""), t || 0);
            }
            function a1(n, t, i) {
                return (i ? Yn(n, t, i) : t === u) ? t = 1 : t = un(t), Zu(_n(n), t);
            }
            function l1() {
                var n = arguments, t = _n(n[0]);
                return n.length < 3 ? t : t.replace(n[1], n[2]);
            }
            var c1 = Fe(function(n, t, i) {
                return n + (i ? "_" : "") + t.toLowerCase();
            });
            function h1(n, t, i) {
                return i && typeof i != "number" && Yn(n, t, i) && (t = i = u), i = i === u ? Q : i >>> 0, i ? (n = _n(n), n && (typeof t == "string" || t != null && !mo(t)) && (t = ot(t), !t && Ie(n)) ? ue(At(n), 0, i) : n.split(t, i)) : [];
            }
            var p1 = Fe(function(n, t, i) {
                return n + (i ? " " : "") + So(t);
            });
            function g1(n, t, i) {
                return n = _n(n), i = i == null ? 0 : he(un(i), 0, n.length), t = ot(t), n.slice(i, i + t.length) == t;
            }
            function d1(n, t, i) {
                var o = l.templateSettings;
                i && Yn(n, t, i) && (t = u), n = _n(n), t = Ai({}, t, o, ta);
                var a = Ai({}, t.imports, o.imports, ta), p = Bn(a), _ = Pu(a, p), m, E, L = 0, b = t.interpolate || Dr, N = "__p += '", D = Ou((t.escape || Dr).source + "|" + b.source + "|" + (b === Ef ? Kc : Dr).source + "|" + (t.evaluate || Dr).source + "|$", "g"), H = "//# sourceURL=" + (vn.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ah + "]") + `
`;
                n.replace(D, function(J, an, cn, st, Kn, at) {
                    return cn || (cn = st), N += n.slice(L, at).replace(th, qh), an && (m = !0, N += `' +
__e(` + an + `) +
'`), Kn && (E = !0, N += `';
` + Kn + `;
__p += '`), cn && (N += `' +
((__t = (` + cn + `)) == null ? '' : __t) +
'`), L = at + J.length, J;
                }), N += `';
`;
                var Z = vn.call(t, "variable") && t.variable;
                if (!Z) N = `with (obj) {
` + N + `
}
`;
                else if (Xc.test(Z)) throw new tn(g);
                N = (E ? N.replace(Lc, "") : N).replace(bc, "$1").replace(Pc, "$1;"), N = "function(" + (Z || "obj") + `) {
` + (Z ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (m ? ", __e = _.escape" : "") + (E ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + N + `return __p
}`;
                var fn = Ya(function() {
                    return dn(p, H + "return " + N).apply(u, _);
                });
                if (fn.source = N, wo(fn)) throw fn;
                return fn;
            }
            function _1(n) {
                return _n(n).toLowerCase();
            }
            function v1(n) {
                return _n(n).toUpperCase();
            }
            function w1(n, t, i) {
                if (n = _n(n), n && (i || t === u)) return es(n);
                if (!n || !(t = ot(t))) return n;
                var o = At(n), a = At(t), p = rs(o, a), _ = is(o, a) + 1;
                return ue(o, p, _).join("");
            }
            function m1(n, t, i) {
                if (n = _n(n), n && (i || t === u)) return n.slice(0, os(n) + 1);
                if (!n || !(t = ot(t))) return n;
                var o = At(n), a = is(o, At(t)) + 1;
                return ue(o, 0, a).join("");
            }
            function y1(n, t, i) {
                if (n = _n(n), n && (i || t === u)) return n.replace(vu, "");
                if (!n || !(t = ot(t))) return n;
                var o = At(n), a = rs(o, At(t));
                return ue(o, a).join("");
            }
            function x1(n, t) {
                var i = pn, o = j;
                if (Rn(t)) {
                    var a = "separator" in t ? t.separator : a;
                    i = "length" in t ? un(t.length) : i, o = "omission" in t ? ot(t.omission) : o;
                }
                n = _n(n);
                var p = n.length;
                if (Ie(n)) {
                    var _ = At(n);
                    p = _.length;
                }
                if (i >= p) return n;
                var m = i - Me(o);
                if (m < 1) return o;
                var E = _ ? ue(_, 0, m).join("") : n.slice(0, m);
                if (a === u) return E + o;
                if (_ && (m += E.length - m), mo(a)) {
                    if (n.slice(m).search(a)) {
                        var L, b = E;
                        for(a.global || (a = Ou(a.source, _n(Af.exec(a)) + "g")), a.lastIndex = 0; L = a.exec(b);)var N = L.index;
                        E = E.slice(0, N === u ? m : N);
                    }
                } else if (n.indexOf(ot(a), m) != m) {
                    var D = E.lastIndexOf(a);
                    D > -1 && (E = E.slice(0, D));
                }
                return E + o;
            }
            function S1(n) {
                return n = _n(n), n && Nc.test(n) ? n.replace(xf, Qh) : n;
            }
            var E1 = Fe(function(n, t, i) {
                return n + (i ? " " : "") + t.toUpperCase();
            }), So = Ks("toUpperCase");
            function Xa(n, t, i) {
                return n = _n(n), t = i ? u : t, t === u ? Xh(n) ? n0(n) : Dh(n) : n.match(t) || [];
            }
            var Ya = sn(function(n, t) {
                try {
                    return it(n, u, t);
                } catch (i) {
                    return wo(i) ? i : new tn(i);
                }
            }), A1 = Gt(function(n, t) {
                return pt(t, function(i) {
                    i = Pt(i), kt(n, i, _o(n[i], n));
                }), n;
            });
            function C1(n) {
                var t = n == null ? 0 : n.length, i = K();
                return n = t ? Cn(n, function(o) {
                    if (typeof o[1] != "function") throw new gt(c);
                    return [
                        i(o[0]),
                        o[1]
                    ];
                }) : [], sn(function(o) {
                    for(var a = -1; ++a < t;){
                        var p = n[a];
                        if (it(p[0], this, o)) return it(p[1], this, o);
                    }
                });
            }
            function R1(n) {
                return Q0(_t(n, y));
            }
            function Eo(n) {
                return function() {
                    return n;
                };
            }
            function T1(n, t) {
                return n == null || n !== n ? t : n;
            }
            var I1 = Js(), M1 = Js(!0);
            function nt(n) {
                return n;
            }
            function Ao(n) {
                return Rs(typeof n == "function" ? n : _t(n, y));
            }
            function L1(n) {
                return Is(_t(n, y));
            }
            function b1(n, t) {
                return Ms(n, _t(t, y));
            }
            var P1 = sn(function(n, t) {
                return function(i) {
                    return sr(i, n, t);
                };
            }), N1 = sn(function(n, t) {
                return function(i) {
                    return sr(n, i, t);
                };
            });
            function Co(n, t, i) {
                var o = Bn(t), a = ui(t, o);
                i == null && !(Rn(t) && (a.length || !o.length)) && (i = t, t = n, n = this, a = ui(t, Bn(t)));
                var p = !(Rn(i) && "chain" in i) || !!i.chain, _ = Ht(n);
                return pt(a, function(m) {
                    var E = t[m];
                    n[m] = E, _ && (n.prototype[m] = function() {
                        var L = this.__chain__;
                        if (p || L) {
                            var b = n(this.__wrapped__), N = b.__actions__ = Qn(this.__actions__);
                            return N.push({
                                func: E,
                                args: arguments,
                                thisArg: n
                            }), b.__chain__ = L, b;
                        }
                        return E.apply(n, jt([
                            this.value()
                        ], arguments));
                    });
                }), n;
            }
            function O1() {
                return Wn._ === this && (Wn._ = o0), this;
            }
            function Ro() {}
            function $1(n) {
                return n = un(n), sn(function(t) {
                    return Ls(t, n);
                });
            }
            var F1 = eo(Cn), D1 = eo(Qf), z1 = eo(Tu);
            function Ka(n) {
                return ao(n) ? Iu(Pt(n)) : gp(n);
            }
            function B1(n) {
                return function(t) {
                    return n == null ? u : pe(n, t);
                };
            }
            var W1 = Vs(), k1 = Vs(!0);
            function To() {
                return [];
            }
            function Io() {
                return !1;
            }
            function U1() {
                return {};
            }
            function G1() {
                return "";
            }
            function q1() {
                return !0;
            }
            function H1(n, t) {
                if (n = un(n), n < 1 || n > G) return [];
                var i = Q, o = Gn(n, Q);
                t = K(t), n -= Q;
                for(var a = bu(o, t); ++i < n;)t(i);
                return a;
            }
            function X1(n) {
                return en(n) ? Cn(n, Pt) : ft(n) ? [
                    n
                ] : Qn(ga(_n(n)));
            }
            function Y1(n) {
                var t = ++i0;
                return _n(n) + t;
            }
            var K1 = ci(function(n, t) {
                return n + t;
            }, 0), Z1 = ro("ceil"), J1 = ci(function(n, t) {
                return n / t;
            }, 1), Q1 = ro("floor");
            function V1(n) {
                return n && n.length ? ii(n, nt, Uu) : u;
            }
            function j1(n, t) {
                return n && n.length ? ii(n, K(t, 2), Uu) : u;
            }
            function nv(n) {
                return ns(n, nt);
            }
            function tv(n, t) {
                return ns(n, K(t, 2));
            }
            function ev(n) {
                return n && n.length ? ii(n, nt, Xu) : u;
            }
            function rv(n, t) {
                return n && n.length ? ii(n, K(t, 2), Xu) : u;
            }
            var iv = ci(function(n, t) {
                return n * t;
            }, 1), uv = ro("round"), ov = ci(function(n, t) {
                return n - t;
            }, 0);
            function fv(n) {
                return n && n.length ? Lu(n, nt) : 0;
            }
            function sv(n, t) {
                return n && n.length ? Lu(n, K(t, 2)) : 0;
            }
            return l.after = Ld, l.ary = Ca, l.assign = v_, l.assignIn = Ba, l.assignInWith = Ai, l.assignWith = w_, l.at = m_, l.before = Ra, l.bind = _o, l.bindAll = A1, l.bindKey = Ta, l.castArray = Ud, l.chain = Sa, l.chunk = Qp, l.compact = Vp, l.concat = jp, l.cond = C1, l.conforms = R1, l.constant = Eo, l.countBy = fd, l.create = y_, l.curry = Ia, l.curryRight = Ma, l.debounce = La, l.defaults = x_, l.defaultsDeep = S_, l.defer = bd, l.delay = Pd, l.difference = ng, l.differenceBy = tg, l.differenceWith = eg, l.drop = rg, l.dropRight = ig, l.dropRightWhile = ug, l.dropWhile = og, l.fill = fg, l.filter = ad, l.flatMap = hd, l.flatMapDeep = pd, l.flatMapDepth = gd, l.flatten = wa, l.flattenDeep = sg, l.flattenDepth = ag, l.flip = Nd, l.flow = I1, l.flowRight = M1, l.fromPairs = lg, l.functions = M_, l.functionsIn = L_, l.groupBy = dd, l.initial = hg, l.intersection = pg, l.intersectionBy = gg, l.intersectionWith = dg, l.invert = P_, l.invertBy = N_, l.invokeMap = vd, l.iteratee = Ao, l.keyBy = wd, l.keys = Bn, l.keysIn = jn, l.map = wi, l.mapKeys = $_, l.mapValues = F_, l.matches = L1, l.matchesProperty = b1, l.memoize = yi, l.merge = D_, l.mergeWith = Wa, l.method = P1, l.methodOf = N1, l.mixin = Co, l.negate = xi, l.nthArg = $1, l.omit = z_, l.omitBy = B_, l.once = Od, l.orderBy = md, l.over = F1, l.overArgs = $d, l.overEvery = D1, l.overSome = z1, l.partial = vo, l.partialRight = ba, l.partition = yd, l.pick = W_, l.pickBy = ka, l.property = Ka, l.propertyOf = B1, l.pull = mg, l.pullAll = ya, l.pullAllBy = yg, l.pullAllWith = xg, l.pullAt = Sg, l.range = W1, l.rangeRight = k1, l.rearg = Fd, l.reject = Ed, l.remove = Eg, l.rest = Dd, l.reverse = po, l.sampleSize = Cd, l.set = U_, l.setWith = G_, l.shuffle = Rd, l.slice = Ag, l.sortBy = Md, l.sortedUniq = bg, l.sortedUniqBy = Pg, l.split = h1, l.spread = zd, l.tail = Ng, l.take = Og, l.takeRight = $g, l.takeRightWhile = Fg, l.takeWhile = Dg, l.tap = Vg, l.throttle = Bd, l.thru = vi, l.toArray = Fa, l.toPairs = Ua, l.toPairsIn = Ga, l.toPath = X1, l.toPlainObject = za, l.transform = q_, l.unary = Wd, l.union = zg, l.unionBy = Bg, l.unionWith = Wg, l.uniq = kg, l.uniqBy = Ug, l.uniqWith = Gg, l.unset = H_, l.unzip = go, l.unzipWith = xa, l.update = X_, l.updateWith = Y_, l.values = Be, l.valuesIn = K_, l.without = qg, l.words = Xa, l.wrap = kd, l.xor = Hg, l.xorBy = Xg, l.xorWith = Yg, l.zip = Kg, l.zipObject = Zg, l.zipObjectDeep = Jg, l.zipWith = Qg, l.entries = Ua, l.entriesIn = Ga, l.extend = Ba, l.extendWith = Ai, Co(l, l), l.add = K1, l.attempt = Ya, l.camelCase = V_, l.capitalize = qa, l.ceil = Z1, l.clamp = Z_, l.clone = Gd, l.cloneDeep = Hd, l.cloneDeepWith = Xd, l.cloneWith = qd, l.conformsTo = Yd, l.deburr = Ha, l.defaultTo = T1, l.divide = J1, l.endsWith = j_, l.eq = Rt, l.escape = n1, l.escapeRegExp = t1, l.every = sd, l.find = ld, l.findIndex = _a, l.findKey = E_, l.findLast = cd, l.findLastIndex = va, l.findLastKey = A_, l.floor = Q1, l.forEach = Ea, l.forEachRight = Aa, l.forIn = C_, l.forInRight = R_, l.forOwn = T_, l.forOwnRight = I_, l.get = yo, l.gt = Kd, l.gte = Zd, l.has = b_, l.hasIn = xo, l.head = ma, l.identity = nt, l.includes = _d, l.indexOf = cg, l.inRange = J_, l.invoke = O_, l.isArguments = _e, l.isArray = en, l.isArrayBuffer = Jd, l.isArrayLike = Vn, l.isArrayLikeObject = bn, l.isBoolean = Qd, l.isBuffer = oe, l.isDate = Vd, l.isElement = jd, l.isEmpty = n_, l.isEqual = t_, l.isEqualWith = e_, l.isError = wo, l.isFinite = r_, l.isFunction = Ht, l.isInteger = Pa, l.isLength = Si, l.isMap = Na, l.isMatch = i_, l.isMatchWith = u_, l.isNaN = o_, l.isNative = f_, l.isNil = a_, l.isNull = s_, l.isNumber = Oa, l.isObject = Rn, l.isObjectLike = Mn, l.isPlainObject = gr, l.isRegExp = mo, l.isSafeInteger = l_, l.isSet = $a, l.isString = Ei, l.isSymbol = ft, l.isTypedArray = ze, l.isUndefined = c_, l.isWeakMap = h_, l.isWeakSet = p_, l.join = _g, l.kebabCase = e1, l.last = wt, l.lastIndexOf = vg, l.lowerCase = r1, l.lowerFirst = i1, l.lt = g_, l.lte = d_, l.max = V1, l.maxBy = j1, l.mean = nv, l.meanBy = tv, l.min = ev, l.minBy = rv, l.stubArray = To, l.stubFalse = Io, l.stubObject = U1, l.stubString = G1, l.stubTrue = q1, l.multiply = iv, l.nth = wg, l.noConflict = O1, l.noop = Ro, l.now = mi, l.pad = u1, l.padEnd = o1, l.padStart = f1, l.parseInt = s1, l.random = Q_, l.reduce = xd, l.reduceRight = Sd, l.repeat = a1, l.replace = l1, l.result = k_, l.round = uv, l.runInContext = S, l.sample = Ad, l.size = Td, l.snakeCase = c1, l.some = Id, l.sortedIndex = Cg, l.sortedIndexBy = Rg, l.sortedIndexOf = Tg, l.sortedLastIndex = Ig, l.sortedLastIndexBy = Mg, l.sortedLastIndexOf = Lg, l.startCase = p1, l.startsWith = g1, l.subtract = ov, l.sum = fv, l.sumBy = sv, l.template = d1, l.times = H1, l.toFinite = Xt, l.toInteger = un, l.toLength = Da, l.toLower = _1, l.toNumber = mt, l.toSafeInteger = __, l.toString = _n, l.toUpper = v1, l.trim = w1, l.trimEnd = m1, l.trimStart = y1, l.truncate = x1, l.unescape = S1, l.uniqueId = Y1, l.upperCase = E1, l.upperFirst = So, l.each = Ea, l.eachRight = Aa, l.first = ma, Co(l, function() {
                var n = {};
                return Lt(l, function(t, i) {
                    vn.call(l.prototype, i) || (n[i] = t);
                }), n;
            }(), {
                chain: !1
            }), l.VERSION = f, pt([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(n) {
                l[n].placeholder = l;
            }), pt([
                "drop",
                "take"
            ], function(n, t) {
                ln.prototype[n] = function(i) {
                    i = i === u ? 1 : Dn(un(i), 0);
                    var o = this.__filtered__ && !t ? new ln(this) : this.clone();
                    return o.__filtered__ ? o.__takeCount__ = Gn(i, o.__takeCount__) : o.__views__.push({
                        size: Gn(i, Q),
                        type: n + (o.__dir__ < 0 ? "Right" : "")
                    }), o;
                }, ln.prototype[n + "Right"] = function(i) {
                    return this.reverse()[n](i).reverse();
                };
            }), pt([
                "filter",
                "map",
                "takeWhile"
            ], function(n, t) {
                var i = t + 1, o = i == A || i == I;
                ln.prototype[n] = function(a) {
                    var p = this.clone();
                    return p.__iteratees__.push({
                        iteratee: K(a, 3),
                        type: i
                    }), p.__filtered__ = p.__filtered__ || o, p;
                };
            }), pt([
                "head",
                "last"
            ], function(n, t) {
                var i = "take" + (t ? "Right" : "");
                ln.prototype[n] = function() {
                    return this[i](1).value()[0];
                };
            }), pt([
                "initial",
                "tail"
            ], function(n, t) {
                var i = "drop" + (t ? "" : "Right");
                ln.prototype[n] = function() {
                    return this.__filtered__ ? new ln(this) : this[i](1);
                };
            }), ln.prototype.compact = function() {
                return this.filter(nt);
            }, ln.prototype.find = function(n) {
                return this.filter(n).head();
            }, ln.prototype.findLast = function(n) {
                return this.reverse().find(n);
            }, ln.prototype.invokeMap = sn(function(n, t) {
                return typeof n == "function" ? new ln(this) : this.map(function(i) {
                    return sr(i, n, t);
                });
            }), ln.prototype.reject = function(n) {
                return this.filter(xi(K(n)));
            }, ln.prototype.slice = function(n, t) {
                n = un(n);
                var i = this;
                return i.__filtered__ && (n > 0 || t < 0) ? new ln(i) : (n < 0 ? i = i.takeRight(-n) : n && (i = i.drop(n)), t !== u && (t = un(t), i = t < 0 ? i.dropRight(-t) : i.take(t - n)), i);
            }, ln.prototype.takeRightWhile = function(n) {
                return this.reverse().takeWhile(n).reverse();
            }, ln.prototype.toArray = function() {
                return this.take(Q);
            }, Lt(ln.prototype, function(n, t) {
                var i = /^(?:filter|find|map|reject)|While$/.test(t), o = /^(?:head|last)$/.test(t), a = l[o ? "take" + (t == "last" ? "Right" : "") : t], p = o || /^find/.test(t);
                a && (l.prototype[t] = function() {
                    var _ = this.__wrapped__, m = o ? [
                        1
                    ] : arguments, E = _ instanceof ln, L = m[0], b = E || en(_), N = function(an) {
                        var cn = a.apply(l, jt([
                            an
                        ], m));
                        return o && D ? cn[0] : cn;
                    };
                    b && i && typeof L == "function" && L.length != 1 && (E = b = !1);
                    var D = this.__chain__, H = !!this.__actions__.length, Z = p && !D, fn = E && !H;
                    if (!p && b) {
                        _ = fn ? _ : new ln(this);
                        var J = n.apply(_, m);
                        return J.__actions__.push({
                            func: vi,
                            args: [
                                N
                            ],
                            thisArg: u
                        }), new dt(J, D);
                    }
                    return Z && fn ? n.apply(this, m) : (J = this.thru(N), Z ? o ? J.value()[0] : J.value() : J);
                });
            }), pt([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(n) {
                var t = Gr[n], i = /^(?:push|sort|unshift)$/.test(n) ? "tap" : "thru", o = /^(?:pop|shift)$/.test(n);
                l.prototype[n] = function() {
                    var a = arguments;
                    if (o && !this.__chain__) {
                        var p = this.value();
                        return t.apply(en(p) ? p : [], a);
                    }
                    return this[i](function(_) {
                        return t.apply(en(_) ? _ : [], a);
                    });
                };
            }), Lt(ln.prototype, function(n, t) {
                var i = l[t];
                if (i) {
                    var o = i.name + "";
                    vn.call(Ne, o) || (Ne[o] = []), Ne[o].push({
                        name: t,
                        func: i
                    });
                }
            }), Ne[li(u, O).name] = [
                {
                    name: "wrapper",
                    func: u
                }
            ], ln.prototype.clone = S0, ln.prototype.reverse = E0, ln.prototype.value = A0, l.prototype.at = jg, l.prototype.chain = nd, l.prototype.commit = td, l.prototype.next = ed, l.prototype.plant = id, l.prototype.reverse = ud, l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = od, l.prototype.first = l.prototype.head, tr && (l.prototype[tr] = rd), l;
        }, Le = t0();
        se ? ((se.exports = Le)._ = Le, Eu._ = Le) : Wn._ = Le;
    }).call($3cfd30e35d79a5df$var$dr);
})($3cfd30e35d79a5df$var$Wi, $3cfd30e35d79a5df$var$Wi.exports);
var $3cfd30e35d79a5df$var$hv = $3cfd30e35d79a5df$var$Wi.exports, $3cfd30e35d79a5df$var$Fo = "http://www.w3.org/1999/xhtml";
const $3cfd30e35d79a5df$var$Ja = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $3cfd30e35d79a5df$var$Fo,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};
function $3cfd30e35d79a5df$var$iu(e) {
    var r = e += "", u = r.indexOf(":");
    return u >= 0 && (r = e.slice(0, u)) !== "xmlns" && (e = e.slice(u + 1)), $3cfd30e35d79a5df$var$Ja.hasOwnProperty(r) ? {
        space: $3cfd30e35d79a5df$var$Ja[r],
        local: e
    } : e;
}
function $3cfd30e35d79a5df$var$pv(e) {
    return function() {
        var r = this.ownerDocument, u = this.namespaceURI;
        return u === $3cfd30e35d79a5df$var$Fo && r.documentElement.namespaceURI === $3cfd30e35d79a5df$var$Fo ? r.createElement(e) : r.createElementNS(u, e);
    };
}
function $3cfd30e35d79a5df$var$gv(e) {
    return function() {
        return this.ownerDocument.createElementNS(e.space, e.local);
    };
}
function $3cfd30e35d79a5df$var$Nl(e) {
    var r = $3cfd30e35d79a5df$var$iu(e);
    return (r.local ? $3cfd30e35d79a5df$var$gv : $3cfd30e35d79a5df$var$pv)(r);
}
function $3cfd30e35d79a5df$var$dv() {}
function $3cfd30e35d79a5df$var$ff(e) {
    return e == null ? $3cfd30e35d79a5df$var$dv : function() {
        return this.querySelector(e);
    };
}
function $3cfd30e35d79a5df$var$_v(e) {
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$ff(e));
    for(var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)for(var h = r[s], c = h.length, g = f[s] = new Array(c), v, w, d = 0; d < c; ++d)(v = h[d]) && (w = e.call(v, v.__data__, d, h)) && ("__data__" in v && (w.__data__ = v.__data__), g[d] = w);
    return new $3cfd30e35d79a5df$var$Zn(f, this._parents);
}
function $3cfd30e35d79a5df$var$Ol(e) {
    return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function $3cfd30e35d79a5df$var$vv() {
    return [];
}
function $3cfd30e35d79a5df$var$$l(e) {
    return e == null ? $3cfd30e35d79a5df$var$vv : function() {
        return this.querySelectorAll(e);
    };
}
function $3cfd30e35d79a5df$var$wv(e) {
    return function() {
        return $3cfd30e35d79a5df$var$Ol(e.apply(this, arguments));
    };
}
function $3cfd30e35d79a5df$var$mv(e) {
    typeof e == "function" ? e = $3cfd30e35d79a5df$var$wv(e) : e = $3cfd30e35d79a5df$var$$l(e);
    for(var r = this._groups, u = r.length, f = [], s = [], h = 0; h < u; ++h)for(var c = r[h], g = c.length, v, w = 0; w < g; ++w)(v = c[w]) && (f.push(e.call(v, v.__data__, w, c)), s.push(v));
    return new $3cfd30e35d79a5df$var$Zn(f, s);
}
function $3cfd30e35d79a5df$var$Fl(e) {
    return function() {
        return this.matches(e);
    };
}
function $3cfd30e35d79a5df$var$Dl(e) {
    return function(r) {
        return r.matches(e);
    };
}
var $3cfd30e35d79a5df$var$yv = Array.prototype.find;
function $3cfd30e35d79a5df$var$xv(e) {
    return function() {
        return $3cfd30e35d79a5df$var$yv.call(this.children, e);
    };
}
function $3cfd30e35d79a5df$var$Sv() {
    return this.firstElementChild;
}
function $3cfd30e35d79a5df$var$Ev(e) {
    return this.select(e == null ? $3cfd30e35d79a5df$var$Sv : $3cfd30e35d79a5df$var$xv(typeof e == "function" ? e : $3cfd30e35d79a5df$var$Dl(e)));
}
var $3cfd30e35d79a5df$var$Av = Array.prototype.filter;
function $3cfd30e35d79a5df$var$Cv() {
    return Array.from(this.children);
}
function $3cfd30e35d79a5df$var$Rv(e) {
    return function() {
        return $3cfd30e35d79a5df$var$Av.call(this.children, e);
    };
}
function $3cfd30e35d79a5df$var$Tv(e) {
    return this.selectAll(e == null ? $3cfd30e35d79a5df$var$Cv : $3cfd30e35d79a5df$var$Rv(typeof e == "function" ? e : $3cfd30e35d79a5df$var$Dl(e)));
}
function $3cfd30e35d79a5df$var$Iv(e) {
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$Fl(e));
    for(var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)for(var h = r[s], c = h.length, g = f[s] = [], v, w = 0; w < c; ++w)(v = h[w]) && e.call(v, v.__data__, w, h) && g.push(v);
    return new $3cfd30e35d79a5df$var$Zn(f, this._parents);
}
function $3cfd30e35d79a5df$var$zl(e) {
    return new Array(e.length);
}
function $3cfd30e35d79a5df$var$Mv() {
    return new $3cfd30e35d79a5df$var$Zn(this._enter || this._groups.map($3cfd30e35d79a5df$var$zl), this._parents);
}
function $3cfd30e35d79a5df$var$ki(e, r) {
    this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = r;
}
$3cfd30e35d79a5df$var$ki.prototype = {
    constructor: $3cfd30e35d79a5df$var$ki,
    appendChild: function(e) {
        return this._parent.insertBefore(e, this._next);
    },
    insertBefore: function(e, r) {
        return this._parent.insertBefore(e, r);
    },
    querySelector: function(e) {
        return this._parent.querySelector(e);
    },
    querySelectorAll: function(e) {
        return this._parent.querySelectorAll(e);
    }
};
function $3cfd30e35d79a5df$var$Lv(e) {
    return function() {
        return e;
    };
}
function $3cfd30e35d79a5df$var$bv(e, r, u, f, s, h) {
    for(var c = 0, g, v = r.length, w = h.length; c < w; ++c)(g = r[c]) ? (g.__data__ = h[c], f[c] = g) : u[c] = new $3cfd30e35d79a5df$var$ki(e, h[c]);
    for(; c < v; ++c)(g = r[c]) && (s[c] = g);
}
function $3cfd30e35d79a5df$var$Pv(e, r, u, f, s, h, c) {
    var g, v, w = /* @__PURE__ */ new Map(), d = r.length, y = h.length, x = new Array(d), C;
    for(g = 0; g < d; ++g)(v = r[g]) && (x[g] = C = c.call(v, v.__data__, g, r) + "", w.has(C) ? s[g] = v : w.set(C, v));
    for(g = 0; g < y; ++g)C = c.call(e, h[g], g, h) + "", (v = w.get(C)) ? (f[g] = v, v.__data__ = h[g], w.delete(C)) : u[g] = new $3cfd30e35d79a5df$var$ki(e, h[g]);
    for(g = 0; g < d; ++g)(v = r[g]) && w.get(x[g]) === v && (s[g] = v);
}
function $3cfd30e35d79a5df$var$Nv(e) {
    return e.__data__;
}
function $3cfd30e35d79a5df$var$Ov(e, r) {
    if (!arguments.length) return Array.from(this, $3cfd30e35d79a5df$var$Nv);
    var u = r ? $3cfd30e35d79a5df$var$Pv : $3cfd30e35d79a5df$var$bv, f = this._parents, s = this._groups;
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$Lv(e));
    for(var h = s.length, c = new Array(h), g = new Array(h), v = new Array(h), w = 0; w < h; ++w){
        var d = f[w], y = s[w], x = y.length, C = $3cfd30e35d79a5df$var$$v(e.call(d, d && d.__data__, w, f)), P = C.length, z = g[w] = new Array(P), $ = c[w] = new Array(P), O = v[w] = new Array(x);
        u(d, y, z, $, O, C, r);
        for(var U = 0, k = 0, B, q; U < P; ++U)if (B = z[U]) {
            for(U >= k && (k = U + 1); !(q = $[k]) && ++k < P;);
            B._next = q || null;
        }
    }
    return c = new $3cfd30e35d79a5df$var$Zn(c, f), c._enter = g, c._exit = v, c;
}
function $3cfd30e35d79a5df$var$$v(e) {
    return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function $3cfd30e35d79a5df$var$Fv() {
    return new $3cfd30e35d79a5df$var$Zn(this._exit || this._groups.map($3cfd30e35d79a5df$var$zl), this._parents);
}
function $3cfd30e35d79a5df$var$Dv(e, r, u) {
    var f = this.enter(), s = this, h = this.exit();
    return typeof e == "function" ? (f = e(f), f && (f = f.selection())) : f = f.append(e + ""), r != null && (s = r(s), s && (s = s.selection())), u == null ? h.remove() : u(h), f && s ? f.merge(s).order() : s;
}
function $3cfd30e35d79a5df$var$zv(e) {
    for(var r = e.selection ? e.selection() : e, u = this._groups, f = r._groups, s = u.length, h = f.length, c = Math.min(s, h), g = new Array(s), v = 0; v < c; ++v)for(var w = u[v], d = f[v], y = w.length, x = g[v] = new Array(y), C, P = 0; P < y; ++P)(C = w[P] || d[P]) && (x[P] = C);
    for(; v < s; ++v)g[v] = u[v];
    return new $3cfd30e35d79a5df$var$Zn(g, this._parents);
}
function $3cfd30e35d79a5df$var$Bv() {
    for(var e = this._groups, r = -1, u = e.length; ++r < u;)for(var f = e[r], s = f.length - 1, h = f[s], c; --s >= 0;)(c = f[s]) && (h && c.compareDocumentPosition(h) ^ 4 && h.parentNode.insertBefore(c, h), h = c);
    return this;
}
function $3cfd30e35d79a5df$var$Wv(e) {
    e || (e = $3cfd30e35d79a5df$var$kv);
    function r(y, x) {
        return y && x ? e(y.__data__, x.__data__) : !y - !x;
    }
    for(var u = this._groups, f = u.length, s = new Array(f), h = 0; h < f; ++h){
        for(var c = u[h], g = c.length, v = s[h] = new Array(g), w, d = 0; d < g; ++d)(w = c[d]) && (v[d] = w);
        v.sort(r);
    }
    return new $3cfd30e35d79a5df$var$Zn(s, this._parents).order();
}
function $3cfd30e35d79a5df$var$kv(e, r) {
    return e < r ? -1 : e > r ? 1 : e >= r ? 0 : NaN;
}
function $3cfd30e35d79a5df$var$Uv() {
    var e = arguments[0];
    return arguments[0] = this, e.apply(null, arguments), this;
}
function $3cfd30e35d79a5df$var$Gv() {
    return Array.from(this);
}
function $3cfd30e35d79a5df$var$qv() {
    for(var e = this._groups, r = 0, u = e.length; r < u; ++r)for(var f = e[r], s = 0, h = f.length; s < h; ++s){
        var c = f[s];
        if (c) return c;
    }
    return null;
}
function $3cfd30e35d79a5df$var$Hv() {
    let e = 0;
    for (const r of this)++e;
    return e;
}
function $3cfd30e35d79a5df$var$Xv() {
    return !this.node();
}
function $3cfd30e35d79a5df$var$Yv(e) {
    for(var r = this._groups, u = 0, f = r.length; u < f; ++u)for(var s = r[u], h = 0, c = s.length, g; h < c; ++h)(g = s[h]) && e.call(g, g.__data__, h, s);
    return this;
}
function $3cfd30e35d79a5df$var$Kv(e) {
    return function() {
        this.removeAttribute(e);
    };
}
function $3cfd30e35d79a5df$var$Zv(e) {
    return function() {
        this.removeAttributeNS(e.space, e.local);
    };
}
function $3cfd30e35d79a5df$var$Jv(e, r) {
    return function() {
        this.setAttribute(e, r);
    };
}
function $3cfd30e35d79a5df$var$Qv(e, r) {
    return function() {
        this.setAttributeNS(e.space, e.local, r);
    };
}
function $3cfd30e35d79a5df$var$Vv(e, r) {
    return function() {
        var u = r.apply(this, arguments);
        u == null ? this.removeAttribute(e) : this.setAttribute(e, u);
    };
}
function $3cfd30e35d79a5df$var$jv(e, r) {
    return function() {
        var u = r.apply(this, arguments);
        u == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, u);
    };
}
function $3cfd30e35d79a5df$var$nw(e, r) {
    var u = $3cfd30e35d79a5df$var$iu(e);
    if (arguments.length < 2) {
        var f = this.node();
        return u.local ? f.getAttributeNS(u.space, u.local) : f.getAttribute(u);
    }
    return this.each((r == null ? u.local ? $3cfd30e35d79a5df$var$Zv : $3cfd30e35d79a5df$var$Kv : typeof r == "function" ? u.local ? $3cfd30e35d79a5df$var$jv : $3cfd30e35d79a5df$var$Vv : u.local ? $3cfd30e35d79a5df$var$Qv : $3cfd30e35d79a5df$var$Jv)(u, r));
}
function $3cfd30e35d79a5df$var$Bl(e) {
    return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function $3cfd30e35d79a5df$var$tw(e) {
    return function() {
        this.style.removeProperty(e);
    };
}
function $3cfd30e35d79a5df$var$ew(e, r, u) {
    return function() {
        this.style.setProperty(e, r, u);
    };
}
function $3cfd30e35d79a5df$var$rw(e, r, u) {
    return function() {
        var f = r.apply(this, arguments);
        f == null ? this.style.removeProperty(e) : this.style.setProperty(e, f, u);
    };
}
function $3cfd30e35d79a5df$var$iw(e, r, u) {
    return arguments.length > 1 ? this.each((r == null ? $3cfd30e35d79a5df$var$tw : typeof r == "function" ? $3cfd30e35d79a5df$var$rw : $3cfd30e35d79a5df$var$ew)(e, r, u ?? "")) : $3cfd30e35d79a5df$var$qe(this.node(), e);
}
function $3cfd30e35d79a5df$var$qe(e, r) {
    return e.style.getPropertyValue(r) || $3cfd30e35d79a5df$var$Bl(e).getComputedStyle(e, null).getPropertyValue(r);
}
function $3cfd30e35d79a5df$var$uw(e) {
    return function() {
        delete this[e];
    };
}
function $3cfd30e35d79a5df$var$ow(e, r) {
    return function() {
        this[e] = r;
    };
}
function $3cfd30e35d79a5df$var$fw(e, r) {
    return function() {
        var u = r.apply(this, arguments);
        u == null ? delete this[e] : this[e] = u;
    };
}
function $3cfd30e35d79a5df$var$sw(e, r) {
    return arguments.length > 1 ? this.each((r == null ? $3cfd30e35d79a5df$var$uw : typeof r == "function" ? $3cfd30e35d79a5df$var$fw : $3cfd30e35d79a5df$var$ow)(e, r)) : this.node()[e];
}
function $3cfd30e35d79a5df$var$Wl(e) {
    return e.trim().split(/^|\s+/);
}
function $3cfd30e35d79a5df$var$sf(e) {
    return e.classList || new $3cfd30e35d79a5df$var$kl(e);
}
function $3cfd30e35d79a5df$var$kl(e) {
    this._node = e, this._names = $3cfd30e35d79a5df$var$Wl(e.getAttribute("class") || "");
}
$3cfd30e35d79a5df$var$kl.prototype = {
    add: function(e) {
        var r = this._names.indexOf(e);
        r < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
    },
    remove: function(e) {
        var r = this._names.indexOf(e);
        r >= 0 && (this._names.splice(r, 1), this._node.setAttribute("class", this._names.join(" ")));
    },
    contains: function(e) {
        return this._names.indexOf(e) >= 0;
    }
};
function $3cfd30e35d79a5df$var$Ul(e, r) {
    for(var u = $3cfd30e35d79a5df$var$sf(e), f = -1, s = r.length; ++f < s;)u.add(r[f]);
}
function $3cfd30e35d79a5df$var$Gl(e, r) {
    for(var u = $3cfd30e35d79a5df$var$sf(e), f = -1, s = r.length; ++f < s;)u.remove(r[f]);
}
function $3cfd30e35d79a5df$var$aw(e) {
    return function() {
        $3cfd30e35d79a5df$var$Ul(this, e);
    };
}
function $3cfd30e35d79a5df$var$lw(e) {
    return function() {
        $3cfd30e35d79a5df$var$Gl(this, e);
    };
}
function $3cfd30e35d79a5df$var$cw(e, r) {
    return function() {
        (r.apply(this, arguments) ? $3cfd30e35d79a5df$var$Ul : $3cfd30e35d79a5df$var$Gl)(this, e);
    };
}
function $3cfd30e35d79a5df$var$hw(e, r) {
    var u = $3cfd30e35d79a5df$var$Wl(e + "");
    if (arguments.length < 2) {
        for(var f = $3cfd30e35d79a5df$var$sf(this.node()), s = -1, h = u.length; ++s < h;)if (!f.contains(u[s])) return !1;
        return !0;
    }
    return this.each((typeof r == "function" ? $3cfd30e35d79a5df$var$cw : r ? $3cfd30e35d79a5df$var$aw : $3cfd30e35d79a5df$var$lw)(u, r));
}
function $3cfd30e35d79a5df$var$pw() {
    this.textContent = "";
}
function $3cfd30e35d79a5df$var$gw(e) {
    return function() {
        this.textContent = e;
    };
}
function $3cfd30e35d79a5df$var$dw(e) {
    return function() {
        var r = e.apply(this, arguments);
        this.textContent = r ?? "";
    };
}
function $3cfd30e35d79a5df$var$_w(e) {
    return arguments.length ? this.each(e == null ? $3cfd30e35d79a5df$var$pw : (typeof e == "function" ? $3cfd30e35d79a5df$var$dw : $3cfd30e35d79a5df$var$gw)(e)) : this.node().textContent;
}
function $3cfd30e35d79a5df$var$vw() {
    this.innerHTML = "";
}
function $3cfd30e35d79a5df$var$ww(e) {
    return function() {
        this.innerHTML = e;
    };
}
function $3cfd30e35d79a5df$var$mw(e) {
    return function() {
        var r = e.apply(this, arguments);
        this.innerHTML = r ?? "";
    };
}
function $3cfd30e35d79a5df$var$yw(e) {
    return arguments.length ? this.each(e == null ? $3cfd30e35d79a5df$var$vw : (typeof e == "function" ? $3cfd30e35d79a5df$var$mw : $3cfd30e35d79a5df$var$ww)(e)) : this.node().innerHTML;
}
function $3cfd30e35d79a5df$var$xw() {
    this.nextSibling && this.parentNode.appendChild(this);
}
function $3cfd30e35d79a5df$var$Sw() {
    return this.each($3cfd30e35d79a5df$var$xw);
}
function $3cfd30e35d79a5df$var$Ew() {
    this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $3cfd30e35d79a5df$var$Aw() {
    return this.each($3cfd30e35d79a5df$var$Ew);
}
function $3cfd30e35d79a5df$var$Cw(e) {
    var r = typeof e == "function" ? e : $3cfd30e35d79a5df$var$Nl(e);
    return this.select(function() {
        return this.appendChild(r.apply(this, arguments));
    });
}
function $3cfd30e35d79a5df$var$Rw() {
    return null;
}
function $3cfd30e35d79a5df$var$Tw(e, r) {
    var u = typeof e == "function" ? e : $3cfd30e35d79a5df$var$Nl(e), f = r == null ? $3cfd30e35d79a5df$var$Rw : typeof r == "function" ? r : $3cfd30e35d79a5df$var$ff(r);
    return this.select(function() {
        return this.insertBefore(u.apply(this, arguments), f.apply(this, arguments) || null);
    });
}
function $3cfd30e35d79a5df$var$Iw() {
    var e = this.parentNode;
    e && e.removeChild(this);
}
function $3cfd30e35d79a5df$var$Mw() {
    return this.each($3cfd30e35d79a5df$var$Iw);
}
function $3cfd30e35d79a5df$var$Lw() {
    var e = this.cloneNode(!1), r = this.parentNode;
    return r ? r.insertBefore(e, this.nextSibling) : e;
}
function $3cfd30e35d79a5df$var$bw() {
    var e = this.cloneNode(!0), r = this.parentNode;
    return r ? r.insertBefore(e, this.nextSibling) : e;
}
function $3cfd30e35d79a5df$var$Pw(e) {
    return this.select(e ? $3cfd30e35d79a5df$var$bw : $3cfd30e35d79a5df$var$Lw);
}
function $3cfd30e35d79a5df$var$Nw(e) {
    return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function $3cfd30e35d79a5df$var$Ow(e) {
    return function(r) {
        e.call(this, r, this.__data__);
    };
}
function $3cfd30e35d79a5df$var$$w(e) {
    return e.trim().split(/^|\s+/).map(function(r) {
        var u = "", f = r.indexOf(".");
        return f >= 0 && (u = r.slice(f + 1), r = r.slice(0, f)), {
            type: r,
            name: u
        };
    });
}
function $3cfd30e35d79a5df$var$Fw(e) {
    return function() {
        var r = this.__on;
        if (r) {
            for(var u = 0, f = -1, s = r.length, h; u < s; ++u)h = r[u], (!e.type || h.type === e.type) && h.name === e.name ? this.removeEventListener(h.type, h.listener, h.options) : r[++f] = h;
            ++f ? r.length = f : delete this.__on;
        }
    };
}
function $3cfd30e35d79a5df$var$Dw(e, r, u) {
    return function() {
        var f = this.__on, s, h = $3cfd30e35d79a5df$var$Ow(r);
        if (f) {
            for(var c = 0, g = f.length; c < g; ++c)if ((s = f[c]).type === e.type && s.name === e.name) {
                this.removeEventListener(s.type, s.listener, s.options), this.addEventListener(s.type, s.listener = h, s.options = u), s.value = r;
                return;
            }
        }
        this.addEventListener(e.type, h, u), s = {
            type: e.type,
            name: e.name,
            value: r,
            listener: h,
            options: u
        }, f ? f.push(s) : this.__on = [
            s
        ];
    };
}
function $3cfd30e35d79a5df$var$zw(e, r, u) {
    var f = $3cfd30e35d79a5df$var$$w(e + ""), s, h = f.length, c;
    if (arguments.length < 2) {
        var g = this.node().__on;
        if (g) {
            for(var v = 0, w = g.length, d; v < w; ++v)for(s = 0, d = g[v]; s < h; ++s)if ((c = f[s]).type === d.type && c.name === d.name) return d.value;
        }
        return;
    }
    for(g = r ? $3cfd30e35d79a5df$var$Dw : $3cfd30e35d79a5df$var$Fw, s = 0; s < h; ++s)this.each(g(f[s], r, u));
    return this;
}
function $3cfd30e35d79a5df$var$ql(e, r, u) {
    var f = $3cfd30e35d79a5df$var$Bl(e), s = f.CustomEvent;
    typeof s == "function" ? s = new s(r, u) : (s = f.document.createEvent("Event"), u ? (s.initEvent(r, u.bubbles, u.cancelable), s.detail = u.detail) : s.initEvent(r, !1, !1)), e.dispatchEvent(s);
}
function $3cfd30e35d79a5df$var$Bw(e, r) {
    return function() {
        return $3cfd30e35d79a5df$var$ql(this, e, r);
    };
}
function $3cfd30e35d79a5df$var$Ww(e, r) {
    return function() {
        return $3cfd30e35d79a5df$var$ql(this, e, r.apply(this, arguments));
    };
}
function $3cfd30e35d79a5df$var$kw(e, r) {
    return this.each((typeof r == "function" ? $3cfd30e35d79a5df$var$Ww : $3cfd30e35d79a5df$var$Bw)(e, r));
}
function* $3cfd30e35d79a5df$var$Uw() {
    for(var e = this._groups, r = 0, u = e.length; r < u; ++r)for(var f = e[r], s = 0, h = f.length, c; s < h; ++s)(c = f[s]) && (yield c);
}
var $3cfd30e35d79a5df$var$af = [
    null
];
function $3cfd30e35d79a5df$var$Zn(e, r) {
    this._groups = e, this._parents = r;
}
function $3cfd30e35d79a5df$var$Ke() {
    return new $3cfd30e35d79a5df$var$Zn([
        [
            document.documentElement
        ]
    ], $3cfd30e35d79a5df$var$af);
}
function $3cfd30e35d79a5df$var$Gw() {
    return this;
}
$3cfd30e35d79a5df$var$Zn.prototype = $3cfd30e35d79a5df$var$Ke.prototype = {
    constructor: $3cfd30e35d79a5df$var$Zn,
    select: $3cfd30e35d79a5df$var$_v,
    selectAll: $3cfd30e35d79a5df$var$mv,
    selectChild: $3cfd30e35d79a5df$var$Ev,
    selectChildren: $3cfd30e35d79a5df$var$Tv,
    filter: $3cfd30e35d79a5df$var$Iv,
    data: $3cfd30e35d79a5df$var$Ov,
    enter: $3cfd30e35d79a5df$var$Mv,
    exit: $3cfd30e35d79a5df$var$Fv,
    join: $3cfd30e35d79a5df$var$Dv,
    merge: $3cfd30e35d79a5df$var$zv,
    selection: $3cfd30e35d79a5df$var$Gw,
    order: $3cfd30e35d79a5df$var$Bv,
    sort: $3cfd30e35d79a5df$var$Wv,
    call: $3cfd30e35d79a5df$var$Uv,
    nodes: $3cfd30e35d79a5df$var$Gv,
    node: $3cfd30e35d79a5df$var$qv,
    size: $3cfd30e35d79a5df$var$Hv,
    empty: $3cfd30e35d79a5df$var$Xv,
    each: $3cfd30e35d79a5df$var$Yv,
    attr: $3cfd30e35d79a5df$var$nw,
    style: $3cfd30e35d79a5df$var$iw,
    property: $3cfd30e35d79a5df$var$sw,
    classed: $3cfd30e35d79a5df$var$hw,
    text: $3cfd30e35d79a5df$var$_w,
    html: $3cfd30e35d79a5df$var$yw,
    raise: $3cfd30e35d79a5df$var$Sw,
    lower: $3cfd30e35d79a5df$var$Aw,
    append: $3cfd30e35d79a5df$var$Cw,
    insert: $3cfd30e35d79a5df$var$Tw,
    remove: $3cfd30e35d79a5df$var$Mw,
    clone: $3cfd30e35d79a5df$var$Pw,
    datum: $3cfd30e35d79a5df$var$Nw,
    on: $3cfd30e35d79a5df$var$zw,
    dispatch: $3cfd30e35d79a5df$var$kw,
    [Symbol.iterator]: $3cfd30e35d79a5df$var$Uw
};
function $3cfd30e35d79a5df$var$Un(e) {
    return typeof e == "string" ? new $3cfd30e35d79a5df$var$Zn([
        [
            document.querySelector(e)
        ]
    ], [
        document.documentElement
    ]) : new $3cfd30e35d79a5df$var$Zn([
        [
            e
        ]
    ], $3cfd30e35d79a5df$var$af);
}
function $3cfd30e35d79a5df$var$qw(e) {
    let r;
    for(; r = e.sourceEvent;)e = r;
    return e;
}
function $3cfd30e35d79a5df$var$ve(e, r) {
    if (e = $3cfd30e35d79a5df$var$qw(e), r === void 0 && (r = e.currentTarget), r) {
        var u = r.ownerSVGElement || r;
        if (u.createSVGPoint) {
            var f = u.createSVGPoint();
            return f.x = e.clientX, f.y = e.clientY, f = f.matrixTransform(r.getScreenCTM().inverse()), [
                f.x,
                f.y
            ];
        }
        if (r.getBoundingClientRect) {
            var s = r.getBoundingClientRect();
            return [
                e.clientX - s.left - r.clientLeft,
                e.clientY - s.top - r.clientTop
            ];
        }
    }
    return [
        e.pageX,
        e.pageY
    ];
}
function $3cfd30e35d79a5df$var$we(e) {
    return typeof e == "string" ? new $3cfd30e35d79a5df$var$Zn([
        document.querySelectorAll(e)
    ], [
        document.documentElement
    ]) : new $3cfd30e35d79a5df$var$Zn([
        $3cfd30e35d79a5df$var$Ol(e)
    ], $3cfd30e35d79a5df$var$af);
}
class $3cfd30e35d79a5df$var$xe {
    constructor(){
        this._partials = new Float64Array(32), this._n = 0;
    }
    add(r) {
        const u = this._partials;
        let f = 0;
        for(let s = 0; s < this._n && s < 32; s++){
            const h = u[s], c = r + h, g = Math.abs(r) < Math.abs(h) ? r - (c - h) : h - (c - r);
            g && (u[f++] = g), r = c;
        }
        return u[f] = r, this._n = f + 1, this;
    }
    valueOf() {
        const r = this._partials;
        let u = this._n, f, s, h, c = 0;
        if (u > 0) {
            for(c = r[--u]; u > 0 && (f = c, s = r[--u], c = f + s, h = s - (c - f), !h););
            u > 0 && (h < 0 && r[u - 1] < 0 || h > 0 && r[u - 1] > 0) && (s = h * 2, f = c + s, s == f - c && (c = f));
        }
        return c;
    }
}
function* $3cfd30e35d79a5df$var$Hw(e) {
    for (const r of e)yield* r;
}
function $3cfd30e35d79a5df$var$Hl(e) {
    return Array.from($3cfd30e35d79a5df$var$Hw(e));
}
var $3cfd30e35d79a5df$var$yn = 1e-6, $3cfd30e35d79a5df$var$Xw = 1e-12, $3cfd30e35d79a5df$var$hn = Math.PI, $3cfd30e35d79a5df$var$tt = $3cfd30e35d79a5df$var$hn / 2, $3cfd30e35d79a5df$var$Qa = $3cfd30e35d79a5df$var$hn / 4, $3cfd30e35d79a5df$var$ct = $3cfd30e35d79a5df$var$hn * 2, $3cfd30e35d79a5df$var$lt = 180 / $3cfd30e35d79a5df$var$hn, $3cfd30e35d79a5df$var$$n = $3cfd30e35d79a5df$var$hn / 180, $3cfd30e35d79a5df$var$Tn = Math.abs, $3cfd30e35d79a5df$var$Xl = Math.atan, $3cfd30e35d79a5df$var$Cr = Math.atan2, $3cfd30e35d79a5df$var$Nn = Math.cos, $3cfd30e35d79a5df$var$Yw = Math.exp, $3cfd30e35d79a5df$var$Kw = Math.log, $3cfd30e35d79a5df$var$On = Math.sin, $3cfd30e35d79a5df$var$Zw = Math.sign || function(e) {
    return e > 0 ? 1 : e < 0 ? -1 : 0;
}, $3cfd30e35d79a5df$var$Ae = Math.sqrt, $3cfd30e35d79a5df$var$Jw = Math.tan;
function $3cfd30e35d79a5df$var$Qw(e) {
    return e > 1 ? 0 : e < -1 ? $3cfd30e35d79a5df$var$hn : Math.acos(e);
}
function $3cfd30e35d79a5df$var$Rr(e) {
    return e > 1 ? $3cfd30e35d79a5df$var$tt : e < -1 ? -$3cfd30e35d79a5df$var$tt : Math.asin(e);
}
function $3cfd30e35d79a5df$var$xt() {}
function $3cfd30e35d79a5df$var$Ui(e, r) {
    e && $3cfd30e35d79a5df$var$ja.hasOwnProperty(e.type) && $3cfd30e35d79a5df$var$ja[e.type](e, r);
}
var $3cfd30e35d79a5df$var$Va = {
    Feature: function(e, r) {
        $3cfd30e35d79a5df$var$Ui(e.geometry, r);
    },
    FeatureCollection: function(e, r) {
        for(var u = e.features, f = -1, s = u.length; ++f < s;)$3cfd30e35d79a5df$var$Ui(u[f].geometry, r);
    }
}, $3cfd30e35d79a5df$var$ja = {
    Sphere: function(e, r) {
        r.sphere();
    },
    Point: function(e, r) {
        e = e.coordinates, r.point(e[0], e[1], e[2]);
    },
    MultiPoint: function(e, r) {
        for(var u = e.coordinates, f = -1, s = u.length; ++f < s;)e = u[f], r.point(e[0], e[1], e[2]);
    },
    LineString: function(e, r) {
        $3cfd30e35d79a5df$var$Do(e.coordinates, r, 0);
    },
    MultiLineString: function(e, r) {
        for(var u = e.coordinates, f = -1, s = u.length; ++f < s;)$3cfd30e35d79a5df$var$Do(u[f], r, 0);
    },
    Polygon: function(e, r) {
        $3cfd30e35d79a5df$var$nl(e.coordinates, r);
    },
    MultiPolygon: function(e, r) {
        for(var u = e.coordinates, f = -1, s = u.length; ++f < s;)$3cfd30e35d79a5df$var$nl(u[f], r);
    },
    GeometryCollection: function(e, r) {
        for(var u = e.geometries, f = -1, s = u.length; ++f < s;)$3cfd30e35d79a5df$var$Ui(u[f], r);
    }
};
function $3cfd30e35d79a5df$var$Do(e, r, u) {
    var f = -1, s = e.length - u, h;
    for(r.lineStart(); ++f < s;)h = e[f], r.point(h[0], h[1], h[2]);
    r.lineEnd();
}
function $3cfd30e35d79a5df$var$nl(e, r) {
    var u = -1, f = e.length;
    for(r.polygonStart(); ++u < f;)$3cfd30e35d79a5df$var$Do(e[u], r, 1);
    r.polygonEnd();
}
function $3cfd30e35d79a5df$var$We(e, r) {
    e && $3cfd30e35d79a5df$var$Va.hasOwnProperty(e.type) ? $3cfd30e35d79a5df$var$Va[e.type](e, r) : $3cfd30e35d79a5df$var$Ui(e, r);
}
function $3cfd30e35d79a5df$var$zo(e) {
    return [
        $3cfd30e35d79a5df$var$Cr(e[1], e[0]),
        $3cfd30e35d79a5df$var$Rr(e[2])
    ];
}
function $3cfd30e35d79a5df$var$He(e) {
    var r = e[0], u = e[1], f = $3cfd30e35d79a5df$var$Nn(u);
    return [
        f * $3cfd30e35d79a5df$var$Nn(r),
        f * $3cfd30e35d79a5df$var$On(r),
        $3cfd30e35d79a5df$var$On(u)
    ];
}
function $3cfd30e35d79a5df$var$Ti(e, r) {
    return e[0] * r[0] + e[1] * r[1] + e[2] * r[2];
}
function $3cfd30e35d79a5df$var$Gi(e, r) {
    return [
        e[1] * r[2] - e[2] * r[1],
        e[2] * r[0] - e[0] * r[2],
        e[0] * r[1] - e[1] * r[0]
    ];
}
function $3cfd30e35d79a5df$var$Mo(e, r) {
    e[0] += r[0], e[1] += r[1], e[2] += r[2];
}
function $3cfd30e35d79a5df$var$Ii(e, r) {
    return [
        e[0] * r,
        e[1] * r,
        e[2] * r
    ];
}
function $3cfd30e35d79a5df$var$Bo(e) {
    var r = $3cfd30e35d79a5df$var$Ae(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
    e[0] /= r, e[1] /= r, e[2] /= r;
}
function $3cfd30e35d79a5df$var$Wo(e, r) {
    function u(f, s) {
        return f = e(f, s), r(f[0], f[1]);
    }
    return e.invert && r.invert && (u.invert = function(f, s) {
        return f = r.invert(f, s), f && e.invert(f[0], f[1]);
    }), u;
}
function $3cfd30e35d79a5df$var$ko(e, r) {
    return $3cfd30e35d79a5df$var$Tn(e) > $3cfd30e35d79a5df$var$hn && (e -= Math.round(e / $3cfd30e35d79a5df$var$ct) * $3cfd30e35d79a5df$var$ct), [
        e,
        r
    ];
}
$3cfd30e35d79a5df$var$ko.invert = $3cfd30e35d79a5df$var$ko;
function $3cfd30e35d79a5df$var$Yl(e, r, u) {
    return (e %= $3cfd30e35d79a5df$var$ct) ? r || u ? $3cfd30e35d79a5df$var$Wo($3cfd30e35d79a5df$var$el(e), $3cfd30e35d79a5df$var$rl(r, u)) : $3cfd30e35d79a5df$var$el(e) : r || u ? $3cfd30e35d79a5df$var$rl(r, u) : $3cfd30e35d79a5df$var$ko;
}
function $3cfd30e35d79a5df$var$tl(e) {
    return function(r, u) {
        return r += e, $3cfd30e35d79a5df$var$Tn(r) > $3cfd30e35d79a5df$var$hn && (r -= Math.round(r / $3cfd30e35d79a5df$var$ct) * $3cfd30e35d79a5df$var$ct), [
            r,
            u
        ];
    };
}
function $3cfd30e35d79a5df$var$el(e) {
    var r = $3cfd30e35d79a5df$var$tl(e);
    return r.invert = $3cfd30e35d79a5df$var$tl(-e), r;
}
function $3cfd30e35d79a5df$var$rl(e, r) {
    var u = $3cfd30e35d79a5df$var$Nn(e), f = $3cfd30e35d79a5df$var$On(e), s = $3cfd30e35d79a5df$var$Nn(r), h = $3cfd30e35d79a5df$var$On(r);
    function c(g, v) {
        var w = $3cfd30e35d79a5df$var$Nn(v), d = $3cfd30e35d79a5df$var$Nn(g) * w, y = $3cfd30e35d79a5df$var$On(g) * w, x = $3cfd30e35d79a5df$var$On(v), C = x * u + d * f;
        return [
            $3cfd30e35d79a5df$var$Cr(y * s - C * h, d * u - x * f),
            $3cfd30e35d79a5df$var$Rr(C * s + y * h)
        ];
    }
    return c.invert = function(g, v) {
        var w = $3cfd30e35d79a5df$var$Nn(v), d = $3cfd30e35d79a5df$var$Nn(g) * w, y = $3cfd30e35d79a5df$var$On(g) * w, x = $3cfd30e35d79a5df$var$On(v), C = x * s - y * h;
        return [
            $3cfd30e35d79a5df$var$Cr(y * s + x * h, d * u + C * f),
            $3cfd30e35d79a5df$var$Rr(C * u - d * f)
        ];
    }, c;
}
function $3cfd30e35d79a5df$var$Vw(e) {
    e = $3cfd30e35d79a5df$var$Yl(e[0] * $3cfd30e35d79a5df$var$$n, e[1] * $3cfd30e35d79a5df$var$$n, e.length > 2 ? e[2] * $3cfd30e35d79a5df$var$$n : 0);
    function r(u) {
        return u = e(u[0] * $3cfd30e35d79a5df$var$$n, u[1] * $3cfd30e35d79a5df$var$$n), u[0] *= $3cfd30e35d79a5df$var$lt, u[1] *= $3cfd30e35d79a5df$var$lt, u;
    }
    return r.invert = function(u) {
        return u = e.invert(u[0] * $3cfd30e35d79a5df$var$$n, u[1] * $3cfd30e35d79a5df$var$$n), u[0] *= $3cfd30e35d79a5df$var$lt, u[1] *= $3cfd30e35d79a5df$var$lt, u;
    }, r;
}
function $3cfd30e35d79a5df$var$jw(e, r, u, f, s, h) {
    if (u) {
        var c = $3cfd30e35d79a5df$var$Nn(r), g = $3cfd30e35d79a5df$var$On(r), v = f * u;
        s == null ? (s = r + f * $3cfd30e35d79a5df$var$ct, h = r - v / 2) : (s = $3cfd30e35d79a5df$var$il(c, s), h = $3cfd30e35d79a5df$var$il(c, h), (f > 0 ? s < h : s > h) && (s += f * $3cfd30e35d79a5df$var$ct));
        for(var w, d = s; f > 0 ? d > h : d < h; d -= v)w = $3cfd30e35d79a5df$var$zo([
            c,
            -g * $3cfd30e35d79a5df$var$Nn(d),
            -g * $3cfd30e35d79a5df$var$On(d)
        ]), e.point(w[0], w[1]);
    }
}
function $3cfd30e35d79a5df$var$il(e, r) {
    r = $3cfd30e35d79a5df$var$He(r), r[0] -= e, $3cfd30e35d79a5df$var$Bo(r);
    var u = $3cfd30e35d79a5df$var$Qw(-r[1]);
    return ((-r[2] < 0 ? -u : u) + $3cfd30e35d79a5df$var$ct - $3cfd30e35d79a5df$var$yn) % $3cfd30e35d79a5df$var$ct;
}
function $3cfd30e35d79a5df$var$Kl() {
    var e = [], r;
    return {
        point: function(u, f, s) {
            r.push([
                u,
                f,
                s
            ]);
        },
        lineStart: function() {
            e.push(r = []);
        },
        lineEnd: $3cfd30e35d79a5df$var$xt,
        rejoin: function() {
            e.length > 1 && e.push(e.pop().concat(e.shift()));
        },
        result: function() {
            var u = e;
            return e = [], r = null, u;
        }
    };
}
function $3cfd30e35d79a5df$var$$i(e, r) {
    return $3cfd30e35d79a5df$var$Tn(e[0] - r[0]) < $3cfd30e35d79a5df$var$yn && $3cfd30e35d79a5df$var$Tn(e[1] - r[1]) < $3cfd30e35d79a5df$var$yn;
}
function $3cfd30e35d79a5df$var$Mi(e, r, u, f) {
    this.x = e, this.z = r, this.o = u, this.e = f, this.v = !1, this.n = this.p = null;
}
function $3cfd30e35d79a5df$var$Zl(e, r, u, f, s) {
    var h = [], c = [], g, v;
    if (e.forEach(function(P) {
        if (!((z = P.length - 1) <= 0)) {
            var z, $ = P[0], O = P[z], U;
            if ($3cfd30e35d79a5df$var$$i($, O)) {
                if (!$[2] && !O[2]) {
                    for(s.lineStart(), g = 0; g < z; ++g)s.point(($ = P[g])[0], $[1]);
                    s.lineEnd();
                    return;
                }
                O[0] += 2 * $3cfd30e35d79a5df$var$yn;
            }
            h.push(U = new $3cfd30e35d79a5df$var$Mi($, P, null, !0)), c.push(U.o = new $3cfd30e35d79a5df$var$Mi($, null, U, !1)), h.push(U = new $3cfd30e35d79a5df$var$Mi(O, P, null, !1)), c.push(U.o = new $3cfd30e35d79a5df$var$Mi(O, null, U, !0));
        }
    }), !!h.length) {
        for(c.sort(r), $3cfd30e35d79a5df$var$ul(h), $3cfd30e35d79a5df$var$ul(c), g = 0, v = c.length; g < v; ++g)c[g].e = u = !u;
        for(var w = h[0], d, y;;){
            for(var x = w, C = !0; x.v;)if ((x = x.n) === w) return;
            d = x.z, s.lineStart();
            do {
                if (x.v = x.o.v = !0, x.e) {
                    if (C) for(g = 0, v = d.length; g < v; ++g)s.point((y = d[g])[0], y[1]);
                    else f(x.x, x.n.x, 1, s);
                    x = x.n;
                } else {
                    if (C) for(d = x.p.z, g = d.length - 1; g >= 0; --g)s.point((y = d[g])[0], y[1]);
                    else f(x.x, x.p.x, -1, s);
                    x = x.p;
                }
                x = x.o, d = x.z, C = !C;
            }while (!x.v);
            s.lineEnd();
        }
    }
}
function $3cfd30e35d79a5df$var$ul(e) {
    if (r = e.length) {
        for(var r, u = 0, f = e[0], s; ++u < r;)f.n = s = e[u], s.p = f, f = s;
        f.n = s = e[0], s.p = f;
    }
}
function $3cfd30e35d79a5df$var$Lo(e) {
    return $3cfd30e35d79a5df$var$Tn(e[0]) <= $3cfd30e35d79a5df$var$hn ? e[0] : $3cfd30e35d79a5df$var$Zw(e[0]) * (($3cfd30e35d79a5df$var$Tn(e[0]) + $3cfd30e35d79a5df$var$hn) % $3cfd30e35d79a5df$var$ct - $3cfd30e35d79a5df$var$hn);
}
function $3cfd30e35d79a5df$var$nm(e, r) {
    var u = $3cfd30e35d79a5df$var$Lo(r), f = r[1], s = $3cfd30e35d79a5df$var$On(f), h = [
        $3cfd30e35d79a5df$var$On(u),
        -$3cfd30e35d79a5df$var$Nn(u),
        0
    ], c = 0, g = 0, v = new $3cfd30e35d79a5df$var$xe();
    s === 1 ? f = $3cfd30e35d79a5df$var$tt + $3cfd30e35d79a5df$var$yn : s === -1 && (f = -$3cfd30e35d79a5df$var$tt - $3cfd30e35d79a5df$var$yn);
    for(var w = 0, d = e.length; w < d; ++w)if (x = (y = e[w]).length) for(var y, x, C = y[x - 1], P = $3cfd30e35d79a5df$var$Lo(C), z = C[1] / 2 + $3cfd30e35d79a5df$var$Qa, $ = $3cfd30e35d79a5df$var$On(z), O = $3cfd30e35d79a5df$var$Nn(z), U = 0; U < x; ++U, P = B, $ = X, O = V, C = k){
        var k = y[U], B = $3cfd30e35d79a5df$var$Lo(k), q = k[1] / 2 + $3cfd30e35d79a5df$var$Qa, X = $3cfd30e35d79a5df$var$On(q), V = $3cfd30e35d79a5df$var$Nn(q), rn = B - P, on = rn >= 0 ? 1 : -1, pn = on * rn, j = pn > $3cfd30e35d79a5df$var$hn, zn = $ * X;
        if (v.add($3cfd30e35d79a5df$var$Cr(zn * on * $3cfd30e35d79a5df$var$On(pn), O * V + zn * $3cfd30e35d79a5df$var$Nn(pn))), c += j ? rn + on * $3cfd30e35d79a5df$var$ct : rn, j ^ P >= u ^ B >= u) {
            var xn = $3cfd30e35d79a5df$var$Gi($3cfd30e35d79a5df$var$He(C), $3cfd30e35d79a5df$var$He(k));
            $3cfd30e35d79a5df$var$Bo(xn);
            var A = $3cfd30e35d79a5df$var$Gi(h, xn);
            $3cfd30e35d79a5df$var$Bo(A);
            var R = (j ^ rn >= 0 ? -1 : 1) * $3cfd30e35d79a5df$var$Rr(A[2]);
            (f > R || f === R && (xn[0] || xn[1])) && (g += j ^ rn >= 0 ? 1 : -1);
        }
    }
    return (c < -$3cfd30e35d79a5df$var$yn || c < $3cfd30e35d79a5df$var$yn && v < -$3cfd30e35d79a5df$var$Xw) ^ g & 1;
}
function $3cfd30e35d79a5df$var$Jl(e, r, u, f) {
    return function(s) {
        var h = r(s), c = $3cfd30e35d79a5df$var$Kl(), g = r(c), v = !1, w, d, y, x = {
            point: C,
            lineStart: z,
            lineEnd: $,
            polygonStart: function() {
                x.point = O, x.lineStart = U, x.lineEnd = k, d = [], w = [];
            },
            polygonEnd: function() {
                x.point = C, x.lineStart = z, x.lineEnd = $, d = $3cfd30e35d79a5df$var$Hl(d);
                var B = $3cfd30e35d79a5df$var$nm(w, f);
                d.length ? (v || (s.polygonStart(), v = !0), $3cfd30e35d79a5df$var$Zl(d, $3cfd30e35d79a5df$var$em, B, u, s)) : B && (v || (s.polygonStart(), v = !0), s.lineStart(), u(null, null, 1, s), s.lineEnd()), v && (s.polygonEnd(), v = !1), d = w = null;
            },
            sphere: function() {
                s.polygonStart(), s.lineStart(), u(null, null, 1, s), s.lineEnd(), s.polygonEnd();
            }
        };
        function C(B, q) {
            e(B, q) && s.point(B, q);
        }
        function P(B, q) {
            h.point(B, q);
        }
        function z() {
            x.point = P, h.lineStart();
        }
        function $() {
            x.point = C, h.lineEnd();
        }
        function O(B, q) {
            y.push([
                B,
                q
            ]), g.point(B, q);
        }
        function U() {
            g.lineStart(), y = [];
        }
        function k() {
            O(y[0][0], y[0][1]), g.lineEnd();
            var B = g.clean(), q = c.result(), X, V = q.length, rn, on, pn;
            if (y.pop(), w.push(y), y = null, !!V) {
                if (B & 1) {
                    if (on = q[0], (rn = on.length - 1) > 0) {
                        for(v || (s.polygonStart(), v = !0), s.lineStart(), X = 0; X < rn; ++X)s.point((pn = on[X])[0], pn[1]);
                        s.lineEnd();
                    }
                    return;
                }
                V > 1 && B & 2 && q.push(q.pop().concat(q.shift())), d.push(q.filter($3cfd30e35d79a5df$var$tm));
            }
        }
        return x;
    };
}
function $3cfd30e35d79a5df$var$tm(e) {
    return e.length > 1;
}
function $3cfd30e35d79a5df$var$em(e, r) {
    return ((e = e.x)[0] < 0 ? e[1] - $3cfd30e35d79a5df$var$tt - $3cfd30e35d79a5df$var$yn : $3cfd30e35d79a5df$var$tt - e[1]) - ((r = r.x)[0] < 0 ? r[1] - $3cfd30e35d79a5df$var$tt - $3cfd30e35d79a5df$var$yn : $3cfd30e35d79a5df$var$tt - r[1]);
}
const $3cfd30e35d79a5df$var$ol = $3cfd30e35d79a5df$var$Jl(function() {
    return !0;
}, $3cfd30e35d79a5df$var$rm, $3cfd30e35d79a5df$var$um, [
    -$3cfd30e35d79a5df$var$hn,
    -$3cfd30e35d79a5df$var$tt
]);
function $3cfd30e35d79a5df$var$rm(e) {
    var r = NaN, u = NaN, f = NaN, s;
    return {
        lineStart: function() {
            e.lineStart(), s = 1;
        },
        point: function(h, c) {
            var g = h > 0 ? $3cfd30e35d79a5df$var$hn : -$3cfd30e35d79a5df$var$hn, v = $3cfd30e35d79a5df$var$Tn(h - r);
            $3cfd30e35d79a5df$var$Tn(v - $3cfd30e35d79a5df$var$hn) < $3cfd30e35d79a5df$var$yn ? (e.point(r, u = (u + c) / 2 > 0 ? $3cfd30e35d79a5df$var$tt : -$3cfd30e35d79a5df$var$tt), e.point(f, u), e.lineEnd(), e.lineStart(), e.point(g, u), e.point(h, u), s = 0) : f !== g && v >= $3cfd30e35d79a5df$var$hn && ($3cfd30e35d79a5df$var$Tn(r - f) < $3cfd30e35d79a5df$var$yn && (r -= f * $3cfd30e35d79a5df$var$yn), $3cfd30e35d79a5df$var$Tn(h - g) < $3cfd30e35d79a5df$var$yn && (h -= g * $3cfd30e35d79a5df$var$yn), u = $3cfd30e35d79a5df$var$im(r, u, h, c), e.point(f, u), e.lineEnd(), e.lineStart(), e.point(g, u), s = 0), e.point(r = h, u = c), f = g;
        },
        lineEnd: function() {
            e.lineEnd(), r = u = NaN;
        },
        clean: function() {
            return 2 - s;
        }
    };
}
function $3cfd30e35d79a5df$var$im(e, r, u, f) {
    var s, h, c = $3cfd30e35d79a5df$var$On(e - u);
    return $3cfd30e35d79a5df$var$Tn(c) > $3cfd30e35d79a5df$var$yn ? $3cfd30e35d79a5df$var$Xl(($3cfd30e35d79a5df$var$On(r) * (h = $3cfd30e35d79a5df$var$Nn(f)) * $3cfd30e35d79a5df$var$On(u) - $3cfd30e35d79a5df$var$On(f) * (s = $3cfd30e35d79a5df$var$Nn(r)) * $3cfd30e35d79a5df$var$On(e)) / (s * h * c)) : (r + f) / 2;
}
function $3cfd30e35d79a5df$var$um(e, r, u, f) {
    var s;
    if (e == null) s = u * $3cfd30e35d79a5df$var$tt, f.point(-$3cfd30e35d79a5df$var$hn, s), f.point(0, s), f.point($3cfd30e35d79a5df$var$hn, s), f.point($3cfd30e35d79a5df$var$hn, 0), f.point($3cfd30e35d79a5df$var$hn, -s), f.point(0, -s), f.point(-$3cfd30e35d79a5df$var$hn, -s), f.point(-$3cfd30e35d79a5df$var$hn, 0), f.point(-$3cfd30e35d79a5df$var$hn, s);
    else if ($3cfd30e35d79a5df$var$Tn(e[0] - r[0]) > $3cfd30e35d79a5df$var$yn) {
        var h = e[0] < r[0] ? $3cfd30e35d79a5df$var$hn : -$3cfd30e35d79a5df$var$hn;
        s = u * h / 2, f.point(-h, s), f.point(0, s), f.point(h, s);
    } else f.point(r[0], r[1]);
}
function $3cfd30e35d79a5df$var$om(e) {
    var r = $3cfd30e35d79a5df$var$Nn(e), u = 6 * $3cfd30e35d79a5df$var$$n, f = r > 0, s = $3cfd30e35d79a5df$var$Tn(r) > $3cfd30e35d79a5df$var$yn;
    function h(d, y, x, C) {
        $3cfd30e35d79a5df$var$jw(C, e, u, x, d, y);
    }
    function c(d, y) {
        return $3cfd30e35d79a5df$var$Nn(d) * $3cfd30e35d79a5df$var$Nn(y) > r;
    }
    function g(d) {
        var y, x, C, P, z;
        return {
            lineStart: function() {
                P = C = !1, z = 1;
            },
            point: function($, O) {
                var U = [
                    $,
                    O
                ], k, B = c($, O), q = f ? B ? 0 : w($, O) : B ? w($ + ($ < 0 ? $3cfd30e35d79a5df$var$hn : -$3cfd30e35d79a5df$var$hn), O) : 0;
                if (!y && (P = C = B) && d.lineStart(), B !== C && (k = v(y, U), (!k || $3cfd30e35d79a5df$var$$i(y, k) || $3cfd30e35d79a5df$var$$i(U, k)) && (U[2] = 1)), B !== C) z = 0, B ? (d.lineStart(), k = v(U, y), d.point(k[0], k[1])) : (k = v(y, U), d.point(k[0], k[1], 2), d.lineEnd()), y = k;
                else if (s && y && f ^ B) {
                    var X;
                    !(q & x) && (X = v(U, y, !0)) && (z = 0, f ? (d.lineStart(), d.point(X[0][0], X[0][1]), d.point(X[1][0], X[1][1]), d.lineEnd()) : (d.point(X[1][0], X[1][1]), d.lineEnd(), d.lineStart(), d.point(X[0][0], X[0][1], 3)));
                }
                B && (!y || !$3cfd30e35d79a5df$var$$i(y, U)) && d.point(U[0], U[1]), y = U, C = B, x = q;
            },
            lineEnd: function() {
                C && d.lineEnd(), y = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return z | (P && C) << 1;
            }
        };
    }
    function v(d, y, x) {
        var C = $3cfd30e35d79a5df$var$He(d), P = $3cfd30e35d79a5df$var$He(y), z = [
            1,
            0,
            0
        ], $ = $3cfd30e35d79a5df$var$Gi(C, P), O = $3cfd30e35d79a5df$var$Ti($, $), U = $[0], k = O - U * U;
        if (!k) return !x && d;
        var B = r * O / k, q = -r * U / k, X = $3cfd30e35d79a5df$var$Gi(z, $), V = $3cfd30e35d79a5df$var$Ii(z, B), rn = $3cfd30e35d79a5df$var$Ii($, q);
        $3cfd30e35d79a5df$var$Mo(V, rn);
        var on = X, pn = $3cfd30e35d79a5df$var$Ti(V, on), j = $3cfd30e35d79a5df$var$Ti(on, on), zn = pn * pn - j * ($3cfd30e35d79a5df$var$Ti(V, V) - 1);
        if (!(zn < 0)) {
            var xn = $3cfd30e35d79a5df$var$Ae(zn), A = $3cfd30e35d79a5df$var$Ii(on, (-pn - xn) / j);
            if ($3cfd30e35d79a5df$var$Mo(A, V), A = $3cfd30e35d79a5df$var$zo(A), !x) return A;
            var R = d[0], I = y[0], F = d[1], G = y[1], Y;
            I < R && (Y = R, R = I, I = Y);
            var nn = I - R, Q = $3cfd30e35d79a5df$var$Tn(nn - $3cfd30e35d79a5df$var$hn) < $3cfd30e35d79a5df$var$yn, gn = Q || nn < $3cfd30e35d79a5df$var$yn;
            if (!Q && G < F && (Y = F, F = G, G = Y), gn ? Q ? F + G > 0 ^ A[1] < ($3cfd30e35d79a5df$var$Tn(A[0] - R) < $3cfd30e35d79a5df$var$yn ? F : G) : F <= A[1] && A[1] <= G : nn > $3cfd30e35d79a5df$var$hn ^ (R <= A[0] && A[0] <= I)) {
                var In = $3cfd30e35d79a5df$var$Ii(on, (-pn + xn) / j);
                return $3cfd30e35d79a5df$var$Mo(In, V), [
                    A,
                    $3cfd30e35d79a5df$var$zo(In)
                ];
            }
        }
    }
    function w(d, y) {
        var x = f ? e : $3cfd30e35d79a5df$var$hn - e, C = 0;
        return d < -x ? C |= 1 : d > x && (C |= 2), y < -x ? C |= 4 : y > x && (C |= 8), C;
    }
    return $3cfd30e35d79a5df$var$Jl(c, g, h, f ? [
        0,
        -e
    ] : [
        -$3cfd30e35d79a5df$var$hn,
        e - $3cfd30e35d79a5df$var$hn
    ]);
}
function $3cfd30e35d79a5df$var$fm(e, r, u, f, s, h) {
    var c = e[0], g = e[1], v = r[0], w = r[1], d = 0, y = 1, x = v - c, C = w - g, P;
    if (P = u - c, !(!x && P > 0)) {
        if (P /= x, x < 0) {
            if (P < d) return;
            P < y && (y = P);
        } else if (x > 0) {
            if (P > y) return;
            P > d && (d = P);
        }
        if (P = s - c, !(!x && P < 0)) {
            if (P /= x, x < 0) {
                if (P > y) return;
                P > d && (d = P);
            } else if (x > 0) {
                if (P < d) return;
                P < y && (y = P);
            }
            if (P = f - g, !(!C && P > 0)) {
                if (P /= C, C < 0) {
                    if (P < d) return;
                    P < y && (y = P);
                } else if (C > 0) {
                    if (P > y) return;
                    P > d && (d = P);
                }
                if (P = h - g, !(!C && P < 0)) {
                    if (P /= C, C < 0) {
                        if (P > y) return;
                        P > d && (d = P);
                    } else if (C > 0) {
                        if (P < d) return;
                        P < y && (y = P);
                    }
                    return d > 0 && (e[0] = c + d * x, e[1] = g + d * C), y < 1 && (r[0] = c + y * x, r[1] = g + y * C), !0;
                }
            }
        }
    }
}
var $3cfd30e35d79a5df$var$wr = 1e9, $3cfd30e35d79a5df$var$Li = -$3cfd30e35d79a5df$var$wr;
function $3cfd30e35d79a5df$var$sm(e, r, u, f) {
    function s(w, d) {
        return e <= w && w <= u && r <= d && d <= f;
    }
    function h(w, d, y, x) {
        var C = 0, P = 0;
        if (w == null || (C = c(w, y)) !== (P = c(d, y)) || v(w, d) < 0 ^ y > 0) do x.point(C === 0 || C === 3 ? e : u, C > 1 ? f : r);
        while ((C = (C + y + 4) % 4) !== P);
        else x.point(d[0], d[1]);
    }
    function c(w, d) {
        return $3cfd30e35d79a5df$var$Tn(w[0] - e) < $3cfd30e35d79a5df$var$yn ? d > 0 ? 0 : 3 : $3cfd30e35d79a5df$var$Tn(w[0] - u) < $3cfd30e35d79a5df$var$yn ? d > 0 ? 2 : 1 : $3cfd30e35d79a5df$var$Tn(w[1] - r) < $3cfd30e35d79a5df$var$yn ? d > 0 ? 1 : 0 : d > 0 ? 3 : 2;
    }
    function g(w, d) {
        return v(w.x, d.x);
    }
    function v(w, d) {
        var y = c(w, 1), x = c(d, 1);
        return y !== x ? y - x : y === 0 ? d[1] - w[1] : y === 1 ? w[0] - d[0] : y === 2 ? w[1] - d[1] : d[0] - w[0];
    }
    return function(w) {
        var d = w, y = $3cfd30e35d79a5df$var$Kl(), x, C, P, z, $, O, U, k, B, q, X, V = {
            point: rn,
            lineStart: zn,
            lineEnd: xn,
            polygonStart: pn,
            polygonEnd: j
        };
        function rn(R, I) {
            s(R, I) && d.point(R, I);
        }
        function on() {
            for(var R = 0, I = 0, F = C.length; I < F; ++I)for(var G = C[I], Y = 1, nn = G.length, Q = G[0], gn, In, An = Q[0], Sn = Q[1]; Y < nn; ++Y)gn = An, In = Sn, Q = G[Y], An = Q[0], Sn = Q[1], In <= f ? Sn > f && (An - gn) * (f - In) > (Sn - In) * (e - gn) && ++R : Sn <= f && (An - gn) * (f - In) < (Sn - In) * (e - gn) && --R;
            return R;
        }
        function pn() {
            d = y, x = [], C = [], X = !0;
        }
        function j() {
            var R = on(), I = X && R, F = (x = $3cfd30e35d79a5df$var$Hl(x)).length;
            (I || F) && (w.polygonStart(), I && (w.lineStart(), h(null, null, 1, w), w.lineEnd()), F && $3cfd30e35d79a5df$var$Zl(x, g, R, h, w), w.polygonEnd()), d = w, x = C = P = null;
        }
        function zn() {
            V.point = A, C && C.push(P = []), q = !0, B = !1, U = k = NaN;
        }
        function xn() {
            x && (A(z, $), O && B && y.rejoin(), x.push(y.result())), V.point = rn, B && d.lineEnd();
        }
        function A(R, I) {
            var F = s(R, I);
            if (C && P.push([
                R,
                I
            ]), q) z = R, $ = I, O = F, q = !1, F && (d.lineStart(), d.point(R, I));
            else if (F && B) d.point(R, I);
            else {
                var G = [
                    U = Math.max($3cfd30e35d79a5df$var$Li, Math.min($3cfd30e35d79a5df$var$wr, U)),
                    k = Math.max($3cfd30e35d79a5df$var$Li, Math.min($3cfd30e35d79a5df$var$wr, k))
                ], Y = [
                    R = Math.max($3cfd30e35d79a5df$var$Li, Math.min($3cfd30e35d79a5df$var$wr, R)),
                    I = Math.max($3cfd30e35d79a5df$var$Li, Math.min($3cfd30e35d79a5df$var$wr, I))
                ];
                $3cfd30e35d79a5df$var$fm(G, Y, e, r, u, f) ? (B || (d.lineStart(), d.point(G[0], G[1])), d.point(Y[0], Y[1]), F || d.lineEnd(), X = !1) : F && (d.lineStart(), d.point(R, I), X = !1);
            }
            U = R, k = I, B = F;
        }
        return V;
    };
}
const $3cfd30e35d79a5df$var$Uo = (e)=>e;
var $3cfd30e35d79a5df$var$bo = new $3cfd30e35d79a5df$var$xe(), $3cfd30e35d79a5df$var$Go = new $3cfd30e35d79a5df$var$xe(), $3cfd30e35d79a5df$var$Ql, $3cfd30e35d79a5df$var$Vl, $3cfd30e35d79a5df$var$qo, $3cfd30e35d79a5df$var$Ho, $3cfd30e35d79a5df$var$Zt = {
    point: $3cfd30e35d79a5df$var$xt,
    lineStart: $3cfd30e35d79a5df$var$xt,
    lineEnd: $3cfd30e35d79a5df$var$xt,
    polygonStart: function() {
        $3cfd30e35d79a5df$var$Zt.lineStart = $3cfd30e35d79a5df$var$am, $3cfd30e35d79a5df$var$Zt.lineEnd = $3cfd30e35d79a5df$var$cm;
    },
    polygonEnd: function() {
        $3cfd30e35d79a5df$var$Zt.lineStart = $3cfd30e35d79a5df$var$Zt.lineEnd = $3cfd30e35d79a5df$var$Zt.point = $3cfd30e35d79a5df$var$xt, $3cfd30e35d79a5df$var$bo.add($3cfd30e35d79a5df$var$Tn($3cfd30e35d79a5df$var$Go)), $3cfd30e35d79a5df$var$Go = new $3cfd30e35d79a5df$var$xe();
    },
    result: function() {
        var e = $3cfd30e35d79a5df$var$bo / 2;
        return $3cfd30e35d79a5df$var$bo = new $3cfd30e35d79a5df$var$xe(), e;
    }
};
function $3cfd30e35d79a5df$var$am() {
    $3cfd30e35d79a5df$var$Zt.point = $3cfd30e35d79a5df$var$lm;
}
function $3cfd30e35d79a5df$var$lm(e, r) {
    $3cfd30e35d79a5df$var$Zt.point = $3cfd30e35d79a5df$var$jl, $3cfd30e35d79a5df$var$Ql = $3cfd30e35d79a5df$var$qo = e, $3cfd30e35d79a5df$var$Vl = $3cfd30e35d79a5df$var$Ho = r;
}
function $3cfd30e35d79a5df$var$jl(e, r) {
    $3cfd30e35d79a5df$var$Go.add($3cfd30e35d79a5df$var$Ho * e - $3cfd30e35d79a5df$var$qo * r), $3cfd30e35d79a5df$var$qo = e, $3cfd30e35d79a5df$var$Ho = r;
}
function $3cfd30e35d79a5df$var$cm() {
    $3cfd30e35d79a5df$var$jl($3cfd30e35d79a5df$var$Ql, $3cfd30e35d79a5df$var$Vl);
}
var $3cfd30e35d79a5df$var$Xe = 1 / 0, $3cfd30e35d79a5df$var$qi = $3cfd30e35d79a5df$var$Xe, $3cfd30e35d79a5df$var$Tr = -$3cfd30e35d79a5df$var$Xe, $3cfd30e35d79a5df$var$Hi = $3cfd30e35d79a5df$var$Tr, $3cfd30e35d79a5df$var$Xi = {
    point: $3cfd30e35d79a5df$var$hm,
    lineStart: $3cfd30e35d79a5df$var$xt,
    lineEnd: $3cfd30e35d79a5df$var$xt,
    polygonStart: $3cfd30e35d79a5df$var$xt,
    polygonEnd: $3cfd30e35d79a5df$var$xt,
    result: function() {
        var e = [
            [
                $3cfd30e35d79a5df$var$Xe,
                $3cfd30e35d79a5df$var$qi
            ],
            [
                $3cfd30e35d79a5df$var$Tr,
                $3cfd30e35d79a5df$var$Hi
            ]
        ];
        return $3cfd30e35d79a5df$var$Tr = $3cfd30e35d79a5df$var$Hi = -($3cfd30e35d79a5df$var$qi = $3cfd30e35d79a5df$var$Xe = 1 / 0), e;
    }
};
function $3cfd30e35d79a5df$var$hm(e, r) {
    e < $3cfd30e35d79a5df$var$Xe && ($3cfd30e35d79a5df$var$Xe = e), e > $3cfd30e35d79a5df$var$Tr && ($3cfd30e35d79a5df$var$Tr = e), r < $3cfd30e35d79a5df$var$qi && ($3cfd30e35d79a5df$var$qi = r), r > $3cfd30e35d79a5df$var$Hi && ($3cfd30e35d79a5df$var$Hi = r);
}
var $3cfd30e35d79a5df$var$Xo = 0, $3cfd30e35d79a5df$var$Yo = 0, $3cfd30e35d79a5df$var$mr = 0, $3cfd30e35d79a5df$var$Yi = 0, $3cfd30e35d79a5df$var$Ki = 0, $3cfd30e35d79a5df$var$ke = 0, $3cfd30e35d79a5df$var$Ko = 0, $3cfd30e35d79a5df$var$Zo = 0, $3cfd30e35d79a5df$var$yr = 0, $3cfd30e35d79a5df$var$nc, $3cfd30e35d79a5df$var$tc, $3cfd30e35d79a5df$var$Nt, $3cfd30e35d79a5df$var$Ot, $3cfd30e35d79a5df$var$yt = {
    point: $3cfd30e35d79a5df$var$Se,
    lineStart: $3cfd30e35d79a5df$var$fl,
    lineEnd: $3cfd30e35d79a5df$var$sl,
    polygonStart: function() {
        $3cfd30e35d79a5df$var$yt.lineStart = $3cfd30e35d79a5df$var$dm, $3cfd30e35d79a5df$var$yt.lineEnd = $3cfd30e35d79a5df$var$_m;
    },
    polygonEnd: function() {
        $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$Se, $3cfd30e35d79a5df$var$yt.lineStart = $3cfd30e35d79a5df$var$fl, $3cfd30e35d79a5df$var$yt.lineEnd = $3cfd30e35d79a5df$var$sl;
    },
    result: function() {
        var e = $3cfd30e35d79a5df$var$yr ? [
            $3cfd30e35d79a5df$var$Ko / $3cfd30e35d79a5df$var$yr,
            $3cfd30e35d79a5df$var$Zo / $3cfd30e35d79a5df$var$yr
        ] : $3cfd30e35d79a5df$var$ke ? [
            $3cfd30e35d79a5df$var$Yi / $3cfd30e35d79a5df$var$ke,
            $3cfd30e35d79a5df$var$Ki / $3cfd30e35d79a5df$var$ke
        ] : $3cfd30e35d79a5df$var$mr ? [
            $3cfd30e35d79a5df$var$Xo / $3cfd30e35d79a5df$var$mr,
            $3cfd30e35d79a5df$var$Yo / $3cfd30e35d79a5df$var$mr
        ] : [
            NaN,
            NaN
        ];
        return $3cfd30e35d79a5df$var$Xo = $3cfd30e35d79a5df$var$Yo = $3cfd30e35d79a5df$var$mr = $3cfd30e35d79a5df$var$Yi = $3cfd30e35d79a5df$var$Ki = $3cfd30e35d79a5df$var$ke = $3cfd30e35d79a5df$var$Ko = $3cfd30e35d79a5df$var$Zo = $3cfd30e35d79a5df$var$yr = 0, e;
    }
};
function $3cfd30e35d79a5df$var$Se(e, r) {
    $3cfd30e35d79a5df$var$Xo += e, $3cfd30e35d79a5df$var$Yo += r, ++$3cfd30e35d79a5df$var$mr;
}
function $3cfd30e35d79a5df$var$fl() {
    $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$pm;
}
function $3cfd30e35d79a5df$var$pm(e, r) {
    $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$gm, $3cfd30e35d79a5df$var$Se($3cfd30e35d79a5df$var$Nt = e, $3cfd30e35d79a5df$var$Ot = r);
}
function $3cfd30e35d79a5df$var$gm(e, r) {
    var u = e - $3cfd30e35d79a5df$var$Nt, f = r - $3cfd30e35d79a5df$var$Ot, s = $3cfd30e35d79a5df$var$Ae(u * u + f * f);
    $3cfd30e35d79a5df$var$Yi += s * ($3cfd30e35d79a5df$var$Nt + e) / 2, $3cfd30e35d79a5df$var$Ki += s * ($3cfd30e35d79a5df$var$Ot + r) / 2, $3cfd30e35d79a5df$var$ke += s, $3cfd30e35d79a5df$var$Se($3cfd30e35d79a5df$var$Nt = e, $3cfd30e35d79a5df$var$Ot = r);
}
function $3cfd30e35d79a5df$var$sl() {
    $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$Se;
}
function $3cfd30e35d79a5df$var$dm() {
    $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$vm;
}
function $3cfd30e35d79a5df$var$_m() {
    $3cfd30e35d79a5df$var$ec($3cfd30e35d79a5df$var$nc, $3cfd30e35d79a5df$var$tc);
}
function $3cfd30e35d79a5df$var$vm(e, r) {
    $3cfd30e35d79a5df$var$yt.point = $3cfd30e35d79a5df$var$ec, $3cfd30e35d79a5df$var$Se($3cfd30e35d79a5df$var$nc = $3cfd30e35d79a5df$var$Nt = e, $3cfd30e35d79a5df$var$tc = $3cfd30e35d79a5df$var$Ot = r);
}
function $3cfd30e35d79a5df$var$ec(e, r) {
    var u = e - $3cfd30e35d79a5df$var$Nt, f = r - $3cfd30e35d79a5df$var$Ot, s = $3cfd30e35d79a5df$var$Ae(u * u + f * f);
    $3cfd30e35d79a5df$var$Yi += s * ($3cfd30e35d79a5df$var$Nt + e) / 2, $3cfd30e35d79a5df$var$Ki += s * ($3cfd30e35d79a5df$var$Ot + r) / 2, $3cfd30e35d79a5df$var$ke += s, s = $3cfd30e35d79a5df$var$Ot * e - $3cfd30e35d79a5df$var$Nt * r, $3cfd30e35d79a5df$var$Ko += s * ($3cfd30e35d79a5df$var$Nt + e), $3cfd30e35d79a5df$var$Zo += s * ($3cfd30e35d79a5df$var$Ot + r), $3cfd30e35d79a5df$var$yr += s * 3, $3cfd30e35d79a5df$var$Se($3cfd30e35d79a5df$var$Nt = e, $3cfd30e35d79a5df$var$Ot = r);
}
function $3cfd30e35d79a5df$var$rc(e) {
    this._context = e;
}
$3cfd30e35d79a5df$var$rc.prototype = {
    _radius: 4.5,
    pointRadius: function(e) {
        return this._radius = e, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        this._line === 0 && this._context.closePath(), this._point = NaN;
    },
    point: function(e, r) {
        switch(this._point){
            case 0:
                this._context.moveTo(e, r), this._point = 1;
                break;
            case 1:
                this._context.lineTo(e, r);
                break;
            default:
                this._context.moveTo(e + this._radius, r), this._context.arc(e, r, this._radius, 0, $3cfd30e35d79a5df$var$ct);
                break;
        }
    },
    result: $3cfd30e35d79a5df$var$xt
};
var $3cfd30e35d79a5df$var$Jo = new $3cfd30e35d79a5df$var$xe(), $3cfd30e35d79a5df$var$Po, $3cfd30e35d79a5df$var$ic, $3cfd30e35d79a5df$var$uc, $3cfd30e35d79a5df$var$xr, $3cfd30e35d79a5df$var$Sr, $3cfd30e35d79a5df$var$Ir = {
    point: $3cfd30e35d79a5df$var$xt,
    lineStart: function() {
        $3cfd30e35d79a5df$var$Ir.point = $3cfd30e35d79a5df$var$wm;
    },
    lineEnd: function() {
        $3cfd30e35d79a5df$var$Po && $3cfd30e35d79a5df$var$oc($3cfd30e35d79a5df$var$ic, $3cfd30e35d79a5df$var$uc), $3cfd30e35d79a5df$var$Ir.point = $3cfd30e35d79a5df$var$xt;
    },
    polygonStart: function() {
        $3cfd30e35d79a5df$var$Po = !0;
    },
    polygonEnd: function() {
        $3cfd30e35d79a5df$var$Po = null;
    },
    result: function() {
        var e = +$3cfd30e35d79a5df$var$Jo;
        return $3cfd30e35d79a5df$var$Jo = new $3cfd30e35d79a5df$var$xe(), e;
    }
};
function $3cfd30e35d79a5df$var$wm(e, r) {
    $3cfd30e35d79a5df$var$Ir.point = $3cfd30e35d79a5df$var$oc, $3cfd30e35d79a5df$var$ic = $3cfd30e35d79a5df$var$xr = e, $3cfd30e35d79a5df$var$uc = $3cfd30e35d79a5df$var$Sr = r;
}
function $3cfd30e35d79a5df$var$oc(e, r) {
    $3cfd30e35d79a5df$var$xr -= e, $3cfd30e35d79a5df$var$Sr -= r, $3cfd30e35d79a5df$var$Jo.add($3cfd30e35d79a5df$var$Ae($3cfd30e35d79a5df$var$xr * $3cfd30e35d79a5df$var$xr + $3cfd30e35d79a5df$var$Sr * $3cfd30e35d79a5df$var$Sr)), $3cfd30e35d79a5df$var$xr = e, $3cfd30e35d79a5df$var$Sr = r;
}
let $3cfd30e35d79a5df$var$al, $3cfd30e35d79a5df$var$Zi, $3cfd30e35d79a5df$var$ll, $3cfd30e35d79a5df$var$cl;
class $3cfd30e35d79a5df$var$hl {
    constructor(r){
        this._append = r == null ? $3cfd30e35d79a5df$var$fc : $3cfd30e35d79a5df$var$mm(r), this._radius = 4.5, this._ = "";
    }
    pointRadius(r) {
        return this._radius = +r, this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        this._line === 0 && (this._ += "Z"), this._point = NaN;
    }
    point(r, u) {
        switch(this._point){
            case 0:
                this._append`M${r},${u}`, this._point = 1;
                break;
            case 1:
                this._append`L${r},${u}`;
                break;
            default:
                if (this._append`M${r},${u}`, this._radius !== $3cfd30e35d79a5df$var$ll || this._append !== $3cfd30e35d79a5df$var$Zi) {
                    const f = this._radius, s = this._;
                    this._ = "", this._append`m0,${f}a${f},${f} 0 1,1 0,${-2 * f}a${f},${f} 0 1,1 0,${2 * f}z`, $3cfd30e35d79a5df$var$ll = f, $3cfd30e35d79a5df$var$Zi = this._append, $3cfd30e35d79a5df$var$cl = this._, this._ = s;
                }
                this._ += $3cfd30e35d79a5df$var$cl;
                break;
        }
    }
    result() {
        const r = this._;
        return this._ = "", r.length ? r : null;
    }
}
function $3cfd30e35d79a5df$var$fc(e) {
    let r = 1;
    this._ += e[0];
    for(const u = e.length; r < u; ++r)this._ += arguments[r] + e[r];
}
function $3cfd30e35d79a5df$var$mm(e) {
    const r = Math.floor(e);
    if (!(r >= 0)) throw new RangeError(`invalid digits: ${e}`);
    if (r > 15) return $3cfd30e35d79a5df$var$fc;
    if (r !== $3cfd30e35d79a5df$var$al) {
        const u = 10 ** r;
        $3cfd30e35d79a5df$var$al = r, $3cfd30e35d79a5df$var$Zi = function(s) {
            let h = 1;
            this._ += s[0];
            for(const c = s.length; h < c; ++h)this._ += Math.round(arguments[h] * u) / u + s[h];
        };
    }
    return $3cfd30e35d79a5df$var$Zi;
}
function $3cfd30e35d79a5df$var$ym(e, r) {
    let u = 3, f = 4.5, s, h;
    function c(g) {
        return g && (typeof f == "function" && h.pointRadius(+f.apply(this, arguments)), $3cfd30e35d79a5df$var$We(g, s(h))), h.result();
    }
    return c.area = function(g) {
        return $3cfd30e35d79a5df$var$We(g, s($3cfd30e35d79a5df$var$Zt)), $3cfd30e35d79a5df$var$Zt.result();
    }, c.measure = function(g) {
        return $3cfd30e35d79a5df$var$We(g, s($3cfd30e35d79a5df$var$Ir)), $3cfd30e35d79a5df$var$Ir.result();
    }, c.bounds = function(g) {
        return $3cfd30e35d79a5df$var$We(g, s($3cfd30e35d79a5df$var$Xi)), $3cfd30e35d79a5df$var$Xi.result();
    }, c.centroid = function(g) {
        return $3cfd30e35d79a5df$var$We(g, s($3cfd30e35d79a5df$var$yt)), $3cfd30e35d79a5df$var$yt.result();
    }, c.projection = function(g) {
        return arguments.length ? (s = g == null ? (e = null, $3cfd30e35d79a5df$var$Uo) : (e = g).stream, c) : e;
    }, c.context = function(g) {
        return arguments.length ? (h = g == null ? (r = null, new $3cfd30e35d79a5df$var$hl(u)) : new $3cfd30e35d79a5df$var$rc(r = g), typeof f != "function" && h.pointRadius(f), c) : r;
    }, c.pointRadius = function(g) {
        return arguments.length ? (f = typeof g == "function" ? g : (h.pointRadius(+g), +g), c) : f;
    }, c.digits = function(g) {
        if (!arguments.length) return u;
        if (g == null) u = null;
        else {
            const v = Math.floor(g);
            if (!(v >= 0)) throw new RangeError(`invalid digits: ${g}`);
            u = v;
        }
        return r === null && (h = new $3cfd30e35d79a5df$var$hl(u)), c;
    }, c.projection(e).digits(u).context(r);
}
function $3cfd30e35d79a5df$var$lf(e) {
    return function(r) {
        var u = new $3cfd30e35d79a5df$var$Qo();
        for(var f in e)u[f] = e[f];
        return u.stream = r, u;
    };
}
function $3cfd30e35d79a5df$var$Qo() {}
$3cfd30e35d79a5df$var$Qo.prototype = {
    constructor: $3cfd30e35d79a5df$var$Qo,
    point: function(e, r) {
        this.stream.point(e, r);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};
function $3cfd30e35d79a5df$var$cf(e, r, u) {
    var f = e.clipExtent && e.clipExtent();
    return e.scale(150).translate([
        0,
        0
    ]), f != null && e.clipExtent(null), $3cfd30e35d79a5df$var$We(u, e.stream($3cfd30e35d79a5df$var$Xi)), r($3cfd30e35d79a5df$var$Xi.result()), f != null && e.clipExtent(f), e;
}
function $3cfd30e35d79a5df$var$sc(e, r, u) {
    return $3cfd30e35d79a5df$var$cf(e, function(f) {
        var s = r[1][0] - r[0][0], h = r[1][1] - r[0][1], c = Math.min(s / (f[1][0] - f[0][0]), h / (f[1][1] - f[0][1])), g = +r[0][0] + (s - c * (f[1][0] + f[0][0])) / 2, v = +r[0][1] + (h - c * (f[1][1] + f[0][1])) / 2;
        e.scale(150 * c).translate([
            g,
            v
        ]);
    }, u);
}
function $3cfd30e35d79a5df$var$xm(e, r, u) {
    return $3cfd30e35d79a5df$var$sc(e, [
        [
            0,
            0
        ],
        r
    ], u);
}
function $3cfd30e35d79a5df$var$Sm(e, r, u) {
    return $3cfd30e35d79a5df$var$cf(e, function(f) {
        var s = +r, h = s / (f[1][0] - f[0][0]), c = (s - h * (f[1][0] + f[0][0])) / 2, g = -h * f[0][1];
        e.scale(150 * h).translate([
            c,
            g
        ]);
    }, u);
}
function $3cfd30e35d79a5df$var$Em(e, r, u) {
    return $3cfd30e35d79a5df$var$cf(e, function(f) {
        var s = +r, h = s / (f[1][1] - f[0][1]), c = -h * f[0][0], g = (s - h * (f[1][1] + f[0][1])) / 2;
        e.scale(150 * h).translate([
            c,
            g
        ]);
    }, u);
}
var $3cfd30e35d79a5df$var$pl = 16, $3cfd30e35d79a5df$var$Am = $3cfd30e35d79a5df$var$Nn(30 * $3cfd30e35d79a5df$var$$n);
function $3cfd30e35d79a5df$var$gl(e, r) {
    return +r ? $3cfd30e35d79a5df$var$Rm(e, r) : $3cfd30e35d79a5df$var$Cm(e);
}
function $3cfd30e35d79a5df$var$Cm(e) {
    return $3cfd30e35d79a5df$var$lf({
        point: function(r, u) {
            r = e(r, u), this.stream.point(r[0], r[1]);
        }
    });
}
function $3cfd30e35d79a5df$var$Rm(e, r) {
    function u(f, s, h, c, g, v, w, d, y, x, C, P, z, $) {
        var O = w - f, U = d - s, k = O * O + U * U;
        if (k > 4 * r && z--) {
            var B = c + x, q = g + C, X = v + P, V = $3cfd30e35d79a5df$var$Ae(B * B + q * q + X * X), rn = $3cfd30e35d79a5df$var$Rr(X /= V), on = $3cfd30e35d79a5df$var$Tn($3cfd30e35d79a5df$var$Tn(X) - 1) < $3cfd30e35d79a5df$var$yn || $3cfd30e35d79a5df$var$Tn(h - y) < $3cfd30e35d79a5df$var$yn ? (h + y) / 2 : $3cfd30e35d79a5df$var$Cr(q, B), pn = e(on, rn), j = pn[0], zn = pn[1], xn = j - f, A = zn - s, R = U * xn - O * A;
            (R * R / k > r || $3cfd30e35d79a5df$var$Tn((O * xn + U * A) / k - 0.5) > 0.3 || c * x + g * C + v * P < $3cfd30e35d79a5df$var$Am) && (u(f, s, h, c, g, v, j, zn, on, B /= V, q /= V, X, z, $), $.point(j, zn), u(j, zn, on, B, q, X, w, d, y, x, C, P, z, $));
        }
    }
    return function(f) {
        var s, h, c, g, v, w, d, y, x, C, P, z, $ = {
            point: O,
            lineStart: U,
            lineEnd: B,
            polygonStart: function() {
                f.polygonStart(), $.lineStart = q;
            },
            polygonEnd: function() {
                f.polygonEnd(), $.lineStart = U;
            }
        };
        function O(rn, on) {
            rn = e(rn, on), f.point(rn[0], rn[1]);
        }
        function U() {
            y = NaN, $.point = k, f.lineStart();
        }
        function k(rn, on) {
            var pn = $3cfd30e35d79a5df$var$He([
                rn,
                on
            ]), j = e(rn, on);
            u(y, x, d, C, P, z, y = j[0], x = j[1], d = rn, C = pn[0], P = pn[1], z = pn[2], $3cfd30e35d79a5df$var$pl, f), f.point(y, x);
        }
        function B() {
            $.point = O, f.lineEnd();
        }
        function q() {
            U(), $.point = X, $.lineEnd = V;
        }
        function X(rn, on) {
            k(s = rn, on), h = y, c = x, g = C, v = P, w = z, $.point = k;
        }
        function V() {
            u(y, x, d, C, P, z, h, c, s, g, v, w, $3cfd30e35d79a5df$var$pl, f), $.lineEnd = B, B();
        }
        return $;
    };
}
var $3cfd30e35d79a5df$var$Tm = $3cfd30e35d79a5df$var$lf({
    point: function(e, r) {
        this.stream.point(e * $3cfd30e35d79a5df$var$$n, r * $3cfd30e35d79a5df$var$$n);
    }
});
function $3cfd30e35d79a5df$var$Im(e) {
    return $3cfd30e35d79a5df$var$lf({
        point: function(r, u) {
            var f = e(r, u);
            return this.stream.point(f[0], f[1]);
        }
    });
}
function $3cfd30e35d79a5df$var$Mm(e, r, u, f, s) {
    function h(c, g) {
        return c *= f, g *= s, [
            r + e * c,
            u - e * g
        ];
    }
    return h.invert = function(c, g) {
        return [
            (c - r) / e * f,
            (u - g) / e * s
        ];
    }, h;
}
function $3cfd30e35d79a5df$var$dl(e, r, u, f, s, h) {
    if (!h) return $3cfd30e35d79a5df$var$Mm(e, r, u, f, s);
    var c = $3cfd30e35d79a5df$var$Nn(h), g = $3cfd30e35d79a5df$var$On(h), v = c * e, w = g * e, d = c / e, y = g / e, x = (g * u - c * r) / e, C = (g * r + c * u) / e;
    function P(z, $) {
        return z *= f, $ *= s, [
            v * z - w * $ + r,
            u - w * z - v * $
        ];
    }
    return P.invert = function(z, $) {
        return [
            f * (d * z - y * $ + x),
            s * (C - y * z - d * $)
        ];
    }, P;
}
function $3cfd30e35d79a5df$var$Lm(e) {
    return $3cfd30e35d79a5df$var$bm(function() {
        return e;
    })();
}
function $3cfd30e35d79a5df$var$bm(e) {
    var r, u = 150, f = 480, s = 250, h = 0, c = 0, g = 0, v = 0, w = 0, d, y = 0, x = 1, C = 1, P = null, z = $3cfd30e35d79a5df$var$ol, $ = null, O, U, k, B = $3cfd30e35d79a5df$var$Uo, q = 0.5, X, V, rn, on, pn;
    function j(R) {
        return rn(R[0] * $3cfd30e35d79a5df$var$$n, R[1] * $3cfd30e35d79a5df$var$$n);
    }
    function zn(R) {
        return R = rn.invert(R[0], R[1]), R && [
            R[0] * $3cfd30e35d79a5df$var$lt,
            R[1] * $3cfd30e35d79a5df$var$lt
        ];
    }
    j.stream = function(R) {
        return on && pn === R ? on : on = $3cfd30e35d79a5df$var$Tm($3cfd30e35d79a5df$var$Im(d)(z(X(B(pn = R)))));
    }, j.preclip = function(R) {
        return arguments.length ? (z = R, P = void 0, A()) : z;
    }, j.postclip = function(R) {
        return arguments.length ? (B = R, $ = O = U = k = null, A()) : B;
    }, j.clipAngle = function(R) {
        return arguments.length ? (z = +R ? $3cfd30e35d79a5df$var$om(P = R * $3cfd30e35d79a5df$var$$n) : (P = null, $3cfd30e35d79a5df$var$ol), A()) : P * $3cfd30e35d79a5df$var$lt;
    }, j.clipExtent = function(R) {
        return arguments.length ? (B = R == null ? ($ = O = U = k = null, $3cfd30e35d79a5df$var$Uo) : $3cfd30e35d79a5df$var$sm($ = +R[0][0], O = +R[0][1], U = +R[1][0], k = +R[1][1]), A()) : $ == null ? null : [
            [
                $,
                O
            ],
            [
                U,
                k
            ]
        ];
    }, j.scale = function(R) {
        return arguments.length ? (u = +R, xn()) : u;
    }, j.translate = function(R) {
        return arguments.length ? (f = +R[0], s = +R[1], xn()) : [
            f,
            s
        ];
    }, j.center = function(R) {
        return arguments.length ? (h = R[0] % 360 * $3cfd30e35d79a5df$var$$n, c = R[1] % 360 * $3cfd30e35d79a5df$var$$n, xn()) : [
            h * $3cfd30e35d79a5df$var$lt,
            c * $3cfd30e35d79a5df$var$lt
        ];
    }, j.rotate = function(R) {
        return arguments.length ? (g = R[0] % 360 * $3cfd30e35d79a5df$var$$n, v = R[1] % 360 * $3cfd30e35d79a5df$var$$n, w = R.length > 2 ? R[2] % 360 * $3cfd30e35d79a5df$var$$n : 0, xn()) : [
            g * $3cfd30e35d79a5df$var$lt,
            v * $3cfd30e35d79a5df$var$lt,
            w * $3cfd30e35d79a5df$var$lt
        ];
    }, j.angle = function(R) {
        return arguments.length ? (y = R % 360 * $3cfd30e35d79a5df$var$$n, xn()) : y * $3cfd30e35d79a5df$var$lt;
    }, j.reflectX = function(R) {
        return arguments.length ? (x = R ? -1 : 1, xn()) : x < 0;
    }, j.reflectY = function(R) {
        return arguments.length ? (C = R ? -1 : 1, xn()) : C < 0;
    }, j.precision = function(R) {
        return arguments.length ? (X = $3cfd30e35d79a5df$var$gl(V, q = R * R), A()) : $3cfd30e35d79a5df$var$Ae(q);
    }, j.fitExtent = function(R, I) {
        return $3cfd30e35d79a5df$var$sc(j, R, I);
    }, j.fitSize = function(R, I) {
        return $3cfd30e35d79a5df$var$xm(j, R, I);
    }, j.fitWidth = function(R, I) {
        return $3cfd30e35d79a5df$var$Sm(j, R, I);
    }, j.fitHeight = function(R, I) {
        return $3cfd30e35d79a5df$var$Em(j, R, I);
    };
    function xn() {
        var R = $3cfd30e35d79a5df$var$dl(u, 0, 0, x, C, y).apply(null, r(h, c)), I = $3cfd30e35d79a5df$var$dl(u, f - R[0], s - R[1], x, C, y);
        return d = $3cfd30e35d79a5df$var$Yl(g, v, w), V = $3cfd30e35d79a5df$var$Wo(r, I), rn = $3cfd30e35d79a5df$var$Wo(d, V), X = $3cfd30e35d79a5df$var$gl(V, q), A();
    }
    function A() {
        return on = pn = null, j;
    }
    return function() {
        return r = e.apply(this, arguments), j.invert = r.invert && zn, xn();
    };
}
function $3cfd30e35d79a5df$var$hf(e, r) {
    return [
        e,
        $3cfd30e35d79a5df$var$Kw($3cfd30e35d79a5df$var$Jw(($3cfd30e35d79a5df$var$tt + r) / 2))
    ];
}
$3cfd30e35d79a5df$var$hf.invert = function(e, r) {
    return [
        e,
        2 * $3cfd30e35d79a5df$var$Xl($3cfd30e35d79a5df$var$Yw(r)) - $3cfd30e35d79a5df$var$tt
    ];
};
function $3cfd30e35d79a5df$var$Pm() {
    return $3cfd30e35d79a5df$var$Nm($3cfd30e35d79a5df$var$hf).scale(961 / $3cfd30e35d79a5df$var$ct);
}
function $3cfd30e35d79a5df$var$Nm(e) {
    var r = $3cfd30e35d79a5df$var$Lm(e), u = r.center, f = r.scale, s = r.translate, h = r.clipExtent, c = null, g, v, w;
    r.scale = function(y) {
        return arguments.length ? (f(y), d()) : f();
    }, r.translate = function(y) {
        return arguments.length ? (s(y), d()) : s();
    }, r.center = function(y) {
        return arguments.length ? (u(y), d()) : u();
    }, r.clipExtent = function(y) {
        return arguments.length ? (y == null ? c = g = v = w = null : (c = +y[0][0], g = +y[0][1], v = +y[1][0], w = +y[1][1]), d()) : c == null ? null : [
            [
                c,
                g
            ],
            [
                v,
                w
            ]
        ];
    };
    function d() {
        var y = $3cfd30e35d79a5df$var$hn * f(), x = r($3cfd30e35d79a5df$var$Vw(r.rotate()).invert([
            0,
            0
        ]));
        return h(c == null ? [
            [
                x[0] - y,
                x[1] - y
            ],
            [
                x[0] + y,
                x[1] + y
            ]
        ] : e === $3cfd30e35d79a5df$var$hf ? [
            [
                Math.max(x[0] - y, c),
                g
            ],
            [
                Math.min(x[0] + y, v),
                w
            ]
        ] : [
            [
                c,
                Math.max(x[1] - y, g)
            ],
            [
                v,
                Math.min(x[1] + y, w)
            ]
        ]);
    }
    return d();
}
var $3cfd30e35d79a5df$var$Om = {
    value: ()=>{}
};
function $3cfd30e35d79a5df$var$pf() {
    for(var e = 0, r = arguments.length, u = {}, f; e < r; ++e){
        if (!(f = arguments[e] + "") || f in u || /[\s.]/.test(f)) throw new Error("illegal type: " + f);
        u[f] = [];
    }
    return new $3cfd30e35d79a5df$var$Fi(u);
}
function $3cfd30e35d79a5df$var$Fi(e) {
    this._ = e;
}
function $3cfd30e35d79a5df$var$$m(e, r) {
    return e.trim().split(/^|\s+/).map(function(u) {
        var f = "", s = u.indexOf(".");
        if (s >= 0 && (f = u.slice(s + 1), u = u.slice(0, s)), u && !r.hasOwnProperty(u)) throw new Error("unknown type: " + u);
        return {
            type: u,
            name: f
        };
    });
}
$3cfd30e35d79a5df$var$Fi.prototype = $3cfd30e35d79a5df$var$pf.prototype = {
    constructor: $3cfd30e35d79a5df$var$Fi,
    on: function(e, r) {
        var u = this._, f = $3cfd30e35d79a5df$var$$m(e + "", u), s, h = -1, c = f.length;
        if (arguments.length < 2) {
            for(; ++h < c;)if ((s = (e = f[h]).type) && (s = $3cfd30e35d79a5df$var$Fm(u[s], e.name))) return s;
            return;
        }
        if (r != null && typeof r != "function") throw new Error("invalid callback: " + r);
        for(; ++h < c;)if (s = (e = f[h]).type) u[s] = $3cfd30e35d79a5df$var$_l(u[s], e.name, r);
        else if (r == null) for(s in u)u[s] = $3cfd30e35d79a5df$var$_l(u[s], e.name, null);
        return this;
    },
    copy: function() {
        var e = {}, r = this._;
        for(var u in r)e[u] = r[u].slice();
        return new $3cfd30e35d79a5df$var$Fi(e);
    },
    call: function(e, r) {
        if ((s = arguments.length - 2) > 0) for(var u = new Array(s), f = 0, s, h; f < s; ++f)u[f] = arguments[f + 2];
        if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
        for(h = this._[e], f = 0, s = h.length; f < s; ++f)h[f].value.apply(r, u);
    },
    apply: function(e, r, u) {
        if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
        for(var f = this._[e], s = 0, h = f.length; s < h; ++s)f[s].value.apply(r, u);
    }
};
function $3cfd30e35d79a5df$var$Fm(e, r) {
    for(var u = 0, f = e.length, s; u < f; ++u)if ((s = e[u]).name === r) return s.value;
}
function $3cfd30e35d79a5df$var$_l(e, r, u) {
    for(var f = 0, s = e.length; f < s; ++f)if (e[f].name === r) {
        e[f] = $3cfd30e35d79a5df$var$Om, e = e.slice(0, f).concat(e.slice(f + 1));
        break;
    }
    return u != null && e.push({
        name: r,
        value: u
    }), e;
}
var $3cfd30e35d79a5df$var$Ye = 0, $3cfd30e35d79a5df$var$Er = 0, $3cfd30e35d79a5df$var$_r = 0, $3cfd30e35d79a5df$var$ac = 1e3, $3cfd30e35d79a5df$var$Ji, $3cfd30e35d79a5df$var$Ar, $3cfd30e35d79a5df$var$Qi = 0, $3cfd30e35d79a5df$var$Ee = 0, $3cfd30e35d79a5df$var$uu = 0, $3cfd30e35d79a5df$var$Mr = typeof performance == "object" && performance.now ? performance : Date, $3cfd30e35d79a5df$var$lc = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
    setTimeout(e, 17);
};
function $3cfd30e35d79a5df$var$gf() {
    return $3cfd30e35d79a5df$var$Ee || ($3cfd30e35d79a5df$var$lc($3cfd30e35d79a5df$var$Dm), $3cfd30e35d79a5df$var$Ee = $3cfd30e35d79a5df$var$Mr.now() + $3cfd30e35d79a5df$var$uu);
}
function $3cfd30e35d79a5df$var$Dm() {
    $3cfd30e35d79a5df$var$Ee = 0;
}
function $3cfd30e35d79a5df$var$Vi() {
    this._call = this._time = this._next = null;
}
$3cfd30e35d79a5df$var$Vi.prototype = $3cfd30e35d79a5df$var$cc.prototype = {
    constructor: $3cfd30e35d79a5df$var$Vi,
    restart: function(e, r, u) {
        if (typeof e != "function") throw new TypeError("callback is not a function");
        u = (u == null ? $3cfd30e35d79a5df$var$gf() : +u) + (r == null ? 0 : +r), !this._next && $3cfd30e35d79a5df$var$Ar !== this && ($3cfd30e35d79a5df$var$Ar ? $3cfd30e35d79a5df$var$Ar._next = this : $3cfd30e35d79a5df$var$Ji = this, $3cfd30e35d79a5df$var$Ar = this), this._call = e, this._time = u, $3cfd30e35d79a5df$var$Vo();
    },
    stop: function() {
        this._call && (this._call = null, this._time = 1 / 0, $3cfd30e35d79a5df$var$Vo());
    }
};
function $3cfd30e35d79a5df$var$cc(e, r, u) {
    var f = new $3cfd30e35d79a5df$var$Vi();
    return f.restart(e, r, u), f;
}
function $3cfd30e35d79a5df$var$zm() {
    $3cfd30e35d79a5df$var$gf(), ++$3cfd30e35d79a5df$var$Ye;
    for(var e = $3cfd30e35d79a5df$var$Ji, r; e;)(r = $3cfd30e35d79a5df$var$Ee - e._time) >= 0 && e._call.call(void 0, r), e = e._next;
    --$3cfd30e35d79a5df$var$Ye;
}
function $3cfd30e35d79a5df$var$vl() {
    $3cfd30e35d79a5df$var$Ee = ($3cfd30e35d79a5df$var$Qi = $3cfd30e35d79a5df$var$Mr.now()) + $3cfd30e35d79a5df$var$uu, $3cfd30e35d79a5df$var$Ye = $3cfd30e35d79a5df$var$Er = 0;
    try {
        $3cfd30e35d79a5df$var$zm();
    } finally{
        $3cfd30e35d79a5df$var$Ye = 0, $3cfd30e35d79a5df$var$Wm(), $3cfd30e35d79a5df$var$Ee = 0;
    }
}
function $3cfd30e35d79a5df$var$Bm() {
    var e = $3cfd30e35d79a5df$var$Mr.now(), r = e - $3cfd30e35d79a5df$var$Qi;
    r > $3cfd30e35d79a5df$var$ac && ($3cfd30e35d79a5df$var$uu -= r, $3cfd30e35d79a5df$var$Qi = e);
}
function $3cfd30e35d79a5df$var$Wm() {
    for(var e, r = $3cfd30e35d79a5df$var$Ji, u, f = 1 / 0; r;)r._call ? (f > r._time && (f = r._time), e = r, r = r._next) : (u = r._next, r._next = null, r = e ? e._next = u : $3cfd30e35d79a5df$var$Ji = u);
    $3cfd30e35d79a5df$var$Ar = e, $3cfd30e35d79a5df$var$Vo(f);
}
function $3cfd30e35d79a5df$var$Vo(e) {
    if (!$3cfd30e35d79a5df$var$Ye) {
        $3cfd30e35d79a5df$var$Er && ($3cfd30e35d79a5df$var$Er = clearTimeout($3cfd30e35d79a5df$var$Er));
        var r = e - $3cfd30e35d79a5df$var$Ee;
        r > 24 ? (e < 1 / 0 && ($3cfd30e35d79a5df$var$Er = setTimeout($3cfd30e35d79a5df$var$vl, e - $3cfd30e35d79a5df$var$Mr.now() - $3cfd30e35d79a5df$var$uu)), $3cfd30e35d79a5df$var$_r && ($3cfd30e35d79a5df$var$_r = clearInterval($3cfd30e35d79a5df$var$_r))) : ($3cfd30e35d79a5df$var$_r || ($3cfd30e35d79a5df$var$Qi = $3cfd30e35d79a5df$var$Mr.now(), $3cfd30e35d79a5df$var$_r = setInterval($3cfd30e35d79a5df$var$Bm, $3cfd30e35d79a5df$var$ac)), $3cfd30e35d79a5df$var$Ye = 1, $3cfd30e35d79a5df$var$lc($3cfd30e35d79a5df$var$vl));
    }
}
function $3cfd30e35d79a5df$var$wl(e, r, u) {
    var f = new $3cfd30e35d79a5df$var$Vi();
    return r = r == null ? 0 : +r, f.restart((s)=>{
        f.stop(), e(s + r);
    }, r, u), f;
}
var $3cfd30e35d79a5df$var$km = $3cfd30e35d79a5df$var$pf("start", "end", "cancel", "interrupt"), $3cfd30e35d79a5df$var$Um = [], $3cfd30e35d79a5df$var$hc = 0, $3cfd30e35d79a5df$var$ml = 1, $3cfd30e35d79a5df$var$jo = 2, $3cfd30e35d79a5df$var$Di = 3, $3cfd30e35d79a5df$var$yl = 4, $3cfd30e35d79a5df$var$nf = 5, $3cfd30e35d79a5df$var$zi = 6;
function $3cfd30e35d79a5df$var$ou(e, r, u, f, s, h) {
    var c = e.__transition;
    if (!c) e.__transition = {};
    else if (u in c) return;
    $3cfd30e35d79a5df$var$Gm(e, u, {
        name: r,
        index: f,
        // For context during callback.
        group: s,
        // For context during callback.
        on: $3cfd30e35d79a5df$var$km,
        tween: $3cfd30e35d79a5df$var$Um,
        time: h.time,
        delay: h.delay,
        duration: h.duration,
        ease: h.ease,
        timer: null,
        state: $3cfd30e35d79a5df$var$hc
    });
}
function $3cfd30e35d79a5df$var$df(e, r) {
    var u = $3cfd30e35d79a5df$var$Mt(e, r);
    if (u.state > $3cfd30e35d79a5df$var$hc) throw new Error("too late; already scheduled");
    return u;
}
function $3cfd30e35d79a5df$var$Ft(e, r) {
    var u = $3cfd30e35d79a5df$var$Mt(e, r);
    if (u.state > $3cfd30e35d79a5df$var$Di) throw new Error("too late; already running");
    return u;
}
function $3cfd30e35d79a5df$var$Mt(e, r) {
    var u = e.__transition;
    if (!u || !(u = u[r])) throw new Error("transition not found");
    return u;
}
function $3cfd30e35d79a5df$var$Gm(e, r, u) {
    var f = e.__transition, s;
    f[r] = u, u.timer = $3cfd30e35d79a5df$var$cc(h, 0, u.time);
    function h(w) {
        u.state = $3cfd30e35d79a5df$var$ml, u.timer.restart(c, u.delay, u.time), u.delay <= w && c(w - u.delay);
    }
    function c(w) {
        var d, y, x, C;
        if (u.state !== $3cfd30e35d79a5df$var$ml) return v();
        for(d in f)if (C = f[d], C.name === u.name) {
            if (C.state === $3cfd30e35d79a5df$var$Di) return $3cfd30e35d79a5df$var$wl(c);
            C.state === $3cfd30e35d79a5df$var$yl ? (C.state = $3cfd30e35d79a5df$var$zi, C.timer.stop(), C.on.call("interrupt", e, e.__data__, C.index, C.group), delete f[d]) : +d < r && (C.state = $3cfd30e35d79a5df$var$zi, C.timer.stop(), C.on.call("cancel", e, e.__data__, C.index, C.group), delete f[d]);
        }
        if ($3cfd30e35d79a5df$var$wl(function() {
            u.state === $3cfd30e35d79a5df$var$Di && (u.state = $3cfd30e35d79a5df$var$yl, u.timer.restart(g, u.delay, u.time), g(w));
        }), u.state = $3cfd30e35d79a5df$var$jo, u.on.call("start", e, e.__data__, u.index, u.group), u.state === $3cfd30e35d79a5df$var$jo) {
            for(u.state = $3cfd30e35d79a5df$var$Di, s = new Array(x = u.tween.length), d = 0, y = -1; d < x; ++d)(C = u.tween[d].value.call(e, e.__data__, u.index, u.group)) && (s[++y] = C);
            s.length = y + 1;
        }
    }
    function g(w) {
        for(var d = w < u.duration ? u.ease.call(null, w / u.duration) : (u.timer.restart(v), u.state = $3cfd30e35d79a5df$var$nf, 1), y = -1, x = s.length; ++y < x;)s[y].call(e, d);
        u.state === $3cfd30e35d79a5df$var$nf && (u.on.call("end", e, e.__data__, u.index, u.group), v());
    }
    function v() {
        u.state = $3cfd30e35d79a5df$var$zi, u.timer.stop(), delete f[r];
        for(var w in f)return;
        delete e.__transition;
    }
}
function $3cfd30e35d79a5df$var$Bi(e, r) {
    var u = e.__transition, f, s, h = !0, c;
    if (u) {
        r = r == null ? null : r + "";
        for(c in u){
            if ((f = u[c]).name !== r) {
                h = !1;
                continue;
            }
            s = f.state > $3cfd30e35d79a5df$var$jo && f.state < $3cfd30e35d79a5df$var$nf, f.state = $3cfd30e35d79a5df$var$zi, f.timer.stop(), f.on.call(s ? "interrupt" : "cancel", e, e.__data__, f.index, f.group), delete u[c];
        }
        h && delete e.__transition;
    }
}
function $3cfd30e35d79a5df$var$qm(e) {
    return this.each(function() {
        $3cfd30e35d79a5df$var$Bi(this, e);
    });
}
function $3cfd30e35d79a5df$var$_f(e, r, u) {
    e.prototype = r.prototype = u, u.constructor = e;
}
function $3cfd30e35d79a5df$var$pc(e, r) {
    var u = Object.create(e.prototype);
    for(var f in r)u[f] = r[f];
    return u;
}
function $3cfd30e35d79a5df$var$Nr() {}
var $3cfd30e35d79a5df$var$Lr = 0.7, $3cfd30e35d79a5df$var$ji = 1 / $3cfd30e35d79a5df$var$Lr, $3cfd30e35d79a5df$var$Ge = "\\s*([+-]?\\d+)\\s*", $3cfd30e35d79a5df$var$br = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $3cfd30e35d79a5df$var$$t = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $3cfd30e35d79a5df$var$Hm = /^#([0-9a-f]{3,8})$/, $3cfd30e35d79a5df$var$Xm = new RegExp(`^rgb\\(${$3cfd30e35d79a5df$var$Ge},${$3cfd30e35d79a5df$var$Ge},${$3cfd30e35d79a5df$var$Ge}\\)$`), $3cfd30e35d79a5df$var$Ym = new RegExp(`^rgb\\(${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t}\\)$`), $3cfd30e35d79a5df$var$Km = new RegExp(`^rgba\\(${$3cfd30e35d79a5df$var$Ge},${$3cfd30e35d79a5df$var$Ge},${$3cfd30e35d79a5df$var$Ge},${$3cfd30e35d79a5df$var$br}\\)$`), $3cfd30e35d79a5df$var$Zm = new RegExp(`^rgba\\(${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$br}\\)$`), $3cfd30e35d79a5df$var$Jm = new RegExp(`^hsl\\(${$3cfd30e35d79a5df$var$br},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t}\\)$`), $3cfd30e35d79a5df$var$Qm = new RegExp(`^hsla\\(${$3cfd30e35d79a5df$var$br},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$$t},${$3cfd30e35d79a5df$var$br}\\)$`), $3cfd30e35d79a5df$var$xl = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
};
$3cfd30e35d79a5df$var$_f($3cfd30e35d79a5df$var$Nr, $3cfd30e35d79a5df$var$Pr, {
    copy (e) {
        return Object.assign(new this.constructor(), this, e);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $3cfd30e35d79a5df$var$Sl,
    // Deprecated! Use color.formatHex.
    formatHex: $3cfd30e35d79a5df$var$Sl,
    formatHex8: $3cfd30e35d79a5df$var$Vm,
    formatHsl: $3cfd30e35d79a5df$var$jm,
    formatRgb: $3cfd30e35d79a5df$var$El,
    toString: $3cfd30e35d79a5df$var$El
});
function $3cfd30e35d79a5df$var$Sl() {
    return this.rgb().formatHex();
}
function $3cfd30e35d79a5df$var$Vm() {
    return this.rgb().formatHex8();
}
function $3cfd30e35d79a5df$var$jm() {
    return $3cfd30e35d79a5df$var$gc(this).formatHsl();
}
function $3cfd30e35d79a5df$var$El() {
    return this.rgb().formatRgb();
}
function $3cfd30e35d79a5df$var$Pr(e) {
    var r, u;
    return e = (e + "").trim().toLowerCase(), (r = $3cfd30e35d79a5df$var$Hm.exec(e)) ? (u = r[1].length, r = parseInt(r[1], 16), u === 6 ? $3cfd30e35d79a5df$var$Al(r) : u === 3 ? new $3cfd30e35d79a5df$var$et(r >> 8 & 15 | r >> 4 & 240, r >> 4 & 15 | r & 240, (r & 15) << 4 | r & 15, 1) : u === 8 ? $3cfd30e35d79a5df$var$bi(r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, (r & 255) / 255) : u === 4 ? $3cfd30e35d79a5df$var$bi(r >> 12 & 15 | r >> 8 & 240, r >> 8 & 15 | r >> 4 & 240, r >> 4 & 15 | r & 240, ((r & 15) << 4 | r & 15) / 255) : null) : (r = $3cfd30e35d79a5df$var$Xm.exec(e)) ? new $3cfd30e35d79a5df$var$et(r[1], r[2], r[3], 1) : (r = $3cfd30e35d79a5df$var$Ym.exec(e)) ? new $3cfd30e35d79a5df$var$et(r[1] * 255 / 100, r[2] * 255 / 100, r[3] * 255 / 100, 1) : (r = $3cfd30e35d79a5df$var$Km.exec(e)) ? $3cfd30e35d79a5df$var$bi(r[1], r[2], r[3], r[4]) : (r = $3cfd30e35d79a5df$var$Zm.exec(e)) ? $3cfd30e35d79a5df$var$bi(r[1] * 255 / 100, r[2] * 255 / 100, r[3] * 255 / 100, r[4]) : (r = $3cfd30e35d79a5df$var$Jm.exec(e)) ? $3cfd30e35d79a5df$var$Tl(r[1], r[2] / 100, r[3] / 100, 1) : (r = $3cfd30e35d79a5df$var$Qm.exec(e)) ? $3cfd30e35d79a5df$var$Tl(r[1], r[2] / 100, r[3] / 100, r[4]) : $3cfd30e35d79a5df$var$xl.hasOwnProperty(e) ? $3cfd30e35d79a5df$var$Al($3cfd30e35d79a5df$var$xl[e]) : e === "transparent" ? new $3cfd30e35d79a5df$var$et(NaN, NaN, NaN, 0) : null;
}
function $3cfd30e35d79a5df$var$Al(e) {
    return new $3cfd30e35d79a5df$var$et(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function $3cfd30e35d79a5df$var$bi(e, r, u, f) {
    return f <= 0 && (e = r = u = NaN), new $3cfd30e35d79a5df$var$et(e, r, u, f);
}
function $3cfd30e35d79a5df$var$ny(e) {
    return e instanceof $3cfd30e35d79a5df$var$Nr || (e = $3cfd30e35d79a5df$var$Pr(e)), e ? (e = e.rgb(), new $3cfd30e35d79a5df$var$et(e.r, e.g, e.b, e.opacity)) : new $3cfd30e35d79a5df$var$et();
}
function $3cfd30e35d79a5df$var$tf(e, r, u, f) {
    return arguments.length === 1 ? $3cfd30e35d79a5df$var$ny(e) : new $3cfd30e35d79a5df$var$et(e, r, u, f ?? 1);
}
function $3cfd30e35d79a5df$var$et(e, r, u, f) {
    this.r = +e, this.g = +r, this.b = +u, this.opacity = +f;
}
$3cfd30e35d79a5df$var$_f($3cfd30e35d79a5df$var$et, $3cfd30e35d79a5df$var$tf, $3cfd30e35d79a5df$var$pc($3cfd30e35d79a5df$var$Nr, {
    brighter (e) {
        return e = e == null ? $3cfd30e35d79a5df$var$ji : Math.pow($3cfd30e35d79a5df$var$ji, e), new $3cfd30e35d79a5df$var$et(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    darker (e) {
        return e = e == null ? $3cfd30e35d79a5df$var$Lr : Math.pow($3cfd30e35d79a5df$var$Lr, e), new $3cfd30e35d79a5df$var$et(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $3cfd30e35d79a5df$var$et($3cfd30e35d79a5df$var$ye(this.r), $3cfd30e35d79a5df$var$ye(this.g), $3cfd30e35d79a5df$var$ye(this.b), $3cfd30e35d79a5df$var$nu(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $3cfd30e35d79a5df$var$Cl,
    // Deprecated! Use color.formatHex.
    formatHex: $3cfd30e35d79a5df$var$Cl,
    formatHex8: $3cfd30e35d79a5df$var$ty,
    formatRgb: $3cfd30e35d79a5df$var$Rl,
    toString: $3cfd30e35d79a5df$var$Rl
}));
function $3cfd30e35d79a5df$var$Cl() {
    return `#${$3cfd30e35d79a5df$var$me(this.r)}${$3cfd30e35d79a5df$var$me(this.g)}${$3cfd30e35d79a5df$var$me(this.b)}`;
}
function $3cfd30e35d79a5df$var$ty() {
    return `#${$3cfd30e35d79a5df$var$me(this.r)}${$3cfd30e35d79a5df$var$me(this.g)}${$3cfd30e35d79a5df$var$me(this.b)}${$3cfd30e35d79a5df$var$me((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $3cfd30e35d79a5df$var$Rl() {
    const e = $3cfd30e35d79a5df$var$nu(this.opacity);
    return `${e === 1 ? "rgb(" : "rgba("}${$3cfd30e35d79a5df$var$ye(this.r)}, ${$3cfd30e35d79a5df$var$ye(this.g)}, ${$3cfd30e35d79a5df$var$ye(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function $3cfd30e35d79a5df$var$nu(e) {
    return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function $3cfd30e35d79a5df$var$ye(e) {
    return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function $3cfd30e35d79a5df$var$me(e) {
    return e = $3cfd30e35d79a5df$var$ye(e), (e < 16 ? "0" : "") + e.toString(16);
}
function $3cfd30e35d79a5df$var$Tl(e, r, u, f) {
    return f <= 0 ? e = r = u = NaN : u <= 0 || u >= 1 ? e = r = NaN : r <= 0 && (e = NaN), new $3cfd30e35d79a5df$var$It(e, r, u, f);
}
function $3cfd30e35d79a5df$var$gc(e) {
    if (e instanceof $3cfd30e35d79a5df$var$It) return new $3cfd30e35d79a5df$var$It(e.h, e.s, e.l, e.opacity);
    if (e instanceof $3cfd30e35d79a5df$var$Nr || (e = $3cfd30e35d79a5df$var$Pr(e)), !e) return new $3cfd30e35d79a5df$var$It();
    if (e instanceof $3cfd30e35d79a5df$var$It) return e;
    e = e.rgb();
    var r = e.r / 255, u = e.g / 255, f = e.b / 255, s = Math.min(r, u, f), h = Math.max(r, u, f), c = NaN, g = h - s, v = (h + s) / 2;
    return g ? (r === h ? c = (u - f) / g + (u < f) * 6 : u === h ? c = (f - r) / g + 2 : c = (r - u) / g + 4, g /= v < 0.5 ? h + s : 2 - h - s, c *= 60) : g = v > 0 && v < 1 ? 0 : c, new $3cfd30e35d79a5df$var$It(c, g, v, e.opacity);
}
function $3cfd30e35d79a5df$var$ey(e, r, u, f) {
    return arguments.length === 1 ? $3cfd30e35d79a5df$var$gc(e) : new $3cfd30e35d79a5df$var$It(e, r, u, f ?? 1);
}
function $3cfd30e35d79a5df$var$It(e, r, u, f) {
    this.h = +e, this.s = +r, this.l = +u, this.opacity = +f;
}
$3cfd30e35d79a5df$var$_f($3cfd30e35d79a5df$var$It, $3cfd30e35d79a5df$var$ey, $3cfd30e35d79a5df$var$pc($3cfd30e35d79a5df$var$Nr, {
    brighter (e) {
        return e = e == null ? $3cfd30e35d79a5df$var$ji : Math.pow($3cfd30e35d79a5df$var$ji, e), new $3cfd30e35d79a5df$var$It(this.h, this.s, this.l * e, this.opacity);
    },
    darker (e) {
        return e = e == null ? $3cfd30e35d79a5df$var$Lr : Math.pow($3cfd30e35d79a5df$var$Lr, e), new $3cfd30e35d79a5df$var$It(this.h, this.s, this.l * e, this.opacity);
    },
    rgb () {
        var e = this.h % 360 + (this.h < 0) * 360, r = isNaN(e) || isNaN(this.s) ? 0 : this.s, u = this.l, f = u + (u < 0.5 ? u : 1 - u) * r, s = 2 * u - f;
        return new $3cfd30e35d79a5df$var$et($3cfd30e35d79a5df$var$No(e >= 240 ? e - 240 : e + 120, s, f), $3cfd30e35d79a5df$var$No(e, s, f), $3cfd30e35d79a5df$var$No(e < 120 ? e + 240 : e - 120, s, f), this.opacity);
    },
    clamp () {
        return new $3cfd30e35d79a5df$var$It($3cfd30e35d79a5df$var$Il(this.h), $3cfd30e35d79a5df$var$Pi(this.s), $3cfd30e35d79a5df$var$Pi(this.l), $3cfd30e35d79a5df$var$nu(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const e = $3cfd30e35d79a5df$var$nu(this.opacity);
        return `${e === 1 ? "hsl(" : "hsla("}${$3cfd30e35d79a5df$var$Il(this.h)}, ${$3cfd30e35d79a5df$var$Pi(this.s) * 100}%, ${$3cfd30e35d79a5df$var$Pi(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
    }
}));
function $3cfd30e35d79a5df$var$Il(e) {
    return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function $3cfd30e35d79a5df$var$Pi(e) {
    return Math.max(0, Math.min(1, e || 0));
}
function $3cfd30e35d79a5df$var$No(e, r, u) {
    return (e < 60 ? r + (u - r) * e / 60 : e < 180 ? u : e < 240 ? r + (u - r) * (240 - e) / 60 : r) * 255;
}
const $3cfd30e35d79a5df$var$dc = (e)=>()=>e;
function $3cfd30e35d79a5df$var$ry(e, r) {
    return function(u) {
        return e + u * r;
    };
}
function $3cfd30e35d79a5df$var$iy(e, r, u) {
    return e = Math.pow(e, u), r = Math.pow(r, u) - e, u = 1 / u, function(f) {
        return Math.pow(e + f * r, u);
    };
}
function $3cfd30e35d79a5df$var$uy(e) {
    return (e = +e) == 1 ? $3cfd30e35d79a5df$var$_c : function(r, u) {
        return u - r ? $3cfd30e35d79a5df$var$iy(r, u, e) : $3cfd30e35d79a5df$var$dc(isNaN(r) ? u : r);
    };
}
function $3cfd30e35d79a5df$var$_c(e, r) {
    var u = r - e;
    return u ? $3cfd30e35d79a5df$var$ry(e, u) : $3cfd30e35d79a5df$var$dc(isNaN(e) ? r : e);
}
const $3cfd30e35d79a5df$var$Ml = function e(r) {
    var u = $3cfd30e35d79a5df$var$uy(r);
    function f(s, h) {
        var c = u((s = $3cfd30e35d79a5df$var$tf(s)).r, (h = $3cfd30e35d79a5df$var$tf(h)).r), g = u(s.g, h.g), v = u(s.b, h.b), w = $3cfd30e35d79a5df$var$_c(s.opacity, h.opacity);
        return function(d) {
            return s.r = c(d), s.g = g(d), s.b = v(d), s.opacity = w(d), s + "";
        };
    }
    return f.gamma = e, f;
}(1);
function $3cfd30e35d79a5df$var$fe(e, r) {
    return e = +e, r = +r, function(u) {
        return e * (1 - u) + r * u;
    };
}
var $3cfd30e35d79a5df$var$ef = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $3cfd30e35d79a5df$var$Oo = new RegExp($3cfd30e35d79a5df$var$ef.source, "g");
function $3cfd30e35d79a5df$var$oy(e) {
    return function() {
        return e;
    };
}
function $3cfd30e35d79a5df$var$fy(e) {
    return function(r) {
        return e(r) + "";
    };
}
function $3cfd30e35d79a5df$var$sy(e, r) {
    var u = $3cfd30e35d79a5df$var$ef.lastIndex = $3cfd30e35d79a5df$var$Oo.lastIndex = 0, f, s, h, c = -1, g = [], v = [];
    for(e = e + "", r = r + ""; (f = $3cfd30e35d79a5df$var$ef.exec(e)) && (s = $3cfd30e35d79a5df$var$Oo.exec(r));)(h = s.index) > u && (h = r.slice(u, h), g[c] ? g[c] += h : g[++c] = h), (f = f[0]) === (s = s[0]) ? g[c] ? g[c] += s : g[++c] = s : (g[++c] = null, v.push({
        i: c,
        x: $3cfd30e35d79a5df$var$fe(f, s)
    })), u = $3cfd30e35d79a5df$var$Oo.lastIndex;
    return u < r.length && (h = r.slice(u), g[c] ? g[c] += h : g[++c] = h), g.length < 2 ? v[0] ? $3cfd30e35d79a5df$var$fy(v[0].x) : $3cfd30e35d79a5df$var$oy(r) : (r = v.length, function(w) {
        for(var d = 0, y; d < r; ++d)g[(y = v[d]).i] = y.x(w);
        return g.join("");
    });
}
var $3cfd30e35d79a5df$var$Ll = 180 / Math.PI, $3cfd30e35d79a5df$var$rf = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $3cfd30e35d79a5df$var$vc(e, r, u, f, s, h) {
    var c, g, v;
    return (c = Math.sqrt(e * e + r * r)) && (e /= c, r /= c), (v = e * u + r * f) && (u -= e * v, f -= r * v), (g = Math.sqrt(u * u + f * f)) && (u /= g, f /= g, v /= g), e * f < r * u && (e = -e, r = -r, v = -v, c = -c), {
        translateX: s,
        translateY: h,
        rotate: Math.atan2(r, e) * $3cfd30e35d79a5df$var$Ll,
        skewX: Math.atan(v) * $3cfd30e35d79a5df$var$Ll,
        scaleX: c,
        scaleY: g
    };
}
var $3cfd30e35d79a5df$var$Ni;
function $3cfd30e35d79a5df$var$ay(e) {
    const r = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
    return r.isIdentity ? $3cfd30e35d79a5df$var$rf : $3cfd30e35d79a5df$var$vc(r.a, r.b, r.c, r.d, r.e, r.f);
}
function $3cfd30e35d79a5df$var$ly(e) {
    return e == null || ($3cfd30e35d79a5df$var$Ni || ($3cfd30e35d79a5df$var$Ni = document.createElementNS("http://www.w3.org/2000/svg", "g")), $3cfd30e35d79a5df$var$Ni.setAttribute("transform", e), !(e = $3cfd30e35d79a5df$var$Ni.transform.baseVal.consolidate())) ? $3cfd30e35d79a5df$var$rf : (e = e.matrix, $3cfd30e35d79a5df$var$vc(e.a, e.b, e.c, e.d, e.e, e.f));
}
function $3cfd30e35d79a5df$var$wc(e, r, u, f) {
    function s(w) {
        return w.length ? w.pop() + " " : "";
    }
    function h(w, d, y, x, C, P) {
        if (w !== y || d !== x) {
            var z = C.push("translate(", null, r, null, u);
            P.push({
                i: z - 4,
                x: $3cfd30e35d79a5df$var$fe(w, y)
            }, {
                i: z - 2,
                x: $3cfd30e35d79a5df$var$fe(d, x)
            });
        } else (y || x) && C.push("translate(" + y + r + x + u);
    }
    function c(w, d, y, x) {
        w !== d ? (w - d > 180 ? d += 360 : d - w > 180 && (w += 360), x.push({
            i: y.push(s(y) + "rotate(", null, f) - 2,
            x: $3cfd30e35d79a5df$var$fe(w, d)
        })) : d && y.push(s(y) + "rotate(" + d + f);
    }
    function g(w, d, y, x) {
        w !== d ? x.push({
            i: y.push(s(y) + "skewX(", null, f) - 2,
            x: $3cfd30e35d79a5df$var$fe(w, d)
        }) : d && y.push(s(y) + "skewX(" + d + f);
    }
    function v(w, d, y, x, C, P) {
        if (w !== y || d !== x) {
            var z = C.push(s(C) + "scale(", null, ",", null, ")");
            P.push({
                i: z - 4,
                x: $3cfd30e35d79a5df$var$fe(w, y)
            }, {
                i: z - 2,
                x: $3cfd30e35d79a5df$var$fe(d, x)
            });
        } else (y !== 1 || x !== 1) && C.push(s(C) + "scale(" + y + "," + x + ")");
    }
    return function(w, d) {
        var y = [], x = [];
        return w = e(w), d = e(d), h(w.translateX, w.translateY, d.translateX, d.translateY, y, x), c(w.rotate, d.rotate, y, x), g(w.skewX, d.skewX, y, x), v(w.scaleX, w.scaleY, d.scaleX, d.scaleY, y, x), w = d = null, function(C) {
            for(var P = -1, z = x.length, $; ++P < z;)y[($ = x[P]).i] = $.x(C);
            return y.join("");
        };
    };
}
var $3cfd30e35d79a5df$var$cy = $3cfd30e35d79a5df$var$wc($3cfd30e35d79a5df$var$ay, "px, ", "px)", "deg)"), $3cfd30e35d79a5df$var$hy = $3cfd30e35d79a5df$var$wc($3cfd30e35d79a5df$var$ly, ", ", ")", ")"), $3cfd30e35d79a5df$var$py = 1e-12;
function $3cfd30e35d79a5df$var$bl(e) {
    return ((e = Math.exp(e)) + 1 / e) / 2;
}
function $3cfd30e35d79a5df$var$gy(e) {
    return ((e = Math.exp(e)) - 1 / e) / 2;
}
function $3cfd30e35d79a5df$var$dy(e) {
    return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const $3cfd30e35d79a5df$var$_y = function e(r, u, f) {
    function s(h, c) {
        var g = h[0], v = h[1], w = h[2], d = c[0], y = c[1], x = c[2], C = d - g, P = y - v, z = C * C + P * P, $, O;
        if (z < $3cfd30e35d79a5df$var$py) O = Math.log(x / w) / r, $ = function(V) {
            return [
                g + V * C,
                v + V * P,
                w * Math.exp(r * V * O)
            ];
        };
        else {
            var U = Math.sqrt(z), k = (x * x - w * w + f * z) / (2 * w * u * U), B = (x * x - w * w - f * z) / (2 * x * u * U), q = Math.log(Math.sqrt(k * k + 1) - k), X = Math.log(Math.sqrt(B * B + 1) - B);
            O = (X - q) / r, $ = function(V) {
                var rn = V * O, on = $3cfd30e35d79a5df$var$bl(q), pn = w / (u * U) * (on * $3cfd30e35d79a5df$var$dy(r * rn + q) - $3cfd30e35d79a5df$var$gy(q));
                return [
                    g + pn * C,
                    v + pn * P,
                    w * on / $3cfd30e35d79a5df$var$bl(r * rn + q)
                ];
            };
        }
        return $.duration = O * 1e3 * r / Math.SQRT2, $;
    }
    return s.rho = function(h) {
        var c = Math.max(1e-3, +h), g = c * c, v = g * g;
        return e(c, g, v);
    }, s;
}(Math.SQRT2, 2, 4);
function $3cfd30e35d79a5df$var$vy(e, r) {
    var u, f;
    return function() {
        var s = $3cfd30e35d79a5df$var$Ft(this, e), h = s.tween;
        if (h !== u) {
            f = u = h;
            for(var c = 0, g = f.length; c < g; ++c)if (f[c].name === r) {
                f = f.slice(), f.splice(c, 1);
                break;
            }
        }
        s.tween = f;
    };
}
function $3cfd30e35d79a5df$var$wy(e, r, u) {
    var f, s;
    if (typeof u != "function") throw new Error();
    return function() {
        var h = $3cfd30e35d79a5df$var$Ft(this, e), c = h.tween;
        if (c !== f) {
            s = (f = c).slice();
            for(var g = {
                name: r,
                value: u
            }, v = 0, w = s.length; v < w; ++v)if (s[v].name === r) {
                s[v] = g;
                break;
            }
            v === w && s.push(g);
        }
        h.tween = s;
    };
}
function $3cfd30e35d79a5df$var$my(e, r) {
    var u = this._id;
    if (e += "", arguments.length < 2) {
        for(var f = $3cfd30e35d79a5df$var$Mt(this.node(), u).tween, s = 0, h = f.length, c; s < h; ++s)if ((c = f[s]).name === e) return c.value;
        return null;
    }
    return this.each((r == null ? $3cfd30e35d79a5df$var$vy : $3cfd30e35d79a5df$var$wy)(u, e, r));
}
function $3cfd30e35d79a5df$var$vf(e, r, u) {
    var f = e._id;
    return e.each(function() {
        var s = $3cfd30e35d79a5df$var$Ft(this, f);
        (s.value || (s.value = {}))[r] = u.apply(this, arguments);
    }), function(s) {
        return $3cfd30e35d79a5df$var$Mt(s, f).value[r];
    };
}
function $3cfd30e35d79a5df$var$mc(e, r) {
    var u;
    return (typeof r == "number" ? $3cfd30e35d79a5df$var$fe : r instanceof $3cfd30e35d79a5df$var$Pr ? $3cfd30e35d79a5df$var$Ml : (u = $3cfd30e35d79a5df$var$Pr(r)) ? (r = u, $3cfd30e35d79a5df$var$Ml) : $3cfd30e35d79a5df$var$sy)(e, r);
}
function $3cfd30e35d79a5df$var$yy(e) {
    return function() {
        this.removeAttribute(e);
    };
}
function $3cfd30e35d79a5df$var$xy(e) {
    return function() {
        this.removeAttributeNS(e.space, e.local);
    };
}
function $3cfd30e35d79a5df$var$Sy(e, r, u) {
    var f, s = u + "", h;
    return function() {
        var c = this.getAttribute(e);
        return c === s ? null : c === f ? h : h = r(f = c, u);
    };
}
function $3cfd30e35d79a5df$var$Ey(e, r, u) {
    var f, s = u + "", h;
    return function() {
        var c = this.getAttributeNS(e.space, e.local);
        return c === s ? null : c === f ? h : h = r(f = c, u);
    };
}
function $3cfd30e35d79a5df$var$Ay(e, r, u) {
    var f, s, h;
    return function() {
        var c, g = u(this), v;
        return g == null ? void this.removeAttribute(e) : (c = this.getAttribute(e), v = g + "", c === v ? null : c === f && v === s ? h : (s = v, h = r(f = c, g)));
    };
}
function $3cfd30e35d79a5df$var$Cy(e, r, u) {
    var f, s, h;
    return function() {
        var c, g = u(this), v;
        return g == null ? void this.removeAttributeNS(e.space, e.local) : (c = this.getAttributeNS(e.space, e.local), v = g + "", c === v ? null : c === f && v === s ? h : (s = v, h = r(f = c, g)));
    };
}
function $3cfd30e35d79a5df$var$Ry(e, r) {
    var u = $3cfd30e35d79a5df$var$iu(e), f = u === "transform" ? $3cfd30e35d79a5df$var$hy : $3cfd30e35d79a5df$var$mc;
    return this.attrTween(e, typeof r == "function" ? (u.local ? $3cfd30e35d79a5df$var$Cy : $3cfd30e35d79a5df$var$Ay)(u, f, $3cfd30e35d79a5df$var$vf(this, "attr." + e, r)) : r == null ? (u.local ? $3cfd30e35d79a5df$var$xy : $3cfd30e35d79a5df$var$yy)(u) : (u.local ? $3cfd30e35d79a5df$var$Ey : $3cfd30e35d79a5df$var$Sy)(u, f, r));
}
function $3cfd30e35d79a5df$var$Ty(e, r) {
    return function(u) {
        this.setAttribute(e, r.call(this, u));
    };
}
function $3cfd30e35d79a5df$var$Iy(e, r) {
    return function(u) {
        this.setAttributeNS(e.space, e.local, r.call(this, u));
    };
}
function $3cfd30e35d79a5df$var$My(e, r) {
    var u, f;
    function s() {
        var h = r.apply(this, arguments);
        return h !== f && (u = (f = h) && $3cfd30e35d79a5df$var$Iy(e, h)), u;
    }
    return s._value = r, s;
}
function $3cfd30e35d79a5df$var$Ly(e, r) {
    var u, f;
    function s() {
        var h = r.apply(this, arguments);
        return h !== f && (u = (f = h) && $3cfd30e35d79a5df$var$Ty(e, h)), u;
    }
    return s._value = r, s;
}
function $3cfd30e35d79a5df$var$by(e, r) {
    var u = "attr." + e;
    if (arguments.length < 2) return (u = this.tween(u)) && u._value;
    if (r == null) return this.tween(u, null);
    if (typeof r != "function") throw new Error();
    var f = $3cfd30e35d79a5df$var$iu(e);
    return this.tween(u, (f.local ? $3cfd30e35d79a5df$var$My : $3cfd30e35d79a5df$var$Ly)(f, r));
}
function $3cfd30e35d79a5df$var$Py(e, r) {
    return function() {
        $3cfd30e35d79a5df$var$df(this, e).delay = +r.apply(this, arguments);
    };
}
function $3cfd30e35d79a5df$var$Ny(e, r) {
    return r = +r, function() {
        $3cfd30e35d79a5df$var$df(this, e).delay = r;
    };
}
function $3cfd30e35d79a5df$var$Oy(e) {
    var r = this._id;
    return arguments.length ? this.each((typeof e == "function" ? $3cfd30e35d79a5df$var$Py : $3cfd30e35d79a5df$var$Ny)(r, e)) : $3cfd30e35d79a5df$var$Mt(this.node(), r).delay;
}
function $3cfd30e35d79a5df$var$$y(e, r) {
    return function() {
        $3cfd30e35d79a5df$var$Ft(this, e).duration = +r.apply(this, arguments);
    };
}
function $3cfd30e35d79a5df$var$Fy(e, r) {
    return r = +r, function() {
        $3cfd30e35d79a5df$var$Ft(this, e).duration = r;
    };
}
function $3cfd30e35d79a5df$var$Dy(e) {
    var r = this._id;
    return arguments.length ? this.each((typeof e == "function" ? $3cfd30e35d79a5df$var$$y : $3cfd30e35d79a5df$var$Fy)(r, e)) : $3cfd30e35d79a5df$var$Mt(this.node(), r).duration;
}
function $3cfd30e35d79a5df$var$zy(e, r) {
    if (typeof r != "function") throw new Error();
    return function() {
        $3cfd30e35d79a5df$var$Ft(this, e).ease = r;
    };
}
function $3cfd30e35d79a5df$var$By(e) {
    var r = this._id;
    return arguments.length ? this.each($3cfd30e35d79a5df$var$zy(r, e)) : $3cfd30e35d79a5df$var$Mt(this.node(), r).ease;
}
function $3cfd30e35d79a5df$var$Wy(e, r) {
    return function() {
        var u = r.apply(this, arguments);
        if (typeof u != "function") throw new Error();
        $3cfd30e35d79a5df$var$Ft(this, e).ease = u;
    };
}
function $3cfd30e35d79a5df$var$ky(e) {
    if (typeof e != "function") throw new Error();
    return this.each($3cfd30e35d79a5df$var$Wy(this._id, e));
}
function $3cfd30e35d79a5df$var$Uy(e) {
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$Fl(e));
    for(var r = this._groups, u = r.length, f = new Array(u), s = 0; s < u; ++s)for(var h = r[s], c = h.length, g = f[s] = [], v, w = 0; w < c; ++w)(v = h[w]) && e.call(v, v.__data__, w, h) && g.push(v);
    return new $3cfd30e35d79a5df$var$Qt(f, this._parents, this._name, this._id);
}
function $3cfd30e35d79a5df$var$Gy(e) {
    if (e._id !== this._id) throw new Error();
    for(var r = this._groups, u = e._groups, f = r.length, s = u.length, h = Math.min(f, s), c = new Array(f), g = 0; g < h; ++g)for(var v = r[g], w = u[g], d = v.length, y = c[g] = new Array(d), x, C = 0; C < d; ++C)(x = v[C] || w[C]) && (y[C] = x);
    for(; g < f; ++g)c[g] = r[g];
    return new $3cfd30e35d79a5df$var$Qt(c, this._parents, this._name, this._id);
}
function $3cfd30e35d79a5df$var$qy(e) {
    return (e + "").trim().split(/^|\s+/).every(function(r) {
        var u = r.indexOf(".");
        return u >= 0 && (r = r.slice(0, u)), !r || r === "start";
    });
}
function $3cfd30e35d79a5df$var$Hy(e, r, u) {
    var f, s, h = $3cfd30e35d79a5df$var$qy(r) ? $3cfd30e35d79a5df$var$df : $3cfd30e35d79a5df$var$Ft;
    return function() {
        var c = h(this, e), g = c.on;
        g !== f && (s = (f = g).copy()).on(r, u), c.on = s;
    };
}
function $3cfd30e35d79a5df$var$Xy(e, r) {
    var u = this._id;
    return arguments.length < 2 ? $3cfd30e35d79a5df$var$Mt(this.node(), u).on.on(e) : this.each($3cfd30e35d79a5df$var$Hy(u, e, r));
}
function $3cfd30e35d79a5df$var$Yy(e) {
    return function() {
        var r = this.parentNode;
        for(var u in this.__transition)if (+u !== e) return;
        r && r.removeChild(this);
    };
}
function $3cfd30e35d79a5df$var$Ky() {
    return this.on("end.remove", $3cfd30e35d79a5df$var$Yy(this._id));
}
function $3cfd30e35d79a5df$var$Zy(e) {
    var r = this._name, u = this._id;
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$ff(e));
    for(var f = this._groups, s = f.length, h = new Array(s), c = 0; c < s; ++c)for(var g = f[c], v = g.length, w = h[c] = new Array(v), d, y, x = 0; x < v; ++x)(d = g[x]) && (y = e.call(d, d.__data__, x, g)) && ("__data__" in d && (y.__data__ = d.__data__), w[x] = y, $3cfd30e35d79a5df$var$ou(w[x], r, u, x, w, $3cfd30e35d79a5df$var$Mt(d, u)));
    return new $3cfd30e35d79a5df$var$Qt(h, this._parents, r, u);
}
function $3cfd30e35d79a5df$var$Jy(e) {
    var r = this._name, u = this._id;
    typeof e != "function" && (e = $3cfd30e35d79a5df$var$$l(e));
    for(var f = this._groups, s = f.length, h = [], c = [], g = 0; g < s; ++g)for(var v = f[g], w = v.length, d, y = 0; y < w; ++y)if (d = v[y]) {
        for(var x = e.call(d, d.__data__, y, v), C, P = $3cfd30e35d79a5df$var$Mt(d, u), z = 0, $ = x.length; z < $; ++z)(C = x[z]) && $3cfd30e35d79a5df$var$ou(C, r, u, z, x, P);
        h.push(x), c.push(d);
    }
    return new $3cfd30e35d79a5df$var$Qt(h, c, r, u);
}
var $3cfd30e35d79a5df$var$Qy = $3cfd30e35d79a5df$var$Ke.prototype.constructor;
function $3cfd30e35d79a5df$var$Vy() {
    return new $3cfd30e35d79a5df$var$Qy(this._groups, this._parents);
}
function $3cfd30e35d79a5df$var$jy(e, r) {
    var u, f, s;
    return function() {
        var h = $3cfd30e35d79a5df$var$qe(this, e), c = (this.style.removeProperty(e), $3cfd30e35d79a5df$var$qe(this, e));
        return h === c ? null : h === u && c === f ? s : s = r(u = h, f = c);
    };
}
function $3cfd30e35d79a5df$var$yc(e) {
    return function() {
        this.style.removeProperty(e);
    };
}
function $3cfd30e35d79a5df$var$nx(e, r, u) {
    var f, s = u + "", h;
    return function() {
        var c = $3cfd30e35d79a5df$var$qe(this, e);
        return c === s ? null : c === f ? h : h = r(f = c, u);
    };
}
function $3cfd30e35d79a5df$var$tx(e, r, u) {
    var f, s, h;
    return function() {
        var c = $3cfd30e35d79a5df$var$qe(this, e), g = u(this), v = g + "";
        return g == null && (v = g = (this.style.removeProperty(e), $3cfd30e35d79a5df$var$qe(this, e))), c === v ? null : c === f && v === s ? h : (s = v, h = r(f = c, g));
    };
}
function $3cfd30e35d79a5df$var$ex(e, r) {
    var u, f, s, h = "style." + r, c = "end." + h, g;
    return function() {
        var v = $3cfd30e35d79a5df$var$Ft(this, e), w = v.on, d = v.value[h] == null ? g || (g = $3cfd30e35d79a5df$var$yc(r)) : void 0;
        (w !== u || s !== d) && (f = (u = w).copy()).on(c, s = d), v.on = f;
    };
}
function $3cfd30e35d79a5df$var$rx(e, r, u) {
    var f = (e += "") == "transform" ? $3cfd30e35d79a5df$var$cy : $3cfd30e35d79a5df$var$mc;
    return r == null ? this.styleTween(e, $3cfd30e35d79a5df$var$jy(e, f)).on("end.style." + e, $3cfd30e35d79a5df$var$yc(e)) : typeof r == "function" ? this.styleTween(e, $3cfd30e35d79a5df$var$tx(e, f, $3cfd30e35d79a5df$var$vf(this, "style." + e, r))).each($3cfd30e35d79a5df$var$ex(this._id, e)) : this.styleTween(e, $3cfd30e35d79a5df$var$nx(e, f, r), u).on("end.style." + e, null);
}
function $3cfd30e35d79a5df$var$ix(e, r, u) {
    return function(f) {
        this.style.setProperty(e, r.call(this, f), u);
    };
}
function $3cfd30e35d79a5df$var$ux(e, r, u) {
    var f, s;
    function h() {
        var c = r.apply(this, arguments);
        return c !== s && (f = (s = c) && $3cfd30e35d79a5df$var$ix(e, c, u)), f;
    }
    return h._value = r, h;
}
function $3cfd30e35d79a5df$var$ox(e, r, u) {
    var f = "style." + (e += "");
    if (arguments.length < 2) return (f = this.tween(f)) && f._value;
    if (r == null) return this.tween(f, null);
    if (typeof r != "function") throw new Error();
    return this.tween(f, $3cfd30e35d79a5df$var$ux(e, r, u ?? ""));
}
function $3cfd30e35d79a5df$var$fx(e) {
    return function() {
        this.textContent = e;
    };
}
function $3cfd30e35d79a5df$var$sx(e) {
    return function() {
        var r = e(this);
        this.textContent = r ?? "";
    };
}
function $3cfd30e35d79a5df$var$ax(e) {
    return this.tween("text", typeof e == "function" ? $3cfd30e35d79a5df$var$sx($3cfd30e35d79a5df$var$vf(this, "text", e)) : $3cfd30e35d79a5df$var$fx(e == null ? "" : e + ""));
}
function $3cfd30e35d79a5df$var$lx(e) {
    return function(r) {
        this.textContent = e.call(this, r);
    };
}
function $3cfd30e35d79a5df$var$cx(e) {
    var r, u;
    function f() {
        var s = e.apply(this, arguments);
        return s !== u && (r = (u = s) && $3cfd30e35d79a5df$var$lx(s)), r;
    }
    return f._value = e, f;
}
function $3cfd30e35d79a5df$var$hx(e) {
    var r = "text";
    if (arguments.length < 1) return (r = this.tween(r)) && r._value;
    if (e == null) return this.tween(r, null);
    if (typeof e != "function") throw new Error();
    return this.tween(r, $3cfd30e35d79a5df$var$cx(e));
}
function $3cfd30e35d79a5df$var$px() {
    for(var e = this._name, r = this._id, u = $3cfd30e35d79a5df$var$xc(), f = this._groups, s = f.length, h = 0; h < s; ++h)for(var c = f[h], g = c.length, v, w = 0; w < g; ++w)if (v = c[w]) {
        var d = $3cfd30e35d79a5df$var$Mt(v, r);
        $3cfd30e35d79a5df$var$ou(v, e, u, w, c, {
            time: d.time + d.delay + d.duration,
            delay: 0,
            duration: d.duration,
            ease: d.ease
        });
    }
    return new $3cfd30e35d79a5df$var$Qt(f, this._parents, e, u);
}
function $3cfd30e35d79a5df$var$gx() {
    var e, r, u = this, f = u._id, s = u.size();
    return new Promise(function(h, c) {
        var g = {
            value: c
        }, v = {
            value: function() {
                --s === 0 && h();
            }
        };
        u.each(function() {
            var w = $3cfd30e35d79a5df$var$Ft(this, f), d = w.on;
            d !== e && (r = (e = d).copy(), r._.cancel.push(g), r._.interrupt.push(g), r._.end.push(v)), w.on = r;
        }), s === 0 && h();
    });
}
var $3cfd30e35d79a5df$var$dx = 0;
function $3cfd30e35d79a5df$var$Qt(e, r, u, f) {
    this._groups = e, this._parents = r, this._name = u, this._id = f;
}
function $3cfd30e35d79a5df$var$wf(e) {
    return $3cfd30e35d79a5df$var$Ke().transition(e);
}
function $3cfd30e35d79a5df$var$xc() {
    return ++$3cfd30e35d79a5df$var$dx;
}
var $3cfd30e35d79a5df$var$Kt = $3cfd30e35d79a5df$var$Ke.prototype;
$3cfd30e35d79a5df$var$Qt.prototype = $3cfd30e35d79a5df$var$wf.prototype = {
    constructor: $3cfd30e35d79a5df$var$Qt,
    select: $3cfd30e35d79a5df$var$Zy,
    selectAll: $3cfd30e35d79a5df$var$Jy,
    selectChild: $3cfd30e35d79a5df$var$Kt.selectChild,
    selectChildren: $3cfd30e35d79a5df$var$Kt.selectChildren,
    filter: $3cfd30e35d79a5df$var$Uy,
    merge: $3cfd30e35d79a5df$var$Gy,
    selection: $3cfd30e35d79a5df$var$Vy,
    transition: $3cfd30e35d79a5df$var$px,
    call: $3cfd30e35d79a5df$var$Kt.call,
    nodes: $3cfd30e35d79a5df$var$Kt.nodes,
    node: $3cfd30e35d79a5df$var$Kt.node,
    size: $3cfd30e35d79a5df$var$Kt.size,
    empty: $3cfd30e35d79a5df$var$Kt.empty,
    each: $3cfd30e35d79a5df$var$Kt.each,
    on: $3cfd30e35d79a5df$var$Xy,
    attr: $3cfd30e35d79a5df$var$Ry,
    attrTween: $3cfd30e35d79a5df$var$by,
    style: $3cfd30e35d79a5df$var$rx,
    styleTween: $3cfd30e35d79a5df$var$ox,
    text: $3cfd30e35d79a5df$var$ax,
    textTween: $3cfd30e35d79a5df$var$hx,
    remove: $3cfd30e35d79a5df$var$Ky,
    tween: $3cfd30e35d79a5df$var$my,
    delay: $3cfd30e35d79a5df$var$Oy,
    duration: $3cfd30e35d79a5df$var$Dy,
    ease: $3cfd30e35d79a5df$var$By,
    easeVarying: $3cfd30e35d79a5df$var$ky,
    end: $3cfd30e35d79a5df$var$gx,
    [Symbol.iterator]: $3cfd30e35d79a5df$var$Kt[Symbol.iterator]
};
function $3cfd30e35d79a5df$var$_x(e) {
    return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var $3cfd30e35d79a5df$var$vx = {
    time: null,
    // Set on use.
    delay: 0,
    duration: 250,
    ease: $3cfd30e35d79a5df$var$_x
};
function $3cfd30e35d79a5df$var$wx(e, r) {
    for(var u; !(u = e.__transition) || !(u = u[r]);)if (!(e = e.parentNode)) throw new Error(`transition ${r} not found`);
    return u;
}
function $3cfd30e35d79a5df$var$mx(e) {
    var r, u;
    e instanceof $3cfd30e35d79a5df$var$Qt ? (r = e._id, e = e._name) : (r = $3cfd30e35d79a5df$var$xc(), (u = $3cfd30e35d79a5df$var$vx).time = $3cfd30e35d79a5df$var$gf(), e = e == null ? null : e + "");
    for(var f = this._groups, s = f.length, h = 0; h < s; ++h)for(var c = f[h], g = c.length, v, w = 0; w < g; ++w)(v = c[w]) && $3cfd30e35d79a5df$var$ou(v, e, r, w, c, u || $3cfd30e35d79a5df$var$wx(v, r));
    return new $3cfd30e35d79a5df$var$Qt(f, this._parents, e, r);
}
$3cfd30e35d79a5df$var$Ke.prototype.interrupt = $3cfd30e35d79a5df$var$qm;
$3cfd30e35d79a5df$var$Ke.prototype.transition = $3cfd30e35d79a5df$var$mx;
const $3cfd30e35d79a5df$var$uf = {
    capture: !0,
    passive: !1
};
function $3cfd30e35d79a5df$var$of(e) {
    e.preventDefault(), e.stopImmediatePropagation();
}
function $3cfd30e35d79a5df$var$yx(e) {
    var r = e.document.documentElement, u = $3cfd30e35d79a5df$var$Un(e).on("dragstart.drag", $3cfd30e35d79a5df$var$of, $3cfd30e35d79a5df$var$uf);
    "onselectstart" in r ? u.on("selectstart.drag", $3cfd30e35d79a5df$var$of, $3cfd30e35d79a5df$var$uf) : (r.__noselect = r.style.MozUserSelect, r.style.MozUserSelect = "none");
}
function $3cfd30e35d79a5df$var$xx(e, r) {
    var u = e.document.documentElement, f = $3cfd30e35d79a5df$var$Un(e).on("dragstart.drag", null);
    r && (f.on("click.drag", $3cfd30e35d79a5df$var$of, $3cfd30e35d79a5df$var$uf), setTimeout(function() {
        f.on("click.drag", null);
    }, 0)), "onselectstart" in u ? f.on("selectstart.drag", null) : (u.style.MozUserSelect = u.__noselect, delete u.__noselect);
}
const $3cfd30e35d79a5df$var$Oi = (e)=>()=>e;
function $3cfd30e35d79a5df$var$Sx(e, { sourceEvent: r, target: u, transform: f, dispatch: s }) {
    Object.defineProperties(this, {
        type: {
            value: e,
            enumerable: !0,
            configurable: !0
        },
        sourceEvent: {
            value: r,
            enumerable: !0,
            configurable: !0
        },
        target: {
            value: u,
            enumerable: !0,
            configurable: !0
        },
        transform: {
            value: f,
            enumerable: !0,
            configurable: !0
        },
        _: {
            value: s
        }
    });
}
function $3cfd30e35d79a5df$var$Jt(e, r, u) {
    this.k = e, this.x = r, this.y = u;
}
$3cfd30e35d79a5df$var$Jt.prototype = {
    constructor: $3cfd30e35d79a5df$var$Jt,
    scale: function(e) {
        return e === 1 ? this : new $3cfd30e35d79a5df$var$Jt(this.k * e, this.x, this.y);
    },
    translate: function(e, r) {
        return e === 0 & r === 0 ? this : new $3cfd30e35d79a5df$var$Jt(this.k, this.x + this.k * e, this.y + this.k * r);
    },
    apply: function(e) {
        return [
            e[0] * this.k + this.x,
            e[1] * this.k + this.y
        ];
    },
    applyX: function(e) {
        return e * this.k + this.x;
    },
    applyY: function(e) {
        return e * this.k + this.y;
    },
    invert: function(e) {
        return [
            (e[0] - this.x) / this.k,
            (e[1] - this.y) / this.k
        ];
    },
    invertX: function(e) {
        return (e - this.x) / this.k;
    },
    invertY: function(e) {
        return (e - this.y) / this.k;
    },
    rescaleX: function(e) {
        return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
    },
    rescaleY: function(e) {
        return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $3cfd30e35d79a5df$var$Ue = new $3cfd30e35d79a5df$var$Jt(1, 0, 0);
$3cfd30e35d79a5df$var$Jt.prototype;
function $3cfd30e35d79a5df$var$$o(e) {
    e.stopImmediatePropagation();
}
function $3cfd30e35d79a5df$var$vr(e) {
    e.preventDefault(), e.stopImmediatePropagation();
}
function $3cfd30e35d79a5df$var$Ex(e) {
    return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function $3cfd30e35d79a5df$var$Ax() {
    var e = this;
    return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [
        [
            e.x,
            e.y
        ],
        [
            e.x + e.width,
            e.y + e.height
        ]
    ]) : [
        [
            0,
            0
        ],
        [
            e.width.baseVal.value,
            e.height.baseVal.value
        ]
    ]) : [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $3cfd30e35d79a5df$var$Pl() {
    return this.__zoom || $3cfd30e35d79a5df$var$Ue;
}
function $3cfd30e35d79a5df$var$Cx(e) {
    return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * (e.ctrlKey ? 10 : 1);
}
function $3cfd30e35d79a5df$var$Rx() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $3cfd30e35d79a5df$var$Tx(e, r, u) {
    var f = e.invertX(r[0][0]) - u[0][0], s = e.invertX(r[1][0]) - u[1][0], h = e.invertY(r[0][1]) - u[0][1], c = e.invertY(r[1][1]) - u[1][1];
    return e.translate(s > f ? (f + s) / 2 : Math.min(0, f) || Math.max(0, s), c > h ? (h + c) / 2 : Math.min(0, h) || Math.max(0, c));
}
function $3cfd30e35d79a5df$var$Ix() {
    var e = $3cfd30e35d79a5df$var$Ex, r = $3cfd30e35d79a5df$var$Ax, u = $3cfd30e35d79a5df$var$Tx, f = $3cfd30e35d79a5df$var$Cx, s = $3cfd30e35d79a5df$var$Rx, h = [
        0,
        1 / 0
    ], c = [
        [
            -1 / 0,
            -1 / 0
        ],
        [
            1 / 0,
            1 / 0
        ]
    ], g = 250, v = $3cfd30e35d79a5df$var$_y, w = $3cfd30e35d79a5df$var$pf("start", "zoom", "end"), d, y, x, C = 500, P = 150, z = 0, $ = 10;
    function O(A) {
        A.property("__zoom", $3cfd30e35d79a5df$var$Pl).on("wheel.zoom", rn, {
            passive: !1
        }).on("mousedown.zoom", on).on("dblclick.zoom", pn).filter(s).on("touchstart.zoom", j).on("touchmove.zoom", zn).on("touchend.zoom touchcancel.zoom", xn).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    O.transform = function(A, R, I, F) {
        var G = A.selection ? A.selection() : A;
        G.property("__zoom", $3cfd30e35d79a5df$var$Pl), A !== G ? q(A, R, I, F) : G.interrupt().each(function() {
            X(this, arguments).event(F).start().zoom(null, typeof R == "function" ? R.apply(this, arguments) : R).end();
        });
    }, O.scaleBy = function(A, R, I, F) {
        O.scaleTo(A, function() {
            var G = this.__zoom.k, Y = typeof R == "function" ? R.apply(this, arguments) : R;
            return G * Y;
        }, I, F);
    }, O.scaleTo = function(A, R, I, F) {
        O.transform(A, function() {
            var G = r.apply(this, arguments), Y = this.__zoom, nn = I == null ? B(G) : typeof I == "function" ? I.apply(this, arguments) : I, Q = Y.invert(nn), gn = typeof R == "function" ? R.apply(this, arguments) : R;
            return u(k(U(Y, gn), nn, Q), G, c);
        }, I, F);
    }, O.translateBy = function(A, R, I, F) {
        O.transform(A, function() {
            return u(this.__zoom.translate(typeof R == "function" ? R.apply(this, arguments) : R, typeof I == "function" ? I.apply(this, arguments) : I), r.apply(this, arguments), c);
        }, null, F);
    }, O.translateTo = function(A, R, I, F, G) {
        O.transform(A, function() {
            var Y = r.apply(this, arguments), nn = this.__zoom, Q = F == null ? B(Y) : typeof F == "function" ? F.apply(this, arguments) : F;
            return u($3cfd30e35d79a5df$var$Ue.translate(Q[0], Q[1]).scale(nn.k).translate(typeof R == "function" ? -R.apply(this, arguments) : -R, typeof I == "function" ? -I.apply(this, arguments) : -I), Y, c);
        }, F, G);
    };
    function U(A, R) {
        return R = Math.max(h[0], Math.min(h[1], R)), R === A.k ? A : new $3cfd30e35d79a5df$var$Jt(R, A.x, A.y);
    }
    function k(A, R, I) {
        var F = R[0] - I[0] * A.k, G = R[1] - I[1] * A.k;
        return F === A.x && G === A.y ? A : new $3cfd30e35d79a5df$var$Jt(A.k, F, G);
    }
    function B(A) {
        return [
            (+A[0][0] + +A[1][0]) / 2,
            (+A[0][1] + +A[1][1]) / 2
        ];
    }
    function q(A, R, I, F) {
        A.on("start.zoom", function() {
            X(this, arguments).event(F).start();
        }).on("interrupt.zoom end.zoom", function() {
            X(this, arguments).event(F).end();
        }).tween("zoom", function() {
            var G = this, Y = arguments, nn = X(G, Y).event(F), Q = r.apply(G, Y), gn = I == null ? B(Q) : typeof I == "function" ? I.apply(G, Y) : I, In = Math.max(Q[1][0] - Q[0][0], Q[1][1] - Q[0][1]), An = G.__zoom, Sn = typeof R == "function" ? R.apply(G, Y) : R, Jn = v(An.invert(gn).concat(In / An.k), Sn.invert(gn).concat(In / Sn.k));
            return function(rt) {
                if (rt === 1) rt = Sn;
                else {
                    var Hn = Jn(rt), Dt = In / Hn[2];
                    rt = new $3cfd30e35d79a5df$var$Jt(Dt, gn[0] - Hn[0] * Dt, gn[1] - Hn[1] * Dt);
                }
                nn.zoom(null, rt);
            };
        });
    }
    function X(A, R, I) {
        return !I && A.__zooming || new V(A, R);
    }
    function V(A, R) {
        this.that = A, this.args = R, this.active = 0, this.sourceEvent = null, this.extent = r.apply(A, R), this.taps = 0;
    }
    V.prototype = {
        event: function(A) {
            return A && (this.sourceEvent = A), this;
        },
        start: function() {
            return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
        },
        zoom: function(A, R) {
            return this.mouse && A !== "mouse" && (this.mouse[1] = R.invert(this.mouse[0])), this.touch0 && A !== "touch" && (this.touch0[1] = R.invert(this.touch0[0])), this.touch1 && A !== "touch" && (this.touch1[1] = R.invert(this.touch1[0])), this.that.__zoom = R, this.emit("zoom"), this;
        },
        end: function() {
            return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
        },
        emit: function(A) {
            var R = $3cfd30e35d79a5df$var$Un(this.that).datum();
            w.call(A, this.that, new $3cfd30e35d79a5df$var$Sx(A, {
                sourceEvent: this.sourceEvent,
                target: O,
                type: A,
                transform: this.that.__zoom,
                dispatch: w
            }), R);
        }
    };
    function rn(A, ...R) {
        if (!e.apply(this, arguments)) return;
        var I = X(this, R).event(A), F = this.__zoom, G = Math.max(h[0], Math.min(h[1], F.k * Math.pow(2, f.apply(this, arguments)))), Y = $3cfd30e35d79a5df$var$ve(A);
        if (I.wheel) (I.mouse[0][0] !== Y[0] || I.mouse[0][1] !== Y[1]) && (I.mouse[1] = F.invert(I.mouse[0] = Y)), clearTimeout(I.wheel);
        else {
            if (F.k === G) return;
            I.mouse = [
                Y,
                F.invert(Y)
            ], $3cfd30e35d79a5df$var$Bi(this), I.start();
        }
        $3cfd30e35d79a5df$var$vr(A), I.wheel = setTimeout(nn, P), I.zoom("mouse", u(k(U(F, G), I.mouse[0], I.mouse[1]), I.extent, c));
        function nn() {
            I.wheel = null, I.end();
        }
    }
    function on(A, ...R) {
        if (x || !e.apply(this, arguments)) return;
        var I = A.currentTarget, F = X(this, R, !0).event(A), G = $3cfd30e35d79a5df$var$Un(A.view).on("mousemove.zoom", gn, !0).on("mouseup.zoom", In, !0), Y = $3cfd30e35d79a5df$var$ve(A, I), nn = A.clientX, Q = A.clientY;
        $3cfd30e35d79a5df$var$yx(A.view), $3cfd30e35d79a5df$var$$o(A), F.mouse = [
            Y,
            this.__zoom.invert(Y)
        ], $3cfd30e35d79a5df$var$Bi(this), F.start();
        function gn(An) {
            if ($3cfd30e35d79a5df$var$vr(An), !F.moved) {
                var Sn = An.clientX - nn, Jn = An.clientY - Q;
                F.moved = Sn * Sn + Jn * Jn > z;
            }
            F.event(An).zoom("mouse", u(k(F.that.__zoom, F.mouse[0] = $3cfd30e35d79a5df$var$ve(An, I), F.mouse[1]), F.extent, c));
        }
        function In(An) {
            G.on("mousemove.zoom mouseup.zoom", null), $3cfd30e35d79a5df$var$xx(An.view, F.moved), $3cfd30e35d79a5df$var$vr(An), F.event(An).end();
        }
    }
    function pn(A, ...R) {
        if (e.apply(this, arguments)) {
            var I = this.__zoom, F = $3cfd30e35d79a5df$var$ve(A.changedTouches ? A.changedTouches[0] : A, this), G = I.invert(F), Y = I.k * (A.shiftKey ? 0.5 : 2), nn = u(k(U(I, Y), F, G), r.apply(this, R), c);
            $3cfd30e35d79a5df$var$vr(A), g > 0 ? $3cfd30e35d79a5df$var$Un(this).transition().duration(g).call(q, nn, F, A) : $3cfd30e35d79a5df$var$Un(this).call(O.transform, nn, F, A);
        }
    }
    function j(A, ...R) {
        if (e.apply(this, arguments)) {
            var I = A.touches, F = I.length, G = X(this, R, A.changedTouches.length === F).event(A), Y, nn, Q, gn;
            for($3cfd30e35d79a5df$var$$o(A), nn = 0; nn < F; ++nn)Q = I[nn], gn = $3cfd30e35d79a5df$var$ve(Q, this), gn = [
                gn,
                this.__zoom.invert(gn),
                Q.identifier
            ], G.touch0 ? !G.touch1 && G.touch0[2] !== gn[2] && (G.touch1 = gn, G.taps = 0) : (G.touch0 = gn, Y = !0, G.taps = 1 + !!d);
            d && (d = clearTimeout(d)), Y && (G.taps < 2 && (y = gn[0], d = setTimeout(function() {
                d = null;
            }, C)), $3cfd30e35d79a5df$var$Bi(this), G.start());
        }
    }
    function zn(A, ...R) {
        if (this.__zooming) {
            var I = X(this, R).event(A), F = A.changedTouches, G = F.length, Y, nn, Q, gn;
            for($3cfd30e35d79a5df$var$vr(A), Y = 0; Y < G; ++Y)nn = F[Y], Q = $3cfd30e35d79a5df$var$ve(nn, this), I.touch0 && I.touch0[2] === nn.identifier ? I.touch0[0] = Q : I.touch1 && I.touch1[2] === nn.identifier && (I.touch1[0] = Q);
            if (nn = I.that.__zoom, I.touch1) {
                var In = I.touch0[0], An = I.touch0[1], Sn = I.touch1[0], Jn = I.touch1[1], rt = (rt = Sn[0] - In[0]) * rt + (rt = Sn[1] - In[1]) * rt, Hn = (Hn = Jn[0] - An[0]) * Hn + (Hn = Jn[1] - An[1]) * Hn;
                nn = U(nn, Math.sqrt(rt / Hn)), Q = [
                    (In[0] + Sn[0]) / 2,
                    (In[1] + Sn[1]) / 2
                ], gn = [
                    (An[0] + Jn[0]) / 2,
                    (An[1] + Jn[1]) / 2
                ];
            } else if (I.touch0) Q = I.touch0[0], gn = I.touch0[1];
            else return;
            I.zoom("touch", u(k(nn, Q, gn), I.extent, c));
        }
    }
    function xn(A, ...R) {
        if (this.__zooming) {
            var I = X(this, R).event(A), F = A.changedTouches, G = F.length, Y, nn;
            for($3cfd30e35d79a5df$var$$o(A), x && clearTimeout(x), x = setTimeout(function() {
                x = null;
            }, C), Y = 0; Y < G; ++Y)nn = F[Y], I.touch0 && I.touch0[2] === nn.identifier ? delete I.touch0 : I.touch1 && I.touch1[2] === nn.identifier && delete I.touch1;
            if (I.touch1 && !I.touch0 && (I.touch0 = I.touch1, delete I.touch1), I.touch0) I.touch0[1] = this.__zoom.invert(I.touch0[0]);
            else if (I.end(), I.taps === 2 && (nn = $3cfd30e35d79a5df$var$ve(nn, this), Math.hypot(y[0] - nn[0], y[1] - nn[1]) < $)) {
                var Q = $3cfd30e35d79a5df$var$Un(this).on("dblclick.zoom");
                Q && Q.apply(this, arguments);
            }
        }
    }
    return O.wheelDelta = function(A) {
        return arguments.length ? (f = typeof A == "function" ? A : $3cfd30e35d79a5df$var$Oi(+A), O) : f;
    }, O.filter = function(A) {
        return arguments.length ? (e = typeof A == "function" ? A : $3cfd30e35d79a5df$var$Oi(!!A), O) : e;
    }, O.touchable = function(A) {
        return arguments.length ? (s = typeof A == "function" ? A : $3cfd30e35d79a5df$var$Oi(!!A), O) : s;
    }, O.extent = function(A) {
        return arguments.length ? (r = typeof A == "function" ? A : $3cfd30e35d79a5df$var$Oi([
            [
                +A[0][0],
                +A[0][1]
            ],
            [
                +A[1][0],
                +A[1][1]
            ]
        ]), O) : r;
    }, O.scaleExtent = function(A) {
        return arguments.length ? (h[0] = +A[0], h[1] = +A[1], O) : [
            h[0],
            h[1]
        ];
    }, O.translateExtent = function(A) {
        return arguments.length ? (c[0][0] = +A[0][0], c[1][0] = +A[1][0], c[0][1] = +A[0][1], c[1][1] = +A[1][1], O) : [
            [
                c[0][0],
                c[0][1]
            ],
            [
                c[1][0],
                c[1][1]
            ]
        ];
    }, O.constrain = function(A) {
        return arguments.length ? (u = A, O) : u;
    }, O.duration = function(A) {
        return arguments.length ? (g = +A, O) : g;
    }, O.interpolate = function(A) {
        return arguments.length ? (v = A, O) : v;
    }, O.on = function() {
        var A = w.on.apply(w, arguments);
        return A === w ? O : A;
    }, O.clickDistance = function(A) {
        return arguments.length ? (z = (A = +A) * A, O) : Math.sqrt(z);
    }, O.tapDistance = function(A) {
        return arguments.length ? ($ = +A, O) : $;
    }, O;
}
function $3cfd30e35d79a5df$var$Mx(e) {
    if (!e.ok) throw new Error(e.status + " " + e.statusText);
    if (!(e.status === 204 || e.status === 205)) return e.json();
}
function $3cfd30e35d79a5df$var$Lx(e, r) {
    return fetch(e, r).then($3cfd30e35d79a5df$var$Mx);
}
const $3cfd30e35d79a5df$var$bx = {
    loadingStart: ()=>{},
    loaded: ()=>{},
    countryClick: ()=>{},
    countryMouseEnter: ()=>{},
    countryMouseLeave: ()=>{},
    markerClick: ()=>{},
    markerMouseEnter: ()=>{},
    markerMouseLeave: ()=>{},
    zoom: ()=>{}
}, $3cfd30e35d79a5df$var$Px = {
    type: "pin",
    color: "blue",
    width: 20,
    height: 20,
    radius: 2,
    strokeWidth: 0,
    strokeColor: "transparent",
    shadow: null
}, $3cfd30e35d79a5df$var$Nx = {
    mapPath: "./public/map.geo.json",
    selectedCountries: [],
    countryGroups: [],
    selectedGroup: null,
    isZoomable: !1,
    zoomedCountries: [],
    maxZoom: 20,
    zoomDefault: null,
    translateDefault: null,
    markers: [],
    markerStyle: $3cfd30e35d79a5df$var$Px,
    countryStrokeWidth: 0.25,
    accentFillColor: "red",
    accentStrokeColor: "#ffffff",
    countryFillColor: "#cccccc",
    countryStrokeColor: "#ffffff",
    groupFillColor: "green",
    width: 900,
    height: 600,
    pattern: null,
    patternGradient: null,
    on: $3cfd30e35d79a5df$var$bx
};
$3cfd30e35d79a5df$var$Un.prototype.transition = $3cfd30e35d79a5df$var$wf;
$3cfd30e35d79a5df$var$we.prototype.transition = $3cfd30e35d79a5df$var$wf;
var $3cfd30e35d79a5df$var$tu, $3cfd30e35d79a5df$var$Sc, $3cfd30e35d79a5df$var$eu, $3cfd30e35d79a5df$var$Ec, $3cfd30e35d79a5df$var$ru, $3cfd30e35d79a5df$var$Ac;
class $3cfd30e35d79a5df$export$2e2bcd8739ae039 {
    constructor(r, u){
        $3cfd30e35d79a5df$var$Ci(this, $3cfd30e35d79a5df$var$tu);
        $3cfd30e35d79a5df$var$Ci(this, $3cfd30e35d79a5df$var$eu);
        $3cfd30e35d79a5df$var$Ci(this, $3cfd30e35d79a5df$var$ru);
        $3cfd30e35d79a5df$var$Ln(this, "selector");
        $3cfd30e35d79a5df$var$Ln(this, "config");
        $3cfd30e35d79a5df$var$Ln(this, "isLoading");
        $3cfd30e35d79a5df$var$Ln(this, "zoomedCountries");
        $3cfd30e35d79a5df$var$Ln(this, "selectedCountries");
        $3cfd30e35d79a5df$var$Ln(this, "selectedGroup");
        $3cfd30e35d79a5df$var$Ln(this, "countryGroups");
        $3cfd30e35d79a5df$var$Ln(this, "markers");
        $3cfd30e35d79a5df$var$Ln(this, "mapInstancePromise");
        $3cfd30e35d79a5df$var$Ln(this, "svg");
        $3cfd30e35d79a5df$var$Ln(this, "scale");
        $3cfd30e35d79a5df$var$Ln(this, "translate");
        $3cfd30e35d79a5df$var$Ln(this, "projection");
        $3cfd30e35d79a5df$var$Ln(this, "g");
        $3cfd30e35d79a5df$var$Ln(this, "path");
        $3cfd30e35d79a5df$var$Ln(this, "zoom");
        $3cfd30e35d79a5df$var$Ln(this, "defs");
        $3cfd30e35d79a5df$var$Ln(this, "pattern");
        $3cfd30e35d79a5df$var$Ln(this, "patternGradient");
        $3cfd30e35d79a5df$var$Ln(this, "patternFilter");
        $3cfd30e35d79a5df$var$Ln(this, "markerShadow");
        var s, h, c, g;
        this.selector = r, this.config = $3cfd30e35d79a5df$var$hv.merge($3cfd30e35d79a5df$var$Nx, u), this.isLoading = !0, this.config.on.loadingStart(), this.mapInstancePromise = $3cfd30e35d79a5df$var$Lx(this.config.mapPath), this.zoomedCountries = this.config.zoomedCountries, this.selectedCountries = this.config.selectedCountries, this.selectedGroup = this.config.selectedGroup, this.countryGroups = this.config.countryGroups ? new Map(this.config.countryGroups.map((v)=>[
                v.id,
                v.countryList
            ])) : null, this.markers = this.config.markers, this.svg = $3cfd30e35d79a5df$var$Un(this.selector).append("svg").attr("width", "100%").attr("height", "100%").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `0 0 ${this.config.width} ${this.config.height}`).style("fill", this.config.countryFillColor).style("stroke", this.config.countryStrokeColor).style("stroke-width", `${this.config.countryStrokeWidth}px`), this.scale = this.config.width / (Math.PI * 2), this.translate = [
            this.config.width / 2,
            this.config.height / 1.4
        ], this.projection = $3cfd30e35d79a5df$var$Pm().fitSize([
            500,
            500
        ], {}).scale(this.scale).translate(this.translate), this.path = $3cfd30e35d79a5df$var$ym(this.projection), this.g = this.svg.append("g"), this.zoom = $3cfd30e35d79a5df$var$Ix().scaleExtent([
            1,
            this.config.maxZoom
        ]).translateExtent([
            [
                0,
                0
            ],
            [
                this.config.width,
                this.config.height
            ]
        ]).on("zoom", (v, w)=>{
            f(v, this), this.config.on.zoom({
                target: v.target,
                data: w,
                metaMap: this
            });
        });
        function f(v, w) {
            w.g.attr("transform", v.transform);
        }
        if (this.config.isZoomable && this.svg.call(this.zoom), this.config.zoomDefault && this.svg.call(this.zoom.scaleBy, this.config.zoomDefault), this.config.translateDefault) {
            const v = this.projection(this.config.translateDefault);
            v && this.svg.call(this.zoom.translateTo, v[0], v[1]);
        }
        if (this.defs = this.svg.append("defs"), this.patternGradient = ((h = (s = this.config).patternGradient) == null ? void 0 : h.call(s, this.defs)) ?? null, this.patternFilter = null, this.pattern = ((g = (c = this.config).pattern) == null ? void 0 : g.call(c, this.defs)) ?? null, this.pattern && (this.g.style("fill", "url(#pattern)"), this.g.style("stroke", "url(#pattern)")), this.markerShadow = null, this.config.markerStyle.shadow) {
            if (!this.config.markerStyle.shadow.color) throw new Error("Shadow color is require!");
            if (!this.config.markerStyle.shadow.blur) throw new Error("Shadow blur is require!");
            if (!this.config.markerStyle.shadow.radius) throw new Error("Shadow radius is require!");
            this.markerShadow = this.defs.append("filter").attr("id", "markerShadow").attr("x", "-100%").attr("y", "-100%").attr("width", "300%").attr("height", "300%").attr("filterUnits", "userSpaceOnUse").attr("color-interpolation-filters", "sRGB"), this.markerShadow.append("feFlood").attr("flood-color", this.config.markerStyle.shadow.color).attr("result", "flood").attr("in", "SourceAlpha"), this.markerShadow.append("feComposite").attr("in2", "SourceAlpha").attr("in", "flood").attr("operator", "atop").attr("result", "color"), this.markerShadow.append("feMorphology").attr("operator", "dilate").attr("radius", this.config.markerStyle.shadow.radius).attr("result", "spread").attr("in", "color"), this.markerShadow.append("feGaussianBlur").attr("in", "spread").attr("stdDeviation", this.config.markerStyle.shadow.blur).attr("result", "shadow"), this.markerShadow.append("feOffset").attr("dx", 0).attr("dy", 0).attr("in", "shadow").attr("result", "offset");
            const v = this.markerShadow.append("feMerge").attr("result", "merge");
            v.append("feMergeNode").attr("in", "offset"), v.append("feMergeNode").attr("in", "SourceGraphic");
        }
        this.mapInstancePromise.then((v)=>{
            var w;
            v && this.g.selectAll("path").data(v.features).enter().append("path").attr("class", "country").attr("id", (d)=>d.properties.id).attr("d", this.path), this.patternGradient && (this.patternFilter = this.g.append("rect").attr("id", "patternFilter").attr("x", 0).attr("y", 0).attr("width", "100%").attr("height", "100%").style("fill", "url(#patternGradient)").style("mix-blend-mode", "color").style("pointer-events", "none")), ((w = this.g.node()) == null ? void 0 : w.childNodes[0]) === this.g.select(".markers").node() && this.g.append("use").attr("xlink:href", "#markers"), this.isLoading = !1, this.config.on.loaded();
        }), this.mapInstancePromise.then(()=>{
            var v;
            (v = this.countryGroups) == null || v.forEach((w, d)=>{
                const y = w.map((x)=>`#${x}`).join(",");
                $3cfd30e35d79a5df$var$we(y).attr("class", ()=>`country ${d}`).transition().style("fill", this.config.groupFillColor).style("stroke", this.config.countryStrokeColor);
            });
        }), this.selectCountryList(this.selectedCountries), this.zoomCountries(this.zoomedCountries), $3cfd30e35d79a5df$var$Ri(this, $3cfd30e35d79a5df$var$eu, $3cfd30e35d79a5df$var$Ec).call(this), setTimeout(()=>{
            $3cfd30e35d79a5df$var$Ri(this, $3cfd30e35d79a5df$var$tu, $3cfd30e35d79a5df$var$Sc).call(this), $3cfd30e35d79a5df$var$Ri(this, $3cfd30e35d79a5df$var$ru, $3cfd30e35d79a5df$var$Ac).call(this);
        });
    }
    /**
   * @description Select country by id
   * @param {string} id - country id
   */ selectCountry(r) {
        if (!r) throw new Error("id is required!");
        this.selectedCountries = [
            ...this.selectedCountries,
            r
        ], this.mapInstancePromise.then(()=>{
            $3cfd30e35d79a5df$var$Un(`#${r}`).transition().style("fill", this.config.accentFillColor).style("stroke", this.config.accentStrokeColor);
        });
    }
    /**
   * @description Select countries by id.
   * @param {string[]} idList - List of country ids.
   */ selectCountryList(r) {
        if (!r) throw new Error("idList is required!");
        this.mapInstancePromise.then(()=>{
            r.forEach((u)=>{
                this.selectCountry(u);
            });
        });
    }
    /**
   * @description Unselect country by id.
   * @param {string} id - List of country ids.
   */ unselectCountry(r) {
        if (!r) throw new Error("id is required!");
        $3cfd30e35d79a5df$var$Un(`#${r}`).transition().style("fill", this.config.countryFillColor).style("stroke", this.config.countryStrokeColor);
    }
    /**
   * @description Unselect all countries.
   */ unselectAllCountries() {
        const r = this.selectedCountries.map((u)=>`#${u}`).join(",");
        this.mapInstancePromise.then(()=>{
            $3cfd30e35d79a5df$var$we(r).transition().style("fill", this.config.countryFillColor).style("stroke", this.config.countryStrokeColor);
        });
    }
    /**
   * @description Select country group by  group id
   * @param {string} groupId - group id
   */ selectGroup(r) {
        var f, s;
        if (!r) throw new Error("groupId is required!");
        this.selectedGroup = r;
        const u = (s = (f = this.countryGroups) == null ? void 0 : f.get(r)) == null ? void 0 : s.map((h)=>`#${h}`).join(",");
        u && this.mapInstancePromise.then(()=>{
            $3cfd30e35d79a5df$var$we(u).transition().style("fill", this.config.accentFillColor).style("stroke", this.config.accentStrokeColor);
        });
    }
    /**
   * @description Select country group by  group id
   * @param {string} groupId - group id
   */ unselectAllGroups() {
        var u, f;
        const r = this.selectedGroup ? (f = (u = this.countryGroups) == null ? void 0 : u.get(this.selectedGroup)) == null ? void 0 : f.map((s)=>`#${s}`).join(",") : null;
        r && this.mapInstancePromise.then(()=>{
            $3cfd30e35d79a5df$var$we(r).transition().style("fill", this.config.groupFillColor).style("stroke", this.config.countryStrokeColor);
        }), this.selectedGroup = null;
    }
    moveToCountry(r, u = this) {
        if (!r) throw new Error("id is required!");
        this.mapInstancePromise.then(()=>{
            const [f] = $3cfd30e35d79a5df$var$Un(`#${r}`).data(), s = u.path.bounds(f), h = s[1][0] - s[0][0], c = s[1][1] - s[0][1], g = (s[0][0] + s[1][0]) / 2, v = (s[0][1] + s[1][1]) / 2, w = Math.max(1, Math.min(this.config.maxZoom, 0.9 / Math.max(h / u.config.width, c / u.config.height))), d = [
                u.config.width / 2 - w * g,
                u.config.height / 2 - w * v
            ];
            u.svg.transition().duration(750).call(u.zoom.transform, $3cfd30e35d79a5df$var$Ue.translate(d[0], d[1]).scale(w));
        });
    }
    moveToCountries(r, u = this) {
        if (!r || !Array.isArray(r)) throw new Error("idList is required and must be an array of country ids!");
        this.mapInstancePromise.then(()=>{
            const [f] = $3cfd30e35d79a5df$var$Un(`#${r[0]}`).data(), s = u.path.bounds(f);
            r.forEach((y)=>{
                const [x] = $3cfd30e35d79a5df$var$Un(`#${y}`).data(), C = u.path.bounds(x);
                s[0][0] > C[0][0] && (s[0][0] = C[0][0]), s[0][1] > C[0][1] && (s[0][1] = C[0][1]), s[1][0] < C[1][0] && (s[1][0] = C[1][0]), s[1][1] < C[1][1] && (s[1][1] = C[1][1]);
            });
            const h = s[1][0] - s[0][0], c = s[1][1] - s[0][1], g = (s[0][0] + s[1][0]) / 2, v = (s[0][1] + s[1][1]) / 2, w = Math.max(1, Math.min(this.config.maxZoom, 0.9 / Math.max(h / u.config.width, c / u.config.height))), d = [
                u.config.width / 2 - w * g,
                u.config.height / 2 - w * v
            ];
            u.svg.transition().duration(750).call(u.zoom.transform, $3cfd30e35d79a5df$var$Ue.translate(d[0], d[1]).scale(w));
        });
    }
    zoomCountries(r) {
        if (!r) throw new Error('id "string" or idList "array of strings" is required!');
        this.mapInstancePromise.then(()=>{
            if (typeof r == "string") {
                const [u] = $3cfd30e35d79a5df$var$Un(`#${r}`).data(), f = this.path.bounds(u), s = f[1][0] - f[0][0], h = f[1][1] - f[0][1], c = (f[0][0] + f[1][0]) / 2, g = (f[0][1] + f[1][1]) / 2, v = Math.max(1, Math.min(this.config.maxZoom, 0.9 / Math.max(s / this.config.width, h / this.config.height))), w = [
                    this.config.width / 2 - v * c,
                    this.config.height / 2 - v * g
                ];
                this.svg.transition().call(this.zoom.transform, $3cfd30e35d79a5df$var$Ue.translate(w[0], w[1]).scale(v));
            }
            if (Array.isArray(r) && r.length > 0) {
                const [u] = $3cfd30e35d79a5df$var$Un(`#${r[0]}`).data(), f = this.path.bounds(u);
                r.forEach((d)=>{
                    const [y] = $3cfd30e35d79a5df$var$Un(`#${d}`).data(), x = this.path.bounds(y);
                    f[0][0] > x[0][0] && (f[0][0] = x[0][0]), f[0][1] > x[0][1] && (f[0][1] = x[0][1]), f[1][0] < x[1][0] && (f[1][0] = x[1][0]), f[1][1] < x[1][1] && (f[1][1] = x[1][1]);
                });
                const s = f[1][0] - f[0][0], h = f[1][1] - f[0][1], c = (f[0][0] + f[1][0]) / 2, g = (f[0][1] + f[1][1]) / 2, v = Math.max(1, Math.min(this.config.maxZoom, 0.9 / Math.max(s / this.config.width, h / this.config.height))), w = [
                    this.config.width / 2 - v * c,
                    this.config.height / 2 - v * g
                ];
                this.svg.transition().call(this.zoom.transform, $3cfd30e35d79a5df$var$Ue.translate(w[0], w[1]).scale(v));
            }
        });
    }
}
$3cfd30e35d79a5df$var$tu = new WeakSet(), $3cfd30e35d79a5df$var$Sc = function() {
    this.mapInstancePromise.then(()=>{
        const u = this.g.append("g").attr("class", "markers").attr("id", "markers").selectAll(".marker").data(this.markers).enter();
        this.config.markerStyle.type === "image" ? u.append("svg:image").attr("x", (f)=>{
            var h;
            return ((h = this.projection([
                f.long,
                f.lat
            ])) == null ? void 0 : h[0]) ?? null;
        }).attr("class", "marker").attr("y", (f)=>{
            var h;
            const s = (h = this.projection([
                f.long,
                f.lat
            ])) == null ? void 0 : h[1];
            return s ? s - this.config.markerStyle.height : null;
        }).attr("width", this.config.markerStyle.width).attr("height", this.config.markerStyle.height).attr("xlink:href", this.config.markerStyle.img).attr("filter", "url(#markerShadow)") : u.append("circle").attr("class", "marker").attr("r", this.config.markerStyle.radius).attr("cx", (f)=>{
            var s;
            return ((s = this.projection([
                f.long,
                f.lat
            ])) == null ? void 0 : s[0]) ?? null;
        }).attr("cy", (f)=>{
            var s;
            return ((s = this.projection([
                f.long,
                f.lat
            ])) == null ? void 0 : s[1]) ?? null;
        }).style("fill", this.config.markerStyle.color).style("stroke-width", this.config.markerStyle.strokeWidth + "px").style("stroke", this.config.markerStyle.strokeColor).attr("filter", "url(#markerShadow)");
    });
}, $3cfd30e35d79a5df$var$eu = new WeakSet(), $3cfd30e35d79a5df$var$Ec = function() {
    this.mapInstancePromise.then(()=>{
        $3cfd30e35d79a5df$var$we(".country").on("click", ({ target: r }, u)=>this.config.on.countryClick({
                target: r,
                data: u,
                metaMap: this
            })).on("mouseenter", ({ target: r }, u)=>this.config.on.countryMouseEnter({
                target: r,
                data: u,
                metaMap: this
            })).on("mouseleave", ({ target: r }, u)=>this.config.on.countryMouseLeave({
                target: r,
                data: u,
                metaMap: this
            }));
    });
}, $3cfd30e35d79a5df$var$ru = new WeakSet(), $3cfd30e35d79a5df$var$Ac = function() {
    this.mapInstancePromise.then(()=>{
        $3cfd30e35d79a5df$var$we(".marker").on("click", ({ target: r }, u)=>this.config.on.markerClick({
                target: r,
                data: u,
                metaMap: this
            })).on("mouseenter", ({ target: r }, u)=>this.config.on.markerMouseEnter({
                target: r,
                data: u,
                metaMap: this
            })).on("mouseleave", ({ target: r }, u)=>this.config.on.markerMouseLeave({
                target: r,
                data: u,
                metaMap: this
            }));
    });
};
 //# sourceMappingURL=meta-map.js.map


/**
 * function to know what browser client is using [Application and version of it]
 * Used in fixForSwiperSafariOld function to toggle it only in Safari 11 and 12
 * where touch-action: pan-y || pan-x not supported
 * **/ navigator.sayswho = function() {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [
        M[1],
        M[2]
    ] : [
        navigator.appName,
        navigator.appVersion,
        "-?"
    ];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
}();
function $14cc9b9e67667660$export$4ccd5990a7adecc1() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}




let $f987e7bd15e569e6$var$markers = [
    {
        lat: 53.528881,
        long: -2.579298
    },
    {
        lat: 34.049246,
        long: -118.294567
    },
    {
        lat: 19.416088,
        long: -99.229906
    },
    {
        lat: -39.074644,
        long: -68.022409
    },
    {
        lat: -32.750323,
        long: 21.313259
    },
    {
        lat: 8.341953,
        long: 0.184791
    },
    {
        lat: 51.903613,
        long: 6.951336
    },
    {
        lat: 57.903174,
        long: 13.635385
    },
    {
        lat: 43.149094,
        long: 25.244522
    },
    {
        lat: 57.949845,
        long: 54.003521
    },
    {
        lat: 25.502785,
        long: 51.170076
    },
    {
        lat: 24.627045,
        long: 55.039788
    },
    {
        lat: 21.88189,
        long: 111.571077
    },
    {
        lat: 36.120128,
        long: 139.421674
    },
    {
        lat: -8.9936,
        long: 120.77463
    },
    {
        lat: -33.998027,
        long: 149.789727
    }
];
window.initMetaMap = function initMetaMap(markers) {
    const mapSection = document.querySelector(".map-section");
    if (mapSection) {
        const mapWrap = mapSection.querySelector("#map");
        const popover = mapSection.querySelector(".map-popover");
        const popoverContent = mapSection.querySelector(".map-popover");
        const popoverPseudo = mapSection.querySelector(".map-popover-pseudo");
        /*const imgPopover = popover.querySelector('.map-popover__img');*/ const mapSlidesArr = mapSection.querySelectorAll(".map-slider__item");
        const isTab = matchMedia("(max-width: 768px)").matches;
        let radius = 6;
        if (window.innerWidth <= 640) radius = 10;
        new (0, $3cfd30e35d79a5df$export$2e2bcd8739ae039)("#map", {
            mapPath: "app/assets/static/map.geo.json",
            width: 1300,
            height: 850,
            isZoomable: false,
            countryStrokeWidth: 0,
            countryStrokeColor: "#ffffff",
            markerStyle: {
                type: "pin",
                color: "#883EDD",
                width: "7px",
                height: "7px",
                radius: radius,
                strokeWidth: 3,
                shadow: {
                    color: "rgba(136,62,221,0.5)",
                    blur: radius + 4,
                    radius: radius + 4
                }
            },
            zoomDefault: 1,
            translateDefault: isTab ? [
                13.628032,
                21.666104
            ] : null,
            markers: markers,
            /*pattern: (defs) => {
        const pattern = defs
          .append('pattern')
          .attr('id', 'pattern')
          .attr('patternUnits', 'userSpaceOnUse')
          .attr('width', 9)
          .attr('height', 9);

        return pattern
          .append('circle')
          .attr('cx', 4.5)
          .attr('cy', 4.5)
          .attr('r', 3)
          .style('fill', '#24365B');
      },
      patternGradient: (defs) => {
        const patternGradient = defs
          .append('linearGradient')
          .attr('id', 'patternGradient')
          .attr('gradientUnits', 'userSpaceOnUse');
        patternGradient.append('stop').attr('stop-color', '#EDAAC0');
        patternGradient
          .append('stop')
          .attr('stop-color', '#B1B3C0')
          .attr('offset', '1');

        return patternGradient;
      },*/ on: {
                markerClick: ({ data: data, target: target })=>{
                    const activeMarkers = mapWrap.querySelectorAll(".marker.active");
                    activeMarkers.forEach((marker)=>marker.classList.remove("active"));
                    target.classList.add("active");
                    popover.classList.add("active");
                    popoverPseudo.classList.add("active");
                    /*imgPopover.src = data.info.logo;*/ updatePosition(target, popover);
                    updatePositionPseudo(target, popoverPseudo);
                    updateMarkerLines();
                    const markersArr = document.querySelectorAll("#map .marker");
                    markersArr.forEach((marker, i)=>{
                        if (marker.classList.contains("active")) popoverContent.innerHTML = mapSlidesArr[i].innerHTML;
                    });
                },
                zoom: ()=>{
                    const activeMarkers = mapWrap.querySelectorAll(".marker.active");
                    activeMarkers.forEach((marker)=>marker.classList.remove("active"));
                    popover.classList.remove("active");
                    popoverPseudo.classList.remove("active");
                    updateMarkerLines();
                }
            }
        });
        window.addEventListener("click", ({ target: target })=>{
            if (!target.classList.contains("marker") && window.innerWidth >= 641) {
                const activeMarkers = mapWrap.querySelectorAll(".marker.active");
                activeMarkers.forEach((marker)=>marker.classList.remove("active"));
                popover.classList.remove("active");
                popoverPseudo.classList.remove("active");
                updateMarkerLines();
            }
        });
        setTimeout(function() {
            function updateMarkerLines() {
                const mapLinesContainer = mapSection.querySelector(".map-decors");
                const mapLine = mapLinesContainer.querySelector("span");
                const markersArr = mapSection.querySelectorAll(".markers .marker");
                mapLinesContainer.innerHTML = "";
                const originalMapLine = mapLine.cloneNode(true);
                mapLine.remove();
                markersArr.forEach((marker)=>{
                    const markerRect = marker.getBoundingClientRect();
                    const mapSectionRect = mapWrap.getBoundingClientRect();
                    const top = markerRect.top - mapSectionRect.top + mapSection.scrollTop;
                    const left = markerRect.left - mapSectionRect.left + mapSection.scrollLeft;
                    const mapLineClone = originalMapLine.cloneNode(true);
                    mapLineClone.style.position = "absolute";
                    mapLineClone.style.top = `${top}px`;
                    mapLineClone.style.left = `${left}px`;
                    mapLineClone.classList.remove("active-sw");
                    mapLinesContainer.appendChild(mapLineClone);
                });
                mapLinesContainer.style.opacity = 1;
            }
            updateMarkerLines();
            window.addEventListener("resize", updateMarkerLines);
        }, 300);
        let mapSwiperWr = document.querySelectorAll(".map-swiper-wr");
        mapSwiperWr.forEach((el)=>{
            if (el) {
                let swiperEl = el.querySelector(".swiper");
                let nextEl = el.querySelector(".swiper-button-next");
                let prevEl = el.querySelector(".swiper-button-prev");
                let slidesCount = el.querySelectorAll(".swiper-slide").length;
                let slides = el.querySelectorAll(".swiper-slide");
                let wrapper = swiperEl.querySelector(".swiper-wrapper");
                let swiper = new (0, $6b419225685b7836$export$2e2bcd8739ae039)(swiperEl, {
                    modules: [
                        (0, $a22c4587aa5a240b$export$2e2bcd8739ae039),
                        (0, $0c7a5e05c02656c6$export$2e2bcd8739ae039),
                        (0, $3f55e670ecf070db$export$2e2bcd8739ae039)
                    ],
                    observer: true,
                    observeParents: true,
                    spaceBetween: 20,
                    slidesPerView: 1,
                    threshold: 10,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    autoHeight: true,
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl
                    },
                    on: {
                        slideChange: function() {
                            const markersArr = mapSection.querySelectorAll(".markers .marker");
                            const mapLinesContainer = mapSection.querySelector(".map-decors");
                            const mapLinesArr = mapLinesContainer.querySelectorAll("span");
                            markersArr.forEach((marker)=>marker.classList.remove("active-sw"));
                            mapLinesArr.forEach((markerLine)=>markerLine.classList.remove("active-sw"));
                            if (markersArr[swiper.realIndex]) {
                                markersArr[swiper.realIndex].classList.add("active-sw");
                                mapLinesArr[swiper.realIndex].classList.add("active-sw");
                                updatePositionPseudo(markersArr[swiper.realIndex], popoverPseudo);
                                popoverPseudo.classList.add("active");
                                const labelText = slides[swiper.realIndex].querySelector(".map-popover-label");
                                const labelPseudo = popoverPseudo.querySelector("span");
                                labelPseudo.textContent = labelText.textContent;
                            }
                        }
                    }
                });
                setTimeout(function() {
                    const markersArr = mapSection.querySelectorAll(".markers .marker");
                    const mapLinesContainer = mapSection.querySelector(".map-decors");
                    const mapLinesArr = mapLinesContainer.querySelectorAll("span");
                    markersArr[0].classList.add("active-sw");
                    mapLinesArr[0].classList.add("active-sw");
                    updatePositionPseudo(markersArr[0], popoverPseudo);
                    popoverPseudo.classList.add("active");
                    const labelText = slides[0].querySelector(".map-popover-label");
                    const labelPseudo = popoverPseudo.querySelector("span");
                    labelPseudo.textContent = labelText.textContent;
                }, 350);
            /*swiperObserver(swiper);*/ }
        });
    }
    function updatePosition(pin, popover) {
        (0, $4aebc664d8c92966$export$48a53dcb22e581d0)(pin, popover, {
            placement: "left-start",
            strategy: "fixed",
            middleware: [
                (0, $4aebc664d8c92966$export$8a83211c878a3f1f)(),
                (0, $4aebc664d8c92966$export$fba63a578e423eb)({
                    crossAxis: true,
                    limiter: (0, $4aebc664d8c92966$export$7bf07e38f3dc4b69)()
                }),
                (0, $e273a525241d0e9e$export$cc800923e997bb8)(0)
            ]
        }).then(({ x: x, y: y })=>{
            Object.assign(popover.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    function updatePositionPseudo(pin, popoverPseudo) {
        (0, $4aebc664d8c92966$export$48a53dcb22e581d0)(pin, popoverPseudo, {
            placement: "left",
            strategy: "fixed",
            middleware: [
                (0, $4aebc664d8c92966$export$8a83211c878a3f1f)(),
                (0, $4aebc664d8c92966$export$fba63a578e423eb)({
                    crossAxis: true,
                    limiter: (0, $4aebc664d8c92966$export$7bf07e38f3dc4b69)()
                }),
                (0, $e273a525241d0e9e$export$cc800923e997bb8)(10)
            ]
        }).then(({ x: x, y: y })=>{
            Object.assign(popoverPseudo.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    function updateMarkerLines() {
        const mapLinesContainer = mapSection.querySelector(".map-decors");
        const mapLinesArr = mapLinesContainer.querySelectorAll("span");
        const markersArr = mapSection.querySelectorAll(".markers .marker");
        markersArr.forEach((marker, index)=>{
            if (marker.classList.contains("active")) mapLinesArr[index].classList.add("active");
            else mapLinesArr[index].classList.remove("active");
        });
    }
};


var $05e3867a14f28447$var$t = function() {
    return $05e3867a14f28447$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $05e3867a14f28447$var$t.apply(this, arguments);
}, $05e3867a14f28447$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $05e3867a14f28447$var$t($05e3867a14f28447$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 **/ const $4f5e25340686dc37$var$counts = Array.from(document.getElementsByClassName("count-up"));
if ($4f5e25340686dc37$var$counts) {
    const defaultOptions = {
        separator: "",
        enableScrollSpy: true,
        scrollSpyRunOnce: true
    };
    let idNumber = 1;
    $4f5e25340686dc37$var$counts.forEach((count)=>{
        const id = `count-up-${idNumber}`;
        const textContent = count.textContent.trim();
        const valueMatch = textContent.match(/^([\d.,]+)([^\d.,]*)$/);
        const value = valueMatch ? parseFloat(valueMatch[1].replace(",", "")) : 0;
        const symbol = valueMatch ? valueMatch[2] : "";
        let optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === "") optionsFromDataAttr[key] = true;
        count.id = id;
        const countUpInstance = new (0, $05e3867a14f28447$export$1567cc001e3d0c1d)(id, value, Object.assign({}, defaultOptions, optionsFromDataAttr));
        // Modified printValue function to add gap between number and symbol
        countUpInstance.printValue = function(value) {
            count.innerHTML = value.toFixed(countUpInstance.options.decimalPlaces) + `<span style="margin-left: 10px;">${symbol}</span>`;
        };
        countUpInstance.start();
        idNumber++;
    });
}


/* SELECTS */ const $0c5444ba1638078b$var$choices = document.querySelectorAll(".js-choice");
/*choices.forEach((choice) => {
  new Choices(choice, {
    searchEnabled: false,
    itemSelectText: '',
  });
});*/ window.choicesArray = [];
window.initChoices = function initChoices(elementsArr) {
    const choicesDOM = document.querySelector(elementsArr);
    if (choicesDOM) {
        const choicesArr = document.querySelectorAll(`${elementsArr}`);
        for(let i = 0; i < choicesArr.length; i++){
            console.log("init");
            const parentContainer = choicesArr[i].parentNode;
            /*const list = parentContainer.querySelector(".default-select__list");*/ const choices = new (0, (/*@__PURE__*/$parcel$interopDefault($5445e1f52820f998$exports)))(choicesArr[i], {
                searchEnabled: false,
                itemSelectText: "",
                placeholder: true,
                searchPlaceholderValue: "Search",
                shouldSort: false,
                classNames: {
                    flippedState: ""
                }
            });
            choicesArray.push(choices);
            const choicesMultipleElement = parentContainer.querySelector(".choices[data-type='select-multiple']");
            if (choicesMultipleElement) choicesMultipleElement.addEventListener("click", ()=>{
                if (parentContainer.querySelector(".is-open")) choices.hideDropdown();
            });
            /* New multiselect logic */ if (choicesArr[i].multiple && choicesArr[i].hasAttribute("data-multiple-list-logic")) {
                let optionName = null;
                let optionValue = null;
                const multiplePlaceholder = parentContainer.querySelector(".choices__list--multiple");
                const list = document.createElement("ul");
                list.className = "meta-select__list";
                parentContainer.appendChild(list);
                function createListItem(optionName, optionValue) {
                    const listItem = document.createElement("li");
                    listItem.setAttribute("data-val", optionValue);
                    listItem.innerHTML = `${optionName}`;
                    listItem.classList.add("meta-select__list-item");
                    list.appendChild(listItem);
                    listItem.addEventListener("click", ()=>{
                        handleListItemClick(listItem);
                    });
                }
                function handleSelectedOptions() {
                    list.innerHTML = "";
                    const selectedOptions = Array.from(choicesArr[i].selectedOptions);
                    if (selectedOptions.length >= 1) list.classList.add("is-visible");
                    else list.classList.remove("is-visible");
                    if (selectedOptions.length === 0 && !choicesArr[i].multiple) choices.setChoiceByValue("");
                    selectedOptions.forEach(function(option) {
                        optionName = option.textContent;
                        optionValue = option.value;
                        if (optionName !== "Select") createListItem(optionName, optionValue);
                    });
                    const listArr = list.querySelectorAll(".meta-select__list-item");
                    if (listArr.length === 1) multiplePlaceholder.textContent = optionName;
                    else if (listArr.length >= 2) multiplePlaceholder.textContent = `Selected ${listArr.length} items`;
                    else multiplePlaceholder.textContent = "Select";
                }
                function handleListItemClick(listItem) {
                    const optionValue = listItem.getAttribute("data-val");
                    choices.removeActiveItemsByValue(optionValue);
                    handleSelectedOptions();
                }
                handleSelectedOptions();
                choicesArr[i].addEventListener("change", function() {
                    handleSelectedOptions();
                });
                list.addEventListener("click", function(event) {
                    const liElement = event.target.closest(".meta-select__list-item");
                    if (liElement) handleListItemClick(liElement);
                });
            }
        }
    }
};
window.initChoices(".js-choice");
window.getChoice = function getChoice1(select) {
    let selectEl = typeof select === "object" ? select : document.querySelector(select);
    let choicesArr = window.choicesArray;
    let targetChoice;
    if (choicesArr) window.choicesArray.forEach((choices)=>{
        let choicesSelect = choices.passedElement.element;
        if (choicesSelect == selectEl) targetChoice = choices;
    });
    return targetChoice;
};
window.resetChoice = function resetChoice(select) {
    let choice = getChoice(select);
    if (choice) {
        let startValue = choice.config.choices[0].value;
        choice.setChoiceByValue(startValue);
    }
};
/* ALLOW PHONE TYPE ONLY */ const $0c5444ba1638078b$var$telInputs = document.querySelectorAll('input[type="tel"]');
$0c5444ba1638078b$var$telInputs.forEach((input)=>{
    input.addEventListener("input", function() {
        this.value = this.value.replace(/[^0-9+]/g, "");
    });
});
/* SCROLL DOWN BUTTON */ const $0c5444ba1638078b$var$scrollBtn = document.querySelector(".btn-scroll");
if ($0c5444ba1638078b$var$scrollBtn) $0c5444ba1638078b$var$scrollBtn.addEventListener("click", (e)=>{
    console.log("clicked scroll btn");
    e.preventDefault();
    const currentSection = $0c5444ba1638078b$var$scrollBtn.closest("section");
    const nextSection = currentSection.nextElementSibling;
    if (nextSection) nextSection.scrollIntoView({
        behavior: "smooth"
    });
});
/*if (document.querySelector('.current-jobs-search__submit')) {
  document
    .querySelector('.current-jobs-search__submit')
    .addEventListener('click', function (e) {
      e.preventDefault();
      const targetElement = document.querySelector('.current-jobs-search__cards');
      if (targetElement) {
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      }
    });
}*/ /* Truncate text */ function $0c5444ba1638078b$var$truncateTitle(selector, maxLines) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element)=>{
        const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
        const maxHeight = lineHeight * maxLines;
        let content = element.textContent;
        element.style.maxHeight = maxHeight + "px";
        element.style.overflow = "hidden";
        element.style.display = "-webkit-box";
        element.style.webkitBoxOrient = "vertical";
        element.style.webkitLineClamp = maxLines;
        if (element.scrollHeight > maxHeight) while(element.scrollHeight > maxHeight){
            content = content.replace(/\W*\s(\S)*$/, "...");
            element.textContent = content;
            element.style.display = "block";
            element.scrollHeight;
        }
    });
}
// truncateTitle('.latest-news-card__title', 6);
$0c5444ba1638078b$var$truncateTitle(".jobs-areas-card-title", 3); /* REMOVE FILTERS */ 


//# sourceMappingURL=scripts.1808fc5e.js.map
